// Generated by scripts/generate-live-validators.mjs from src/api/generated/threadLive/serverToBrowserSchema.ts. Do not edit.
var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// node_modules/ajv-formats/dist/formats.js
var require_formats = __commonJS({
  "node_modules/ajv-formats/dist/formats.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
    function fmtDef(validate, compare) {
      return { validate, compare };
    }
    exports.fullFormats = {
      // date: http://tools.ietf.org/html/rfc3339#section-5.6
      date: fmtDef(date, compareDate),
      // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
      time: fmtDef(getTime(true), compareTime),
      "date-time": fmtDef(getDateTime(true), compareDateTime),
      "iso-time": fmtDef(getTime(), compareIsoTime),
      "iso-date-time": fmtDef(getDateTime(), compareIsoDateTime),
      // duration: https://tools.ietf.org/html/rfc3339#appendix-A
      duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
      uri,
      "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
      // uri-template: https://tools.ietf.org/html/rfc6570
      "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
      // For the source: https://gist.github.com/dperini/729294
      // For test cases: https://mathiasbynens.be/demo/url-regex
      url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
      email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
      hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
      // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
      ipv4: /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
      ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
      regex,
      // uuid: http://tools.ietf.org/html/rfc4122
      uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
      // JSON-pointer: https://tools.ietf.org/html/rfc6901
      // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
      "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
      "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
      // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
      "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
      // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
      // byte: https://github.com/miguelmota/is-base64
      byte,
      // signed 32 bit integer
      int32: { type: "number", validate: validateInt32 },
      // signed 64 bit integer
      int64: { type: "number", validate: validateInt64 },
      // C-type float
      float: { type: "number", validate: validateNumber },
      // C-type double
      double: { type: "number", validate: validateNumber },
      // hint to the UI to hide input strings
      password: true,
      // unchecked string payload
      binary: true
    };
    exports.fastFormats = {
      ...exports.fullFormats,
      date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
      time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareTime),
      "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\dt(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
      "iso-time": fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoTime),
      "iso-date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoDateTime),
      // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
      uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
      "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
      // email (sources from jsen validator):
      // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
      // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
      email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
    };
    exports.formatNames = Object.keys(exports.fullFormats);
    function isLeapYear(year) {
      return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    }
    var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
    var DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function date(str) {
      const matches = DATE.exec(str);
      if (!matches)
        return false;
      const year = +matches[1];
      const month = +matches[2];
      const day = +matches[3];
      return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]);
    }
    function compareDate(d1, d2) {
      if (!(d1 && d2))
        return void 0;
      if (d1 > d2)
        return 1;
      if (d1 < d2)
        return -1;
      return 0;
    }
    var TIME = /^(\d\d):(\d\d):(\d\d(?:\.\d+)?)(z|([+-])(\d\d)(?::?(\d\d))?)?$/i;
    function getTime(strictTimeZone) {
      return function time(str) {
        const matches = TIME.exec(str);
        if (!matches)
          return false;
        const hr = +matches[1];
        const min = +matches[2];
        const sec = +matches[3];
        const tz = matches[4];
        const tzSign = matches[5] === "-" ? -1 : 1;
        const tzH = +(matches[6] || 0);
        const tzM = +(matches[7] || 0);
        if (tzH > 23 || tzM > 59 || strictTimeZone && !tz)
          return false;
        if (hr <= 23 && min <= 59 && sec < 60)
          return true;
        const utcMin = min - tzM * tzSign;
        const utcHr = hr - tzH * tzSign - (utcMin < 0 ? 1 : 0);
        return (utcHr === 23 || utcHr === -1) && (utcMin === 59 || utcMin === -1) && sec < 61;
      };
    }
    function compareTime(s1, s2) {
      if (!(s1 && s2))
        return void 0;
      const t1 = (/* @__PURE__ */ new Date("2020-01-01T" + s1)).valueOf();
      const t2 = (/* @__PURE__ */ new Date("2020-01-01T" + s2)).valueOf();
      if (!(t1 && t2))
        return void 0;
      return t1 - t2;
    }
    function compareIsoTime(t1, t2) {
      if (!(t1 && t2))
        return void 0;
      const a1 = TIME.exec(t1);
      const a2 = TIME.exec(t2);
      if (!(a1 && a2))
        return void 0;
      t1 = a1[1] + a1[2] + a1[3];
      t2 = a2[1] + a2[2] + a2[3];
      if (t1 > t2)
        return 1;
      if (t1 < t2)
        return -1;
      return 0;
    }
    var DATE_TIME_SEPARATOR = /t|\s/i;
    function getDateTime(strictTimeZone) {
      const time = getTime(strictTimeZone);
      return function date_time(str) {
        const dateTime = str.split(DATE_TIME_SEPARATOR);
        return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1]);
      };
    }
    function compareDateTime(dt1, dt2) {
      if (!(dt1 && dt2))
        return void 0;
      const d1 = new Date(dt1).valueOf();
      const d2 = new Date(dt2).valueOf();
      if (!(d1 && d2))
        return void 0;
      return d1 - d2;
    }
    function compareIsoDateTime(dt1, dt2) {
      if (!(dt1 && dt2))
        return void 0;
      const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
      const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
      const res = compareDate(d1, d2);
      if (res === void 0)
        return void 0;
      return res || compareTime(t1, t2);
    }
    var NOT_URI_FRAGMENT = /\/|:/;
    var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
    function uri(str) {
      return NOT_URI_FRAGMENT.test(str) && URI.test(str);
    }
    var BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
    function byte(str) {
      BYTE.lastIndex = 0;
      return BYTE.test(str);
    }
    var MIN_INT32 = -(2 ** 31);
    var MAX_INT32 = 2 ** 31 - 1;
    function validateInt32(value) {
      return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
    }
    function validateInt64(value) {
      return Number.isInteger(value);
    }
    function validateNumber() {
      return true;
    }
    var Z_ANCHOR = /[^\\]\\Z/;
    function regex(str) {
      if (Z_ANCHOR.test(str))
        return false;
      try {
        new RegExp(str);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
});

// node_modules/ajv/dist/runtime/ucs2length.js
var require_ucs2length = __commonJS({
  "node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function ucs2length(str) {
      const len = str.length;
      let length = 0;
      let pos = 0;
      let value;
      while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 55296 && value <= 56319 && pos < len) {
          value = str.charCodeAt(pos);
          if ((value & 64512) === 56320)
            pos++;
        }
      }
      return length;
    }
    exports.default = ucs2length;
    ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
  }
});

// standalone.cjs
var validateServerMessage = validate20;
var formats0 = require_formats().fullFormats["date-time"];
function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate23.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.user_id === void 0 && (missing0 = "user_id")) {
        const err0 = { instancePath, schemaPath: "#/$defs/UserAuthor/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs4 = errors;
        for (const key0 in data) {
          if (!(key0 === "kind" || key0 === "user_id")) {
            const err1 = { instancePath, schemaPath: "#/$defs/UserAuthor/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs4 === errors) {
          if (data.kind !== void 0) {
            let data0 = data.kind;
            const _errs5 = errors;
            if (typeof data0 !== "string") {
              const err2 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/UserAuthor/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if ("user" !== data0) {
              const err3 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/UserAuthor/properties/kind/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs5 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.user_id !== void 0) {
              const _errs7 = errors;
              if (typeof data.user_id !== "string") {
                const err4 = { instancePath: instancePath + "/user_id", schemaPath: "#/$defs/UserAuthor/properties/user_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
          }
        }
      }
    } else {
      const err5 = { instancePath, schemaPath: "#/$defs/UserAuthor/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs9 = errors;
  const _errs10 = errors;
  if (errors === _errs10) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing1;
      if (data.kind === void 0 && (missing1 = "kind") || data.turn_id === void 0 && (missing1 = "turn_id")) {
        const err6 = { instancePath, schemaPath: "#/$defs/AgentAuthor/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      } else {
        const _errs12 = errors;
        for (const key1 in data) {
          if (!(key1 === "kind" || key1 === "turn_id")) {
            const err7 = { instancePath, schemaPath: "#/$defs/AgentAuthor/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
            break;
          }
        }
        if (_errs12 === errors) {
          if (data.kind !== void 0) {
            let data2 = data.kind;
            const _errs13 = errors;
            if (typeof data2 !== "string") {
              const err8 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/AgentAuthor/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if ("agent" !== data2) {
              const err9 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/AgentAuthor/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            var valid4 = _errs13 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.turn_id !== void 0) {
              const _errs15 = errors;
              if (typeof data.turn_id !== "string") {
                const err10 = { instancePath: instancePath + "/turn_id", schemaPath: "#/$defs/AgentAuthor/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              var valid4 = _errs15 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      }
    } else {
      const err11 = { instancePath, schemaPath: "#/$defs/AgentAuthor/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
  }
  var _valid0 = _errs9 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
    const _errs17 = errors;
    const _errs18 = errors;
    if (errors === _errs18) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing2;
        if (data.kind === void 0 && (missing2 = "kind")) {
          const err12 = { instancePath, schemaPath: "#/$defs/SystemAuthor/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        } else {
          const _errs20 = errors;
          for (const key2 in data) {
            if (!(key2 === "kind")) {
              const err13 = { instancePath, schemaPath: "#/$defs/SystemAuthor/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
              break;
            }
          }
          if (_errs20 === errors) {
            if (data.kind !== void 0) {
              let data4 = data.kind;
              if (typeof data4 !== "string") {
                const err14 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/SystemAuthor/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if ("system" !== data4) {
                const err15 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/SystemAuthor/properties/kind/const", keyword: "const", params: { allowedValue: "system" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
          }
        }
      } else {
        const err16 = { instancePath, schemaPath: "#/$defs/SystemAuthor/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    var _valid0 = _errs17 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
        if (props0 !== true) {
          props0 = true;
        }
      }
    }
  }
  if (!valid0) {
    const err17 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err17];
    } else {
      vErrors.push(err17);
    }
    errors++;
    validate23.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate23.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate23.evaluated = { "dynamicProps": true, "dynamicItems": false };
var schema42 = { "additionalProperties": false, "description": "The host's settings of one Thread.", "properties": { "agent_instructions": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "A `prompt` version that starts every fresh agent session, or none.", "title": "Agent Instructions" }, "agent_setup": { "$ref": "#/$defs/AgentSetupKind", "default": "extend", "description": "`dmw_only`: the host's agent runs every turn of the Thread with DMW's own folder, not\nthe host's own setup (agent-profiles.md AP-6, \"DMW only\"). Batch items always do." }, "fallback_routes": { "default": [], "description": "Routes a turn may fall back to, in order, when its own route has a refused key or no\ncredit left (Q-93). Empty: a turn runs on its own route or not at all.", "items": { "oneOf": [{ "$ref": "#/$defs/AgentRoute" }, { "$ref": "#/$defs/ApiKeyRoute" }] }, "maxItems": 8, "title": "Fallback Routes", "type": "array" }, "history_preamble": { "description": "How a fresh session learns the Thread so far: `full_history@1` or `recent_entries@1`.", "pattern": "^[a-z][a-z0-9_]{0,62}@[1-9][0-9]{0,3}$", "title": "History Preamble", "type": "string" }, "permission_profile": { "description": "A profile name on the host's PC (connector.md CN-8).", "pattern": "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$", "title": "Permission Profile", "type": "string" }, "reply_item_kinds": { "description": "Item kinds `propose_change_set` may touch in `reply` turns.", "items": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "type": "string" }, "title": "Reply Item Kinds", "type": "array" }, "reply_tools": { "$ref": "#/$defs/TurnTools", "description": "DMW tools, skill servers and agent skills of `reply` turns." }, "route": { "anyOf": [{ "oneOf": [{ "$ref": "#/$defs/AgentRoute" }, { "$ref": "#/$defs/ApiKeyRoute" }] }, { "type": "null" }], "description": "The default route; `None` until the host picks one, and then no turn can run.", "title": "Route" }, "step_routes": { "description": "Routes for single step keys, overriding the default.", "maxProperties": 100, "patternProperties": { "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$": { "oneOf": [{ "$ref": "#/$defs/AgentRoute" }, { "$ref": "#/$defs/ApiKeyRoute" }] } }, "title": "Step Routes", "type": "object" }, "stop_before_agent_steps": { "default": false, "description": '"Stop before agent steps": an agent step that would start by itself waits until a\nperson runs it, so its filled inputs and prompt can be reviewed first (O4 of the workflow\ndesign proposal, section 0.8; built provisionally, awaiting acceptance). Tool and person\nsteps start as before. A start that doesn\'t say takes it from its Workflow (`proven`).', "title": "Stop Before Agent Steps", "type": "boolean" } }, "required": ["route", "step_routes", "permission_profile", "reply_tools", "reply_item_kinds", "agent_instructions", "history_preamble"], "title": "ThreadSettings", "type": "object" };
var schema43 = { "description": "Whose configuration an agent turn starts with (agent-profiles.md AP-1).", "enum": ["extend", "dmw_only"], "title": "AgentSetupKind", "type": "string" };
var func1 = Object.prototype.hasOwnProperty;
var func2 = require_ucs2length().default;
var pattern4 = new RegExp("^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$", "u");
var pattern6 = new RegExp("^[a-z][a-z0-9_]{0,62}@[1-9][0-9]{0,3}$", "u");
var pattern8 = new RegExp("^[a-z][a-z0-9_]{0,62}$", "u");
var pattern14 = new RegExp("^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "u");
function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate27.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.route === void 0 && (missing0 = "route") || data.step_routes === void 0 && (missing0 = "step_routes") || data.permission_profile === void 0 && (missing0 = "permission_profile") || data.reply_tools === void 0 && (missing0 = "reply_tools") || data.reply_item_kinds === void 0 && (missing0 = "reply_item_kinds") || data.agent_instructions === void 0 && (missing0 = "agent_instructions") || data.history_preamble === void 0 && (missing0 = "history_preamble")) {
        validate27.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema42.properties, key0)) {
            validate27.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.agent_instructions !== void 0) {
            let data0 = data.agent_instructions;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate27.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.agent_setup !== void 0) {
              let data1 = data.agent_setup;
              const _errs8 = errors;
              if (typeof data1 !== "string") {
                validate27.errors = [{ instancePath: instancePath + "/agent_setup", schemaPath: "#/$defs/AgentSetupKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "extend" || data1 === "dmw_only")) {
                validate27.errors = [{ instancePath: instancePath + "/agent_setup", schemaPath: "#/$defs/AgentSetupKind/enum", keyword: "enum", params: { allowedValues: schema43.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.fallback_routes !== void 0) {
                let data2 = data.fallback_routes;
                const _errs11 = errors;
                if (errors === _errs11) {
                  if (Array.isArray(data2)) {
                    if (data2.length > 8) {
                      validate27.errors = [{ instancePath: instancePath + "/fallback_routes", schemaPath: "#/properties/fallback_routes/maxItems", keyword: "maxItems", params: { limit: 8 }, message: "must NOT have more than 8 items" }];
                      return false;
                    } else {
                      var valid3 = true;
                      const len0 = data2.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data3 = data2[i0];
                        const _errs13 = errors;
                        const _errs14 = errors;
                        let valid4 = false;
                        let passing0 = null;
                        const _errs15 = errors;
                        const _errs16 = errors;
                        if (errors === _errs16) {
                          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                            let missing1;
                            if (data3.kind === void 0 && (missing1 = "kind") || data3.agent_id === void 0 && (missing1 = "agent_id") || data3.model_id === void 0 && (missing1 = "model_id")) {
                              const err3 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                              if (vErrors === null) {
                                vErrors = [err3];
                              } else {
                                vErrors.push(err3);
                              }
                              errors++;
                            } else {
                              if (data3.agent_id !== void 0) {
                                let data4 = data3.agent_id;
                                const _errs18 = errors;
                                if (errors === _errs18) {
                                  if (typeof data4 === "string") {
                                    if (!pattern4.test(data4)) {
                                      const err4 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    }
                                  } else {
                                    const err5 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err5];
                                    } else {
                                      vErrors.push(err5);
                                    }
                                    errors++;
                                  }
                                }
                                var valid6 = _errs18 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data3.kind !== void 0) {
                                  let data5 = data3.kind;
                                  const _errs20 = errors;
                                  if (typeof data5 !== "string") {
                                    const err6 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err6];
                                    } else {
                                      vErrors.push(err6);
                                    }
                                    errors++;
                                  }
                                  if ("agent" !== data5) {
                                    const err7 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                    if (vErrors === null) {
                                      vErrors = [err7];
                                    } else {
                                      vErrors.push(err7);
                                    }
                                    errors++;
                                  }
                                  var valid6 = _errs20 === errors;
                                } else {
                                  var valid6 = true;
                                }
                                if (valid6) {
                                  if (data3.model_id !== void 0) {
                                    let data6 = data3.model_id;
                                    const _errs22 = errors;
                                    const _errs23 = errors;
                                    let valid7 = false;
                                    const _errs24 = errors;
                                    if (errors === _errs24) {
                                      if (typeof data6 === "string") {
                                        if (func2(data6) > 200) {
                                          const err8 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err8];
                                          } else {
                                            vErrors.push(err8);
                                          }
                                          errors++;
                                        } else {
                                          if (func2(data6) < 1) {
                                            const err9 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err9];
                                            } else {
                                              vErrors.push(err9);
                                            }
                                            errors++;
                                          }
                                        }
                                      } else {
                                        const err10 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err10];
                                        } else {
                                          vErrors.push(err10);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid2 = _errs24 === errors;
                                    valid7 = valid7 || _valid2;
                                    const _errs26 = errors;
                                    if (data6 !== null) {
                                      const err11 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                      if (vErrors === null) {
                                        vErrors = [err11];
                                      } else {
                                        vErrors.push(err11);
                                      }
                                      errors++;
                                    }
                                    var _valid2 = _errs26 === errors;
                                    valid7 = valid7 || _valid2;
                                    if (!valid7) {
                                      const err12 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err12];
                                      } else {
                                        vErrors.push(err12);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs23;
                                      if (vErrors !== null) {
                                        if (_errs23) {
                                          vErrors.length = _errs23;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs22 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                  if (valid6) {
                                    if (data3.reasoning_effort !== void 0) {
                                      let data7 = data3.reasoning_effort;
                                      const _errs28 = errors;
                                      const _errs29 = errors;
                                      let valid8 = false;
                                      const _errs30 = errors;
                                      if (errors === _errs30) {
                                        if (typeof data7 === "string") {
                                          if (func2(data7) > 200) {
                                            const err13 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data7) < 1) {
                                              const err14 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err14];
                                              } else {
                                                vErrors.push(err14);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err15 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err15];
                                          } else {
                                            vErrors.push(err15);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid3 = _errs30 === errors;
                                      valid8 = valid8 || _valid3;
                                      const _errs32 = errors;
                                      if (data7 !== null) {
                                        const err16 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err16];
                                        } else {
                                          vErrors.push(err16);
                                        }
                                        errors++;
                                      }
                                      var _valid3 = _errs32 === errors;
                                      valid8 = valid8 || _valid3;
                                      if (!valid8) {
                                        const err17 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err17];
                                        } else {
                                          vErrors.push(err17);
                                        }
                                        errors++;
                                      } else {
                                        errors = _errs29;
                                        if (vErrors !== null) {
                                          if (_errs29) {
                                            vErrors.length = _errs29;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid6 = _errs28 === errors;
                                    } else {
                                      var valid6 = true;
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            const err18 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err18];
                            } else {
                              vErrors.push(err18);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1) {
                          valid4 = true;
                          passing0 = 0;
                          var props0 = {};
                          props0.agent_id = true;
                          props0.kind = true;
                          props0.model_id = true;
                          props0.reasoning_effort = true;
                        }
                        const _errs34 = errors;
                        const _errs35 = errors;
                        if (errors === _errs35) {
                          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                            let missing2;
                            if (data3.kind === void 0 && (missing2 = "kind") || data3.route_id === void 0 && (missing2 = "route_id") || data3.model_id === void 0 && (missing2 = "model_id")) {
                              const err19 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                              if (vErrors === null) {
                                vErrors = [err19];
                              } else {
                                vErrors.push(err19);
                              }
                              errors++;
                            } else {
                              if (data3.kind !== void 0) {
                                let data8 = data3.kind;
                                const _errs37 = errors;
                                if (typeof data8 !== "string") {
                                  const err20 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err20];
                                  } else {
                                    vErrors.push(err20);
                                  }
                                  errors++;
                                }
                                if ("api_key" !== data8) {
                                  const err21 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                  if (vErrors === null) {
                                    vErrors = [err21];
                                  } else {
                                    vErrors.push(err21);
                                  }
                                  errors++;
                                }
                                var valid10 = _errs37 === errors;
                              } else {
                                var valid10 = true;
                              }
                              if (valid10) {
                                if (data3.model_id !== void 0) {
                                  let data9 = data3.model_id;
                                  const _errs39 = errors;
                                  if (errors === _errs39) {
                                    if (typeof data9 === "string") {
                                      if (func2(data9) > 200) {
                                        const err22 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                        if (vErrors === null) {
                                          vErrors = [err22];
                                        } else {
                                          vErrors.push(err22);
                                        }
                                        errors++;
                                      } else {
                                        if (func2(data9) < 1) {
                                          const err23 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err23];
                                          } else {
                                            vErrors.push(err23);
                                          }
                                          errors++;
                                        }
                                      }
                                    } else {
                                      const err24 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err24];
                                      } else {
                                        vErrors.push(err24);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid10 = _errs39 === errors;
                                } else {
                                  var valid10 = true;
                                }
                                if (valid10) {
                                  if (data3.route_id !== void 0) {
                                    let data10 = data3.route_id;
                                    const _errs41 = errors;
                                    if (errors === _errs41) {
                                      if (typeof data10 === "string") {
                                        if (!pattern4.test(data10)) {
                                          const err25 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                        }
                                      } else {
                                        const err26 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err26];
                                        } else {
                                          vErrors.push(err26);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid10 = _errs41 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            const err27 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err27];
                            } else {
                              vErrors.push(err27);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs34 === errors;
                        if (_valid1 && valid4) {
                          valid4 = false;
                          passing0 = [passing0, 1];
                        } else {
                          if (_valid1) {
                            valid4 = true;
                            passing0 = 1;
                            if (props0 !== true) {
                              props0 = props0 || {};
                              props0.kind = true;
                              props0.model_id = true;
                              props0.route_id = true;
                            }
                          }
                        }
                        if (!valid4) {
                          const err28 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/properties/fallback_routes/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                          if (vErrors === null) {
                            vErrors = [err28];
                          } else {
                            vErrors.push(err28);
                          }
                          errors++;
                          validate27.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs14;
                          if (vErrors !== null) {
                            if (_errs14) {
                              vErrors.length = _errs14;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid3 = _errs13 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate27.errors = [{ instancePath: instancePath + "/fallback_routes", schemaPath: "#/properties/fallback_routes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs11 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.history_preamble !== void 0) {
                  let data11 = data.history_preamble;
                  const _errs43 = errors;
                  if (errors === _errs43) {
                    if (typeof data11 === "string") {
                      if (!pattern6.test(data11)) {
                        validate27.errors = [{ instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}@[1-9][0-9]{0,3}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}@[1-9][0-9]{0,3}$"' }];
                        return false;
                      }
                    } else {
                      validate27.errors = [{ instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                  var valid0 = _errs43 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.permission_profile !== void 0) {
                    let data12 = data.permission_profile;
                    const _errs45 = errors;
                    if (errors === _errs45) {
                      if (typeof data12 === "string") {
                        if (!pattern4.test(data12)) {
                          validate27.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                          return false;
                        }
                      } else {
                        validate27.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                    }
                    var valid0 = _errs45 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.reply_item_kinds !== void 0) {
                      let data13 = data.reply_item_kinds;
                      const _errs47 = errors;
                      if (errors === _errs47) {
                        if (Array.isArray(data13)) {
                          var valid11 = true;
                          const len1 = data13.length;
                          for (let i1 = 0; i1 < len1; i1++) {
                            let data14 = data13[i1];
                            const _errs49 = errors;
                            if (errors === _errs49) {
                              if (typeof data14 === "string") {
                                if (!pattern8.test(data14)) {
                                  validate27.errors = [{ instancePath: instancePath + "/reply_item_kinds/" + i1, schemaPath: "#/properties/reply_item_kinds/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                  return false;
                                }
                              } else {
                                validate27.errors = [{ instancePath: instancePath + "/reply_item_kinds/" + i1, schemaPath: "#/properties/reply_item_kinds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                            }
                            var valid11 = _errs49 === errors;
                            if (!valid11) {
                              break;
                            }
                          }
                        } else {
                          validate27.errors = [{ instancePath: instancePath + "/reply_item_kinds", schemaPath: "#/properties/reply_item_kinds/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs47 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.reply_tools !== void 0) {
                        let data15 = data.reply_tools;
                        const _errs51 = errors;
                        const _errs52 = errors;
                        if (errors === _errs52) {
                          if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                            let missing3;
                            if (data15.dmw === void 0 && (missing3 = "dmw") || data15.skill_servers === void 0 && (missing3 = "skill_servers") || data15.agent_skills === void 0 && (missing3 = "agent_skills")) {
                              validate27.errors = [{ instancePath: instancePath + "/reply_tools", schemaPath: "#/$defs/TurnTools/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" }];
                              return false;
                            } else {
                              if (data15.agent_skills !== void 0) {
                                let data16 = data15.agent_skills;
                                const _errs54 = errors;
                                if (errors === _errs54) {
                                  if (Array.isArray(data16)) {
                                    var valid14 = true;
                                    const len2 = data16.length;
                                    for (let i2 = 0; i2 < len2; i2++) {
                                      let data17 = data16[i2];
                                      const _errs56 = errors;
                                      if (errors === _errs56) {
                                        if (typeof data17 === "string") {
                                          if (!pattern4.test(data17)) {
                                            validate27.errors = [{ instancePath: instancePath + "/reply_tools/agent_skills/" + i2, schemaPath: "#/$defs/TurnTools/properties/agent_skills/items/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                            return false;
                                          }
                                        } else {
                                          validate27.errors = [{ instancePath: instancePath + "/reply_tools/agent_skills/" + i2, schemaPath: "#/$defs/TurnTools/properties/agent_skills/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                      }
                                      var valid14 = _errs56 === errors;
                                      if (!valid14) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate27.errors = [{ instancePath: instancePath + "/reply_tools/agent_skills", schemaPath: "#/$defs/TurnTools/properties/agent_skills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                    return false;
                                  }
                                }
                                var valid13 = _errs54 === errors;
                              } else {
                                var valid13 = true;
                              }
                              if (valid13) {
                                if (data15.dmw !== void 0) {
                                  let data18 = data15.dmw;
                                  const _errs58 = errors;
                                  if (errors === _errs58) {
                                    if (Array.isArray(data18)) {
                                      var valid15 = true;
                                      const len3 = data18.length;
                                      for (let i3 = 0; i3 < len3; i3++) {
                                        let data19 = data18[i3];
                                        const _errs60 = errors;
                                        if (errors === _errs60) {
                                          if (typeof data19 === "string") {
                                            if (!pattern8.test(data19)) {
                                              validate27.errors = [{ instancePath: instancePath + "/reply_tools/dmw/" + i3, schemaPath: "#/$defs/TurnTools/properties/dmw/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                              return false;
                                            }
                                          } else {
                                            validate27.errors = [{ instancePath: instancePath + "/reply_tools/dmw/" + i3, schemaPath: "#/$defs/TurnTools/properties/dmw/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                        }
                                        var valid15 = _errs60 === errors;
                                        if (!valid15) {
                                          break;
                                        }
                                      }
                                    } else {
                                      validate27.errors = [{ instancePath: instancePath + "/reply_tools/dmw", schemaPath: "#/$defs/TurnTools/properties/dmw/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                      return false;
                                    }
                                  }
                                  var valid13 = _errs58 === errors;
                                } else {
                                  var valid13 = true;
                                }
                                if (valid13) {
                                  if (data15.skill_servers !== void 0) {
                                    let data20 = data15.skill_servers;
                                    const _errs62 = errors;
                                    if (errors === _errs62) {
                                      if (Array.isArray(data20)) {
                                        var valid16 = true;
                                        const len4 = data20.length;
                                        for (let i4 = 0; i4 < len4; i4++) {
                                          let data21 = data20[i4];
                                          const _errs64 = errors;
                                          if (errors === _errs64) {
                                            if (typeof data21 === "string") {
                                              if (!pattern4.test(data21)) {
                                                validate27.errors = [{ instancePath: instancePath + "/reply_tools/skill_servers/" + i4, schemaPath: "#/$defs/TurnTools/properties/skill_servers/items/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                                return false;
                                              }
                                            } else {
                                              validate27.errors = [{ instancePath: instancePath + "/reply_tools/skill_servers/" + i4, schemaPath: "#/$defs/TurnTools/properties/skill_servers/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                          }
                                          var valid16 = _errs64 === errors;
                                          if (!valid16) {
                                            break;
                                          }
                                        }
                                      } else {
                                        validate27.errors = [{ instancePath: instancePath + "/reply_tools/skill_servers", schemaPath: "#/$defs/TurnTools/properties/skill_servers/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                        return false;
                                      }
                                    }
                                    var valid13 = _errs62 === errors;
                                  } else {
                                    var valid13 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate27.errors = [{ instancePath: instancePath + "/reply_tools", schemaPath: "#/$defs/TurnTools/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                            return false;
                          }
                        }
                        var valid0 = _errs51 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.route !== void 0) {
                          let data22 = data.route;
                          const _errs66 = errors;
                          const _errs67 = errors;
                          let valid17 = false;
                          const _errs68 = errors;
                          const _errs69 = errors;
                          let valid18 = false;
                          let passing1 = null;
                          const _errs70 = errors;
                          const _errs71 = errors;
                          if (errors === _errs71) {
                            if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
                              let missing4;
                              if (data22.kind === void 0 && (missing4 = "kind") || data22.agent_id === void 0 && (missing4 = "agent_id") || data22.model_id === void 0 && (missing4 = "model_id")) {
                                const err29 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing4 }, message: "must have required property '" + missing4 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err29];
                                } else {
                                  vErrors.push(err29);
                                }
                                errors++;
                              } else {
                                if (data22.agent_id !== void 0) {
                                  let data23 = data22.agent_id;
                                  const _errs73 = errors;
                                  if (errors === _errs73) {
                                    if (typeof data23 === "string") {
                                      if (!pattern4.test(data23)) {
                                        const err30 = { instancePath: instancePath + "/route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                        if (vErrors === null) {
                                          vErrors = [err30];
                                        } else {
                                          vErrors.push(err30);
                                        }
                                        errors++;
                                      }
                                    } else {
                                      const err31 = { instancePath: instancePath + "/route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err31];
                                      } else {
                                        vErrors.push(err31);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid20 = _errs73 === errors;
                                } else {
                                  var valid20 = true;
                                }
                                if (valid20) {
                                  if (data22.kind !== void 0) {
                                    let data24 = data22.kind;
                                    const _errs75 = errors;
                                    if (typeof data24 !== "string") {
                                      const err32 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err32];
                                      } else {
                                        vErrors.push(err32);
                                      }
                                      errors++;
                                    }
                                    if ("agent" !== data24) {
                                      const err33 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                      if (vErrors === null) {
                                        vErrors = [err33];
                                      } else {
                                        vErrors.push(err33);
                                      }
                                      errors++;
                                    }
                                    var valid20 = _errs75 === errors;
                                  } else {
                                    var valid20 = true;
                                  }
                                  if (valid20) {
                                    if (data22.model_id !== void 0) {
                                      let data25 = data22.model_id;
                                      const _errs77 = errors;
                                      const _errs78 = errors;
                                      let valid21 = false;
                                      const _errs79 = errors;
                                      if (errors === _errs79) {
                                        if (typeof data25 === "string") {
                                          if (func2(data25) > 200) {
                                            const err34 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err34];
                                            } else {
                                              vErrors.push(err34);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data25) < 1) {
                                              const err35 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err35];
                                              } else {
                                                vErrors.push(err35);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err36 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err36];
                                          } else {
                                            vErrors.push(err36);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid6 = _errs79 === errors;
                                      valid21 = valid21 || _valid6;
                                      const _errs81 = errors;
                                      if (data25 !== null) {
                                        const err37 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err37];
                                        } else {
                                          vErrors.push(err37);
                                        }
                                        errors++;
                                      }
                                      var _valid6 = _errs81 === errors;
                                      valid21 = valid21 || _valid6;
                                      if (!valid21) {
                                        const err38 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err38];
                                        } else {
                                          vErrors.push(err38);
                                        }
                                        errors++;
                                      } else {
                                        errors = _errs78;
                                        if (vErrors !== null) {
                                          if (_errs78) {
                                            vErrors.length = _errs78;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid20 = _errs77 === errors;
                                    } else {
                                      var valid20 = true;
                                    }
                                    if (valid20) {
                                      if (data22.reasoning_effort !== void 0) {
                                        let data26 = data22.reasoning_effort;
                                        const _errs83 = errors;
                                        const _errs84 = errors;
                                        let valid22 = false;
                                        const _errs85 = errors;
                                        if (errors === _errs85) {
                                          if (typeof data26 === "string") {
                                            if (func2(data26) > 200) {
                                              const err39 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err39];
                                              } else {
                                                vErrors.push(err39);
                                              }
                                              errors++;
                                            } else {
                                              if (func2(data26) < 1) {
                                                const err40 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                if (vErrors === null) {
                                                  vErrors = [err40];
                                                } else {
                                                  vErrors.push(err40);
                                                }
                                                errors++;
                                              }
                                            }
                                          } else {
                                            const err41 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                              vErrors = [err41];
                                            } else {
                                              vErrors.push(err41);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid7 = _errs85 === errors;
                                        valid22 = valid22 || _valid7;
                                        const _errs87 = errors;
                                        if (data26 !== null) {
                                          const err42 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err42];
                                          } else {
                                            vErrors.push(err42);
                                          }
                                          errors++;
                                        }
                                        var _valid7 = _errs87 === errors;
                                        valid22 = valid22 || _valid7;
                                        if (!valid22) {
                                          const err43 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err43];
                                          } else {
                                            vErrors.push(err43);
                                          }
                                          errors++;
                                        } else {
                                          errors = _errs84;
                                          if (vErrors !== null) {
                                            if (_errs84) {
                                              vErrors.length = _errs84;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid20 = _errs83 === errors;
                                      } else {
                                        var valid20 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              const err44 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err44];
                              } else {
                                vErrors.push(err44);
                              }
                              errors++;
                            }
                          }
                          var _valid5 = _errs70 === errors;
                          if (_valid5) {
                            valid18 = true;
                            passing1 = 0;
                            var props1 = {};
                            props1.agent_id = true;
                            props1.kind = true;
                            props1.model_id = true;
                            props1.reasoning_effort = true;
                          }
                          const _errs89 = errors;
                          const _errs90 = errors;
                          if (errors === _errs90) {
                            if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
                              let missing5;
                              if (data22.kind === void 0 && (missing5 = "kind") || data22.route_id === void 0 && (missing5 = "route_id") || data22.model_id === void 0 && (missing5 = "model_id")) {
                                const err45 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing5 }, message: "must have required property '" + missing5 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err45];
                                } else {
                                  vErrors.push(err45);
                                }
                                errors++;
                              } else {
                                if (data22.kind !== void 0) {
                                  let data27 = data22.kind;
                                  const _errs92 = errors;
                                  if (typeof data27 !== "string") {
                                    const err46 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err46];
                                    } else {
                                      vErrors.push(err46);
                                    }
                                    errors++;
                                  }
                                  if ("api_key" !== data27) {
                                    const err47 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                    if (vErrors === null) {
                                      vErrors = [err47];
                                    } else {
                                      vErrors.push(err47);
                                    }
                                    errors++;
                                  }
                                  var valid24 = _errs92 === errors;
                                } else {
                                  var valid24 = true;
                                }
                                if (valid24) {
                                  if (data22.model_id !== void 0) {
                                    let data28 = data22.model_id;
                                    const _errs94 = errors;
                                    if (errors === _errs94) {
                                      if (typeof data28 === "string") {
                                        if (func2(data28) > 200) {
                                          const err48 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err48];
                                          } else {
                                            vErrors.push(err48);
                                          }
                                          errors++;
                                        } else {
                                          if (func2(data28) < 1) {
                                            const err49 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err49];
                                            } else {
                                              vErrors.push(err49);
                                            }
                                            errors++;
                                          }
                                        }
                                      } else {
                                        const err50 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err50];
                                        } else {
                                          vErrors.push(err50);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid24 = _errs94 === errors;
                                  } else {
                                    var valid24 = true;
                                  }
                                  if (valid24) {
                                    if (data22.route_id !== void 0) {
                                      let data29 = data22.route_id;
                                      const _errs96 = errors;
                                      if (errors === _errs96) {
                                        if (typeof data29 === "string") {
                                          if (!pattern4.test(data29)) {
                                            const err51 = { instancePath: instancePath + "/route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                            if (vErrors === null) {
                                              vErrors = [err51];
                                            } else {
                                              vErrors.push(err51);
                                            }
                                            errors++;
                                          }
                                        } else {
                                          const err52 = { instancePath: instancePath + "/route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err52];
                                          } else {
                                            vErrors.push(err52);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid24 = _errs96 === errors;
                                    } else {
                                      var valid24 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              const err53 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err53];
                              } else {
                                vErrors.push(err53);
                              }
                              errors++;
                            }
                          }
                          var _valid5 = _errs89 === errors;
                          if (_valid5 && valid18) {
                            valid18 = false;
                            passing1 = [passing1, 1];
                          } else {
                            if (_valid5) {
                              valid18 = true;
                              passing1 = 1;
                              if (props1 !== true) {
                                props1 = props1 || {};
                                props1.kind = true;
                                props1.model_id = true;
                                props1.route_id = true;
                              }
                            }
                          }
                          if (!valid18) {
                            const err54 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/anyOf/0/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf" };
                            if (vErrors === null) {
                              vErrors = [err54];
                            } else {
                              vErrors.push(err54);
                            }
                            errors++;
                          } else {
                            errors = _errs69;
                            if (vErrors !== null) {
                              if (_errs69) {
                                vErrors.length = _errs69;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var _valid4 = _errs68 === errors;
                          valid17 = valid17 || _valid4;
                          const _errs98 = errors;
                          if (data22 !== null) {
                            const err55 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err55];
                            } else {
                              vErrors.push(err55);
                            }
                            errors++;
                          }
                          var _valid4 = _errs98 === errors;
                          valid17 = valid17 || _valid4;
                          if (!valid17) {
                            const err56 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err56];
                            } else {
                              vErrors.push(err56);
                            }
                            errors++;
                            validate27.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs67;
                            if (vErrors !== null) {
                              if (_errs67) {
                                vErrors.length = _errs67;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs66 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.step_routes !== void 0) {
                            let data30 = data.step_routes;
                            const _errs100 = errors;
                            if (errors === _errs100) {
                              if (data30 && typeof data30 == "object" && !Array.isArray(data30)) {
                                if (Object.keys(data30).length > 100) {
                                  validate27.errors = [{ instancePath: instancePath + "/step_routes", schemaPath: "#/properties/step_routes/maxProperties", keyword: "maxProperties", params: { limit: 100 }, message: "must NOT have more than 100 properties" }];
                                  return false;
                                } else {
                                  var props2 = {};
                                  for (const key1 in data30) {
                                    if (pattern14.test(key1)) {
                                      let data31 = data30[key1];
                                      const _errs103 = errors;
                                      let valid26 = false;
                                      let passing2 = null;
                                      const _errs104 = errors;
                                      const _errs105 = errors;
                                      if (errors === _errs105) {
                                        if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                          let missing6;
                                          if (data31.kind === void 0 && (missing6 = "kind") || data31.agent_id === void 0 && (missing6 = "agent_id") || data31.model_id === void 0 && (missing6 = "model_id")) {
                                            const err57 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing6 }, message: "must have required property '" + missing6 + "'" };
                                            if (vErrors === null) {
                                              vErrors = [err57];
                                            } else {
                                              vErrors.push(err57);
                                            }
                                            errors++;
                                          } else {
                                            if (data31.agent_id !== void 0) {
                                              let data32 = data31.agent_id;
                                              const _errs107 = errors;
                                              if (errors === _errs107) {
                                                if (typeof data32 === "string") {
                                                  if (!pattern4.test(data32)) {
                                                    const err58 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                    if (vErrors === null) {
                                                      vErrors = [err58];
                                                    } else {
                                                      vErrors.push(err58);
                                                    }
                                                    errors++;
                                                  }
                                                } else {
                                                  const err59 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err59];
                                                  } else {
                                                    vErrors.push(err59);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var valid28 = _errs107 === errors;
                                            } else {
                                              var valid28 = true;
                                            }
                                            if (valid28) {
                                              if (data31.kind !== void 0) {
                                                let data33 = data31.kind;
                                                const _errs109 = errors;
                                                if (typeof data33 !== "string") {
                                                  const err60 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err60];
                                                  } else {
                                                    vErrors.push(err60);
                                                  }
                                                  errors++;
                                                }
                                                if ("agent" !== data33) {
                                                  const err61 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                                  if (vErrors === null) {
                                                    vErrors = [err61];
                                                  } else {
                                                    vErrors.push(err61);
                                                  }
                                                  errors++;
                                                }
                                                var valid28 = _errs109 === errors;
                                              } else {
                                                var valid28 = true;
                                              }
                                              if (valid28) {
                                                if (data31.model_id !== void 0) {
                                                  let data34 = data31.model_id;
                                                  const _errs111 = errors;
                                                  const _errs112 = errors;
                                                  let valid29 = false;
                                                  const _errs113 = errors;
                                                  if (errors === _errs113) {
                                                    if (typeof data34 === "string") {
                                                      if (func2(data34) > 200) {
                                                        const err62 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err62];
                                                        } else {
                                                          vErrors.push(err62);
                                                        }
                                                        errors++;
                                                      } else {
                                                        if (func2(data34) < 1) {
                                                          const err63 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err63];
                                                          } else {
                                                            vErrors.push(err63);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                    } else {
                                                      const err64 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                      if (vErrors === null) {
                                                        vErrors = [err64];
                                                      } else {
                                                        vErrors.push(err64);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var _valid9 = _errs113 === errors;
                                                  valid29 = valid29 || _valid9;
                                                  const _errs115 = errors;
                                                  if (data34 !== null) {
                                                    const err65 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                    if (vErrors === null) {
                                                      vErrors = [err65];
                                                    } else {
                                                      vErrors.push(err65);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid9 = _errs115 === errors;
                                                  valid29 = valid29 || _valid9;
                                                  if (!valid29) {
                                                    const err66 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                    if (vErrors === null) {
                                                      vErrors = [err66];
                                                    } else {
                                                      vErrors.push(err66);
                                                    }
                                                    errors++;
                                                  } else {
                                                    errors = _errs112;
                                                    if (vErrors !== null) {
                                                      if (_errs112) {
                                                        vErrors.length = _errs112;
                                                      } else {
                                                        vErrors = null;
                                                      }
                                                    }
                                                  }
                                                  var valid28 = _errs111 === errors;
                                                } else {
                                                  var valid28 = true;
                                                }
                                                if (valid28) {
                                                  if (data31.reasoning_effort !== void 0) {
                                                    let data35 = data31.reasoning_effort;
                                                    const _errs117 = errors;
                                                    const _errs118 = errors;
                                                    let valid30 = false;
                                                    const _errs119 = errors;
                                                    if (errors === _errs119) {
                                                      if (typeof data35 === "string") {
                                                        if (func2(data35) > 200) {
                                                          const err67 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err67];
                                                          } else {
                                                            vErrors.push(err67);
                                                          }
                                                          errors++;
                                                        } else {
                                                          if (func2(data35) < 1) {
                                                            const err68 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                            if (vErrors === null) {
                                                              vErrors = [err68];
                                                            } else {
                                                              vErrors.push(err68);
                                                            }
                                                            errors++;
                                                          }
                                                        }
                                                      } else {
                                                        const err69 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                        if (vErrors === null) {
                                                          vErrors = [err69];
                                                        } else {
                                                          vErrors.push(err69);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                    var _valid10 = _errs119 === errors;
                                                    valid30 = valid30 || _valid10;
                                                    const _errs121 = errors;
                                                    if (data35 !== null) {
                                                      const err70 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                      if (vErrors === null) {
                                                        vErrors = [err70];
                                                      } else {
                                                        vErrors.push(err70);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid10 = _errs121 === errors;
                                                    valid30 = valid30 || _valid10;
                                                    if (!valid30) {
                                                      const err71 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                      if (vErrors === null) {
                                                        vErrors = [err71];
                                                      } else {
                                                        vErrors.push(err71);
                                                      }
                                                      errors++;
                                                    } else {
                                                      errors = _errs118;
                                                      if (vErrors !== null) {
                                                        if (_errs118) {
                                                          vErrors.length = _errs118;
                                                        } else {
                                                          vErrors = null;
                                                        }
                                                      }
                                                    }
                                                    var valid28 = _errs117 === errors;
                                                  } else {
                                                    var valid28 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        } else {
                                          const err72 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                          if (vErrors === null) {
                                            vErrors = [err72];
                                          } else {
                                            vErrors.push(err72);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid8 = _errs104 === errors;
                                      if (_valid8) {
                                        valid26 = true;
                                        passing2 = 0;
                                        var props3 = {};
                                        props3.agent_id = true;
                                        props3.kind = true;
                                        props3.model_id = true;
                                        props3.reasoning_effort = true;
                                      }
                                      const _errs123 = errors;
                                      const _errs124 = errors;
                                      if (errors === _errs124) {
                                        if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                          let missing7;
                                          if (data31.kind === void 0 && (missing7 = "kind") || data31.route_id === void 0 && (missing7 = "route_id") || data31.model_id === void 0 && (missing7 = "model_id")) {
                                            const err73 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing7 }, message: "must have required property '" + missing7 + "'" };
                                            if (vErrors === null) {
                                              vErrors = [err73];
                                            } else {
                                              vErrors.push(err73);
                                            }
                                            errors++;
                                          } else {
                                            if (data31.kind !== void 0) {
                                              let data36 = data31.kind;
                                              const _errs126 = errors;
                                              if (typeof data36 !== "string") {
                                                const err74 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err74];
                                                } else {
                                                  vErrors.push(err74);
                                                }
                                                errors++;
                                              }
                                              if ("api_key" !== data36) {
                                                const err75 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                                if (vErrors === null) {
                                                  vErrors = [err75];
                                                } else {
                                                  vErrors.push(err75);
                                                }
                                                errors++;
                                              }
                                              var valid32 = _errs126 === errors;
                                            } else {
                                              var valid32 = true;
                                            }
                                            if (valid32) {
                                              if (data31.model_id !== void 0) {
                                                let data37 = data31.model_id;
                                                const _errs128 = errors;
                                                if (errors === _errs128) {
                                                  if (typeof data37 === "string") {
                                                    if (func2(data37) > 200) {
                                                      const err76 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                      if (vErrors === null) {
                                                        vErrors = [err76];
                                                      } else {
                                                        vErrors.push(err76);
                                                      }
                                                      errors++;
                                                    } else {
                                                      if (func2(data37) < 1) {
                                                        const err77 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err77];
                                                        } else {
                                                          vErrors.push(err77);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                  } else {
                                                    const err78 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err78];
                                                    } else {
                                                      vErrors.push(err78);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var valid32 = _errs128 === errors;
                                              } else {
                                                var valid32 = true;
                                              }
                                              if (valid32) {
                                                if (data31.route_id !== void 0) {
                                                  let data38 = data31.route_id;
                                                  const _errs130 = errors;
                                                  if (errors === _errs130) {
                                                    if (typeof data38 === "string") {
                                                      if (!pattern4.test(data38)) {
                                                        const err79 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                        if (vErrors === null) {
                                                          vErrors = [err79];
                                                        } else {
                                                          vErrors.push(err79);
                                                        }
                                                        errors++;
                                                      }
                                                    } else {
                                                      const err80 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                      if (vErrors === null) {
                                                        vErrors = [err80];
                                                      } else {
                                                        vErrors.push(err80);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var valid32 = _errs130 === errors;
                                                } else {
                                                  var valid32 = true;
                                                }
                                              }
                                            }
                                          }
                                        } else {
                                          const err81 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                          if (vErrors === null) {
                                            vErrors = [err81];
                                          } else {
                                            vErrors.push(err81);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid8 = _errs123 === errors;
                                      if (_valid8 && valid26) {
                                        valid26 = false;
                                        passing2 = [passing2, 1];
                                      } else {
                                        if (_valid8) {
                                          valid26 = true;
                                          passing2 = 1;
                                          if (props3 !== true) {
                                            props3 = props3 || {};
                                            props3.kind = true;
                                            props3.model_id = true;
                                            props3.route_id = true;
                                          }
                                        }
                                      }
                                      if (!valid26) {
                                        const err82 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/step_routes/patternProperties/%5E%5Ba-z%5D%5Ba-z0-9_%5D%7B0%2C62%7D(%5C.%5Ba-z%5D%5Ba-z0-9_%5D%7B0%2C62%7D)%7B0%2C7%7D%24/oneOf", keyword: "oneOf", params: { passingSchemas: passing2 }, message: "must match exactly one schema in oneOf" };
                                        if (vErrors === null) {
                                          vErrors = [err82];
                                        } else {
                                          vErrors.push(err82);
                                        }
                                        errors++;
                                        validate27.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs103;
                                        if (vErrors !== null) {
                                          if (_errs103) {
                                            vErrors.length = _errs103;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      props2[key1] = true;
                                    }
                                  }
                                }
                              } else {
                                validate27.errors = [{ instancePath: instancePath + "/step_routes", schemaPath: "#/properties/step_routes/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                            var valid0 = _errs100 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.stop_before_agent_steps !== void 0) {
                              const _errs132 = errors;
                              if (typeof data.stop_before_agent_steps !== "boolean") {
                                validate27.errors = [{ instancePath: instancePath + "/stop_before_agent_steps", schemaPath: "#/properties/stop_before_agent_steps/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                return false;
                              }
                              var valid0 = _errs132 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate27.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
validate27.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate26.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.project_id === void 0 && (missing0 = "project_id") || data.title === void 0 && (missing0 = "title") || data.host === void 0 && (missing0 = "host") || data.bindings === void 0 && (missing0 = "bindings") || data.workflow === void 0 && (missing0 = "workflow") || data.settings === void 0 && (missing0 = "settings")) {
        validate26.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "bindings" || key0 === "host" || key0 === "input_values" || key0 === "kind" || key0 === "project_id" || key0 === "settings" || key0 === "title" || key0 === "workflow")) {
            validate26.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.bindings !== void 0) {
            let data0 = data.bindings;
            const _errs2 = errors;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                let missing1;
                if (data0.content_version === void 0 && (missing1 = "content_version") || data0.corpus_version === void 0 && (missing1 = "corpus_version") || data0.subject === void 0 && (missing1 = "subject")) {
                  validate26.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                  return false;
                } else {
                  const _errs5 = errors;
                  for (const key1 in data0) {
                    if (!(key1 === "content_version" || key1 === "context_outputs" || key1 === "corpus_version" || key1 === "selection" || key1 === "source_version" || key1 === "subject")) {
                      validate26.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                      return false;
                      break;
                    }
                  }
                  if (_errs5 === errors) {
                    if (data0.content_version !== void 0) {
                      const _errs6 = errors;
                      if (typeof data0.content_version !== "string") {
                        validate26.errors = [{ instancePath: instancePath + "/bindings/content_version", schemaPath: "#/$defs/ThreadBindings/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid2 = _errs6 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data0.context_outputs !== void 0) {
                        let data2 = data0.context_outputs;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                          if (Array.isArray(data2)) {
                            var valid3 = true;
                            const len0 = data2.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs10 = errors;
                              if (typeof data2[i0] !== "string") {
                                validate26.errors = [{ instancePath: instancePath + "/bindings/context_outputs/" + i0, schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                              if (!valid3) {
                                break;
                              }
                            }
                          } else {
                            validate26.errors = [{ instancePath: instancePath + "/bindings/context_outputs", schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid2 = _errs8 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data0.corpus_version !== void 0) {
                          let data4 = data0.corpus_version;
                          const _errs12 = errors;
                          const _errs13 = errors;
                          let valid4 = false;
                          const _errs14 = errors;
                          if (typeof data4 !== "string") {
                            const err0 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err0];
                            } else {
                              vErrors.push(err0);
                            }
                            errors++;
                          }
                          var _valid0 = _errs14 === errors;
                          valid4 = valid4 || _valid0;
                          const _errs16 = errors;
                          if (data4 !== null) {
                            const err1 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          var _valid0 = _errs16 === errors;
                          valid4 = valid4 || _valid0;
                          if (!valid4) {
                            const err2 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                            validate26.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs13;
                            if (vErrors !== null) {
                              if (_errs13) {
                                vErrors.length = _errs13;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid2 = _errs12 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data0.selection !== void 0) {
                            let data5 = data0.selection;
                            const _errs18 = errors;
                            if (errors === _errs18) {
                              if (Array.isArray(data5)) {
                                if (data5.length > 200) {
                                  validate26.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" }];
                                  return false;
                                } else {
                                  var valid5 = true;
                                  const len1 = data5.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs20 = errors;
                                    if (typeof data5[i1] !== "string") {
                                      validate26.errors = [{ instancePath: instancePath + "/bindings/selection/" + i1, schemaPath: "#/$defs/ThreadBindings/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid5 = _errs20 === errors;
                                    if (!valid5) {
                                      break;
                                    }
                                  }
                                }
                              } else {
                                validate26.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                return false;
                              }
                            }
                            var valid2 = _errs18 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data0.source_version !== void 0) {
                              let data7 = data0.source_version;
                              const _errs22 = errors;
                              const _errs23 = errors;
                              let valid6 = false;
                              const _errs24 = errors;
                              if (typeof data7 !== "string") {
                                const err3 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                              }
                              var _valid1 = _errs24 === errors;
                              valid6 = valid6 || _valid1;
                              const _errs26 = errors;
                              if (data7 !== null) {
                                const err4 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err4];
                                } else {
                                  vErrors.push(err4);
                                }
                                errors++;
                              }
                              var _valid1 = _errs26 === errors;
                              valid6 = valid6 || _valid1;
                              if (!valid6) {
                                const err5 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err5];
                                } else {
                                  vErrors.push(err5);
                                }
                                errors++;
                                validate26.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs23;
                                if (vErrors !== null) {
                                  if (_errs23) {
                                    vErrors.length = _errs23;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid2 = _errs22 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data0.subject !== void 0) {
                                let data8 = data0.subject;
                                const _errs28 = errors;
                                const _errs29 = errors;
                                let valid7 = false;
                                const _errs30 = errors;
                                if (typeof data8 !== "string") {
                                  const err6 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs30 === errors;
                                valid7 = valid7 || _valid2;
                                const _errs32 = errors;
                                if (data8 !== null) {
                                  const err7 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs32 === errors;
                                valid7 = valid7 || _valid2;
                                if (!valid7) {
                                  const err8 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                  validate26.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs29;
                                  if (vErrors !== null) {
                                    if (_errs29) {
                                      vErrors.length = _errs29;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid2 = _errs28 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate26.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.host !== void 0) {
              const _errs34 = errors;
              if (typeof data.host !== "string") {
                validate26.errors = [{ instancePath: instancePath + "/host", schemaPath: "#/properties/host/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs34 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.input_values !== void 0) {
                let data10 = data.input_values;
                const _errs36 = errors;
                if (errors === _errs36) {
                  if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                    if (Object.keys(data10).length > 60) {
                      validate26.errors = [{ instancePath: instancePath + "/input_values", schemaPath: "#/properties/input_values/maxProperties", keyword: "maxProperties", params: { limit: 60 }, message: "must NOT have more than 60 properties" }];
                      return false;
                    } else {
                      for (const key2 in data10) {
                        const _errs39 = errors;
                        var valid8 = _errs39 === errors;
                        if (!valid8) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate26.errors = [{ instancePath: instancePath + "/input_values", schemaPath: "#/properties/input_values/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                    return false;
                  }
                }
                var valid0 = _errs36 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.kind !== void 0) {
                  let data12 = data.kind;
                  const _errs40 = errors;
                  if (typeof data12 !== "string") {
                    validate26.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if ("thread_started" !== data12) {
                    validate26.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "thread_started" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs40 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.project_id !== void 0) {
                    const _errs42 = errors;
                    if (typeof data.project_id !== "string") {
                      validate26.errors = [{ instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs42 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.settings !== void 0) {
                      const _errs44 = errors;
                      if (!validate27(data.settings, { instancePath: instancePath + "/settings", parentData: data, parentDataProperty: "settings", rootData, dynamicAnchors })) {
                        vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs44 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.title !== void 0) {
                        let data15 = data.title;
                        const _errs45 = errors;
                        if (errors === _errs45) {
                          if (typeof data15 === "string") {
                            if (func2(data15) > 200) {
                              validate26.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                              return false;
                            } else {
                              if (func2(data15) < 1) {
                                validate26.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                return false;
                              }
                            }
                          } else {
                            validate26.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                        }
                        var valid0 = _errs45 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.workflow !== void 0) {
                          let data16 = data.workflow;
                          const _errs47 = errors;
                          const _errs48 = errors;
                          let valid10 = false;
                          const _errs49 = errors;
                          if (typeof data16 !== "string") {
                            const err9 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                          }
                          var _valid3 = _errs49 === errors;
                          valid10 = valid10 || _valid3;
                          const _errs51 = errors;
                          if (data16 !== null) {
                            const err10 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err10];
                            } else {
                              vErrors.push(err10);
                            }
                            errors++;
                          }
                          var _valid3 = _errs51 === errors;
                          valid10 = valid10 || _valid3;
                          if (!valid10) {
                            const err11 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err11];
                            } else {
                              vErrors.push(err11);
                            }
                            errors++;
                            validate26.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs48;
                            if (vErrors !== null) {
                              if (_errs48) {
                                vErrors.length = _errs48;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs47 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate26.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate26.errors = vErrors;
  return errors === 0;
}
validate26.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema51 = { "additionalProperties": false, "description": "Always the first own entry of a fork; it continues numbering after `parent`.", "properties": { "bindings": { "$ref": "#/$defs/ThreadBindings" }, "by": { "title": "By", "type": "string" }, "continue_with_step": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "type": "string" }, { "type": "null" }], "description": "The step that becomes due: with `retained_steps`, the first one not kept; in older\nlogs, the step to go on with on another Workflow version.", "title": "Continue With Step" }, "correction_base": { "anyOf": [{ "$ref": "#/$defs/CorrectionBase" }, { "type": "null" }], "default": null, "description": "Explicit review base; absent in ordinary forks and older logs." }, "kept_input_changes": { "default": [], "description": "Kept steps that read an item which has another version at the fork's content\nversion, found once at the fork; absent when there are none, and in older logs.", "items": { "$ref": "#/$defs/KeptInputChange" }, "title": "Kept Input Changes", "type": "array" }, "kind": { "const": "fork_origin", "title": "Kind", "type": "string" }, "offer_entry": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "description": "The `fork_offered` entry this fork accepts, if any.", "title": "Offer Entry" }, "parent": { "title": "Parent", "type": "string" }, "project_id": { "title": "Project Id", "type": "string" }, "retained_steps": { "anyOf": [{ "items": { "$ref": "#/$defs/RetainedStep" }, "type": "array" }, { "type": "null" }], "default": null, "description": "The fork's continuation (`threads.fork_continuation`): the steps it keeps, in order;\nthe others start not due. Absent when the fork keeps the progress at the fork point as\nit is (same Workflow, same material, no step named), and in older logs.", "title": "Retained Steps" }, "settings": { "$ref": "#/$defs/ThreadSettings" }, "title": { "maxLength": 200, "minLength": 1, "title": "Title", "type": "string" }, "workflow": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Workflow" } }, "required": ["kind", "project_id", "title", "parent", "by", "bindings", "workflow", "settings", "continue_with_step", "offer_entry"], "title": "ForkOriginPayload", "type": "object" };
var schema59 = { "additionalProperties": false, "description": "A step a fork keeps as it was at the fork point (T-10, D6).", "properties": { "state": { "enum": ["done", "skipped"], "title": "State", "type": "string" }, "step_key": { "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "title": "Step Key", "type": "string" } }, "required": ["step_key", "state"], "title": "RetainedStep", "type": "object" };
var schema56 = { "description": "What a statement of instance data claims about its passage (R6, WI-9.4: extraction is\nnot interpretation). Module B's instance-data check refuses an interpretive statement\nbefore acceptance.", "enum": ["explicit", "interpretive", "unresolved"], "title": "ClaimKind", "type": "string" };
function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate33.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.triples === void 0 && (missing0 = "triples") || data.evidence === void 0 && (missing0 = "evidence") || data.note === void 0 && (missing0 = "note")) {
        validate33.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "claim" || key0 === "evidence" || key0 === "note" || key0 === "triples")) {
            validate33.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.claim !== void 0) {
            let data0 = data.claim;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate33.errors = [{ instancePath: instancePath + "/claim", schemaPath: "#/$defs/ClaimKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "explicit" || data0 === "interpretive" || data0 === "unresolved")) {
              validate33.errors = [{ instancePath: instancePath + "/claim", schemaPath: "#/$defs/ClaimKind/enum", keyword: "enum", params: { allowedValues: schema56.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.evidence !== void 0) {
              let data1 = data.evidence;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data1)) {
                  if (data1.length < 1) {
                    validate33.errors = [{ instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items" }];
                    return false;
                  } else {
                    var valid2 = true;
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data2 = data1[i0];
                      const _errs7 = errors;
                      const _errs8 = errors;
                      if (errors === _errs8) {
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                          let missing1;
                          if (data2.segment === void 0 && (missing1 = "segment") || data2.start === void 0 && (missing1 = "start") || data2.end === void 0 && (missing1 = "end") || data2.quote === void 0 && (missing1 = "quote")) {
                            validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0, schemaPath: "#/$defs/InstanceEvidence/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                            return false;
                          } else {
                            const _errs10 = errors;
                            for (const key1 in data2) {
                              if (!(key1 === "end" || key1 === "quote" || key1 === "segment" || key1 === "start")) {
                                validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0, schemaPath: "#/$defs/InstanceEvidence/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                                return false;
                                break;
                              }
                            }
                            if (_errs10 === errors) {
                              if (data2.end !== void 0) {
                                let data3 = data2.end;
                                const _errs11 = errors;
                                if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                                  validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/end", schemaPath: "#/$defs/InstanceEvidence/properties/end/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                  return false;
                                }
                                if (errors === _errs11) {
                                  if (typeof data3 == "number") {
                                    if (data3 < 1 || isNaN(data3)) {
                                      validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/end", schemaPath: "#/$defs/InstanceEvidence/properties/end/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                      return false;
                                    }
                                  }
                                }
                                var valid4 = _errs11 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data2.quote !== void 0) {
                                  let data4 = data2.quote;
                                  const _errs13 = errors;
                                  if (errors === _errs13) {
                                    if (typeof data4 === "string") {
                                      if (func2(data4) > 2e3) {
                                        validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/quote", schemaPath: "#/$defs/InstanceEvidence/properties/quote/maxLength", keyword: "maxLength", params: { limit: 2e3 }, message: "must NOT have more than 2000 characters" }];
                                        return false;
                                      } else {
                                        if (func2(data4) < 1) {
                                          validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/quote", schemaPath: "#/$defs/InstanceEvidence/properties/quote/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                          return false;
                                        }
                                      }
                                    } else {
                                      validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/quote", schemaPath: "#/$defs/InstanceEvidence/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                  }
                                  var valid4 = _errs13 === errors;
                                } else {
                                  var valid4 = true;
                                }
                                if (valid4) {
                                  if (data2.segment !== void 0) {
                                    const _errs15 = errors;
                                    if (typeof data2.segment !== "string") {
                                      validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/segment", schemaPath: "#/$defs/InstanceEvidence/properties/segment/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid4 = _errs15 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                  if (valid4) {
                                    if (data2.start !== void 0) {
                                      let data6 = data2.start;
                                      const _errs17 = errors;
                                      if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                                        validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/start", schemaPath: "#/$defs/InstanceEvidence/properties/start/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                        return false;
                                      }
                                      if (errors === _errs17) {
                                        if (typeof data6 == "number") {
                                          if (data6 < 0 || isNaN(data6)) {
                                            validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0 + "/start", schemaPath: "#/$defs/InstanceEvidence/properties/start/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" }];
                                            return false;
                                          }
                                        }
                                      }
                                      var valid4 = _errs17 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate33.errors = [{ instancePath: instancePath + "/evidence/" + i0, schemaPath: "#/$defs/InstanceEvidence/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                          return false;
                        }
                      }
                      var valid2 = _errs7 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  }
                } else {
                  validate33.errors = [{ instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.note !== void 0) {
                let data7 = data.note;
                const _errs19 = errors;
                if (errors === _errs19) {
                  if (typeof data7 === "string") {
                    if (func2(data7) > 2e3) {
                      validate33.errors = [{ instancePath: instancePath + "/note", schemaPath: "#/properties/note/maxLength", keyword: "maxLength", params: { limit: 2e3 }, message: "must NOT have more than 2000 characters" }];
                      return false;
                    }
                  } else {
                    validate33.errors = [{ instancePath: instancePath + "/note", schemaPath: "#/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
                var valid0 = _errs19 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.triples !== void 0) {
                  let data8 = data.triples;
                  const _errs21 = errors;
                  if (errors === _errs21) {
                    if (Array.isArray(data8)) {
                      if (data8.length < 1) {
                        validate33.errors = [{ instancePath: instancePath + "/triples", schemaPath: "#/properties/triples/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items" }];
                        return false;
                      } else {
                        var valid5 = true;
                        const len1 = data8.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          const _errs23 = errors;
                          if (typeof data8[i1] !== "string") {
                            validate33.errors = [{ instancePath: instancePath + "/triples/" + i1, schemaPath: "#/properties/triples/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          var valid5 = _errs23 === errors;
                          if (!valid5) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate33.errors = [{ instancePath: instancePath + "/triples", schemaPath: "#/properties/triples/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs21 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate33.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate33.errors = vErrors;
  return errors === 0;
}
validate33.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate32.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.output_kind === void 0 && (missing0 = "output_kind") || data.document === void 0 && (missing0 = "document") || data.model === void 0 && (missing0 = "model") || data.statements === void 0 && (missing0 = "statements")) {
        validate32.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "document" || key0 === "documents" || key0 === "model" || key0 === "output_kind" || key0 === "statements")) {
            validate32.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.document !== void 0) {
            const _errs2 = errors;
            if (typeof data.document !== "string") {
              validate32.errors = [{ instancePath: instancePath + "/document", schemaPath: "#/properties/document/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.documents !== void 0) {
              let data1 = data.documents;
              const _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  const len0 = data1.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs6 = errors;
                    if (typeof data1[i0] !== "string") {
                      validate32.errors = [{ instancePath: instancePath + "/documents/" + i0, schemaPath: "#/properties/documents/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate32.errors = [{ instancePath: instancePath + "/documents", schemaPath: "#/properties/documents/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.model !== void 0) {
                const _errs8 = errors;
                if (typeof data.model !== "string") {
                  validate32.errors = [{ instancePath: instancePath + "/model", schemaPath: "#/properties/model/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.output_kind !== void 0) {
                  let data4 = data.output_kind;
                  const _errs10 = errors;
                  if (typeof data4 !== "string") {
                    validate32.errors = [{ instancePath: instancePath + "/output_kind", schemaPath: "#/properties/output_kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if ("instance_data" !== data4) {
                    validate32.errors = [{ instancePath: instancePath + "/output_kind", schemaPath: "#/properties/output_kind/const", keyword: "const", params: { allowedValue: "instance_data" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.statements !== void 0) {
                    let data5 = data.statements;
                    const _errs12 = errors;
                    if (errors === _errs12) {
                      if (Array.isArray(data5)) {
                        var valid2 = true;
                        const len1 = data5.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          const _errs14 = errors;
                          if (!validate33(data5[i1], { instancePath: instancePath + "/statements/" + i1, parentData: data5, parentDataProperty: i1, rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate33.errors : vErrors.concat(validate33.errors);
                            errors = vErrors.length;
                          }
                          var valid2 = _errs14 === errors;
                          if (!valid2) {
                            break;
                          }
                        }
                      } else {
                        validate32.errors = [{ instancePath: instancePath + "/statements", schemaPath: "#/properties/statements/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate32.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
validate32.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate31.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.result_ref === void 0 && (missing0 = "result_ref") || data.output === void 0 && (missing0 = "output")) {
        validate31.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "output" || key0 === "result_ref")) {
            validate31.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.output !== void 0) {
            const _errs2 = errors;
            if (!validate32(data.output, { instancePath: instancePath + "/output", parentData: data, parentDataProperty: "output", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.result_ref !== void 0) {
              const _errs3 = errors;
              if (typeof data.result_ref !== "string") {
                validate31.errors = [{ instancePath: instancePath + "/result_ref", schemaPath: "#/properties/result_ref/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate31.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
validate31.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate30.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.project_id === void 0 && (missing0 = "project_id") || data.title === void 0 && (missing0 = "title") || data.parent === void 0 && (missing0 = "parent") || data.by === void 0 && (missing0 = "by") || data.bindings === void 0 && (missing0 = "bindings") || data.workflow === void 0 && (missing0 = "workflow") || data.settings === void 0 && (missing0 = "settings") || data.continue_with_step === void 0 && (missing0 = "continue_with_step") || data.offer_entry === void 0 && (missing0 = "offer_entry")) {
        validate30.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema51.properties, key0)) {
            validate30.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.bindings !== void 0) {
            let data0 = data.bindings;
            const _errs2 = errors;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                let missing1;
                if (data0.content_version === void 0 && (missing1 = "content_version") || data0.corpus_version === void 0 && (missing1 = "corpus_version") || data0.subject === void 0 && (missing1 = "subject")) {
                  validate30.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                  return false;
                } else {
                  const _errs5 = errors;
                  for (const key1 in data0) {
                    if (!(key1 === "content_version" || key1 === "context_outputs" || key1 === "corpus_version" || key1 === "selection" || key1 === "source_version" || key1 === "subject")) {
                      validate30.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                      return false;
                      break;
                    }
                  }
                  if (_errs5 === errors) {
                    if (data0.content_version !== void 0) {
                      const _errs6 = errors;
                      if (typeof data0.content_version !== "string") {
                        validate30.errors = [{ instancePath: instancePath + "/bindings/content_version", schemaPath: "#/$defs/ThreadBindings/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid2 = _errs6 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data0.context_outputs !== void 0) {
                        let data2 = data0.context_outputs;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                          if (Array.isArray(data2)) {
                            var valid3 = true;
                            const len0 = data2.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs10 = errors;
                              if (typeof data2[i0] !== "string") {
                                validate30.errors = [{ instancePath: instancePath + "/bindings/context_outputs/" + i0, schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                              if (!valid3) {
                                break;
                              }
                            }
                          } else {
                            validate30.errors = [{ instancePath: instancePath + "/bindings/context_outputs", schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid2 = _errs8 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data0.corpus_version !== void 0) {
                          let data4 = data0.corpus_version;
                          const _errs12 = errors;
                          const _errs13 = errors;
                          let valid4 = false;
                          const _errs14 = errors;
                          if (typeof data4 !== "string") {
                            const err0 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err0];
                            } else {
                              vErrors.push(err0);
                            }
                            errors++;
                          }
                          var _valid0 = _errs14 === errors;
                          valid4 = valid4 || _valid0;
                          const _errs16 = errors;
                          if (data4 !== null) {
                            const err1 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          var _valid0 = _errs16 === errors;
                          valid4 = valid4 || _valid0;
                          if (!valid4) {
                            const err2 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                            validate30.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs13;
                            if (vErrors !== null) {
                              if (_errs13) {
                                vErrors.length = _errs13;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid2 = _errs12 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data0.selection !== void 0) {
                            let data5 = data0.selection;
                            const _errs18 = errors;
                            if (errors === _errs18) {
                              if (Array.isArray(data5)) {
                                if (data5.length > 200) {
                                  validate30.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" }];
                                  return false;
                                } else {
                                  var valid5 = true;
                                  const len1 = data5.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs20 = errors;
                                    if (typeof data5[i1] !== "string") {
                                      validate30.errors = [{ instancePath: instancePath + "/bindings/selection/" + i1, schemaPath: "#/$defs/ThreadBindings/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid5 = _errs20 === errors;
                                    if (!valid5) {
                                      break;
                                    }
                                  }
                                }
                              } else {
                                validate30.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                return false;
                              }
                            }
                            var valid2 = _errs18 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data0.source_version !== void 0) {
                              let data7 = data0.source_version;
                              const _errs22 = errors;
                              const _errs23 = errors;
                              let valid6 = false;
                              const _errs24 = errors;
                              if (typeof data7 !== "string") {
                                const err3 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                              }
                              var _valid1 = _errs24 === errors;
                              valid6 = valid6 || _valid1;
                              const _errs26 = errors;
                              if (data7 !== null) {
                                const err4 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err4];
                                } else {
                                  vErrors.push(err4);
                                }
                                errors++;
                              }
                              var _valid1 = _errs26 === errors;
                              valid6 = valid6 || _valid1;
                              if (!valid6) {
                                const err5 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err5];
                                } else {
                                  vErrors.push(err5);
                                }
                                errors++;
                                validate30.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs23;
                                if (vErrors !== null) {
                                  if (_errs23) {
                                    vErrors.length = _errs23;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid2 = _errs22 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data0.subject !== void 0) {
                                let data8 = data0.subject;
                                const _errs28 = errors;
                                const _errs29 = errors;
                                let valid7 = false;
                                const _errs30 = errors;
                                if (typeof data8 !== "string") {
                                  const err6 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs30 === errors;
                                valid7 = valid7 || _valid2;
                                const _errs32 = errors;
                                if (data8 !== null) {
                                  const err7 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs32 === errors;
                                valid7 = valid7 || _valid2;
                                if (!valid7) {
                                  const err8 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                  validate30.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs29;
                                  if (vErrors !== null) {
                                    if (_errs29) {
                                      vErrors.length = _errs29;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid2 = _errs28 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate30.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.by !== void 0) {
              const _errs34 = errors;
              if (typeof data.by !== "string") {
                validate30.errors = [{ instancePath: instancePath + "/by", schemaPath: "#/properties/by/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs34 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.continue_with_step !== void 0) {
                let data10 = data.continue_with_step;
                const _errs36 = errors;
                const _errs37 = errors;
                let valid8 = false;
                const _errs38 = errors;
                if (errors === _errs38) {
                  if (typeof data10 === "string") {
                    if (!pattern14.test(data10)) {
                      const err9 = { instancePath: instancePath + "/continue_with_step", schemaPath: "#/properties/continue_with_step/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                      if (vErrors === null) {
                        vErrors = [err9];
                      } else {
                        vErrors.push(err9);
                      }
                      errors++;
                    }
                  } else {
                    const err10 = { instancePath: instancePath + "/continue_with_step", schemaPath: "#/properties/continue_with_step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err10];
                    } else {
                      vErrors.push(err10);
                    }
                    errors++;
                  }
                }
                var _valid3 = _errs38 === errors;
                valid8 = valid8 || _valid3;
                const _errs40 = errors;
                if (data10 !== null) {
                  const err11 = { instancePath: instancePath + "/continue_with_step", schemaPath: "#/properties/continue_with_step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var _valid3 = _errs40 === errors;
                valid8 = valid8 || _valid3;
                if (!valid8) {
                  const err12 = { instancePath: instancePath + "/continue_with_step", schemaPath: "#/properties/continue_with_step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                  validate30.errors = vErrors;
                  return false;
                } else {
                  errors = _errs37;
                  if (vErrors !== null) {
                    if (_errs37) {
                      vErrors.length = _errs37;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs36 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.correction_base !== void 0) {
                  let data11 = data.correction_base;
                  const _errs42 = errors;
                  const _errs43 = errors;
                  let valid9 = false;
                  const _errs44 = errors;
                  if (!validate31(data11, { instancePath: instancePath + "/correction_base", parentData: data, parentDataProperty: "correction_base", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
                    errors = vErrors.length;
                  }
                  var _valid4 = _errs44 === errors;
                  valid9 = valid9 || _valid4;
                  const _errs45 = errors;
                  if (data11 !== null) {
                    const err13 = { instancePath: instancePath + "/correction_base", schemaPath: "#/properties/correction_base/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                  var _valid4 = _errs45 === errors;
                  valid9 = valid9 || _valid4;
                  if (!valid9) {
                    const err14 = { instancePath: instancePath + "/correction_base", schemaPath: "#/properties/correction_base/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                    validate30.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs43;
                    if (vErrors !== null) {
                      if (_errs43) {
                        vErrors.length = _errs43;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs42 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.kept_input_changes !== void 0) {
                    let data12 = data.kept_input_changes;
                    const _errs47 = errors;
                    if (errors === _errs47) {
                      if (Array.isArray(data12)) {
                        var valid10 = true;
                        const len2 = data12.length;
                        for (let i2 = 0; i2 < len2; i2++) {
                          let data13 = data12[i2];
                          const _errs49 = errors;
                          const _errs50 = errors;
                          if (errors === _errs50) {
                            if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                              let missing2;
                              if (data13.step_key === void 0 && (missing2 = "step_key") || data13.input === void 0 && (missing2 = "input") || data13.read === void 0 && (missing2 = "read") || data13.now === void 0 && (missing2 = "now")) {
                                validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2, schemaPath: "#/$defs/KeptInputChange/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" }];
                                return false;
                              } else {
                                const _errs52 = errors;
                                for (const key2 in data13) {
                                  if (!(key2 === "input" || key2 === "now" || key2 === "read" || key2 === "step_key")) {
                                    validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2, schemaPath: "#/$defs/KeptInputChange/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" }];
                                    return false;
                                    break;
                                  }
                                }
                                if (_errs52 === errors) {
                                  if (data13.input !== void 0) {
                                    let data14 = data13.input;
                                    const _errs53 = errors;
                                    if (errors === _errs53) {
                                      if (typeof data14 === "string") {
                                        if (!pattern8.test(data14)) {
                                          validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2 + "/input", schemaPath: "#/$defs/KeptInputChange/properties/input/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                          return false;
                                        }
                                      } else {
                                        validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2 + "/input", schemaPath: "#/$defs/KeptInputChange/properties/input/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                    }
                                    var valid12 = _errs53 === errors;
                                  } else {
                                    var valid12 = true;
                                  }
                                  if (valid12) {
                                    if (data13.now !== void 0) {
                                      const _errs55 = errors;
                                      if (typeof data13.now !== "string") {
                                        validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2 + "/now", schemaPath: "#/$defs/KeptInputChange/properties/now/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      var valid12 = _errs55 === errors;
                                    } else {
                                      var valid12 = true;
                                    }
                                    if (valid12) {
                                      if (data13.read !== void 0) {
                                        const _errs57 = errors;
                                        if (typeof data13.read !== "string") {
                                          validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2 + "/read", schemaPath: "#/$defs/KeptInputChange/properties/read/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                        var valid12 = _errs57 === errors;
                                      } else {
                                        var valid12 = true;
                                      }
                                      if (valid12) {
                                        if (data13.step_key !== void 0) {
                                          let data17 = data13.step_key;
                                          const _errs59 = errors;
                                          if (errors === _errs59) {
                                            if (typeof data17 === "string") {
                                              if (!pattern14.test(data17)) {
                                                validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2 + "/step_key", schemaPath: "#/$defs/KeptInputChange/properties/step_key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' }];
                                                return false;
                                              }
                                            } else {
                                              validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2 + "/step_key", schemaPath: "#/$defs/KeptInputChange/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                          }
                                          var valid12 = _errs59 === errors;
                                        } else {
                                          var valid12 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate30.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i2, schemaPath: "#/$defs/KeptInputChange/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                              return false;
                            }
                          }
                          var valid10 = _errs49 === errors;
                          if (!valid10) {
                            break;
                          }
                        }
                      } else {
                        validate30.errors = [{ instancePath: instancePath + "/kept_input_changes", schemaPath: "#/properties/kept_input_changes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs47 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.kind !== void 0) {
                      let data18 = data.kind;
                      const _errs61 = errors;
                      if (typeof data18 !== "string") {
                        validate30.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      if ("fork_origin" !== data18) {
                        validate30.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "fork_origin" }, message: "must be equal to constant" }];
                        return false;
                      }
                      var valid0 = _errs61 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.offer_entry !== void 0) {
                        let data19 = data.offer_entry;
                        const _errs63 = errors;
                        const _errs64 = errors;
                        let valid13 = false;
                        const _errs65 = errors;
                        if (!(typeof data19 == "number" && (!(data19 % 1) && !isNaN(data19)))) {
                          const err15 = { instancePath: instancePath + "/offer_entry", schemaPath: "#/properties/offer_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                          if (vErrors === null) {
                            vErrors = [err15];
                          } else {
                            vErrors.push(err15);
                          }
                          errors++;
                        }
                        if (errors === _errs65) {
                          if (typeof data19 == "number") {
                            if (data19 < 1 || isNaN(data19)) {
                              const err16 = { instancePath: instancePath + "/offer_entry", schemaPath: "#/properties/offer_entry/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                            }
                          }
                        }
                        var _valid5 = _errs65 === errors;
                        valid13 = valid13 || _valid5;
                        const _errs67 = errors;
                        if (data19 !== null) {
                          const err17 = { instancePath: instancePath + "/offer_entry", schemaPath: "#/properties/offer_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err17];
                          } else {
                            vErrors.push(err17);
                          }
                          errors++;
                        }
                        var _valid5 = _errs67 === errors;
                        valid13 = valid13 || _valid5;
                        if (!valid13) {
                          const err18 = { instancePath: instancePath + "/offer_entry", schemaPath: "#/properties/offer_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err18];
                          } else {
                            vErrors.push(err18);
                          }
                          errors++;
                          validate30.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs64;
                          if (vErrors !== null) {
                            if (_errs64) {
                              vErrors.length = _errs64;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs63 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.parent !== void 0) {
                          const _errs69 = errors;
                          if (typeof data.parent !== "string") {
                            validate30.errors = [{ instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          var valid0 = _errs69 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.project_id !== void 0) {
                            const _errs71 = errors;
                            if (typeof data.project_id !== "string") {
                              validate30.errors = [{ instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            var valid0 = _errs71 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.retained_steps !== void 0) {
                              let data22 = data.retained_steps;
                              const _errs73 = errors;
                              const _errs74 = errors;
                              let valid14 = false;
                              const _errs75 = errors;
                              if (errors === _errs75) {
                                if (Array.isArray(data22)) {
                                  var valid15 = true;
                                  const len3 = data22.length;
                                  for (let i3 = 0; i3 < len3; i3++) {
                                    let data23 = data22[i3];
                                    const _errs77 = errors;
                                    const _errs78 = errors;
                                    if (errors === _errs78) {
                                      if (data23 && typeof data23 == "object" && !Array.isArray(data23)) {
                                        let missing3;
                                        if (data23.step_key === void 0 && (missing3 = "step_key") || data23.state === void 0 && (missing3 = "state")) {
                                          const err19 = { instancePath: instancePath + "/retained_steps/" + i3, schemaPath: "#/$defs/RetainedStep/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" };
                                          if (vErrors === null) {
                                            vErrors = [err19];
                                          } else {
                                            vErrors.push(err19);
                                          }
                                          errors++;
                                        } else {
                                          const _errs80 = errors;
                                          for (const key3 in data23) {
                                            if (!(key3 === "state" || key3 === "step_key")) {
                                              const err20 = { instancePath: instancePath + "/retained_steps/" + i3, schemaPath: "#/$defs/RetainedStep/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                              if (vErrors === null) {
                                                vErrors = [err20];
                                              } else {
                                                vErrors.push(err20);
                                              }
                                              errors++;
                                              break;
                                            }
                                          }
                                          if (_errs80 === errors) {
                                            if (data23.state !== void 0) {
                                              let data24 = data23.state;
                                              const _errs81 = errors;
                                              if (typeof data24 !== "string") {
                                                const err21 = { instancePath: instancePath + "/retained_steps/" + i3 + "/state", schemaPath: "#/$defs/RetainedStep/properties/state/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err21];
                                                } else {
                                                  vErrors.push(err21);
                                                }
                                                errors++;
                                              }
                                              if (!(data24 === "done" || data24 === "skipped")) {
                                                const err22 = { instancePath: instancePath + "/retained_steps/" + i3 + "/state", schemaPath: "#/$defs/RetainedStep/properties/state/enum", keyword: "enum", params: { allowedValues: schema59.properties.state.enum }, message: "must be equal to one of the allowed values" };
                                                if (vErrors === null) {
                                                  vErrors = [err22];
                                                } else {
                                                  vErrors.push(err22);
                                                }
                                                errors++;
                                              }
                                              var valid17 = _errs81 === errors;
                                            } else {
                                              var valid17 = true;
                                            }
                                            if (valid17) {
                                              if (data23.step_key !== void 0) {
                                                let data25 = data23.step_key;
                                                const _errs83 = errors;
                                                if (errors === _errs83) {
                                                  if (typeof data25 === "string") {
                                                    if (!pattern14.test(data25)) {
                                                      const err23 = { instancePath: instancePath + "/retained_steps/" + i3 + "/step_key", schemaPath: "#/$defs/RetainedStep/properties/step_key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                                                      if (vErrors === null) {
                                                        vErrors = [err23];
                                                      } else {
                                                        vErrors.push(err23);
                                                      }
                                                      errors++;
                                                    }
                                                  } else {
                                                    const err24 = { instancePath: instancePath + "/retained_steps/" + i3 + "/step_key", schemaPath: "#/$defs/RetainedStep/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err24];
                                                    } else {
                                                      vErrors.push(err24);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var valid17 = _errs83 === errors;
                                              } else {
                                                var valid17 = true;
                                              }
                                            }
                                          }
                                        }
                                      } else {
                                        const err25 = { instancePath: instancePath + "/retained_steps/" + i3, schemaPath: "#/$defs/RetainedStep/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                        if (vErrors === null) {
                                          vErrors = [err25];
                                        } else {
                                          vErrors.push(err25);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid15 = _errs77 === errors;
                                    if (!valid15) {
                                      break;
                                    }
                                  }
                                } else {
                                  const err26 = { instancePath: instancePath + "/retained_steps", schemaPath: "#/properties/retained_steps/anyOf/0/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                  if (vErrors === null) {
                                    vErrors = [err26];
                                  } else {
                                    vErrors.push(err26);
                                  }
                                  errors++;
                                }
                              }
                              var _valid6 = _errs75 === errors;
                              valid14 = valid14 || _valid6;
                              const _errs85 = errors;
                              if (data22 !== null) {
                                const err27 = { instancePath: instancePath + "/retained_steps", schemaPath: "#/properties/retained_steps/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err27];
                                } else {
                                  vErrors.push(err27);
                                }
                                errors++;
                              }
                              var _valid6 = _errs85 === errors;
                              valid14 = valid14 || _valid6;
                              if (!valid14) {
                                const err28 = { instancePath: instancePath + "/retained_steps", schemaPath: "#/properties/retained_steps/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err28];
                                } else {
                                  vErrors.push(err28);
                                }
                                errors++;
                                validate30.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs74;
                                if (vErrors !== null) {
                                  if (_errs74) {
                                    vErrors.length = _errs74;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs73 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.settings !== void 0) {
                                const _errs87 = errors;
                                if (!validate27(data.settings, { instancePath: instancePath + "/settings", parentData: data, parentDataProperty: "settings", rootData, dynamicAnchors })) {
                                  vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                  errors = vErrors.length;
                                }
                                var valid0 = _errs87 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.title !== void 0) {
                                  let data27 = data.title;
                                  const _errs88 = errors;
                                  if (errors === _errs88) {
                                    if (typeof data27 === "string") {
                                      if (func2(data27) > 200) {
                                        validate30.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                        return false;
                                      } else {
                                        if (func2(data27) < 1) {
                                          validate30.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                          return false;
                                        }
                                      }
                                    } else {
                                      validate30.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs88 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.workflow !== void 0) {
                                    let data28 = data.workflow;
                                    const _errs90 = errors;
                                    const _errs91 = errors;
                                    let valid18 = false;
                                    const _errs92 = errors;
                                    if (typeof data28 !== "string") {
                                      const err29 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err29];
                                      } else {
                                        vErrors.push(err29);
                                      }
                                      errors++;
                                    }
                                    var _valid7 = _errs92 === errors;
                                    valid18 = valid18 || _valid7;
                                    const _errs94 = errors;
                                    if (data28 !== null) {
                                      const err30 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                      if (vErrors === null) {
                                        vErrors = [err30];
                                      } else {
                                        vErrors.push(err30);
                                      }
                                      errors++;
                                    }
                                    var _valid7 = _errs94 === errors;
                                    valid18 = valid18 || _valid7;
                                    if (!valid18) {
                                      const err31 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err31];
                                      } else {
                                        vErrors.push(err31);
                                      }
                                      errors++;
                                      validate30.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs91;
                                      if (vErrors !== null) {
                                        if (_errs91) {
                                          vErrors.length = _errs91;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid0 = _errs90 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate30.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
validate30.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate40(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate40.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.entry === void 0 && (missing0 = "entry")) {
        const err0 = { instancePath, schemaPath: "#/$defs/EntryMention/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs4 = errors;
        for (const key0 in data) {
          if (!(key0 === "entry" || key0 === "kind")) {
            const err1 = { instancePath, schemaPath: "#/$defs/EntryMention/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs4 === errors) {
          if (data.entry !== void 0) {
            const _errs5 = errors;
            if (typeof data.entry !== "string") {
              const err2 = { instancePath: instancePath + "/entry", schemaPath: "#/$defs/EntryMention/properties/entry/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs5 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.kind !== void 0) {
              let data1 = data.kind;
              const _errs7 = errors;
              if (typeof data1 !== "string") {
                const err3 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/EntryMention/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              if ("entry" !== data1) {
                const err4 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/EntryMention/properties/kind/const", keyword: "const", params: { allowedValue: "entry" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
          }
        }
      }
    } else {
      const err5 = { instancePath, schemaPath: "#/$defs/EntryMention/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs9 = errors;
  const _errs10 = errors;
  if (errors === _errs10) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing1;
      if (data.kind === void 0 && (missing1 = "kind") || data.tool === void 0 && (missing1 = "tool")) {
        const err6 = { instancePath, schemaPath: "#/$defs/ToolMention/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      } else {
        const _errs12 = errors;
        for (const key1 in data) {
          if (!(key1 === "kind" || key1 === "tool")) {
            const err7 = { instancePath, schemaPath: "#/$defs/ToolMention/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
            break;
          }
        }
        if (_errs12 === errors) {
          if (data.kind !== void 0) {
            let data2 = data.kind;
            const _errs13 = errors;
            if (typeof data2 !== "string") {
              const err8 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ToolMention/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if ("tool" !== data2) {
              const err9 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ToolMention/properties/kind/const", keyword: "const", params: { allowedValue: "tool" }, message: "must be equal to constant" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            var valid4 = _errs13 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.tool !== void 0) {
              const _errs15 = errors;
              if (typeof data.tool !== "string") {
                const err10 = { instancePath: instancePath + "/tool", schemaPath: "#/$defs/ToolMention/properties/tool/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              var valid4 = _errs15 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      }
    } else {
      const err11 = { instancePath, schemaPath: "#/$defs/ToolMention/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
  }
  var _valid0 = _errs9 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
  }
  if (!valid0) {
    const err12 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
    validate40.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate40.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate40.evaluated = { "dynamicProps": true, "dynamicItems": false };
function validate39(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate39.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.text === void 0 && (missing0 = "text") || data.mentions === void 0 && (missing0 = "mentions")) {
        validate39.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "addresses_agent" || key0 === "kind" || key0 === "mentions" || key0 === "text")) {
            validate39.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.addresses_agent !== void 0) {
            let data0 = data.addresses_agent;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "boolean") {
              const err0 = { instancePath: instancePath + "/addresses_agent", schemaPath: "#/properties/addresses_agent/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/addresses_agent", schemaPath: "#/properties/addresses_agent/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/addresses_agent", schemaPath: "#/properties/addresses_agent/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate39.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.kind !== void 0) {
              let data1 = data.kind;
              const _errs8 = errors;
              if (typeof data1 !== "string") {
                validate39.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if ("message" !== data1) {
                validate39.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "message" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.mentions !== void 0) {
                let data2 = data.mentions;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (Array.isArray(data2)) {
                    if (data2.length > 50) {
                      validate39.errors = [{ instancePath: instancePath + "/mentions", schemaPath: "#/properties/mentions/maxItems", keyword: "maxItems", params: { limit: 50 }, message: "must NOT have more than 50 items" }];
                      return false;
                    } else {
                      var valid2 = true;
                      const len0 = data2.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        const _errs12 = errors;
                        if (!validate40(data2[i0], { instancePath: instancePath + "/mentions/" + i0, parentData: data2, parentDataProperty: i0, rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate40.errors : vErrors.concat(validate40.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs12 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate39.errors = [{ instancePath: instancePath + "/mentions", schemaPath: "#/properties/mentions/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.text !== void 0) {
                  let data4 = data.text;
                  const _errs13 = errors;
                  if (errors === _errs13) {
                    if (typeof data4 === "string") {
                      if (func2(data4) < 1) {
                        validate39.errors = [{ instancePath: instancePath + "/text", schemaPath: "#/properties/text/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                        return false;
                      }
                    } else {
                      validate39.errors = [{ instancePath: instancePath + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate39.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate39.errors = vErrors;
  return errors === 0;
}
validate39.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema64 = { "additionalProperties": false, "description": "The frozen turn (T-4): the connector receives exactly this input.", "properties": { "agent_setup": { "$ref": "#/$defs/AgentSetupKind", "default": "extend", "description": "`dmw_only` when the turn must not use the host's own agent setup (AP-6)." }, "based_on_entry": { "minimum": 1, "title": "Based On Entry", "type": "integer" }, "capabilities": { "anyOf": [{ "$ref": "#/$defs/TurnCapabilityBasis" }, { "type": "null" }], "default": null, "description": "What the route was matched on (CAP-3); `None` in turns before capability facts." }, "covers": { "description": "Message entries this turn hands over.", "items": { "minimum": 1, "type": "integer" }, "title": "Covers", "type": "array" }, "expected_output": { "$ref": "#/$defs/ExpectedOutput" }, "input": { "items": { "$ref": "#/$defs/InputBlock" }, "title": "Input", "type": "array" }, "input_digest": { "pattern": "^sha256-jcs:[0-9a-f]{64}$", "title": "Input Digest", "type": "string" }, "input_values": { "description": "This run's values for the step's declared inputs (ADR-0032 D7), frozen with the\nturn; each is rendered into the prompt block, so `input_digest` covers it. Absent when\nthere are none, so earlier turns keep their bytes.", "patternProperties": { "^[a-z][a-z0-9_]{0,62}$": { "$ref": "#/$defs/JsonValue" } }, "title": "Input Values", "type": "object" }, "item_tools": { "default": [], "description": "The tool versions the agent may run through `run_tool` in this turn (W2-6): its\nstep's `tools.item_tools`, the tools its skills bundle, and the tools the messages it\nanswers give it. The turn note names them, so `input_digest` covers them. Absent when\nthere are none, so earlier turns keep their bytes.", "items": { "type": "string" }, "title": "Item Tools", "type": "array" }, "kind": { "const": "turn_requested", "title": "Kind", "type": "string" }, "limits": { "$ref": "#/$defs/TurnLimits" }, "next_route": { "anyOf": [{ "oneOf": [{ "$ref": "#/$defs/AgentRoute" }, { "$ref": "#/$defs/ApiKeyRoute" }] }, { "type": "null" }], "default": null, "description": "The allowed route after this one, named if this one's credit runs out (Q-93).", "title": "Next Route" }, "permission_profile": { "pattern": "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$", "title": "Permission Profile", "type": "string" }, "requested_by": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "The participant who asked for it, or `None` for the runner.", "title": "Requested By" }, "route": { "oneOf": [{ "$ref": "#/$defs/AgentRoute" }, { "$ref": "#/$defs/ApiKeyRoute" }], "title": "Route" }, "session": { "$ref": "#/$defs/AgentSessionRequest" }, "skills": { "default": [], "description": "The step's skills, pinned; empty for replies and turns before skills existed.", "items": { "$ref": "#/$defs/TurnSkill" }, "title": "Skills", "type": "array" }, "step": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Step" }, "step_key": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "type": "string" }, { "type": "null" }], "title": "Step Key" }, "supersedes": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "default": null, "description": "A rerun's withdrawal of the waiting human step request after its step: that request\nshowed an older output (RF-03). One entry with the rerun, so neither takes effect\nalone; absent for other requests.", "title": "Supersedes" }, "talk": { "anyOf": [{ "$ref": "#/$defs/TalkUse" }, { "type": "null" }], "default": null, "description": "A person's talk with the agent of a reviewed step (F105): this turn is a run of that\nagent step, in its own session. Absent for every other turn." }, "tools": { "$ref": "#/$defs/TurnTools" }, "turn_id": { "title": "Turn Id", "type": "string" }, "turn_kind": { "$ref": "#/$defs/TurnKind" }, "versions_used": { "$ref": "#/$defs/VersionsUsed" } }, "required": ["kind", "turn_id", "turn_kind", "step_key", "step", "covers", "based_on_entry", "input", "input_digest", "versions_used", "route", "permission_profile", "tools", "session", "limits", "expected_output", "requested_by"], "title": "TurnRequestedPayload", "type": "object" };
var schema85 = { "additionalProperties": false, "description": "A skill the step offers or requests in this turn (processes.md P-9); the MCP\nendpoint's `list_skills` and `read_skill` serve exactly these.", "properties": { "description": { "maxLength": 1024, "minLength": 1, "title": "Description", "type": "string" }, "name": { "maxLength": 64, "minLength": 1, "title": "Name", "type": "string" }, "skill": { "title": "Skill", "type": "string" }, "use": { "enum": ["offered", "requested"], "title": "Use", "type": "string" } }, "required": ["skill", "name", "description", "use"], "title": "TurnSkill", "type": "object" };
var schema96 = { "enum": ["reply", "step"], "title": "TurnKind", "type": "string" };
var schema67 = { "additionalProperties": false, "properties": { "at_least": { "anyOf": [{ "type": "integer" }, { "type": "null" }], "title": "At Least" }, "capability": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "title": "Capability", "type": "string" }, "equals": { "anyOf": [{ "type": "boolean" }, { "type": "integer" }, { "type": "string" }, { "type": "null" }], "title": "Equals" }, "evidence": { "anyOf": [{ "maxLength": 400, "minLength": 1, "type": "string" }, { "type": "null" }], "title": "Evidence" }, "hint": { "anyOf": [{ "$ref": "#/$defs/RequirementHint" }, { "type": "null" }], "default": null, "description": "For an unknown requirement, the estimate an agent reported, if any." }, "matched_key": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}$", "type": "string" }, { "type": "null" }], "description": "The key whose value decided: the capability itself, or an alternative the\nvocabulary names (`skills` met by `tools`).", "title": "Matched Key" }, "observed_at": { "anyOf": [{ "format": "date-time", "type": "string" }, { "type": "null" }], "title": "Observed At" }, "outcome": { "$ref": "#/$defs/RequirementOutcome" }, "override": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "The `capability_overrides` item version that decided, if a project override did.", "title": "Override" }, "source": { "anyOf": [{ "$ref": "#/$defs/CapabilitySource" }, { "type": "null" }] }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "integer" }, { "type": "string" }, { "type": "null" }], "title": "Value" } }, "required": ["capability", "equals", "at_least", "outcome", "matched_key", "value", "source", "observed_at", "evidence", "override"], "title": "RequirementBasis", "type": "object" };
var schema70 = { "enum": ["met", "not_met", "unknown"], "title": "RequirementOutcome", "type": "string" };
var schema69 = { "description": "Where a resolved capability came from, in resolution order (CAP-3).", "enum": ["override_project", "override_installation", "override_host", "reported", "probed", "observed"], "title": "CapabilitySource", "type": "string" };
function validate46(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate46.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.value === void 0 && (missing0 = "value") || data.source === void 0 && (missing0 = "source") || data.observed_at === void 0 && (missing0 = "observed_at") || data.evidence === void 0 && (missing0 = "evidence")) {
        validate46.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "evidence" || key0 === "observed_at" || key0 === "source" || key0 === "value")) {
            validate46.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.evidence !== void 0) {
            let data0 = data.evidence;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (typeof data0 === "string") {
                if (func2(data0) > 400) {
                  validate46.errors = [{ instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/maxLength", keyword: "maxLength", params: { limit: 400 }, message: "must NOT have more than 400 characters" }];
                  return false;
                } else {
                  if (func2(data0) < 1) {
                    validate46.errors = [{ instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                    return false;
                  }
                }
              } else {
                validate46.errors = [{ instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.observed_at !== void 0) {
              let data1 = data.observed_at;
              const _errs4 = errors;
              const _errs5 = errors;
              let valid1 = false;
              const _errs6 = errors;
              if (errors === _errs6) {
                if (errors === _errs6) {
                  if (typeof data1 === "string") {
                    if (!formats0.validate(data1)) {
                      const err0 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                      if (vErrors === null) {
                        vErrors = [err0];
                      } else {
                        vErrors.push(err0);
                      }
                      errors++;
                    }
                  } else {
                    const err1 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1];
                    } else {
                      vErrors.push(err1);
                    }
                    errors++;
                  }
                }
              }
              var _valid0 = _errs6 === errors;
              valid1 = valid1 || _valid0;
              const _errs8 = errors;
              if (data1 !== null) {
                const err2 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var _valid0 = _errs8 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const err3 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
                validate46.errors = vErrors;
                return false;
              } else {
                errors = _errs5;
                if (vErrors !== null) {
                  if (_errs5) {
                    vErrors.length = _errs5;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.source !== void 0) {
                let data2 = data.source;
                const _errs10 = errors;
                if (typeof data2 !== "string") {
                  validate46.errors = [{ instancePath: instancePath + "/source", schemaPath: "#/$defs/CapabilitySource/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data2 === "override_project" || data2 === "override_installation" || data2 === "override_host" || data2 === "reported" || data2 === "probed" || data2 === "observed")) {
                  validate46.errors = [{ instancePath: instancePath + "/source", schemaPath: "#/$defs/CapabilitySource/enum", keyword: "enum", params: { allowedValues: schema69.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.value !== void 0) {
                  let data3 = data.value;
                  const _errs13 = errors;
                  const _errs14 = errors;
                  let valid3 = false;
                  const _errs15 = errors;
                  if (typeof data3 !== "boolean") {
                    const err4 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var _valid1 = _errs15 === errors;
                  valid3 = valid3 || _valid1;
                  const _errs17 = errors;
                  if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                    const err5 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/1/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                  var _valid1 = _errs17 === errors;
                  valid3 = valid3 || _valid1;
                  const _errs19 = errors;
                  if (typeof data3 !== "string") {
                    const err6 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/2/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                  }
                  var _valid1 = _errs19 === errors;
                  valid3 = valid3 || _valid1;
                  if (!valid3) {
                    const err7 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                    validate46.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs14;
                    if (vErrors !== null) {
                      if (_errs14) {
                        vErrors.length = _errs14;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate46.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate46.errors = vErrors;
  return errors === 0;
}
validate46.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate45(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate45.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.capability === void 0 && (missing0 = "capability") || data.equals === void 0 && (missing0 = "equals") || data.at_least === void 0 && (missing0 = "at_least") || data.outcome === void 0 && (missing0 = "outcome") || data.matched_key === void 0 && (missing0 = "matched_key") || data.value === void 0 && (missing0 = "value") || data.source === void 0 && (missing0 = "source") || data.observed_at === void 0 && (missing0 = "observed_at") || data.evidence === void 0 && (missing0 = "evidence") || data.override === void 0 && (missing0 = "override")) {
        validate45.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema67.properties, key0)) {
            validate45.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.at_least !== void 0) {
            let data0 = data.at_least;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              const err0 = { instancePath: instancePath + "/at_least", schemaPath: "#/properties/at_least/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/at_least", schemaPath: "#/properties/at_least/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/at_least", schemaPath: "#/properties/at_least/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate45.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.capability !== void 0) {
              let data1 = data.capability;
              const _errs8 = errors;
              if (errors === _errs8) {
                if (typeof data1 === "string") {
                  if (!pattern8.test(data1)) {
                    validate45.errors = [{ instancePath: instancePath + "/capability", schemaPath: "#/properties/capability/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                    return false;
                  }
                } else {
                  validate45.errors = [{ instancePath: instancePath + "/capability", schemaPath: "#/properties/capability/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.equals !== void 0) {
                let data2 = data.equals;
                const _errs10 = errors;
                const _errs11 = errors;
                let valid2 = false;
                const _errs12 = errors;
                if (typeof data2 !== "boolean") {
                  const err3 = { instancePath: instancePath + "/equals", schemaPath: "#/properties/equals/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var _valid1 = _errs12 === errors;
                valid2 = valid2 || _valid1;
                const _errs14 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  const err4 = { instancePath: instancePath + "/equals", schemaPath: "#/properties/equals/anyOf/1/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var _valid1 = _errs14 === errors;
                valid2 = valid2 || _valid1;
                const _errs16 = errors;
                if (typeof data2 !== "string") {
                  const err5 = { instancePath: instancePath + "/equals", schemaPath: "#/properties/equals/anyOf/2/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                var _valid1 = _errs16 === errors;
                valid2 = valid2 || _valid1;
                const _errs18 = errors;
                if (data2 !== null) {
                  const err6 = { instancePath: instancePath + "/equals", schemaPath: "#/properties/equals/anyOf/3/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                }
                var _valid1 = _errs18 === errors;
                valid2 = valid2 || _valid1;
                if (!valid2) {
                  const err7 = { instancePath: instancePath + "/equals", schemaPath: "#/properties/equals/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err7];
                  } else {
                    vErrors.push(err7);
                  }
                  errors++;
                  validate45.errors = vErrors;
                  return false;
                } else {
                  errors = _errs11;
                  if (vErrors !== null) {
                    if (_errs11) {
                      vErrors.length = _errs11;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.evidence !== void 0) {
                  let data3 = data.evidence;
                  const _errs20 = errors;
                  const _errs21 = errors;
                  let valid3 = false;
                  const _errs22 = errors;
                  if (errors === _errs22) {
                    if (typeof data3 === "string") {
                      if (func2(data3) > 400) {
                        const err8 = { instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 400 }, message: "must NOT have more than 400 characters" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      } else {
                        if (func2(data3) < 1) {
                          const err9 = { instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                          if (vErrors === null) {
                            vErrors = [err9];
                          } else {
                            vErrors.push(err9);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err10 = { instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err10];
                      } else {
                        vErrors.push(err10);
                      }
                      errors++;
                    }
                  }
                  var _valid2 = _errs22 === errors;
                  valid3 = valid3 || _valid2;
                  const _errs24 = errors;
                  if (data3 !== null) {
                    const err11 = { instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err11];
                    } else {
                      vErrors.push(err11);
                    }
                    errors++;
                  }
                  var _valid2 = _errs24 === errors;
                  valid3 = valid3 || _valid2;
                  if (!valid3) {
                    const err12 = { instancePath: instancePath + "/evidence", schemaPath: "#/properties/evidence/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                    validate45.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs21;
                    if (vErrors !== null) {
                      if (_errs21) {
                        vErrors.length = _errs21;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs20 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hint !== void 0) {
                    let data4 = data.hint;
                    const _errs26 = errors;
                    const _errs27 = errors;
                    let valid4 = false;
                    const _errs28 = errors;
                    if (!validate46(data4, { instancePath: instancePath + "/hint", parentData: data, parentDataProperty: "hint", rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate46.errors : vErrors.concat(validate46.errors);
                      errors = vErrors.length;
                    }
                    var _valid3 = _errs28 === errors;
                    valid4 = valid4 || _valid3;
                    const _errs29 = errors;
                    if (data4 !== null) {
                      const err13 = { instancePath: instancePath + "/hint", schemaPath: "#/properties/hint/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                    var _valid3 = _errs29 === errors;
                    valid4 = valid4 || _valid3;
                    if (!valid4) {
                      const err14 = { instancePath: instancePath + "/hint", schemaPath: "#/properties/hint/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err14];
                      } else {
                        vErrors.push(err14);
                      }
                      errors++;
                      validate45.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs27;
                      if (vErrors !== null) {
                        if (_errs27) {
                          vErrors.length = _errs27;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs26 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.matched_key !== void 0) {
                      let data5 = data.matched_key;
                      const _errs31 = errors;
                      const _errs32 = errors;
                      let valid5 = false;
                      const _errs33 = errors;
                      if (errors === _errs33) {
                        if (typeof data5 === "string") {
                          if (!pattern8.test(data5)) {
                            const err15 = { instancePath: instancePath + "/matched_key", schemaPath: "#/properties/matched_key/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                            if (vErrors === null) {
                              vErrors = [err15];
                            } else {
                              vErrors.push(err15);
                            }
                            errors++;
                          }
                        } else {
                          const err16 = { instancePath: instancePath + "/matched_key", schemaPath: "#/properties/matched_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err16];
                          } else {
                            vErrors.push(err16);
                          }
                          errors++;
                        }
                      }
                      var _valid4 = _errs33 === errors;
                      valid5 = valid5 || _valid4;
                      const _errs35 = errors;
                      if (data5 !== null) {
                        const err17 = { instancePath: instancePath + "/matched_key", schemaPath: "#/properties/matched_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err17];
                        } else {
                          vErrors.push(err17);
                        }
                        errors++;
                      }
                      var _valid4 = _errs35 === errors;
                      valid5 = valid5 || _valid4;
                      if (!valid5) {
                        const err18 = { instancePath: instancePath + "/matched_key", schemaPath: "#/properties/matched_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err18];
                        } else {
                          vErrors.push(err18);
                        }
                        errors++;
                        validate45.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs32;
                        if (vErrors !== null) {
                          if (_errs32) {
                            vErrors.length = _errs32;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs31 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.observed_at !== void 0) {
                        let data6 = data.observed_at;
                        const _errs37 = errors;
                        const _errs38 = errors;
                        let valid6 = false;
                        const _errs39 = errors;
                        if (errors === _errs39) {
                          if (errors === _errs39) {
                            if (typeof data6 === "string") {
                              if (!formats0.validate(data6)) {
                                const err19 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                              }
                            } else {
                              const err20 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err20];
                              } else {
                                vErrors.push(err20);
                              }
                              errors++;
                            }
                          }
                        }
                        var _valid5 = _errs39 === errors;
                        valid6 = valid6 || _valid5;
                        const _errs41 = errors;
                        if (data6 !== null) {
                          const err21 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err21];
                          } else {
                            vErrors.push(err21);
                          }
                          errors++;
                        }
                        var _valid5 = _errs41 === errors;
                        valid6 = valid6 || _valid5;
                        if (!valid6) {
                          const err22 = { instancePath: instancePath + "/observed_at", schemaPath: "#/properties/observed_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err22];
                          } else {
                            vErrors.push(err22);
                          }
                          errors++;
                          validate45.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs38;
                          if (vErrors !== null) {
                            if (_errs38) {
                              vErrors.length = _errs38;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs37 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.outcome !== void 0) {
                          let data7 = data.outcome;
                          const _errs43 = errors;
                          if (typeof data7 !== "string") {
                            validate45.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/RequirementOutcome/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          if (!(data7 === "met" || data7 === "not_met" || data7 === "unknown")) {
                            validate45.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/RequirementOutcome/enum", keyword: "enum", params: { allowedValues: schema70.enum }, message: "must be equal to one of the allowed values" }];
                            return false;
                          }
                          var valid0 = _errs43 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.override !== void 0) {
                            let data8 = data.override;
                            const _errs46 = errors;
                            const _errs47 = errors;
                            let valid8 = false;
                            const _errs48 = errors;
                            if (typeof data8 !== "string") {
                              const err23 = { instancePath: instancePath + "/override", schemaPath: "#/properties/override/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err23];
                              } else {
                                vErrors.push(err23);
                              }
                              errors++;
                            }
                            var _valid6 = _errs48 === errors;
                            valid8 = valid8 || _valid6;
                            const _errs50 = errors;
                            if (data8 !== null) {
                              const err24 = { instancePath: instancePath + "/override", schemaPath: "#/properties/override/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err24];
                              } else {
                                vErrors.push(err24);
                              }
                              errors++;
                            }
                            var _valid6 = _errs50 === errors;
                            valid8 = valid8 || _valid6;
                            if (!valid8) {
                              const err25 = { instancePath: instancePath + "/override", schemaPath: "#/properties/override/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err25];
                              } else {
                                vErrors.push(err25);
                              }
                              errors++;
                              validate45.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs47;
                              if (vErrors !== null) {
                                if (_errs47) {
                                  vErrors.length = _errs47;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs46 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.source !== void 0) {
                              let data9 = data.source;
                              const _errs52 = errors;
                              const _errs53 = errors;
                              let valid9 = false;
                              const _errs54 = errors;
                              if (typeof data9 !== "string") {
                                const err26 = { instancePath: instancePath + "/source", schemaPath: "#/$defs/CapabilitySource/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err26];
                                } else {
                                  vErrors.push(err26);
                                }
                                errors++;
                              }
                              if (!(data9 === "override_project" || data9 === "override_installation" || data9 === "override_host" || data9 === "reported" || data9 === "probed" || data9 === "observed")) {
                                const err27 = { instancePath: instancePath + "/source", schemaPath: "#/$defs/CapabilitySource/enum", keyword: "enum", params: { allowedValues: schema69.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                  vErrors = [err27];
                                } else {
                                  vErrors.push(err27);
                                }
                                errors++;
                              }
                              var _valid7 = _errs54 === errors;
                              valid9 = valid9 || _valid7;
                              const _errs57 = errors;
                              if (data9 !== null) {
                                const err28 = { instancePath: instancePath + "/source", schemaPath: "#/properties/source/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err28];
                                } else {
                                  vErrors.push(err28);
                                }
                                errors++;
                              }
                              var _valid7 = _errs57 === errors;
                              valid9 = valid9 || _valid7;
                              if (!valid9) {
                                const err29 = { instancePath: instancePath + "/source", schemaPath: "#/properties/source/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err29];
                                } else {
                                  vErrors.push(err29);
                                }
                                errors++;
                                validate45.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs53;
                                if (vErrors !== null) {
                                  if (_errs53) {
                                    vErrors.length = _errs53;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs52 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.value !== void 0) {
                                let data10 = data.value;
                                const _errs59 = errors;
                                const _errs60 = errors;
                                let valid11 = false;
                                const _errs61 = errors;
                                if (typeof data10 !== "boolean") {
                                  const err30 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                  if (vErrors === null) {
                                    vErrors = [err30];
                                  } else {
                                    vErrors.push(err30);
                                  }
                                  errors++;
                                }
                                var _valid8 = _errs61 === errors;
                                valid11 = valid11 || _valid8;
                                const _errs63 = errors;
                                if (!(typeof data10 == "number" && (!(data10 % 1) && !isNaN(data10)))) {
                                  const err31 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/1/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                  if (vErrors === null) {
                                    vErrors = [err31];
                                  } else {
                                    vErrors.push(err31);
                                  }
                                  errors++;
                                }
                                var _valid8 = _errs63 === errors;
                                valid11 = valid11 || _valid8;
                                const _errs65 = errors;
                                if (typeof data10 !== "string") {
                                  const err32 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/2/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err32];
                                  } else {
                                    vErrors.push(err32);
                                  }
                                  errors++;
                                }
                                var _valid8 = _errs65 === errors;
                                valid11 = valid11 || _valid8;
                                const _errs67 = errors;
                                if (data10 !== null) {
                                  const err33 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/3/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err33];
                                  } else {
                                    vErrors.push(err33);
                                  }
                                  errors++;
                                }
                                var _valid8 = _errs67 === errors;
                                valid11 = valid11 || _valid8;
                                if (!valid11) {
                                  const err34 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err34];
                                  } else {
                                    vErrors.push(err34);
                                  }
                                  errors++;
                                  validate45.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs60;
                                  if (vErrors !== null) {
                                    if (_errs60) {
                                      vErrors.length = _errs60;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs59 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate45.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate45.errors = vErrors;
  return errors === 0;
}
validate45.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate44(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate44.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.report_received_at === void 0 && (missing0 = "report_received_at") || data.overrides_used === void 0 && (missing0 = "overrides_used") || data.installation_overrides_file === void 0 && (missing0 = "installation_overrides_file") || data.requirements === void 0 && (missing0 = "requirements")) {
        validate44.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "installation_overrides_file" || key0 === "overrides_used" || key0 === "report_received_at" || key0 === "requirements")) {
            validate44.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.installation_overrides_file !== void 0) {
            const _errs2 = errors;
            if (typeof data.installation_overrides_file !== "boolean") {
              validate44.errors = [{ instancePath: instancePath + "/installation_overrides_file", schemaPath: "#/properties/installation_overrides_file/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.overrides_used !== void 0) {
              let data1 = data.overrides_used;
              const _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  const len0 = data1.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs6 = errors;
                    if (typeof data1[i0] !== "string") {
                      validate44.errors = [{ instancePath: instancePath + "/overrides_used/" + i0, schemaPath: "#/properties/overrides_used/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate44.errors = [{ instancePath: instancePath + "/overrides_used", schemaPath: "#/properties/overrides_used/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.report_received_at !== void 0) {
                let data3 = data.report_received_at;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (errors === _errs8) {
                    if (typeof data3 === "string") {
                      if (!formats0.validate(data3)) {
                        validate44.errors = [{ instancePath: instancePath + "/report_received_at", schemaPath: "#/properties/report_received_at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                        return false;
                      }
                    } else {
                      validate44.errors = [{ instancePath: instancePath + "/report_received_at", schemaPath: "#/properties/report_received_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.requirements !== void 0) {
                  let data4 = data.requirements;
                  const _errs10 = errors;
                  if (errors === _errs10) {
                    if (Array.isArray(data4)) {
                      var valid2 = true;
                      const len1 = data4.length;
                      for (let i1 = 0; i1 < len1; i1++) {
                        const _errs12 = errors;
                        if (!validate45(data4[i1], { instancePath: instancePath + "/requirements/" + i1, parentData: data4, parentDataProperty: i1, rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs12 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    } else {
                      validate44.errors = [{ instancePath: instancePath + "/requirements", schemaPath: "#/properties/requirements/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate44.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate44.errors = vErrors;
  return errors === 0;
}
validate44.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema73 = { "description": "Where an annotation step's result goes (Q-43).", "enum": ["content_change_set", "knowledge_data", "thread_log"], "title": "AnnotationDestination", "type": "string" };
var schema74 = { "enum": ["text", "annotations", "instance_data", "change_set"], "title": "OutputKind", "type": "string" };
function validate50(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate50.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.required === void 0 && (missing0 = "required") || data.label_list === void 0 && (missing0 = "label_list") || data.document === void 0 && (missing0 = "document") || data.allowed_item_kinds === void 0 && (missing0 = "allowed_item_kinds")) {
        validate50.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "allowed_item_kinds" || key0 === "destination" || key0 === "document" || key0 === "kind" || key0 === "label_list" || key0 === "required")) {
            validate50.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.allowed_item_kinds !== void 0) {
            let data0 = data.allowed_item_kinds;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  if (errors === _errs4) {
                    if (typeof data1 === "string") {
                      if (!pattern8.test(data1)) {
                        validate50.errors = [{ instancePath: instancePath + "/allowed_item_kinds/" + i0, schemaPath: "#/properties/allowed_item_kinds/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                        return false;
                      }
                    } else {
                      validate50.errors = [{ instancePath: instancePath + "/allowed_item_kinds/" + i0, schemaPath: "#/properties/allowed_item_kinds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate50.errors = [{ instancePath: instancePath + "/allowed_item_kinds", schemaPath: "#/properties/allowed_item_kinds/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.destination !== void 0) {
              let data2 = data.destination;
              const _errs6 = errors;
              const _errs7 = errors;
              let valid2 = false;
              const _errs8 = errors;
              if (typeof data2 !== "string") {
                const err0 = { instancePath: instancePath + "/destination", schemaPath: "#/$defs/AnnotationDestination/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              if (!(data2 === "content_change_set" || data2 === "knowledge_data" || data2 === "thread_log")) {
                const err1 = { instancePath: instancePath + "/destination", schemaPath: "#/$defs/AnnotationDestination/enum", keyword: "enum", params: { allowedValues: schema73.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs8 === errors;
              valid2 = valid2 || _valid0;
              const _errs11 = errors;
              if (data2 !== null) {
                const err2 = { instancePath: instancePath + "/destination", schemaPath: "#/properties/destination/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var _valid0 = _errs11 === errors;
              valid2 = valid2 || _valid0;
              if (!valid2) {
                const err3 = { instancePath: instancePath + "/destination", schemaPath: "#/properties/destination/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
                validate50.errors = vErrors;
                return false;
              } else {
                errors = _errs7;
                if (vErrors !== null) {
                  if (_errs7) {
                    vErrors.length = _errs7;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.document !== void 0) {
                let data3 = data.document;
                const _errs13 = errors;
                const _errs14 = errors;
                let valid4 = false;
                const _errs15 = errors;
                if (typeof data3 !== "string") {
                  const err4 = { instancePath: instancePath + "/document", schemaPath: "#/properties/document/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var _valid1 = _errs15 === errors;
                valid4 = valid4 || _valid1;
                const _errs17 = errors;
                if (data3 !== null) {
                  const err5 = { instancePath: instancePath + "/document", schemaPath: "#/properties/document/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                var _valid1 = _errs17 === errors;
                valid4 = valid4 || _valid1;
                if (!valid4) {
                  const err6 = { instancePath: instancePath + "/document", schemaPath: "#/properties/document/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                  validate50.errors = vErrors;
                  return false;
                } else {
                  errors = _errs14;
                  if (vErrors !== null) {
                    if (_errs14) {
                      vErrors.length = _errs14;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs13 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.kind !== void 0) {
                  let data4 = data.kind;
                  const _errs19 = errors;
                  if (typeof data4 !== "string") {
                    validate50.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/OutputKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data4 === "text" || data4 === "annotations" || data4 === "instance_data" || data4 === "change_set")) {
                    validate50.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/OutputKind/enum", keyword: "enum", params: { allowedValues: schema74.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs19 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.label_list !== void 0) {
                    let data5 = data.label_list;
                    const _errs22 = errors;
                    const _errs23 = errors;
                    let valid6 = false;
                    const _errs24 = errors;
                    if (typeof data5 !== "string") {
                      const err7 = { instancePath: instancePath + "/label_list", schemaPath: "#/properties/label_list/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                    var _valid2 = _errs24 === errors;
                    valid6 = valid6 || _valid2;
                    const _errs26 = errors;
                    if (data5 !== null) {
                      const err8 = { instancePath: instancePath + "/label_list", schemaPath: "#/properties/label_list/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err8];
                      } else {
                        vErrors.push(err8);
                      }
                      errors++;
                    }
                    var _valid2 = _errs26 === errors;
                    valid6 = valid6 || _valid2;
                    if (!valid6) {
                      const err9 = { instancePath: instancePath + "/label_list", schemaPath: "#/properties/label_list/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err9];
                      } else {
                        vErrors.push(err9);
                      }
                      errors++;
                      validate50.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs23;
                      if (vErrors !== null) {
                        if (_errs23) {
                          vErrors.length = _errs23;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs22 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.required !== void 0) {
                      const _errs28 = errors;
                      if (typeof data.required !== "boolean") {
                        validate50.errors = [{ instancePath: instancePath + "/required", schemaPath: "#/properties/required/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs28 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate50.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate50.errors = vErrors;
  return errors === 0;
}
validate50.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema76 = { "description": "Why a block is in the frozen input (threads.md T-4).", "enum": ["agent_instructions", "history_preamble", "pending_messages", "step_instructions", "step_prompt", "turn_note"], "title": "InputPurpose", "type": "string" };
function validate52(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate52.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.purpose === void 0 && (missing0 = "purpose") || data.text === void 0 && (missing0 = "text")) {
        validate52.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.purpose !== void 0) {
          let data0 = data.purpose;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate52.errors = [{ instancePath: instancePath + "/purpose", schemaPath: "#/$defs/InputPurpose/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
            return false;
          }
          if (!(data0 === "agent_instructions" || data0 === "history_preamble" || data0 === "pending_messages" || data0 === "step_instructions" || data0 === "step_prompt" || data0 === "turn_note")) {
            validate52.errors = [{ instancePath: instancePath + "/purpose", schemaPath: "#/$defs/InputPurpose/enum", keyword: "enum", params: { allowedValues: schema76.enum }, message: "must be equal to one of the allowed values" }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.text !== void 0) {
            const _errs4 = errors;
            if (typeof data.text !== "string") {
              validate52.errors = [{ instancePath: instancePath + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate52.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate52.errors = vErrors;
  return errors === 0;
}
validate52.evaluated = { "props": { "purpose": true, "text": true }, "dynamicProps": false, "dynamicItems": false };
var schema84 = { "enum": ["continue", "fresh", "isolated", "resume"], "title": "AgentSessionMode", "type": "string" };
var pattern31 = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$", "u");
function validate54(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate54.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.mode === void 0 && (missing0 = "mode") || data.key === void 0 && (missing0 = "key")) {
        validate54.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.key !== void 0) {
          let data0 = data.key;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (typeof data0 === "string") {
              if (!pattern31.test(data0)) {
                validate54.errors = [{ instancePath: instancePath + "/key", schemaPath: "#/properties/key/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" }, message: 'must match pattern "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"' }];
                return false;
              }
            } else {
              validate54.errors = [{ instancePath: instancePath + "/key", schemaPath: "#/properties/key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.mode !== void 0) {
            let data1 = data.mode;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate54.errors = [{ instancePath: instancePath + "/mode", schemaPath: "#/$defs/AgentSessionMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data1 === "continue" || data1 === "fresh" || data1 === "isolated" || data1 === "resume")) {
              validate54.errors = [{ instancePath: instancePath + "/mode", schemaPath: "#/$defs/AgentSessionMode/enum", keyword: "enum", params: { allowedValues: schema84.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.resumes !== void 0) {
              let data2 = data.resumes;
              const _errs6 = errors;
              const _errs7 = errors;
              let valid2 = false;
              const _errs8 = errors;
              if (errors === _errs8) {
                if (typeof data2 === "string") {
                  if (!pattern31.test(data2)) {
                    const err0 = { instancePath: instancePath + "/resumes", schemaPath: "#/properties/resumes/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" }, message: 'must match pattern "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"' };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  }
                } else {
                  const err1 = { instancePath: instancePath + "/resumes", schemaPath: "#/properties/resumes/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs8 === errors;
              valid2 = valid2 || _valid0;
              const _errs10 = errors;
              if (data2 !== null) {
                const err2 = { instancePath: instancePath + "/resumes", schemaPath: "#/properties/resumes/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var _valid0 = _errs10 === errors;
              valid2 = valid2 || _valid0;
              if (!valid2) {
                const err3 = { instancePath: instancePath + "/resumes", schemaPath: "#/properties/resumes/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
                validate54.errors = vErrors;
                return false;
              } else {
                errors = _errs7;
                if (vErrors !== null) {
                  if (_errs7) {
                    vErrors.length = _errs7;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate54.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate54.errors = vErrors;
  return errors === 0;
}
validate54.evaluated = { "props": { "key": true, "mode": true, "resumes": true }, "dynamicProps": false, "dynamicItems": false };
var schema87 = { "description": "How a talk continues the reviewed step's agent session (F105).", "enum": ["thread", "resumed", "rebuilt"], "title": "TalkContinuation", "type": "string" };
var schema91 = { "additionalProperties": false, "properties": { "change_set_id": { "title": "Change Set Id", "type": "string" }, "collection": { "default": "project_content", "description": "Whose change set: the project's content, or the Thread's corpus (a tool step's\ncorpus import, Q-30), which is reviewed on its own page.", "enum": ["project_content", "corpus"], "title": "Collection", "type": "string" }, "head": { "title": "Head", "type": "string" }, "output_kind": { "const": "change_set", "title": "Output Kind", "type": "string" } }, "required": ["output_kind", "change_set_id", "head"], "title": "ChangeSetResult", "type": "object" };
function validate58(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate58.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.output_kind === void 0 && (missing0 = "output_kind") || data.document === void 0 && (missing0 = "document") || data.label_list === void 0 && (missing0 = "label_list") || data.annotations === void 0 && (missing0 = "annotations")) {
        validate58.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "annotations" || key0 === "document" || key0 === "documents" || key0 === "label_list" || key0 === "output_kind")) {
            validate58.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.annotations !== void 0) {
            let data0 = data.annotations;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  const _errs5 = errors;
                  if (errors === _errs5) {
                    if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                      let missing1;
                      if (data1.segment === void 0 && (missing1 = "segment") || data1.start === void 0 && (missing1 = "start") || data1.end === void 0 && (missing1 = "end") || data1.quote === void 0 && (missing1 = "quote") || data1.label === void 0 && (missing1 = "label") || data1.note === void 0 && (missing1 = "note")) {
                        validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0, schemaPath: "#/$defs/Annotation/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                        return false;
                      } else {
                        const _errs7 = errors;
                        for (const key1 in data1) {
                          if (!(key1 === "end" || key1 === "label" || key1 === "note" || key1 === "quote" || key1 === "segment" || key1 === "start")) {
                            validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0, schemaPath: "#/$defs/Annotation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                            return false;
                            break;
                          }
                        }
                        if (_errs7 === errors) {
                          if (data1.end !== void 0) {
                            let data2 = data1.end;
                            const _errs8 = errors;
                            if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                              validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/end", schemaPath: "#/$defs/Annotation/properties/end/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                              return false;
                            }
                            if (errors === _errs8) {
                              if (typeof data2 == "number") {
                                if (data2 < 1 || isNaN(data2)) {
                                  validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/end", schemaPath: "#/$defs/Annotation/properties/end/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                  return false;
                                }
                              }
                            }
                            var valid3 = _errs8 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.label !== void 0) {
                              let data3 = data1.label;
                              const _errs10 = errors;
                              if (errors === _errs10) {
                                if (typeof data3 === "string") {
                                  if (!pattern8.test(data3)) {
                                    validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/label", schemaPath: "#/$defs/Annotation/properties/label/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                    return false;
                                  }
                                } else {
                                  validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/label", schemaPath: "#/$defs/Annotation/properties/label/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                              }
                              var valid3 = _errs10 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.note !== void 0) {
                                let data4 = data1.note;
                                const _errs12 = errors;
                                if (errors === _errs12) {
                                  if (typeof data4 === "string") {
                                    if (func2(data4) > 2e3) {
                                      validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/note", schemaPath: "#/$defs/Annotation/properties/note/maxLength", keyword: "maxLength", params: { limit: 2e3 }, message: "must NOT have more than 2000 characters" }];
                                      return false;
                                    }
                                  } else {
                                    validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/note", schemaPath: "#/$defs/Annotation/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                }
                                var valid3 = _errs12 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.quote !== void 0) {
                                  let data5 = data1.quote;
                                  const _errs14 = errors;
                                  if (errors === _errs14) {
                                    if (typeof data5 === "string") {
                                      if (func2(data5) > 2e3) {
                                        validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/quote", schemaPath: "#/$defs/Annotation/properties/quote/maxLength", keyword: "maxLength", params: { limit: 2e3 }, message: "must NOT have more than 2000 characters" }];
                                        return false;
                                      } else {
                                        if (func2(data5) < 1) {
                                          validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/quote", schemaPath: "#/$defs/Annotation/properties/quote/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                          return false;
                                        }
                                      }
                                    } else {
                                      validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/quote", schemaPath: "#/$defs/Annotation/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                  }
                                  var valid3 = _errs14 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data1.segment !== void 0) {
                                    const _errs16 = errors;
                                    if (typeof data1.segment !== "string") {
                                      validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/segment", schemaPath: "#/$defs/Annotation/properties/segment/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid3 = _errs16 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data1.start !== void 0) {
                                      let data7 = data1.start;
                                      const _errs18 = errors;
                                      if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)))) {
                                        validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/start", schemaPath: "#/$defs/Annotation/properties/start/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                        return false;
                                      }
                                      if (errors === _errs18) {
                                        if (typeof data7 == "number") {
                                          if (data7 < 0 || isNaN(data7)) {
                                            validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0 + "/start", schemaPath: "#/$defs/Annotation/properties/start/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" }];
                                            return false;
                                          }
                                        }
                                      }
                                      var valid3 = _errs18 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate58.errors = [{ instancePath: instancePath + "/annotations/" + i0, schemaPath: "#/$defs/Annotation/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                      return false;
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate58.errors = [{ instancePath: instancePath + "/annotations", schemaPath: "#/properties/annotations/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.document !== void 0) {
              const _errs20 = errors;
              if (typeof data.document !== "string") {
                validate58.errors = [{ instancePath: instancePath + "/document", schemaPath: "#/properties/document/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs20 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.documents !== void 0) {
                let data9 = data.documents;
                const _errs22 = errors;
                if (errors === _errs22) {
                  if (Array.isArray(data9)) {
                    var valid4 = true;
                    const len1 = data9.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      const _errs24 = errors;
                      if (typeof data9[i1] !== "string") {
                        validate58.errors = [{ instancePath: instancePath + "/documents/" + i1, schemaPath: "#/properties/documents/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid4 = _errs24 === errors;
                      if (!valid4) {
                        break;
                      }
                    }
                  } else {
                    validate58.errors = [{ instancePath: instancePath + "/documents", schemaPath: "#/properties/documents/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs22 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.label_list !== void 0) {
                  const _errs26 = errors;
                  if (typeof data.label_list !== "string") {
                    validate58.errors = [{ instancePath: instancePath + "/label_list", schemaPath: "#/properties/label_list/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs26 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.output_kind !== void 0) {
                    let data12 = data.output_kind;
                    const _errs28 = errors;
                    if (typeof data12 !== "string") {
                      validate58.errors = [{ instancePath: instancePath + "/output_kind", schemaPath: "#/properties/output_kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    if ("annotations" !== data12) {
                      validate58.errors = [{ instancePath: instancePath + "/output_kind", schemaPath: "#/properties/output_kind/const", keyword: "const", params: { allowedValue: "annotations" }, message: "must be equal to constant" }];
                      return false;
                    }
                    var valid0 = _errs28 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate58.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate58.errors = vErrors;
  return errors === 0;
}
validate58.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema94 = { "enum": ["text", "choice", "annotations", "instance_data", "change_set", "text_units", "item", "item_refs", "term_cards", "check_report", "derived", "workspace_file", "corpus_import", "source_version", "release_request", "release", "html_page", "derived_records", "memory", "result"], "title": "ValueKind", "type": "string" };
var pattern24 = new RegExp("^sha256-jcs:[0-9a-f]{64}$", "u");
function validate61(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate61.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.output_kind === void 0 && (missing0 = "output_kind") || data.value_kind === void 0 && (missing0 = "value_kind") || data.value === void 0 && (missing0 = "value") || data.digest === void 0 && (missing0 = "digest")) {
        validate61.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "digest" || key0 === "output_kind" || key0 === "value" || key0 === "value_kind")) {
            validate61.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.digest !== void 0) {
            let data0 = data.digest;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (typeof data0 === "string") {
                if (!pattern24.test(data0)) {
                  validate61.errors = [{ instancePath: instancePath + "/digest", schemaPath: "#/properties/digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' }];
                  return false;
                }
              } else {
                validate61.errors = [{ instancePath: instancePath + "/digest", schemaPath: "#/properties/digest/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.output_kind !== void 0) {
              let data1 = data.output_kind;
              const _errs4 = errors;
              if (typeof data1 !== "string") {
                validate61.errors = [{ instancePath: instancePath + "/output_kind", schemaPath: "#/properties/output_kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if ("value" !== data1) {
                validate61.errors = [{ instancePath: instancePath + "/output_kind", schemaPath: "#/properties/output_kind/const", keyword: "const", params: { allowedValue: "value" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== void 0) {
                const _errs6 = errors;
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.value_kind !== void 0) {
                  let data3 = data.value_kind;
                  const _errs7 = errors;
                  if (typeof data3 !== "string") {
                    validate61.errors = [{ instancePath: instancePath + "/value_kind", schemaPath: "#/$defs/ValueKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data3 === "text" || data3 === "choice" || data3 === "annotations" || data3 === "instance_data" || data3 === "change_set" || data3 === "text_units" || data3 === "item" || data3 === "item_refs" || data3 === "term_cards" || data3 === "check_report" || data3 === "derived" || data3 === "workspace_file" || data3 === "corpus_import" || data3 === "source_version" || data3 === "release_request" || data3 === "release" || data3 === "html_page" || data3 === "derived_records" || data3 === "memory" || data3 === "result")) {
                    validate61.errors = [{ instancePath: instancePath + "/value_kind", schemaPath: "#/$defs/ValueKind/enum", keyword: "enum", params: { allowedValues: schema94.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate61.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate61.errors = vErrors;
  return errors === 0;
}
validate61.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate57(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate57.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  if (!validate58(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
    vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs2 = errors;
  if (!validate32(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
    vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
    const _errs3 = errors;
    const _errs4 = errors;
    if (errors === _errs4) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing0;
        if (data.output_kind === void 0 && (missing0 = "output_kind") || data.change_set_id === void 0 && (missing0 = "change_set_id") || data.head === void 0 && (missing0 = "head")) {
          const err0 = { instancePath, schemaPath: "#/$defs/ChangeSetResult/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        } else {
          const _errs6 = errors;
          for (const key0 in data) {
            if (!(key0 === "change_set_id" || key0 === "collection" || key0 === "head" || key0 === "output_kind")) {
              const err1 = { instancePath, schemaPath: "#/$defs/ChangeSetResult/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              break;
            }
          }
          if (_errs6 === errors) {
            if (data.change_set_id !== void 0) {
              const _errs7 = errors;
              if (typeof data.change_set_id !== "string") {
                const err2 = { instancePath: instancePath + "/change_set_id", schemaPath: "#/$defs/ChangeSetResult/properties/change_set_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.collection !== void 0) {
                let data1 = data.collection;
                const _errs9 = errors;
                if (typeof data1 !== "string") {
                  const err3 = { instancePath: instancePath + "/collection", schemaPath: "#/$defs/ChangeSetResult/properties/collection/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                if (!(data1 === "project_content" || data1 === "corpus")) {
                  const err4 = { instancePath: instancePath + "/collection", schemaPath: "#/$defs/ChangeSetResult/properties/collection/enum", keyword: "enum", params: { allowedValues: schema91.properties.collection.enum }, message: "must be equal to one of the allowed values" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.head !== void 0) {
                  const _errs11 = errors;
                  if (typeof data.head !== "string") {
                    const err5 = { instancePath: instancePath + "/head", schemaPath: "#/$defs/ChangeSetResult/properties/head/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                  var valid2 = _errs11 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.output_kind !== void 0) {
                    let data3 = data.output_kind;
                    const _errs13 = errors;
                    if (typeof data3 !== "string") {
                      const err6 = { instancePath: instancePath + "/output_kind", schemaPath: "#/$defs/ChangeSetResult/properties/output_kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err6];
                      } else {
                        vErrors.push(err6);
                      }
                      errors++;
                    }
                    if ("change_set" !== data3) {
                      const err7 = { instancePath: instancePath + "/output_kind", schemaPath: "#/$defs/ChangeSetResult/properties/output_kind/const", keyword: "const", params: { allowedValue: "change_set" }, message: "must be equal to constant" };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                    var valid2 = _errs13 === errors;
                  } else {
                    var valid2 = true;
                  }
                }
              }
            }
          }
        }
      } else {
        const err8 = { instancePath, schemaPath: "#/$defs/ChangeSetResult/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    var _valid0 = _errs3 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
        if (props0 !== true) {
          props0 = true;
        }
      }
      const _errs15 = errors;
      if (!validate61(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
        vErrors = vErrors === null ? validate61.errors : vErrors.concat(validate61.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs15 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
          if (props0 !== true) {
            props0 = true;
          }
        }
      }
    }
  }
  if (!valid0) {
    const err9 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
    validate57.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate57.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate57.evaluated = { "dynamicProps": true, "dynamicItems": false };
function validate56(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate56.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.talk_step === void 0 && (missing0 = "talk_step") || data.review_entry === void 0 && (missing0 = "review_entry") || data.earlier_request === void 0 && (missing0 = "earlier_request") || data.reviewed === void 0 && (missing0 = "reviewed") || data.request === void 0 && (missing0 = "request") || data.continuation === void 0 && (missing0 = "continuation")) {
        validate56.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "continuation" || key0 === "earlier_request" || key0 === "request" || key0 === "review_entry" || key0 === "reviewed" || key0 === "talk_step")) {
            validate56.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.continuation !== void 0) {
            let data0 = data.continuation;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate56.errors = [{ instancePath: instancePath + "/continuation", schemaPath: "#/$defs/TalkContinuation/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "thread" || data0 === "resumed" || data0 === "rebuilt")) {
              validate56.errors = [{ instancePath: instancePath + "/continuation", schemaPath: "#/$defs/TalkContinuation/enum", keyword: "enum", params: { allowedValues: schema87.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.earlier_request !== void 0) {
              let data1 = data.earlier_request;
              const _errs5 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                validate56.errors = [{ instancePath: instancePath + "/earlier_request", schemaPath: "#/properties/earlier_request/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              if (errors === _errs5) {
                if (typeof data1 == "number") {
                  if (data1 < 1 || isNaN(data1)) {
                    validate56.errors = [{ instancePath: instancePath + "/earlier_request", schemaPath: "#/properties/earlier_request/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                    return false;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.request !== void 0) {
                const _errs7 = errors;
                if (typeof data.request !== "string") {
                  validate56.errors = [{ instancePath: instancePath + "/request", schemaPath: "#/properties/request/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.review_entry !== void 0) {
                  let data3 = data.review_entry;
                  const _errs9 = errors;
                  if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                    validate56.errors = [{ instancePath: instancePath + "/review_entry", schemaPath: "#/properties/review_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                    return false;
                  }
                  if (errors === _errs9) {
                    if (typeof data3 == "number") {
                      if (data3 < 1 || isNaN(data3)) {
                        validate56.errors = [{ instancePath: instancePath + "/review_entry", schemaPath: "#/properties/review_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                        return false;
                      }
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.reviewed !== void 0) {
                    let data4 = data.reviewed;
                    const _errs11 = errors;
                    const _errs12 = errors;
                    let valid2 = false;
                    const _errs13 = errors;
                    if (!validate57(data4, { instancePath: instancePath + "/reviewed", parentData: data, parentDataProperty: "reviewed", rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                      errors = vErrors.length;
                    }
                    var _valid0 = _errs13 === errors;
                    valid2 = valid2 || _valid0;
                    const _errs14 = errors;
                    if (data4 !== null) {
                      const err0 = { instancePath: instancePath + "/reviewed", schemaPath: "#/properties/reviewed/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err0];
                      } else {
                        vErrors.push(err0);
                      }
                      errors++;
                    }
                    var _valid0 = _errs14 === errors;
                    valid2 = valid2 || _valid0;
                    if (!valid2) {
                      const err1 = { instancePath: instancePath + "/reviewed", schemaPath: "#/properties/reviewed/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                      validate56.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs12;
                      if (vErrors !== null) {
                        if (_errs12) {
                          vErrors.length = _errs12;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.talk_step !== void 0) {
                      const _errs16 = errors;
                      if (typeof data.talk_step !== "string") {
                        validate56.errors = [{ instancePath: instancePath + "/talk_step", schemaPath: "#/properties/talk_step/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs16 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate56.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate56.errors = vErrors;
  return errors === 0;
}
validate56.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema97 = { "additionalProperties": false, "description": "Every exact version a turn's input was built from (invariant 6, NFR-16).", "properties": { "agent_instructions": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "The run's agent instructions that opened the agent's conversation: set where the turn\nstarted one, fresh or isolated (F-4; isolated ones before it opened without).", "title": "Agent Instructions" }, "compaction": { "anyOf": [{ "$ref": "#/$defs/CompactionReport" }, { "type": "null" }] }, "content_version": { "title": "Content Version", "type": "string" }, "corpus_version": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Corpus Version" }, "history_preamble": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "The preamble method, for fresh sessions.", "title": "History Preamble" }, "input_entries": { "items": { "minimum": 1, "type": "integer" }, "title": "Input Entries", "type": "array" }, "placeholders": { "items": { "$ref": "#/$defs/PlaceholderUse" }, "title": "Placeholders", "type": "array" }, "placement": { "anyOf": [{ "$ref": "#/$defs/StepPlacement" }, { "type": "null" }], "default": null, "description": "The step's placement, for a step's turn; `None` for a reply and in turns recorded\nbefore it (W-13)." }, "prompt": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Prompt" }, "selection": { "default": [], "items": { "type": "string" }, "title": "Selection", "type": "array" }, "server_version": { "title": "Server Version", "type": "string" }, "step": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Step" }, "step_instructions": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "description": "The step's own agent instructions this turn sent as their own block (WD-1+3 D-2); left\nout when none, as in every turn recorded before them.", "title": "Step Instructions" }, "subject": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Subject" }, "workflow": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Workflow" } }, "required": ["workflow", "step", "prompt", "content_version", "corpus_version", "subject", "placeholders", "input_entries", "agent_instructions", "history_preamble", "compaction", "server_version"], "title": "VersionsUsed", "type": "object" };
var schema99 = { "additionalProperties": false, "description": "How one placeholder was filled: by which selector or input, reading what.", "properties": { "input_entry": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "title": "Input Entry" }, "placeholder": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "title": "Placeholder", "type": "string" }, "reduction_level": { "description": "How far compaction reduced it; 0 is unreduced.", "title": "Reduction Level", "type": "integer" }, "references_read": { "description": "Every `VersionRef`, `SegmentRef` or `CollectionVersionRef` the text came from.", "items": { "type": "string" }, "title": "References Read", "type": "array" }, "selector_kind": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Selector Kind" }, "selector_version": { "anyOf": [{ "type": "integer" }, { "type": "null" }], "title": "Selector Version" }, "source": { "enum": ["selector", "input"], "title": "Source", "type": "string" } }, "required": ["placeholder", "source", "selector_kind", "selector_version", "references_read", "input_entry", "reduction_level"], "title": "PlaceholderUse", "type": "object" };
function validate65(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate65.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.workflow === void 0 && (missing0 = "workflow") || data.step === void 0 && (missing0 = "step") || data.prompt === void 0 && (missing0 = "prompt") || data.content_version === void 0 && (missing0 = "content_version") || data.corpus_version === void 0 && (missing0 = "corpus_version") || data.subject === void 0 && (missing0 = "subject") || data.placeholders === void 0 && (missing0 = "placeholders") || data.input_entries === void 0 && (missing0 = "input_entries") || data.agent_instructions === void 0 && (missing0 = "agent_instructions") || data.history_preamble === void 0 && (missing0 = "history_preamble") || data.compaction === void 0 && (missing0 = "compaction") || data.server_version === void 0 && (missing0 = "server_version")) {
        validate65.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema97.properties, key0)) {
            validate65.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.agent_instructions !== void 0) {
            let data0 = data.agent_instructions;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate65.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.compaction !== void 0) {
              let data1 = data.compaction;
              const _errs8 = errors;
              const _errs9 = errors;
              let valid2 = false;
              const _errs10 = errors;
              const _errs11 = errors;
              if (errors === _errs11) {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  let missing1;
                  if (data1.method === void 0 && (missing1 = "method") || data1.version === void 0 && (missing1 = "version") || data1.estimated_tokens_before === void 0 && (missing1 = "estimated_tokens_before") || data1.estimated_tokens_after === void 0 && (missing1 = "estimated_tokens_after") || data1.reductions === void 0 && (missing1 = "reductions")) {
                    const err3 = { instancePath: instancePath + "/compaction", schemaPath: "#/$defs/CompactionReport/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  } else {
                    const _errs13 = errors;
                    for (const key1 in data1) {
                      if (!(key1 === "estimated_tokens_after" || key1 === "estimated_tokens_before" || key1 === "method" || key1 === "reductions" || key1 === "version")) {
                        const err4 = { instancePath: instancePath + "/compaction", schemaPath: "#/$defs/CompactionReport/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                        break;
                      }
                    }
                    if (_errs13 === errors) {
                      if (data1.estimated_tokens_after !== void 0) {
                        let data2 = data1.estimated_tokens_after;
                        const _errs14 = errors;
                        if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                          const err5 = { instancePath: instancePath + "/compaction/estimated_tokens_after", schemaPath: "#/$defs/CompactionReport/properties/estimated_tokens_after/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                        var valid4 = _errs14 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data1.estimated_tokens_before !== void 0) {
                          let data3 = data1.estimated_tokens_before;
                          const _errs16 = errors;
                          if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                            const err6 = { instancePath: instancePath + "/compaction/estimated_tokens_before", schemaPath: "#/$defs/CompactionReport/properties/estimated_tokens_before/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err6];
                            } else {
                              vErrors.push(err6);
                            }
                            errors++;
                          }
                          var valid4 = _errs16 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data1.method !== void 0) {
                            let data4 = data1.method;
                            const _errs18 = errors;
                            if (errors === _errs18) {
                              if (typeof data4 === "string") {
                                if (!pattern8.test(data4)) {
                                  const err7 = { instancePath: instancePath + "/compaction/method", schemaPath: "#/$defs/CompactionReport/properties/method/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                              } else {
                                const err8 = { instancePath: instancePath + "/compaction/method", schemaPath: "#/$defs/CompactionReport/properties/method/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err8];
                                } else {
                                  vErrors.push(err8);
                                }
                                errors++;
                              }
                            }
                            var valid4 = _errs18 === errors;
                          } else {
                            var valid4 = true;
                          }
                          if (valid4) {
                            if (data1.reductions !== void 0) {
                              let data5 = data1.reductions;
                              const _errs20 = errors;
                              if (errors === _errs20) {
                                if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                                  var props0 = {};
                                  for (const key2 in data5) {
                                    if (pattern8.test(key2)) {
                                      let data6 = data5[key2];
                                      if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                                        const err9 = { instancePath: instancePath + "/compaction/reductions/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/CompactionReport/properties/reductions/patternProperties/%5E%5Ba-z%5D%5Ba-z0-9_%5D%7B0%2C62%7D%24/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                        if (vErrors === null) {
                                          vErrors = [err9];
                                        } else {
                                          vErrors.push(err9);
                                        }
                                        errors++;
                                      }
                                      props0[key2] = true;
                                    }
                                  }
                                } else {
                                  const err10 = { instancePath: instancePath + "/compaction/reductions", schemaPath: "#/$defs/CompactionReport/properties/reductions/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                  if (vErrors === null) {
                                    vErrors = [err10];
                                  } else {
                                    vErrors.push(err10);
                                  }
                                  errors++;
                                }
                              }
                              var valid4 = _errs20 === errors;
                            } else {
                              var valid4 = true;
                            }
                            if (valid4) {
                              if (data1.version !== void 0) {
                                let data7 = data1.version;
                                const _errs24 = errors;
                                if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)))) {
                                  const err11 = { instancePath: instancePath + "/compaction/version", schemaPath: "#/$defs/CompactionReport/properties/version/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                }
                                if (errors === _errs24) {
                                  if (typeof data7 == "number") {
                                    if (data7 < 1 || isNaN(data7)) {
                                      const err12 = { instancePath: instancePath + "/compaction/version", schemaPath: "#/$defs/CompactionReport/properties/version/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                      if (vErrors === null) {
                                        vErrors = [err12];
                                      } else {
                                        vErrors.push(err12);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                var valid4 = _errs24 === errors;
                              } else {
                                var valid4 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  const err13 = { instancePath: instancePath + "/compaction", schemaPath: "#/$defs/CompactionReport/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
              }
              var _valid1 = _errs10 === errors;
              valid2 = valid2 || _valid1;
              const _errs26 = errors;
              if (data1 !== null) {
                const err14 = { instancePath: instancePath + "/compaction", schemaPath: "#/properties/compaction/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              var _valid1 = _errs26 === errors;
              valid2 = valid2 || _valid1;
              if (!valid2) {
                const err15 = { instancePath: instancePath + "/compaction", schemaPath: "#/properties/compaction/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
                validate65.errors = vErrors;
                return false;
              } else {
                errors = _errs9;
                if (vErrors !== null) {
                  if (_errs9) {
                    vErrors.length = _errs9;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.content_version !== void 0) {
                const _errs28 = errors;
                if (typeof data.content_version !== "string") {
                  validate65.errors = [{ instancePath: instancePath + "/content_version", schemaPath: "#/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs28 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.corpus_version !== void 0) {
                  let data9 = data.corpus_version;
                  const _errs30 = errors;
                  const _errs31 = errors;
                  let valid6 = false;
                  const _errs32 = errors;
                  if (typeof data9 !== "string") {
                    const err16 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err16];
                    } else {
                      vErrors.push(err16);
                    }
                    errors++;
                  }
                  var _valid2 = _errs32 === errors;
                  valid6 = valid6 || _valid2;
                  const _errs34 = errors;
                  if (data9 !== null) {
                    const err17 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err17];
                    } else {
                      vErrors.push(err17);
                    }
                    errors++;
                  }
                  var _valid2 = _errs34 === errors;
                  valid6 = valid6 || _valid2;
                  if (!valid6) {
                    const err18 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                    validate65.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs31;
                    if (vErrors !== null) {
                      if (_errs31) {
                        vErrors.length = _errs31;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs30 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.history_preamble !== void 0) {
                    let data10 = data.history_preamble;
                    const _errs36 = errors;
                    const _errs37 = errors;
                    let valid7 = false;
                    const _errs38 = errors;
                    if (typeof data10 !== "string") {
                      const err19 = { instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err19];
                      } else {
                        vErrors.push(err19);
                      }
                      errors++;
                    }
                    var _valid3 = _errs38 === errors;
                    valid7 = valid7 || _valid3;
                    const _errs40 = errors;
                    if (data10 !== null) {
                      const err20 = { instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err20];
                      } else {
                        vErrors.push(err20);
                      }
                      errors++;
                    }
                    var _valid3 = _errs40 === errors;
                    valid7 = valid7 || _valid3;
                    if (!valid7) {
                      const err21 = { instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                      validate65.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs37;
                      if (vErrors !== null) {
                        if (_errs37) {
                          vErrors.length = _errs37;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs36 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.input_entries !== void 0) {
                      let data11 = data.input_entries;
                      const _errs42 = errors;
                      if (errors === _errs42) {
                        if (Array.isArray(data11)) {
                          var valid8 = true;
                          const len0 = data11.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            let data12 = data11[i0];
                            const _errs44 = errors;
                            if (!(typeof data12 == "number" && (!(data12 % 1) && !isNaN(data12)))) {
                              validate65.errors = [{ instancePath: instancePath + "/input_entries/" + i0, schemaPath: "#/properties/input_entries/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                              return false;
                            }
                            if (errors === _errs44) {
                              if (typeof data12 == "number") {
                                if (data12 < 1 || isNaN(data12)) {
                                  validate65.errors = [{ instancePath: instancePath + "/input_entries/" + i0, schemaPath: "#/properties/input_entries/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                  return false;
                                }
                              }
                            }
                            var valid8 = _errs44 === errors;
                            if (!valid8) {
                              break;
                            }
                          }
                        } else {
                          validate65.errors = [{ instancePath: instancePath + "/input_entries", schemaPath: "#/properties/input_entries/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs42 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.placeholders !== void 0) {
                        let data13 = data.placeholders;
                        const _errs46 = errors;
                        if (errors === _errs46) {
                          if (Array.isArray(data13)) {
                            var valid9 = true;
                            const len1 = data13.length;
                            for (let i1 = 0; i1 < len1; i1++) {
                              let data14 = data13[i1];
                              const _errs48 = errors;
                              const _errs49 = errors;
                              if (errors === _errs49) {
                                if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                                  let missing2;
                                  if (data14.placeholder === void 0 && (missing2 = "placeholder") || data14.source === void 0 && (missing2 = "source") || data14.selector_kind === void 0 && (missing2 = "selector_kind") || data14.selector_version === void 0 && (missing2 = "selector_version") || data14.references_read === void 0 && (missing2 = "references_read") || data14.input_entry === void 0 && (missing2 = "input_entry") || data14.reduction_level === void 0 && (missing2 = "reduction_level")) {
                                    validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1, schemaPath: "#/$defs/PlaceholderUse/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" }];
                                    return false;
                                  } else {
                                    const _errs51 = errors;
                                    for (const key3 in data14) {
                                      if (!(key3 === "input_entry" || key3 === "placeholder" || key3 === "reduction_level" || key3 === "references_read" || key3 === "selector_kind" || key3 === "selector_version" || key3 === "source")) {
                                        validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1, schemaPath: "#/$defs/PlaceholderUse/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" }];
                                        return false;
                                        break;
                                      }
                                    }
                                    if (_errs51 === errors) {
                                      if (data14.input_entry !== void 0) {
                                        let data15 = data14.input_entry;
                                        const _errs52 = errors;
                                        const _errs53 = errors;
                                        let valid12 = false;
                                        const _errs54 = errors;
                                        if (!(typeof data15 == "number" && (!(data15 % 1) && !isNaN(data15)))) {
                                          const err22 = { instancePath: instancePath + "/placeholders/" + i1 + "/input_entry", schemaPath: "#/$defs/PlaceholderUse/properties/input_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                          if (vErrors === null) {
                                            vErrors = [err22];
                                          } else {
                                            vErrors.push(err22);
                                          }
                                          errors++;
                                        }
                                        if (errors === _errs54) {
                                          if (typeof data15 == "number") {
                                            if (data15 < 1 || isNaN(data15)) {
                                              const err23 = { instancePath: instancePath + "/placeholders/" + i1 + "/input_entry", schemaPath: "#/$defs/PlaceholderUse/properties/input_entry/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                              if (vErrors === null) {
                                                vErrors = [err23];
                                              } else {
                                                vErrors.push(err23);
                                              }
                                              errors++;
                                            }
                                          }
                                        }
                                        var _valid4 = _errs54 === errors;
                                        valid12 = valid12 || _valid4;
                                        const _errs56 = errors;
                                        if (data15 !== null) {
                                          const err24 = { instancePath: instancePath + "/placeholders/" + i1 + "/input_entry", schemaPath: "#/$defs/PlaceholderUse/properties/input_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err24];
                                          } else {
                                            vErrors.push(err24);
                                          }
                                          errors++;
                                        }
                                        var _valid4 = _errs56 === errors;
                                        valid12 = valid12 || _valid4;
                                        if (!valid12) {
                                          const err25 = { instancePath: instancePath + "/placeholders/" + i1 + "/input_entry", schemaPath: "#/$defs/PlaceholderUse/properties/input_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                          validate65.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs53;
                                          if (vErrors !== null) {
                                            if (_errs53) {
                                              vErrors.length = _errs53;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid11 = _errs52 === errors;
                                      } else {
                                        var valid11 = true;
                                      }
                                      if (valid11) {
                                        if (data14.placeholder !== void 0) {
                                          let data16 = data14.placeholder;
                                          const _errs58 = errors;
                                          if (errors === _errs58) {
                                            if (typeof data16 === "string") {
                                              if (!pattern8.test(data16)) {
                                                validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/placeholder", schemaPath: "#/$defs/PlaceholderUse/properties/placeholder/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                                return false;
                                              }
                                            } else {
                                              validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/placeholder", schemaPath: "#/$defs/PlaceholderUse/properties/placeholder/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                          }
                                          var valid11 = _errs58 === errors;
                                        } else {
                                          var valid11 = true;
                                        }
                                        if (valid11) {
                                          if (data14.reduction_level !== void 0) {
                                            let data17 = data14.reduction_level;
                                            const _errs60 = errors;
                                            if (!(typeof data17 == "number" && (!(data17 % 1) && !isNaN(data17)))) {
                                              validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/reduction_level", schemaPath: "#/$defs/PlaceholderUse/properties/reduction_level/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                              return false;
                                            }
                                            var valid11 = _errs60 === errors;
                                          } else {
                                            var valid11 = true;
                                          }
                                          if (valid11) {
                                            if (data14.references_read !== void 0) {
                                              let data18 = data14.references_read;
                                              const _errs62 = errors;
                                              if (errors === _errs62) {
                                                if (Array.isArray(data18)) {
                                                  var valid13 = true;
                                                  const len2 = data18.length;
                                                  for (let i2 = 0; i2 < len2; i2++) {
                                                    const _errs64 = errors;
                                                    if (typeof data18[i2] !== "string") {
                                                      validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/references_read/" + i2, schemaPath: "#/$defs/PlaceholderUse/properties/references_read/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                      return false;
                                                    }
                                                    var valid13 = _errs64 === errors;
                                                    if (!valid13) {
                                                      break;
                                                    }
                                                  }
                                                } else {
                                                  validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/references_read", schemaPath: "#/$defs/PlaceholderUse/properties/references_read/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                  return false;
                                                }
                                              }
                                              var valid11 = _errs62 === errors;
                                            } else {
                                              var valid11 = true;
                                            }
                                            if (valid11) {
                                              if (data14.selector_kind !== void 0) {
                                                let data20 = data14.selector_kind;
                                                const _errs66 = errors;
                                                const _errs67 = errors;
                                                let valid14 = false;
                                                const _errs68 = errors;
                                                if (typeof data20 !== "string") {
                                                  const err26 = { instancePath: instancePath + "/placeholders/" + i1 + "/selector_kind", schemaPath: "#/$defs/PlaceholderUse/properties/selector_kind/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err26];
                                                  } else {
                                                    vErrors.push(err26);
                                                  }
                                                  errors++;
                                                }
                                                var _valid5 = _errs68 === errors;
                                                valid14 = valid14 || _valid5;
                                                const _errs70 = errors;
                                                if (data20 !== null) {
                                                  const err27 = { instancePath: instancePath + "/placeholders/" + i1 + "/selector_kind", schemaPath: "#/$defs/PlaceholderUse/properties/selector_kind/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                  if (vErrors === null) {
                                                    vErrors = [err27];
                                                  } else {
                                                    vErrors.push(err27);
                                                  }
                                                  errors++;
                                                }
                                                var _valid5 = _errs70 === errors;
                                                valid14 = valid14 || _valid5;
                                                if (!valid14) {
                                                  const err28 = { instancePath: instancePath + "/placeholders/" + i1 + "/selector_kind", schemaPath: "#/$defs/PlaceholderUse/properties/selector_kind/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                  if (vErrors === null) {
                                                    vErrors = [err28];
                                                  } else {
                                                    vErrors.push(err28);
                                                  }
                                                  errors++;
                                                  validate65.errors = vErrors;
                                                  return false;
                                                } else {
                                                  errors = _errs67;
                                                  if (vErrors !== null) {
                                                    if (_errs67) {
                                                      vErrors.length = _errs67;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid11 = _errs66 === errors;
                                              } else {
                                                var valid11 = true;
                                              }
                                              if (valid11) {
                                                if (data14.selector_version !== void 0) {
                                                  let data21 = data14.selector_version;
                                                  const _errs72 = errors;
                                                  const _errs73 = errors;
                                                  let valid15 = false;
                                                  const _errs74 = errors;
                                                  if (!(typeof data21 == "number" && (!(data21 % 1) && !isNaN(data21)))) {
                                                    const err29 = { instancePath: instancePath + "/placeholders/" + i1 + "/selector_version", schemaPath: "#/$defs/PlaceholderUse/properties/selector_version/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                                    if (vErrors === null) {
                                                      vErrors = [err29];
                                                    } else {
                                                      vErrors.push(err29);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid6 = _errs74 === errors;
                                                  valid15 = valid15 || _valid6;
                                                  const _errs76 = errors;
                                                  if (data21 !== null) {
                                                    const err30 = { instancePath: instancePath + "/placeholders/" + i1 + "/selector_version", schemaPath: "#/$defs/PlaceholderUse/properties/selector_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                    if (vErrors === null) {
                                                      vErrors = [err30];
                                                    } else {
                                                      vErrors.push(err30);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid6 = _errs76 === errors;
                                                  valid15 = valid15 || _valid6;
                                                  if (!valid15) {
                                                    const err31 = { instancePath: instancePath + "/placeholders/" + i1 + "/selector_version", schemaPath: "#/$defs/PlaceholderUse/properties/selector_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                    if (vErrors === null) {
                                                      vErrors = [err31];
                                                    } else {
                                                      vErrors.push(err31);
                                                    }
                                                    errors++;
                                                    validate65.errors = vErrors;
                                                    return false;
                                                  } else {
                                                    errors = _errs73;
                                                    if (vErrors !== null) {
                                                      if (_errs73) {
                                                        vErrors.length = _errs73;
                                                      } else {
                                                        vErrors = null;
                                                      }
                                                    }
                                                  }
                                                  var valid11 = _errs72 === errors;
                                                } else {
                                                  var valid11 = true;
                                                }
                                                if (valid11) {
                                                  if (data14.source !== void 0) {
                                                    let data22 = data14.source;
                                                    const _errs78 = errors;
                                                    if (typeof data22 !== "string") {
                                                      validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/source", schemaPath: "#/$defs/PlaceholderUse/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                      return false;
                                                    }
                                                    if (!(data22 === "selector" || data22 === "input")) {
                                                      validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1 + "/source", schemaPath: "#/$defs/PlaceholderUse/properties/source/enum", keyword: "enum", params: { allowedValues: schema99.properties.source.enum }, message: "must be equal to one of the allowed values" }];
                                                      return false;
                                                    }
                                                    var valid11 = _errs78 === errors;
                                                  } else {
                                                    var valid11 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate65.errors = [{ instancePath: instancePath + "/placeholders/" + i1, schemaPath: "#/$defs/PlaceholderUse/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                  return false;
                                }
                              }
                              var valid9 = _errs48 === errors;
                              if (!valid9) {
                                break;
                              }
                            }
                          } else {
                            validate65.errors = [{ instancePath: instancePath + "/placeholders", schemaPath: "#/properties/placeholders/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs46 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.placement !== void 0) {
                          let data23 = data.placement;
                          const _errs80 = errors;
                          const _errs81 = errors;
                          let valid16 = false;
                          const _errs82 = errors;
                          const _errs83 = errors;
                          if (errors === _errs83) {
                            if (data23 && typeof data23 == "object" && !Array.isArray(data23)) {
                              let missing3;
                              if (data23.workflow === void 0 && (missing3 = "workflow") || data23.key === void 0 && (missing3 = "key")) {
                                const err32 = { instancePath: instancePath + "/placement", schemaPath: "#/$defs/StepPlacement/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err32];
                                } else {
                                  vErrors.push(err32);
                                }
                                errors++;
                              } else {
                                const _errs85 = errors;
                                for (const key4 in data23) {
                                  if (!(key4 === "key" || key4 === "workflow")) {
                                    const err33 = { instancePath: instancePath + "/placement", schemaPath: "#/$defs/StepPlacement/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                      vErrors = [err33];
                                    } else {
                                      vErrors.push(err33);
                                    }
                                    errors++;
                                    break;
                                  }
                                }
                                if (_errs85 === errors) {
                                  if (data23.key !== void 0) {
                                    let data24 = data23.key;
                                    const _errs86 = errors;
                                    if (errors === _errs86) {
                                      if (typeof data24 === "string") {
                                        if (!pattern8.test(data24)) {
                                          const err34 = { instancePath: instancePath + "/placement/key", schemaPath: "#/$defs/StepPlacement/properties/key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                                          if (vErrors === null) {
                                            vErrors = [err34];
                                          } else {
                                            vErrors.push(err34);
                                          }
                                          errors++;
                                        }
                                      } else {
                                        const err35 = { instancePath: instancePath + "/placement/key", schemaPath: "#/$defs/StepPlacement/properties/key/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err35];
                                        } else {
                                          vErrors.push(err35);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid18 = _errs86 === errors;
                                  } else {
                                    var valid18 = true;
                                  }
                                  if (valid18) {
                                    if (data23.workflow !== void 0) {
                                      const _errs88 = errors;
                                      if (typeof data23.workflow !== "string") {
                                        const err36 = { instancePath: instancePath + "/placement/workflow", schemaPath: "#/$defs/StepPlacement/properties/workflow/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err36];
                                        } else {
                                          vErrors.push(err36);
                                        }
                                        errors++;
                                      }
                                      var valid18 = _errs88 === errors;
                                    } else {
                                      var valid18 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              const err37 = { instancePath: instancePath + "/placement", schemaPath: "#/$defs/StepPlacement/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err37];
                              } else {
                                vErrors.push(err37);
                              }
                              errors++;
                            }
                          }
                          var _valid7 = _errs82 === errors;
                          valid16 = valid16 || _valid7;
                          const _errs90 = errors;
                          if (data23 !== null) {
                            const err38 = { instancePath: instancePath + "/placement", schemaPath: "#/properties/placement/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err38];
                            } else {
                              vErrors.push(err38);
                            }
                            errors++;
                          }
                          var _valid7 = _errs90 === errors;
                          valid16 = valid16 || _valid7;
                          if (!valid16) {
                            const err39 = { instancePath: instancePath + "/placement", schemaPath: "#/properties/placement/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err39];
                            } else {
                              vErrors.push(err39);
                            }
                            errors++;
                            validate65.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs81;
                            if (vErrors !== null) {
                              if (_errs81) {
                                vErrors.length = _errs81;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs80 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.prompt !== void 0) {
                            let data26 = data.prompt;
                            const _errs92 = errors;
                            const _errs93 = errors;
                            let valid19 = false;
                            const _errs94 = errors;
                            if (typeof data26 !== "string") {
                              const err40 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err40];
                              } else {
                                vErrors.push(err40);
                              }
                              errors++;
                            }
                            var _valid8 = _errs94 === errors;
                            valid19 = valid19 || _valid8;
                            const _errs96 = errors;
                            if (data26 !== null) {
                              const err41 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err41];
                              } else {
                                vErrors.push(err41);
                              }
                              errors++;
                            }
                            var _valid8 = _errs96 === errors;
                            valid19 = valid19 || _valid8;
                            if (!valid19) {
                              const err42 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err42];
                              } else {
                                vErrors.push(err42);
                              }
                              errors++;
                              validate65.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs93;
                              if (vErrors !== null) {
                                if (_errs93) {
                                  vErrors.length = _errs93;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs92 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.selection !== void 0) {
                              let data27 = data.selection;
                              const _errs98 = errors;
                              if (errors === _errs98) {
                                if (Array.isArray(data27)) {
                                  var valid20 = true;
                                  const len3 = data27.length;
                                  for (let i3 = 0; i3 < len3; i3++) {
                                    const _errs100 = errors;
                                    if (typeof data27[i3] !== "string") {
                                      validate65.errors = [{ instancePath: instancePath + "/selection/" + i3, schemaPath: "#/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid20 = _errs100 === errors;
                                    if (!valid20) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate65.errors = [{ instancePath: instancePath + "/selection", schemaPath: "#/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs98 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.server_version !== void 0) {
                                const _errs102 = errors;
                                if (typeof data.server_version !== "string") {
                                  validate65.errors = [{ instancePath: instancePath + "/server_version", schemaPath: "#/properties/server_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs102 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.step !== void 0) {
                                  let data30 = data.step;
                                  const _errs104 = errors;
                                  const _errs105 = errors;
                                  let valid21 = false;
                                  const _errs106 = errors;
                                  if (typeof data30 !== "string") {
                                    const err43 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err43];
                                    } else {
                                      vErrors.push(err43);
                                    }
                                    errors++;
                                  }
                                  var _valid9 = _errs106 === errors;
                                  valid21 = valid21 || _valid9;
                                  const _errs108 = errors;
                                  if (data30 !== null) {
                                    const err44 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err44];
                                    } else {
                                      vErrors.push(err44);
                                    }
                                    errors++;
                                  }
                                  var _valid9 = _errs108 === errors;
                                  valid21 = valid21 || _valid9;
                                  if (!valid21) {
                                    const err45 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err45];
                                    } else {
                                      vErrors.push(err45);
                                    }
                                    errors++;
                                    validate65.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs105;
                                    if (vErrors !== null) {
                                      if (_errs105) {
                                        vErrors.length = _errs105;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs104 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.step_instructions !== void 0) {
                                    let data31 = data.step_instructions;
                                    const _errs110 = errors;
                                    const _errs111 = errors;
                                    let valid22 = false;
                                    const _errs112 = errors;
                                    if (typeof data31 !== "string") {
                                      const err46 = { instancePath: instancePath + "/step_instructions", schemaPath: "#/properties/step_instructions/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err46];
                                      } else {
                                        vErrors.push(err46);
                                      }
                                      errors++;
                                    }
                                    var _valid10 = _errs112 === errors;
                                    valid22 = valid22 || _valid10;
                                    const _errs114 = errors;
                                    if (data31 !== null) {
                                      const err47 = { instancePath: instancePath + "/step_instructions", schemaPath: "#/properties/step_instructions/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                      if (vErrors === null) {
                                        vErrors = [err47];
                                      } else {
                                        vErrors.push(err47);
                                      }
                                      errors++;
                                    }
                                    var _valid10 = _errs114 === errors;
                                    valid22 = valid22 || _valid10;
                                    if (!valid22) {
                                      const err48 = { instancePath: instancePath + "/step_instructions", schemaPath: "#/properties/step_instructions/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err48];
                                      } else {
                                        vErrors.push(err48);
                                      }
                                      errors++;
                                      validate65.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs111;
                                      if (vErrors !== null) {
                                        if (_errs111) {
                                          vErrors.length = _errs111;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid0 = _errs110 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.subject !== void 0) {
                                      let data32 = data.subject;
                                      const _errs116 = errors;
                                      const _errs117 = errors;
                                      let valid23 = false;
                                      const _errs118 = errors;
                                      if (typeof data32 !== "string") {
                                        const err49 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err49];
                                        } else {
                                          vErrors.push(err49);
                                        }
                                        errors++;
                                      }
                                      var _valid11 = _errs118 === errors;
                                      valid23 = valid23 || _valid11;
                                      const _errs120 = errors;
                                      if (data32 !== null) {
                                        const err50 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err50];
                                        } else {
                                          vErrors.push(err50);
                                        }
                                        errors++;
                                      }
                                      var _valid11 = _errs120 === errors;
                                      valid23 = valid23 || _valid11;
                                      if (!valid23) {
                                        const err51 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err51];
                                        } else {
                                          vErrors.push(err51);
                                        }
                                        errors++;
                                        validate65.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs117;
                                        if (vErrors !== null) {
                                          if (_errs117) {
                                            vErrors.length = _errs117;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid0 = _errs116 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.workflow !== void 0) {
                                        let data33 = data.workflow;
                                        const _errs122 = errors;
                                        const _errs123 = errors;
                                        let valid24 = false;
                                        const _errs124 = errors;
                                        if (typeof data33 !== "string") {
                                          const err52 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err52];
                                          } else {
                                            vErrors.push(err52);
                                          }
                                          errors++;
                                        }
                                        var _valid12 = _errs124 === errors;
                                        valid24 = valid24 || _valid12;
                                        const _errs126 = errors;
                                        if (data33 !== null) {
                                          const err53 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err53];
                                          } else {
                                            vErrors.push(err53);
                                          }
                                          errors++;
                                        }
                                        var _valid12 = _errs126 === errors;
                                        valid24 = valid24 || _valid12;
                                        if (!valid24) {
                                          const err54 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err54];
                                          } else {
                                            vErrors.push(err54);
                                          }
                                          errors++;
                                          validate65.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs123;
                                          if (vErrors !== null) {
                                            if (_errs123) {
                                              vErrors.length = _errs123;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid0 = _errs122 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate65.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate65.errors = vErrors;
  return errors === 0;
}
validate65.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate43(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate43.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.turn_kind === void 0 && (missing0 = "turn_kind") || data.step_key === void 0 && (missing0 = "step_key") || data.step === void 0 && (missing0 = "step") || data.covers === void 0 && (missing0 = "covers") || data.based_on_entry === void 0 && (missing0 = "based_on_entry") || data.input === void 0 && (missing0 = "input") || data.input_digest === void 0 && (missing0 = "input_digest") || data.versions_used === void 0 && (missing0 = "versions_used") || data.route === void 0 && (missing0 = "route") || data.permission_profile === void 0 && (missing0 = "permission_profile") || data.tools === void 0 && (missing0 = "tools") || data.session === void 0 && (missing0 = "session") || data.limits === void 0 && (missing0 = "limits") || data.expected_output === void 0 && (missing0 = "expected_output") || data.requested_by === void 0 && (missing0 = "requested_by")) {
        validate43.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema64.properties, key0)) {
            validate43.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.agent_setup !== void 0) {
            let data0 = data.agent_setup;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate43.errors = [{ instancePath: instancePath + "/agent_setup", schemaPath: "#/$defs/AgentSetupKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "extend" || data0 === "dmw_only")) {
              validate43.errors = [{ instancePath: instancePath + "/agent_setup", schemaPath: "#/$defs/AgentSetupKind/enum", keyword: "enum", params: { allowedValues: schema43.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.based_on_entry !== void 0) {
              let data1 = data.based_on_entry;
              const _errs5 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                validate43.errors = [{ instancePath: instancePath + "/based_on_entry", schemaPath: "#/properties/based_on_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              if (errors === _errs5) {
                if (typeof data1 == "number") {
                  if (data1 < 1 || isNaN(data1)) {
                    validate43.errors = [{ instancePath: instancePath + "/based_on_entry", schemaPath: "#/properties/based_on_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                    return false;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.capabilities !== void 0) {
                let data2 = data.capabilities;
                const _errs7 = errors;
                const _errs8 = errors;
                let valid2 = false;
                const _errs9 = errors;
                if (!validate44(data2, { instancePath: instancePath + "/capabilities", parentData: data, parentDataProperty: "capabilities", rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                  errors = vErrors.length;
                }
                var _valid0 = _errs9 === errors;
                valid2 = valid2 || _valid0;
                const _errs10 = errors;
                if (data2 !== null) {
                  const err0 = { instancePath: instancePath + "/capabilities", schemaPath: "#/properties/capabilities/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                var _valid0 = _errs10 === errors;
                valid2 = valid2 || _valid0;
                if (!valid2) {
                  const err1 = { instancePath: instancePath + "/capabilities", schemaPath: "#/properties/capabilities/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                  validate43.errors = vErrors;
                  return false;
                } else {
                  errors = _errs8;
                  if (vErrors !== null) {
                    if (_errs8) {
                      vErrors.length = _errs8;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.covers !== void 0) {
                  let data3 = data.covers;
                  const _errs12 = errors;
                  if (errors === _errs12) {
                    if (Array.isArray(data3)) {
                      var valid3 = true;
                      const len0 = data3.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data4 = data3[i0];
                        const _errs14 = errors;
                        if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)))) {
                          validate43.errors = [{ instancePath: instancePath + "/covers/" + i0, schemaPath: "#/properties/covers/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                          return false;
                        }
                        if (errors === _errs14) {
                          if (typeof data4 == "number") {
                            if (data4 < 1 || isNaN(data4)) {
                              validate43.errors = [{ instancePath: instancePath + "/covers/" + i0, schemaPath: "#/properties/covers/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                              return false;
                            }
                          }
                        }
                        var valid3 = _errs14 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    } else {
                      validate43.errors = [{ instancePath: instancePath + "/covers", schemaPath: "#/properties/covers/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.expected_output !== void 0) {
                    const _errs16 = errors;
                    if (!validate50(data.expected_output, { instancePath: instancePath + "/expected_output", parentData: data, parentDataProperty: "expected_output", rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs16 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.input !== void 0) {
                      let data6 = data.input;
                      const _errs17 = errors;
                      if (errors === _errs17) {
                        if (Array.isArray(data6)) {
                          var valid4 = true;
                          const len1 = data6.length;
                          for (let i1 = 0; i1 < len1; i1++) {
                            const _errs19 = errors;
                            if (!validate52(data6[i1], { instancePath: instancePath + "/input/" + i1, parentData: data6, parentDataProperty: i1, rootData, dynamicAnchors })) {
                              vErrors = vErrors === null ? validate52.errors : vErrors.concat(validate52.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs19 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        } else {
                          validate43.errors = [{ instancePath: instancePath + "/input", schemaPath: "#/properties/input/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.input_digest !== void 0) {
                        let data8 = data.input_digest;
                        const _errs20 = errors;
                        if (errors === _errs20) {
                          if (typeof data8 === "string") {
                            if (!pattern24.test(data8)) {
                              validate43.errors = [{ instancePath: instancePath + "/input_digest", schemaPath: "#/properties/input_digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' }];
                              return false;
                            }
                          } else {
                            validate43.errors = [{ instancePath: instancePath + "/input_digest", schemaPath: "#/properties/input_digest/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                        }
                        var valid0 = _errs20 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.input_values !== void 0) {
                          let data9 = data.input_values;
                          const _errs22 = errors;
                          if (errors === _errs22) {
                            if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                              var props1 = {};
                              for (const key1 in data9) {
                                if (pattern8.test(key1)) {
                                  props1[key1] = true;
                                }
                              }
                            } else {
                              validate43.errors = [{ instancePath: instancePath + "/input_values", schemaPath: "#/properties/input_values/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                              return false;
                            }
                          }
                          var valid0 = _errs22 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.item_tools !== void 0) {
                            let data11 = data.item_tools;
                            const _errs25 = errors;
                            if (errors === _errs25) {
                              if (Array.isArray(data11)) {
                                var valid7 = true;
                                const len2 = data11.length;
                                for (let i2 = 0; i2 < len2; i2++) {
                                  const _errs27 = errors;
                                  if (typeof data11[i2] !== "string") {
                                    validate43.errors = [{ instancePath: instancePath + "/item_tools/" + i2, schemaPath: "#/properties/item_tools/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid7 = _errs27 === errors;
                                  if (!valid7) {
                                    break;
                                  }
                                }
                              } else {
                                validate43.errors = [{ instancePath: instancePath + "/item_tools", schemaPath: "#/properties/item_tools/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                return false;
                              }
                            }
                            var valid0 = _errs25 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.kind !== void 0) {
                              let data13 = data.kind;
                              const _errs29 = errors;
                              if (typeof data13 !== "string") {
                                validate43.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if ("turn_requested" !== data13) {
                                validate43.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "turn_requested" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid0 = _errs29 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.limits !== void 0) {
                                let data14 = data.limits;
                                const _errs31 = errors;
                                const _errs32 = errors;
                                if (errors === _errs32) {
                                  if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                                    let missing1;
                                    if (data14.timeout_seconds === void 0 && (missing1 = "timeout_seconds") || data14.maximum_tool_rounds === void 0 && (missing1 = "maximum_tool_rounds")) {
                                      validate43.errors = [{ instancePath: instancePath + "/limits", schemaPath: "#/$defs/TurnLimits/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                                      return false;
                                    } else {
                                      if (data14.maximum_tool_rounds !== void 0) {
                                        let data15 = data14.maximum_tool_rounds;
                                        const _errs34 = errors;
                                        if (!(typeof data15 == "number" && (!(data15 % 1) && !isNaN(data15)))) {
                                          validate43.errors = [{ instancePath: instancePath + "/limits/maximum_tool_rounds", schemaPath: "#/$defs/TurnLimits/properties/maximum_tool_rounds/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                          return false;
                                        }
                                        if (errors === _errs34) {
                                          if (typeof data15 == "number") {
                                            if (data15 < 1 || isNaN(data15)) {
                                              validate43.errors = [{ instancePath: instancePath + "/limits/maximum_tool_rounds", schemaPath: "#/$defs/TurnLimits/properties/maximum_tool_rounds/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                              return false;
                                            }
                                          }
                                        }
                                        var valid9 = _errs34 === errors;
                                      } else {
                                        var valid9 = true;
                                      }
                                      if (valid9) {
                                        if (data14.timeout_seconds !== void 0) {
                                          let data16 = data14.timeout_seconds;
                                          const _errs36 = errors;
                                          if (!(typeof data16 == "number" && (!(data16 % 1) && !isNaN(data16)))) {
                                            validate43.errors = [{ instancePath: instancePath + "/limits/timeout_seconds", schemaPath: "#/$defs/TurnLimits/properties/timeout_seconds/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                            return false;
                                          }
                                          if (errors === _errs36) {
                                            if (typeof data16 == "number") {
                                              if (data16 < 1 || isNaN(data16)) {
                                                validate43.errors = [{ instancePath: instancePath + "/limits/timeout_seconds", schemaPath: "#/$defs/TurnLimits/properties/timeout_seconds/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                                return false;
                                              }
                                            }
                                          }
                                          var valid9 = _errs36 === errors;
                                        } else {
                                          var valid9 = true;
                                        }
                                      }
                                    }
                                  } else {
                                    validate43.errors = [{ instancePath: instancePath + "/limits", schemaPath: "#/$defs/TurnLimits/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                    return false;
                                  }
                                }
                                var valid0 = _errs31 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.next_route !== void 0) {
                                  let data17 = data.next_route;
                                  const _errs38 = errors;
                                  const _errs39 = errors;
                                  let valid10 = false;
                                  const _errs40 = errors;
                                  const _errs41 = errors;
                                  let valid11 = false;
                                  let passing0 = null;
                                  const _errs42 = errors;
                                  const _errs43 = errors;
                                  if (errors === _errs43) {
                                    if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                      let missing2;
                                      if (data17.kind === void 0 && (missing2 = "kind") || data17.agent_id === void 0 && (missing2 = "agent_id") || data17.model_id === void 0 && (missing2 = "model_id")) {
                                        const err2 = { instancePath: instancePath + "/next_route", schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                                        if (vErrors === null) {
                                          vErrors = [err2];
                                        } else {
                                          vErrors.push(err2);
                                        }
                                        errors++;
                                      } else {
                                        if (data17.agent_id !== void 0) {
                                          let data18 = data17.agent_id;
                                          const _errs45 = errors;
                                          if (errors === _errs45) {
                                            if (typeof data18 === "string") {
                                              if (!pattern4.test(data18)) {
                                                const err3 = { instancePath: instancePath + "/next_route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                if (vErrors === null) {
                                                  vErrors = [err3];
                                                } else {
                                                  vErrors.push(err3);
                                                }
                                                errors++;
                                              }
                                            } else {
                                              const err4 = { instancePath: instancePath + "/next_route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                              if (vErrors === null) {
                                                vErrors = [err4];
                                              } else {
                                                vErrors.push(err4);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid13 = _errs45 === errors;
                                        } else {
                                          var valid13 = true;
                                        }
                                        if (valid13) {
                                          if (data17.kind !== void 0) {
                                            let data19 = data17.kind;
                                            const _errs47 = errors;
                                            if (typeof data19 !== "string") {
                                              const err5 = { instancePath: instancePath + "/next_route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                              if (vErrors === null) {
                                                vErrors = [err5];
                                              } else {
                                                vErrors.push(err5);
                                              }
                                              errors++;
                                            }
                                            if ("agent" !== data19) {
                                              const err6 = { instancePath: instancePath + "/next_route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                              if (vErrors === null) {
                                                vErrors = [err6];
                                              } else {
                                                vErrors.push(err6);
                                              }
                                              errors++;
                                            }
                                            var valid13 = _errs47 === errors;
                                          } else {
                                            var valid13 = true;
                                          }
                                          if (valid13) {
                                            if (data17.model_id !== void 0) {
                                              let data20 = data17.model_id;
                                              const _errs49 = errors;
                                              const _errs50 = errors;
                                              let valid14 = false;
                                              const _errs51 = errors;
                                              if (errors === _errs51) {
                                                if (typeof data20 === "string") {
                                                  if (func2(data20) > 200) {
                                                    const err7 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                    if (vErrors === null) {
                                                      vErrors = [err7];
                                                    } else {
                                                      vErrors.push(err7);
                                                    }
                                                    errors++;
                                                  } else {
                                                    if (func2(data20) < 1) {
                                                      const err8 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                      if (vErrors === null) {
                                                        vErrors = [err8];
                                                      } else {
                                                        vErrors.push(err8);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                } else {
                                                  const err9 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err9];
                                                  } else {
                                                    vErrors.push(err9);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var _valid3 = _errs51 === errors;
                                              valid14 = valid14 || _valid3;
                                              const _errs53 = errors;
                                              if (data20 !== null) {
                                                const err10 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                if (vErrors === null) {
                                                  vErrors = [err10];
                                                } else {
                                                  vErrors.push(err10);
                                                }
                                                errors++;
                                              }
                                              var _valid3 = _errs53 === errors;
                                              valid14 = valid14 || _valid3;
                                              if (!valid14) {
                                                const err11 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                if (vErrors === null) {
                                                  vErrors = [err11];
                                                } else {
                                                  vErrors.push(err11);
                                                }
                                                errors++;
                                              } else {
                                                errors = _errs50;
                                                if (vErrors !== null) {
                                                  if (_errs50) {
                                                    vErrors.length = _errs50;
                                                  } else {
                                                    vErrors = null;
                                                  }
                                                }
                                              }
                                              var valid13 = _errs49 === errors;
                                            } else {
                                              var valid13 = true;
                                            }
                                            if (valid13) {
                                              if (data17.reasoning_effort !== void 0) {
                                                let data21 = data17.reasoning_effort;
                                                const _errs55 = errors;
                                                const _errs56 = errors;
                                                let valid15 = false;
                                                const _errs57 = errors;
                                                if (errors === _errs57) {
                                                  if (typeof data21 === "string") {
                                                    if (func2(data21) > 200) {
                                                      const err12 = { instancePath: instancePath + "/next_route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                      if (vErrors === null) {
                                                        vErrors = [err12];
                                                      } else {
                                                        vErrors.push(err12);
                                                      }
                                                      errors++;
                                                    } else {
                                                      if (func2(data21) < 1) {
                                                        const err13 = { instancePath: instancePath + "/next_route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err13];
                                                        } else {
                                                          vErrors.push(err13);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                  } else {
                                                    const err14 = { instancePath: instancePath + "/next_route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err14];
                                                    } else {
                                                      vErrors.push(err14);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var _valid4 = _errs57 === errors;
                                                valid15 = valid15 || _valid4;
                                                const _errs59 = errors;
                                                if (data21 !== null) {
                                                  const err15 = { instancePath: instancePath + "/next_route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                  if (vErrors === null) {
                                                    vErrors = [err15];
                                                  } else {
                                                    vErrors.push(err15);
                                                  }
                                                  errors++;
                                                }
                                                var _valid4 = _errs59 === errors;
                                                valid15 = valid15 || _valid4;
                                                if (!valid15) {
                                                  const err16 = { instancePath: instancePath + "/next_route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                  if (vErrors === null) {
                                                    vErrors = [err16];
                                                  } else {
                                                    vErrors.push(err16);
                                                  }
                                                  errors++;
                                                } else {
                                                  errors = _errs56;
                                                  if (vErrors !== null) {
                                                    if (_errs56) {
                                                      vErrors.length = _errs56;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid13 = _errs55 === errors;
                                              } else {
                                                var valid13 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      const err17 = { instancePath: instancePath + "/next_route", schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                      if (vErrors === null) {
                                        vErrors = [err17];
                                      } else {
                                        vErrors.push(err17);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid2 = _errs42 === errors;
                                  if (_valid2) {
                                    valid11 = true;
                                    passing0 = 0;
                                    var props2 = {};
                                    props2.agent_id = true;
                                    props2.kind = true;
                                    props2.model_id = true;
                                    props2.reasoning_effort = true;
                                  }
                                  const _errs61 = errors;
                                  const _errs62 = errors;
                                  if (errors === _errs62) {
                                    if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                      let missing3;
                                      if (data17.kind === void 0 && (missing3 = "kind") || data17.route_id === void 0 && (missing3 = "route_id") || data17.model_id === void 0 && (missing3 = "model_id")) {
                                        const err18 = { instancePath: instancePath + "/next_route", schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" };
                                        if (vErrors === null) {
                                          vErrors = [err18];
                                        } else {
                                          vErrors.push(err18);
                                        }
                                        errors++;
                                      } else {
                                        if (data17.kind !== void 0) {
                                          let data22 = data17.kind;
                                          const _errs64 = errors;
                                          if (typeof data22 !== "string") {
                                            const err19 = { instancePath: instancePath + "/next_route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                              vErrors = [err19];
                                            } else {
                                              vErrors.push(err19);
                                            }
                                            errors++;
                                          }
                                          if ("api_key" !== data22) {
                                            const err20 = { instancePath: instancePath + "/next_route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                            if (vErrors === null) {
                                              vErrors = [err20];
                                            } else {
                                              vErrors.push(err20);
                                            }
                                            errors++;
                                          }
                                          var valid17 = _errs64 === errors;
                                        } else {
                                          var valid17 = true;
                                        }
                                        if (valid17) {
                                          if (data17.model_id !== void 0) {
                                            let data23 = data17.model_id;
                                            const _errs66 = errors;
                                            if (errors === _errs66) {
                                              if (typeof data23 === "string") {
                                                if (func2(data23) > 200) {
                                                  const err21 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                  if (vErrors === null) {
                                                    vErrors = [err21];
                                                  } else {
                                                    vErrors.push(err21);
                                                  }
                                                  errors++;
                                                } else {
                                                  if (func2(data23) < 1) {
                                                    const err22 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                    if (vErrors === null) {
                                                      vErrors = [err22];
                                                    } else {
                                                      vErrors.push(err22);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                              } else {
                                                const err23 = { instancePath: instancePath + "/next_route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err23];
                                                } else {
                                                  vErrors.push(err23);
                                                }
                                                errors++;
                                              }
                                            }
                                            var valid17 = _errs66 === errors;
                                          } else {
                                            var valid17 = true;
                                          }
                                          if (valid17) {
                                            if (data17.route_id !== void 0) {
                                              let data24 = data17.route_id;
                                              const _errs68 = errors;
                                              if (errors === _errs68) {
                                                if (typeof data24 === "string") {
                                                  if (!pattern4.test(data24)) {
                                                    const err24 = { instancePath: instancePath + "/next_route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                    if (vErrors === null) {
                                                      vErrors = [err24];
                                                    } else {
                                                      vErrors.push(err24);
                                                    }
                                                    errors++;
                                                  }
                                                } else {
                                                  const err25 = { instancePath: instancePath + "/next_route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err25];
                                                  } else {
                                                    vErrors.push(err25);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var valid17 = _errs68 === errors;
                                            } else {
                                              var valid17 = true;
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      const err26 = { instancePath: instancePath + "/next_route", schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                      if (vErrors === null) {
                                        vErrors = [err26];
                                      } else {
                                        vErrors.push(err26);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid2 = _errs61 === errors;
                                  if (_valid2 && valid11) {
                                    valid11 = false;
                                    passing0 = [passing0, 1];
                                  } else {
                                    if (_valid2) {
                                      valid11 = true;
                                      passing0 = 1;
                                      if (props2 !== true) {
                                        props2 = props2 || {};
                                        props2.kind = true;
                                        props2.model_id = true;
                                        props2.route_id = true;
                                      }
                                    }
                                  }
                                  if (!valid11) {
                                    const err27 = { instancePath: instancePath + "/next_route", schemaPath: "#/properties/next_route/anyOf/0/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                                    if (vErrors === null) {
                                      vErrors = [err27];
                                    } else {
                                      vErrors.push(err27);
                                    }
                                    errors++;
                                  } else {
                                    errors = _errs41;
                                    if (vErrors !== null) {
                                      if (_errs41) {
                                        vErrors.length = _errs41;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var _valid1 = _errs40 === errors;
                                  valid10 = valid10 || _valid1;
                                  const _errs70 = errors;
                                  if (data17 !== null) {
                                    const err28 = { instancePath: instancePath + "/next_route", schemaPath: "#/properties/next_route/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err28];
                                    } else {
                                      vErrors.push(err28);
                                    }
                                    errors++;
                                  }
                                  var _valid1 = _errs70 === errors;
                                  valid10 = valid10 || _valid1;
                                  if (!valid10) {
                                    const err29 = { instancePath: instancePath + "/next_route", schemaPath: "#/properties/next_route/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err29];
                                    } else {
                                      vErrors.push(err29);
                                    }
                                    errors++;
                                    validate43.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs39;
                                    if (vErrors !== null) {
                                      if (_errs39) {
                                        vErrors.length = _errs39;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs38 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.permission_profile !== void 0) {
                                    let data25 = data.permission_profile;
                                    const _errs72 = errors;
                                    if (errors === _errs72) {
                                      if (typeof data25 === "string") {
                                        if (!pattern4.test(data25)) {
                                          validate43.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                          return false;
                                        }
                                      } else {
                                        validate43.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                    }
                                    var valid0 = _errs72 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.requested_by !== void 0) {
                                      let data26 = data.requested_by;
                                      const _errs74 = errors;
                                      const _errs75 = errors;
                                      let valid18 = false;
                                      const _errs76 = errors;
                                      if (typeof data26 !== "string") {
                                        const err30 = { instancePath: instancePath + "/requested_by", schemaPath: "#/properties/requested_by/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err30];
                                        } else {
                                          vErrors.push(err30);
                                        }
                                        errors++;
                                      }
                                      var _valid5 = _errs76 === errors;
                                      valid18 = valid18 || _valid5;
                                      const _errs78 = errors;
                                      if (data26 !== null) {
                                        const err31 = { instancePath: instancePath + "/requested_by", schemaPath: "#/properties/requested_by/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err31];
                                        } else {
                                          vErrors.push(err31);
                                        }
                                        errors++;
                                      }
                                      var _valid5 = _errs78 === errors;
                                      valid18 = valid18 || _valid5;
                                      if (!valid18) {
                                        const err32 = { instancePath: instancePath + "/requested_by", schemaPath: "#/properties/requested_by/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err32];
                                        } else {
                                          vErrors.push(err32);
                                        }
                                        errors++;
                                        validate43.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs75;
                                        if (vErrors !== null) {
                                          if (_errs75) {
                                            vErrors.length = _errs75;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid0 = _errs74 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.route !== void 0) {
                                        let data27 = data.route;
                                        const _errs80 = errors;
                                        const _errs81 = errors;
                                        let valid19 = false;
                                        let passing1 = null;
                                        const _errs82 = errors;
                                        const _errs83 = errors;
                                        if (errors === _errs83) {
                                          if (data27 && typeof data27 == "object" && !Array.isArray(data27)) {
                                            let missing4;
                                            if (data27.kind === void 0 && (missing4 = "kind") || data27.agent_id === void 0 && (missing4 = "agent_id") || data27.model_id === void 0 && (missing4 = "model_id")) {
                                              const err33 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing4 }, message: "must have required property '" + missing4 + "'" };
                                              if (vErrors === null) {
                                                vErrors = [err33];
                                              } else {
                                                vErrors.push(err33);
                                              }
                                              errors++;
                                            } else {
                                              if (data27.agent_id !== void 0) {
                                                let data28 = data27.agent_id;
                                                const _errs85 = errors;
                                                if (errors === _errs85) {
                                                  if (typeof data28 === "string") {
                                                    if (!pattern4.test(data28)) {
                                                      const err34 = { instancePath: instancePath + "/route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                      if (vErrors === null) {
                                                        vErrors = [err34];
                                                      } else {
                                                        vErrors.push(err34);
                                                      }
                                                      errors++;
                                                    }
                                                  } else {
                                                    const err35 = { instancePath: instancePath + "/route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err35];
                                                    } else {
                                                      vErrors.push(err35);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var valid21 = _errs85 === errors;
                                              } else {
                                                var valid21 = true;
                                              }
                                              if (valid21) {
                                                if (data27.kind !== void 0) {
                                                  let data29 = data27.kind;
                                                  const _errs87 = errors;
                                                  if (typeof data29 !== "string") {
                                                    const err36 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err36];
                                                    } else {
                                                      vErrors.push(err36);
                                                    }
                                                    errors++;
                                                  }
                                                  if ("agent" !== data29) {
                                                    const err37 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                                    if (vErrors === null) {
                                                      vErrors = [err37];
                                                    } else {
                                                      vErrors.push(err37);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid21 = _errs87 === errors;
                                                } else {
                                                  var valid21 = true;
                                                }
                                                if (valid21) {
                                                  if (data27.model_id !== void 0) {
                                                    let data30 = data27.model_id;
                                                    const _errs89 = errors;
                                                    const _errs90 = errors;
                                                    let valid22 = false;
                                                    const _errs91 = errors;
                                                    if (errors === _errs91) {
                                                      if (typeof data30 === "string") {
                                                        if (func2(data30) > 200) {
                                                          const err38 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err38];
                                                          } else {
                                                            vErrors.push(err38);
                                                          }
                                                          errors++;
                                                        } else {
                                                          if (func2(data30) < 1) {
                                                            const err39 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                            if (vErrors === null) {
                                                              vErrors = [err39];
                                                            } else {
                                                              vErrors.push(err39);
                                                            }
                                                            errors++;
                                                          }
                                                        }
                                                      } else {
                                                        const err40 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                        if (vErrors === null) {
                                                          vErrors = [err40];
                                                        } else {
                                                          vErrors.push(err40);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                    var _valid7 = _errs91 === errors;
                                                    valid22 = valid22 || _valid7;
                                                    const _errs93 = errors;
                                                    if (data30 !== null) {
                                                      const err41 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                      if (vErrors === null) {
                                                        vErrors = [err41];
                                                      } else {
                                                        vErrors.push(err41);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid7 = _errs93 === errors;
                                                    valid22 = valid22 || _valid7;
                                                    if (!valid22) {
                                                      const err42 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                      if (vErrors === null) {
                                                        vErrors = [err42];
                                                      } else {
                                                        vErrors.push(err42);
                                                      }
                                                      errors++;
                                                    } else {
                                                      errors = _errs90;
                                                      if (vErrors !== null) {
                                                        if (_errs90) {
                                                          vErrors.length = _errs90;
                                                        } else {
                                                          vErrors = null;
                                                        }
                                                      }
                                                    }
                                                    var valid21 = _errs89 === errors;
                                                  } else {
                                                    var valid21 = true;
                                                  }
                                                  if (valid21) {
                                                    if (data27.reasoning_effort !== void 0) {
                                                      let data31 = data27.reasoning_effort;
                                                      const _errs95 = errors;
                                                      const _errs96 = errors;
                                                      let valid23 = false;
                                                      const _errs97 = errors;
                                                      if (errors === _errs97) {
                                                        if (typeof data31 === "string") {
                                                          if (func2(data31) > 200) {
                                                            const err43 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                            if (vErrors === null) {
                                                              vErrors = [err43];
                                                            } else {
                                                              vErrors.push(err43);
                                                            }
                                                            errors++;
                                                          } else {
                                                            if (func2(data31) < 1) {
                                                              const err44 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                              if (vErrors === null) {
                                                                vErrors = [err44];
                                                              } else {
                                                                vErrors.push(err44);
                                                              }
                                                              errors++;
                                                            }
                                                          }
                                                        } else {
                                                          const err45 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                          if (vErrors === null) {
                                                            vErrors = [err45];
                                                          } else {
                                                            vErrors.push(err45);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                      var _valid8 = _errs97 === errors;
                                                      valid23 = valid23 || _valid8;
                                                      const _errs99 = errors;
                                                      if (data31 !== null) {
                                                        const err46 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                        if (vErrors === null) {
                                                          vErrors = [err46];
                                                        } else {
                                                          vErrors.push(err46);
                                                        }
                                                        errors++;
                                                      }
                                                      var _valid8 = _errs99 === errors;
                                                      valid23 = valid23 || _valid8;
                                                      if (!valid23) {
                                                        const err47 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                        if (vErrors === null) {
                                                          vErrors = [err47];
                                                        } else {
                                                          vErrors.push(err47);
                                                        }
                                                        errors++;
                                                      } else {
                                                        errors = _errs96;
                                                        if (vErrors !== null) {
                                                          if (_errs96) {
                                                            vErrors.length = _errs96;
                                                          } else {
                                                            vErrors = null;
                                                          }
                                                        }
                                                      }
                                                      var valid21 = _errs95 === errors;
                                                    } else {
                                                      var valid21 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            const err48 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                              vErrors = [err48];
                                            } else {
                                              vErrors.push(err48);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid6 = _errs82 === errors;
                                        if (_valid6) {
                                          valid19 = true;
                                          passing1 = 0;
                                          var props3 = {};
                                          props3.agent_id = true;
                                          props3.kind = true;
                                          props3.model_id = true;
                                          props3.reasoning_effort = true;
                                        }
                                        const _errs101 = errors;
                                        const _errs102 = errors;
                                        if (errors === _errs102) {
                                          if (data27 && typeof data27 == "object" && !Array.isArray(data27)) {
                                            let missing5;
                                            if (data27.kind === void 0 && (missing5 = "kind") || data27.route_id === void 0 && (missing5 = "route_id") || data27.model_id === void 0 && (missing5 = "model_id")) {
                                              const err49 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing5 }, message: "must have required property '" + missing5 + "'" };
                                              if (vErrors === null) {
                                                vErrors = [err49];
                                              } else {
                                                vErrors.push(err49);
                                              }
                                              errors++;
                                            } else {
                                              if (data27.kind !== void 0) {
                                                let data32 = data27.kind;
                                                const _errs104 = errors;
                                                if (typeof data32 !== "string") {
                                                  const err50 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err50];
                                                  } else {
                                                    vErrors.push(err50);
                                                  }
                                                  errors++;
                                                }
                                                if ("api_key" !== data32) {
                                                  const err51 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                                  if (vErrors === null) {
                                                    vErrors = [err51];
                                                  } else {
                                                    vErrors.push(err51);
                                                  }
                                                  errors++;
                                                }
                                                var valid25 = _errs104 === errors;
                                              } else {
                                                var valid25 = true;
                                              }
                                              if (valid25) {
                                                if (data27.model_id !== void 0) {
                                                  let data33 = data27.model_id;
                                                  const _errs106 = errors;
                                                  if (errors === _errs106) {
                                                    if (typeof data33 === "string") {
                                                      if (func2(data33) > 200) {
                                                        const err52 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err52];
                                                        } else {
                                                          vErrors.push(err52);
                                                        }
                                                        errors++;
                                                      } else {
                                                        if (func2(data33) < 1) {
                                                          const err53 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err53];
                                                          } else {
                                                            vErrors.push(err53);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                    } else {
                                                      const err54 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                      if (vErrors === null) {
                                                        vErrors = [err54];
                                                      } else {
                                                        vErrors.push(err54);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var valid25 = _errs106 === errors;
                                                } else {
                                                  var valid25 = true;
                                                }
                                                if (valid25) {
                                                  if (data27.route_id !== void 0) {
                                                    let data34 = data27.route_id;
                                                    const _errs108 = errors;
                                                    if (errors === _errs108) {
                                                      if (typeof data34 === "string") {
                                                        if (!pattern4.test(data34)) {
                                                          const err55 = { instancePath: instancePath + "/route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                          if (vErrors === null) {
                                                            vErrors = [err55];
                                                          } else {
                                                            vErrors.push(err55);
                                                          }
                                                          errors++;
                                                        }
                                                      } else {
                                                        const err56 = { instancePath: instancePath + "/route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                        if (vErrors === null) {
                                                          vErrors = [err56];
                                                        } else {
                                                          vErrors.push(err56);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                    var valid25 = _errs108 === errors;
                                                  } else {
                                                    var valid25 = true;
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            const err57 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                              vErrors = [err57];
                                            } else {
                                              vErrors.push(err57);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid6 = _errs101 === errors;
                                        if (_valid6 && valid19) {
                                          valid19 = false;
                                          passing1 = [passing1, 1];
                                        } else {
                                          if (_valid6) {
                                            valid19 = true;
                                            passing1 = 1;
                                            if (props3 !== true) {
                                              props3 = props3 || {};
                                              props3.kind = true;
                                              props3.model_id = true;
                                              props3.route_id = true;
                                            }
                                          }
                                        }
                                        if (!valid19) {
                                          const err58 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf" };
                                          if (vErrors === null) {
                                            vErrors = [err58];
                                          } else {
                                            vErrors.push(err58);
                                          }
                                          errors++;
                                          validate43.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs81;
                                          if (vErrors !== null) {
                                            if (_errs81) {
                                              vErrors.length = _errs81;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid0 = _errs80 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.session !== void 0) {
                                          const _errs110 = errors;
                                          if (!validate54(data.session, { instancePath: instancePath + "/session", parentData: data, parentDataProperty: "session", rootData, dynamicAnchors })) {
                                            vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                            errors = vErrors.length;
                                          }
                                          var valid0 = _errs110 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.skills !== void 0) {
                                            let data36 = data.skills;
                                            const _errs111 = errors;
                                            if (errors === _errs111) {
                                              if (Array.isArray(data36)) {
                                                var valid26 = true;
                                                const len3 = data36.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                  let data37 = data36[i3];
                                                  const _errs113 = errors;
                                                  const _errs114 = errors;
                                                  if (errors === _errs114) {
                                                    if (data37 && typeof data37 == "object" && !Array.isArray(data37)) {
                                                      let missing6;
                                                      if (data37.skill === void 0 && (missing6 = "skill") || data37.name === void 0 && (missing6 = "name") || data37.description === void 0 && (missing6 = "description") || data37.use === void 0 && (missing6 = "use")) {
                                                        validate43.errors = [{ instancePath: instancePath + "/skills/" + i3, schemaPath: "#/$defs/TurnSkill/required", keyword: "required", params: { missingProperty: missing6 }, message: "must have required property '" + missing6 + "'" }];
                                                        return false;
                                                      } else {
                                                        const _errs116 = errors;
                                                        for (const key2 in data37) {
                                                          if (!(key2 === "description" || key2 === "name" || key2 === "skill" || key2 === "use")) {
                                                            validate43.errors = [{ instancePath: instancePath + "/skills/" + i3, schemaPath: "#/$defs/TurnSkill/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" }];
                                                            return false;
                                                            break;
                                                          }
                                                        }
                                                        if (_errs116 === errors) {
                                                          if (data37.description !== void 0) {
                                                            let data38 = data37.description;
                                                            const _errs117 = errors;
                                                            if (errors === _errs117) {
                                                              if (typeof data38 === "string") {
                                                                if (func2(data38) > 1024) {
                                                                  validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/description", schemaPath: "#/$defs/TurnSkill/properties/description/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" }];
                                                                  return false;
                                                                } else {
                                                                  if (func2(data38) < 1) {
                                                                    validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/description", schemaPath: "#/$defs/TurnSkill/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                                                    return false;
                                                                  }
                                                                }
                                                              } else {
                                                                validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/description", schemaPath: "#/$defs/TurnSkill/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                return false;
                                                              }
                                                            }
                                                            var valid28 = _errs117 === errors;
                                                          } else {
                                                            var valid28 = true;
                                                          }
                                                          if (valid28) {
                                                            if (data37.name !== void 0) {
                                                              let data39 = data37.name;
                                                              const _errs119 = errors;
                                                              if (errors === _errs119) {
                                                                if (typeof data39 === "string") {
                                                                  if (func2(data39) > 64) {
                                                                    validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/name", schemaPath: "#/$defs/TurnSkill/properties/name/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" }];
                                                                    return false;
                                                                  } else {
                                                                    if (func2(data39) < 1) {
                                                                      validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/name", schemaPath: "#/$defs/TurnSkill/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                                                      return false;
                                                                    }
                                                                  }
                                                                } else {
                                                                  validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/name", schemaPath: "#/$defs/TurnSkill/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                  return false;
                                                                }
                                                              }
                                                              var valid28 = _errs119 === errors;
                                                            } else {
                                                              var valid28 = true;
                                                            }
                                                            if (valid28) {
                                                              if (data37.skill !== void 0) {
                                                                const _errs121 = errors;
                                                                if (typeof data37.skill !== "string") {
                                                                  validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/skill", schemaPath: "#/$defs/TurnSkill/properties/skill/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                  return false;
                                                                }
                                                                var valid28 = _errs121 === errors;
                                                              } else {
                                                                var valid28 = true;
                                                              }
                                                              if (valid28) {
                                                                if (data37.use !== void 0) {
                                                                  let data41 = data37.use;
                                                                  const _errs123 = errors;
                                                                  if (typeof data41 !== "string") {
                                                                    validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/use", schemaPath: "#/$defs/TurnSkill/properties/use/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                    return false;
                                                                  }
                                                                  if (!(data41 === "offered" || data41 === "requested")) {
                                                                    validate43.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/use", schemaPath: "#/$defs/TurnSkill/properties/use/enum", keyword: "enum", params: { allowedValues: schema85.properties.use.enum }, message: "must be equal to one of the allowed values" }];
                                                                    return false;
                                                                  }
                                                                  var valid28 = _errs123 === errors;
                                                                } else {
                                                                  var valid28 = true;
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    } else {
                                                      validate43.errors = [{ instancePath: instancePath + "/skills/" + i3, schemaPath: "#/$defs/TurnSkill/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                                      return false;
                                                    }
                                                  }
                                                  var valid26 = _errs113 === errors;
                                                  if (!valid26) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                validate43.errors = [{ instancePath: instancePath + "/skills", schemaPath: "#/properties/skills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                return false;
                                              }
                                            }
                                            var valid0 = _errs111 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.step !== void 0) {
                                              let data42 = data.step;
                                              const _errs125 = errors;
                                              const _errs126 = errors;
                                              let valid29 = false;
                                              const _errs127 = errors;
                                              if (typeof data42 !== "string") {
                                                const err59 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err59];
                                                } else {
                                                  vErrors.push(err59);
                                                }
                                                errors++;
                                              }
                                              var _valid9 = _errs127 === errors;
                                              valid29 = valid29 || _valid9;
                                              const _errs129 = errors;
                                              if (data42 !== null) {
                                                const err60 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                if (vErrors === null) {
                                                  vErrors = [err60];
                                                } else {
                                                  vErrors.push(err60);
                                                }
                                                errors++;
                                              }
                                              var _valid9 = _errs129 === errors;
                                              valid29 = valid29 || _valid9;
                                              if (!valid29) {
                                                const err61 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                if (vErrors === null) {
                                                  vErrors = [err61];
                                                } else {
                                                  vErrors.push(err61);
                                                }
                                                errors++;
                                                validate43.errors = vErrors;
                                                return false;
                                              } else {
                                                errors = _errs126;
                                                if (vErrors !== null) {
                                                  if (_errs126) {
                                                    vErrors.length = _errs126;
                                                  } else {
                                                    vErrors = null;
                                                  }
                                                }
                                              }
                                              var valid0 = _errs125 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.step_key !== void 0) {
                                                let data43 = data.step_key;
                                                const _errs131 = errors;
                                                const _errs132 = errors;
                                                let valid30 = false;
                                                const _errs133 = errors;
                                                if (errors === _errs133) {
                                                  if (typeof data43 === "string") {
                                                    if (!pattern14.test(data43)) {
                                                      const err62 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                                                      if (vErrors === null) {
                                                        vErrors = [err62];
                                                      } else {
                                                        vErrors.push(err62);
                                                      }
                                                      errors++;
                                                    }
                                                  } else {
                                                    const err63 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err63];
                                                    } else {
                                                      vErrors.push(err63);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var _valid10 = _errs133 === errors;
                                                valid30 = valid30 || _valid10;
                                                const _errs135 = errors;
                                                if (data43 !== null) {
                                                  const err64 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                  if (vErrors === null) {
                                                    vErrors = [err64];
                                                  } else {
                                                    vErrors.push(err64);
                                                  }
                                                  errors++;
                                                }
                                                var _valid10 = _errs135 === errors;
                                                valid30 = valid30 || _valid10;
                                                if (!valid30) {
                                                  const err65 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                  if (vErrors === null) {
                                                    vErrors = [err65];
                                                  } else {
                                                    vErrors.push(err65);
                                                  }
                                                  errors++;
                                                  validate43.errors = vErrors;
                                                  return false;
                                                } else {
                                                  errors = _errs132;
                                                  if (vErrors !== null) {
                                                    if (_errs132) {
                                                      vErrors.length = _errs132;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid0 = _errs131 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (data.supersedes !== void 0) {
                                                  let data44 = data.supersedes;
                                                  const _errs137 = errors;
                                                  const _errs138 = errors;
                                                  let valid31 = false;
                                                  const _errs139 = errors;
                                                  if (!(typeof data44 == "number" && (!(data44 % 1) && !isNaN(data44)))) {
                                                    const err66 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                                    if (vErrors === null) {
                                                      vErrors = [err66];
                                                    } else {
                                                      vErrors.push(err66);
                                                    }
                                                    errors++;
                                                  }
                                                  if (errors === _errs139) {
                                                    if (typeof data44 == "number") {
                                                      if (data44 < 1 || isNaN(data44)) {
                                                        const err67 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                                        if (vErrors === null) {
                                                          vErrors = [err67];
                                                        } else {
                                                          vErrors.push(err67);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                  }
                                                  var _valid11 = _errs139 === errors;
                                                  valid31 = valid31 || _valid11;
                                                  const _errs141 = errors;
                                                  if (data44 !== null) {
                                                    const err68 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                    if (vErrors === null) {
                                                      vErrors = [err68];
                                                    } else {
                                                      vErrors.push(err68);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid11 = _errs141 === errors;
                                                  valid31 = valid31 || _valid11;
                                                  if (!valid31) {
                                                    const err69 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                    if (vErrors === null) {
                                                      vErrors = [err69];
                                                    } else {
                                                      vErrors.push(err69);
                                                    }
                                                    errors++;
                                                    validate43.errors = vErrors;
                                                    return false;
                                                  } else {
                                                    errors = _errs138;
                                                    if (vErrors !== null) {
                                                      if (_errs138) {
                                                        vErrors.length = _errs138;
                                                      } else {
                                                        vErrors = null;
                                                      }
                                                    }
                                                  }
                                                  var valid0 = _errs137 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (data.talk !== void 0) {
                                                    let data45 = data.talk;
                                                    const _errs143 = errors;
                                                    const _errs144 = errors;
                                                    let valid32 = false;
                                                    const _errs145 = errors;
                                                    if (!validate56(data45, { instancePath: instancePath + "/talk", parentData: data, parentDataProperty: "talk", rootData, dynamicAnchors })) {
                                                      vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
                                                      errors = vErrors.length;
                                                    }
                                                    var _valid12 = _errs145 === errors;
                                                    valid32 = valid32 || _valid12;
                                                    const _errs146 = errors;
                                                    if (data45 !== null) {
                                                      const err70 = { instancePath: instancePath + "/talk", schemaPath: "#/properties/talk/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                      if (vErrors === null) {
                                                        vErrors = [err70];
                                                      } else {
                                                        vErrors.push(err70);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid12 = _errs146 === errors;
                                                    valid32 = valid32 || _valid12;
                                                    if (!valid32) {
                                                      const err71 = { instancePath: instancePath + "/talk", schemaPath: "#/properties/talk/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                      if (vErrors === null) {
                                                        vErrors = [err71];
                                                      } else {
                                                        vErrors.push(err71);
                                                      }
                                                      errors++;
                                                      validate43.errors = vErrors;
                                                      return false;
                                                    } else {
                                                      errors = _errs144;
                                                      if (vErrors !== null) {
                                                        if (_errs144) {
                                                          vErrors.length = _errs144;
                                                        } else {
                                                          vErrors = null;
                                                        }
                                                      }
                                                    }
                                                    var valid0 = _errs143 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (data.tools !== void 0) {
                                                      let data46 = data.tools;
                                                      const _errs148 = errors;
                                                      const _errs149 = errors;
                                                      if (errors === _errs149) {
                                                        if (data46 && typeof data46 == "object" && !Array.isArray(data46)) {
                                                          let missing7;
                                                          if (data46.dmw === void 0 && (missing7 = "dmw") || data46.skill_servers === void 0 && (missing7 = "skill_servers") || data46.agent_skills === void 0 && (missing7 = "agent_skills")) {
                                                            validate43.errors = [{ instancePath: instancePath + "/tools", schemaPath: "#/$defs/TurnTools/required", keyword: "required", params: { missingProperty: missing7 }, message: "must have required property '" + missing7 + "'" }];
                                                            return false;
                                                          } else {
                                                            if (data46.agent_skills !== void 0) {
                                                              let data47 = data46.agent_skills;
                                                              const _errs151 = errors;
                                                              if (errors === _errs151) {
                                                                if (Array.isArray(data47)) {
                                                                  var valid35 = true;
                                                                  const len4 = data47.length;
                                                                  for (let i4 = 0; i4 < len4; i4++) {
                                                                    let data48 = data47[i4];
                                                                    const _errs153 = errors;
                                                                    if (errors === _errs153) {
                                                                      if (typeof data48 === "string") {
                                                                        if (!pattern4.test(data48)) {
                                                                          validate43.errors = [{ instancePath: instancePath + "/tools/agent_skills/" + i4, schemaPath: "#/$defs/TurnTools/properties/agent_skills/items/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                                                          return false;
                                                                        }
                                                                      } else {
                                                                        validate43.errors = [{ instancePath: instancePath + "/tools/agent_skills/" + i4, schemaPath: "#/$defs/TurnTools/properties/agent_skills/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                        return false;
                                                                      }
                                                                    }
                                                                    var valid35 = _errs153 === errors;
                                                                    if (!valid35) {
                                                                      break;
                                                                    }
                                                                  }
                                                                } else {
                                                                  validate43.errors = [{ instancePath: instancePath + "/tools/agent_skills", schemaPath: "#/$defs/TurnTools/properties/agent_skills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                                  return false;
                                                                }
                                                              }
                                                              var valid34 = _errs151 === errors;
                                                            } else {
                                                              var valid34 = true;
                                                            }
                                                            if (valid34) {
                                                              if (data46.dmw !== void 0) {
                                                                let data49 = data46.dmw;
                                                                const _errs155 = errors;
                                                                if (errors === _errs155) {
                                                                  if (Array.isArray(data49)) {
                                                                    var valid36 = true;
                                                                    const len5 = data49.length;
                                                                    for (let i5 = 0; i5 < len5; i5++) {
                                                                      let data50 = data49[i5];
                                                                      const _errs157 = errors;
                                                                      if (errors === _errs157) {
                                                                        if (typeof data50 === "string") {
                                                                          if (!pattern8.test(data50)) {
                                                                            validate43.errors = [{ instancePath: instancePath + "/tools/dmw/" + i5, schemaPath: "#/$defs/TurnTools/properties/dmw/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                                                            return false;
                                                                          }
                                                                        } else {
                                                                          validate43.errors = [{ instancePath: instancePath + "/tools/dmw/" + i5, schemaPath: "#/$defs/TurnTools/properties/dmw/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                          return false;
                                                                        }
                                                                      }
                                                                      var valid36 = _errs157 === errors;
                                                                      if (!valid36) {
                                                                        break;
                                                                      }
                                                                    }
                                                                  } else {
                                                                    validate43.errors = [{ instancePath: instancePath + "/tools/dmw", schemaPath: "#/$defs/TurnTools/properties/dmw/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                                    return false;
                                                                  }
                                                                }
                                                                var valid34 = _errs155 === errors;
                                                              } else {
                                                                var valid34 = true;
                                                              }
                                                              if (valid34) {
                                                                if (data46.skill_servers !== void 0) {
                                                                  let data51 = data46.skill_servers;
                                                                  const _errs159 = errors;
                                                                  if (errors === _errs159) {
                                                                    if (Array.isArray(data51)) {
                                                                      var valid37 = true;
                                                                      const len6 = data51.length;
                                                                      for (let i6 = 0; i6 < len6; i6++) {
                                                                        let data52 = data51[i6];
                                                                        const _errs161 = errors;
                                                                        if (errors === _errs161) {
                                                                          if (typeof data52 === "string") {
                                                                            if (!pattern4.test(data52)) {
                                                                              validate43.errors = [{ instancePath: instancePath + "/tools/skill_servers/" + i6, schemaPath: "#/$defs/TurnTools/properties/skill_servers/items/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                                                              return false;
                                                                            }
                                                                          } else {
                                                                            validate43.errors = [{ instancePath: instancePath + "/tools/skill_servers/" + i6, schemaPath: "#/$defs/TurnTools/properties/skill_servers/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                                            return false;
                                                                          }
                                                                        }
                                                                        var valid37 = _errs161 === errors;
                                                                        if (!valid37) {
                                                                          break;
                                                                        }
                                                                      }
                                                                    } else {
                                                                      validate43.errors = [{ instancePath: instancePath + "/tools/skill_servers", schemaPath: "#/$defs/TurnTools/properties/skill_servers/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                                      return false;
                                                                    }
                                                                  }
                                                                  var valid34 = _errs159 === errors;
                                                                } else {
                                                                  var valid34 = true;
                                                                }
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          validate43.errors = [{ instancePath: instancePath + "/tools", schemaPath: "#/$defs/TurnTools/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                                          return false;
                                                        }
                                                      }
                                                      var valid0 = _errs148 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (data.turn_id !== void 0) {
                                                        const _errs163 = errors;
                                                        if (typeof data.turn_id !== "string") {
                                                          validate43.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                          return false;
                                                        }
                                                        var valid0 = _errs163 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (data.turn_kind !== void 0) {
                                                          let data54 = data.turn_kind;
                                                          const _errs165 = errors;
                                                          if (typeof data54 !== "string") {
                                                            validate43.errors = [{ instancePath: instancePath + "/turn_kind", schemaPath: "#/$defs/TurnKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                            return false;
                                                          }
                                                          if (!(data54 === "reply" || data54 === "step")) {
                                                            validate43.errors = [{ instancePath: instancePath + "/turn_kind", schemaPath: "#/$defs/TurnKind/enum", keyword: "enum", params: { allowedValues: schema96.enum }, message: "must be equal to one of the allowed values" }];
                                                            return false;
                                                          }
                                                          var valid0 = _errs165 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (data.versions_used !== void 0) {
                                                            const _errs168 = errors;
                                                            if (!validate65(data.versions_used, { instancePath: instancePath + "/versions_used", parentData: data, parentDataProperty: "versions_used", rootData, dynamicAnchors })) {
                                                              vErrors = vErrors === null ? validate65.errors : vErrors.concat(validate65.errors);
                                                              errors = vErrors.length;
                                                            }
                                                            var valid0 = _errs168 === errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate43.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate43.errors = vErrors;
  return errors === 0;
}
validate43.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema101 = { "additionalProperties": false, "description": "One DMW tool call by the agent (mcp-endpoint.md, What is recorded). No item content\nor annotation lists: those are in Git or in the `step_output` entry.", "properties": { "arguments": { "additionalProperties": { "$ref": "#/$defs/JsonValue" }, "title": "Arguments", "type": "object" }, "duration_milliseconds": { "title": "Duration Milliseconds", "type": "integer" }, "kind": { "const": "tool_call", "title": "Kind", "type": "string" }, "outcome": { "description": "`ok`, or the problem code.", "title": "Outcome", "type": "string" }, "references_read": { "items": { "type": "string" }, "title": "References Read", "type": "array" }, "result_summary": { "additionalProperties": { "$ref": "#/$defs/JsonValue" }, "title": "Result Summary", "type": "object" }, "started_at": { "title": "Started At", "type": "string" }, "summary": { "anyOf": [{ "$ref": "#/$defs/ToolCallLine" }, { "type": "null" }], "default": null, "description": "The tool's own line for a call that succeeded; absent on failures and older entries." }, "tool": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "title": "Tool", "type": "string" }, "turn_id": { "title": "Turn Id", "type": "string" } }, "required": ["kind", "turn_id", "tool", "arguments", "outcome", "result_summary", "references_read", "started_at", "duration_milliseconds"], "title": "ToolCallPayload", "type": "object" };
function validate68(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate68.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.tool === void 0 && (missing0 = "tool") || data.arguments === void 0 && (missing0 = "arguments") || data.outcome === void 0 && (missing0 = "outcome") || data.result_summary === void 0 && (missing0 = "result_summary") || data.references_read === void 0 && (missing0 = "references_read") || data.started_at === void 0 && (missing0 = "started_at") || data.duration_milliseconds === void 0 && (missing0 = "duration_milliseconds")) {
        validate68.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema101.properties, key0)) {
            validate68.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.arguments !== void 0) {
            let data0 = data.arguments;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                for (const key1 in data0) {
                  const _errs5 = errors;
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate68.errors = [{ instancePath: instancePath + "/arguments", schemaPath: "#/properties/arguments/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.duration_milliseconds !== void 0) {
              let data2 = data.duration_milliseconds;
              const _errs6 = errors;
              if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                validate68.errors = [{ instancePath: instancePath + "/duration_milliseconds", schemaPath: "#/properties/duration_milliseconds/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.kind !== void 0) {
                let data3 = data.kind;
                const _errs8 = errors;
                if (typeof data3 !== "string") {
                  validate68.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("tool_call" !== data3) {
                  validate68.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "tool_call" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.outcome !== void 0) {
                  const _errs10 = errors;
                  if (typeof data.outcome !== "string") {
                    validate68.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/properties/outcome/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.references_read !== void 0) {
                    let data5 = data.references_read;
                    const _errs12 = errors;
                    if (errors === _errs12) {
                      if (Array.isArray(data5)) {
                        var valid3 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs14 = errors;
                          if (typeof data5[i0] !== "string") {
                            validate68.errors = [{ instancePath: instancePath + "/references_read/" + i0, schemaPath: "#/properties/references_read/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          var valid3 = _errs14 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        validate68.errors = [{ instancePath: instancePath + "/references_read", schemaPath: "#/properties/references_read/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.result_summary !== void 0) {
                      let data7 = data.result_summary;
                      const _errs16 = errors;
                      if (errors === _errs16) {
                        if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                          for (const key2 in data7) {
                            const _errs19 = errors;
                            var valid4 = _errs19 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        } else {
                          validate68.errors = [{ instancePath: instancePath + "/result_summary", schemaPath: "#/properties/result_summary/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                          return false;
                        }
                      }
                      var valid0 = _errs16 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.started_at !== void 0) {
                        const _errs20 = errors;
                        if (typeof data.started_at !== "string") {
                          validate68.errors = [{ instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid0 = _errs20 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.summary !== void 0) {
                          let data10 = data.summary;
                          const _errs22 = errors;
                          const _errs23 = errors;
                          let valid6 = false;
                          const _errs24 = errors;
                          const _errs25 = errors;
                          if (errors === _errs25) {
                            if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                              let missing1;
                              if (data10.en === void 0 && (missing1 = "en") || data10.de === void 0 && (missing1 = "de")) {
                                const err0 = { instancePath: instancePath + "/summary", schemaPath: "#/$defs/ToolCallLine/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err0];
                                } else {
                                  vErrors.push(err0);
                                }
                                errors++;
                              } else {
                                const _errs27 = errors;
                                for (const key3 in data10) {
                                  if (!(key3 === "de" || key3 === "en")) {
                                    const err1 = { instancePath: instancePath + "/summary", schemaPath: "#/$defs/ToolCallLine/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                      vErrors = [err1];
                                    } else {
                                      vErrors.push(err1);
                                    }
                                    errors++;
                                    break;
                                  }
                                }
                                if (_errs27 === errors) {
                                  if (data10.de !== void 0) {
                                    let data11 = data10.de;
                                    const _errs28 = errors;
                                    if (errors === _errs28) {
                                      if (typeof data11 === "string") {
                                        if (func2(data11) > 300) {
                                          const err2 = { instancePath: instancePath + "/summary/de", schemaPath: "#/$defs/ToolCallLine/properties/de/maxLength", keyword: "maxLength", params: { limit: 300 }, message: "must NOT have more than 300 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        } else {
                                          if (func2(data11) < 1) {
                                            const err3 = { instancePath: instancePath + "/summary/de", schemaPath: "#/$defs/ToolCallLine/properties/de/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                        }
                                      } else {
                                        const err4 = { instancePath: instancePath + "/summary/de", schemaPath: "#/$defs/ToolCallLine/properties/de/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err4];
                                        } else {
                                          vErrors.push(err4);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid8 = _errs28 === errors;
                                  } else {
                                    var valid8 = true;
                                  }
                                  if (valid8) {
                                    if (data10.en !== void 0) {
                                      let data12 = data10.en;
                                      const _errs30 = errors;
                                      if (errors === _errs30) {
                                        if (typeof data12 === "string") {
                                          if (func2(data12) > 300) {
                                            const err5 = { instancePath: instancePath + "/summary/en", schemaPath: "#/$defs/ToolCallLine/properties/en/maxLength", keyword: "maxLength", params: { limit: 300 }, message: "must NOT have more than 300 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err5];
                                            } else {
                                              vErrors.push(err5);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data12) < 1) {
                                              const err6 = { instancePath: instancePath + "/summary/en", schemaPath: "#/$defs/ToolCallLine/properties/en/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err6];
                                              } else {
                                                vErrors.push(err6);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err7 = { instancePath: instancePath + "/summary/en", schemaPath: "#/$defs/ToolCallLine/properties/en/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err7];
                                          } else {
                                            vErrors.push(err7);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid8 = _errs30 === errors;
                                    } else {
                                      var valid8 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              const err8 = { instancePath: instancePath + "/summary", schemaPath: "#/$defs/ToolCallLine/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err8];
                              } else {
                                vErrors.push(err8);
                              }
                              errors++;
                            }
                          }
                          var _valid0 = _errs24 === errors;
                          valid6 = valid6 || _valid0;
                          const _errs32 = errors;
                          if (data10 !== null) {
                            const err9 = { instancePath: instancePath + "/summary", schemaPath: "#/properties/summary/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                          }
                          var _valid0 = _errs32 === errors;
                          valid6 = valid6 || _valid0;
                          if (!valid6) {
                            const err10 = { instancePath: instancePath + "/summary", schemaPath: "#/properties/summary/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err10];
                            } else {
                              vErrors.push(err10);
                            }
                            errors++;
                            validate68.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs23;
                            if (vErrors !== null) {
                              if (_errs23) {
                                vErrors.length = _errs23;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs22 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.tool !== void 0) {
                            let data13 = data.tool;
                            const _errs34 = errors;
                            if (errors === _errs34) {
                              if (typeof data13 === "string") {
                                if (!pattern8.test(data13)) {
                                  validate68.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                  return false;
                                }
                              } else {
                                validate68.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                            }
                            var valid0 = _errs34 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.turn_id !== void 0) {
                              const _errs36 = errors;
                              if (typeof data.turn_id !== "string") {
                                validate68.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid0 = _errs36 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate68.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate68.errors = vErrors;
  return errors === 0;
}
validate68.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate70(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate70.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.part === void 0 && (missing0 = "part") || data.output === void 0 && (missing0 = "output")) {
        validate70.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "kind" || key0 === "output" || key0 === "part" || key0 === "turn_id")) {
            validate70.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.kind !== void 0) {
            let data0 = data.kind;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate70.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if ("step_output" !== data0) {
              validate70.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "step_output" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.output !== void 0) {
              const _errs4 = errors;
              if (!validate57(data.output, { instancePath: instancePath + "/output", parentData: data, parentDataProperty: "output", rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.part !== void 0) {
                let data2 = data.part;
                const _errs5 = errors;
                if (errors === _errs5) {
                  if (typeof data2 === "string") {
                    if (!pattern8.test(data2)) {
                      validate70.errors = [{ instancePath: instancePath + "/part", schemaPath: "#/properties/part/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                      return false;
                    }
                  } else {
                    validate70.errors = [{ instancePath: instancePath + "/part", schemaPath: "#/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.turn_id !== void 0) {
                  const _errs7 = errors;
                  if (typeof data.turn_id !== "string") {
                    validate70.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate70.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate70.errors = vErrors;
  return errors === 0;
}
validate70.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema106 = { "additionalProperties": false, "description": "The result of a turn, appended once (key `turn-finished:<turn id>`).", "properties": { "agent": { "anyOf": [{ "$ref": "#/$defs/AgentRan" }, { "type": "null" }] }, "agent_compacted_context": { "title": "Agent Compacted Context", "type": "boolean" }, "agent_messages": { "description": "Every agent message in order; the last is the answer.", "items": { "type": "string" }, "title": "Agent Messages", "type": "array" }, "agent_setup": { "anyOf": [{ "$ref": "#/$defs/AgentSetupRecord" }, { "type": "null" }], "default": null, "description": "What the agent ran with, by names and digests (agent-profiles.md AP-3); `None` for\nAPI-key turns, server-written results and turns before it was recorded." }, "connector_id": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Connector Id" }, "finished_at": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Finished At" }, "kind": { "const": "turn_finished", "title": "Kind", "type": "string" }, "local_tool_calls": { "items": { "$ref": "#/$defs/LocalToolCall" }, "title": "Local Tool Calls", "type": "array" }, "outcome": { "$ref": "#/$defs/TurnOutcome" }, "output_entry": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "description": "The turn's last `step_output`, if any.", "title": "Output Entry" }, "permission_profile": { "pattern": "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$", "title": "Permission Profile", "type": "string" }, "problem": { "anyOf": [{ "$ref": "#/$defs/RecordedProblem" }, { "type": "null" }] }, "provider_contact": { "$ref": "#/$defs/ProviderContact" }, "redacted_patterns": { "description": "Secret patterns that matched agent output and were replaced (T-16).", "items": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "type": "string" }, "title": "Redacted Patterns", "type": "array" }, "reported_by": { "description": "`server` when the connector never delivered a result (orphan, cancel while queued).", "enum": ["connector", "server"], "title": "Reported By", "type": "string" }, "request_entry": { "minimum": 1, "title": "Request Entry", "type": "integer" }, "session_use": { "anyOf": [{ "$ref": "#/$defs/SessionUse" }, { "type": "null" }] }, "started_at": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Started At" }, "stop_reason": { "anyOf": [{ "$ref": "#/$defs/StopReason" }, { "type": "null" }] }, "turn_id": { "title": "Turn Id", "type": "string" }, "usage": { "$ref": "#/$defs/TurnUsage" } }, "required": ["kind", "turn_id", "request_entry", "outcome", "stop_reason", "agent_messages", "local_tool_calls", "output_entry", "usage", "agent", "session_use", "agent_compacted_context", "provider_contact", "problem", "connector_id", "permission_profile", "started_at", "finished_at", "redacted_patterns", "reported_by"], "title": "TurnFinishedPayload", "type": "object" };
var schema123 = { "enum": ["completed", "failed", "cancelled"], "title": "TurnOutcome", "type": "string" };
var schema126 = { "description": "Whether a provider may have been reached, and so may have charged (T-11).", "enum": ["none", "possible", "confirmed"], "title": "ProviderContact", "type": "string" };
var schema127 = { "enum": ["continued", "fresh", "isolated", "resumed"], "title": "SessionUse", "type": "string" };
var schema128 = { "enum": ["end_turn", "max_tokens", "max_turn_requests", "refusal", "cancelled"], "title": "StopReason", "type": "string" };
var pattern45 = new RegExp("^\\d+\\.\\d+\\.\\d+$", "u");
var pattern46 = new RegExp("^sha256:[0-9a-f]{64}$", "u");
var pattern47 = new RegExp("^[0-9a-f]{40}$", "u");
function validate74(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate74.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.version === void 0 && (missing0 = "version") || data.model_id === void 0 && (missing0 = "model_id")) {
        validate74.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.gta !== void 0) {
          let data0 = data.gta;
          const _errs1 = errors;
          const _errs2 = errors;
          let valid1 = false;
          const _errs3 = errors;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              let missing1;
              if (data0.version === void 0 && (missing1 = "version") || data0.revision === void 0 && (missing1 = "revision") || data0.contract_version === void 0 && (missing1 = "contract_version") || data0.environment_digest === void 0 && (missing1 = "environment_digest")) {
                const err0 = { instancePath: instancePath + "/gta", schemaPath: "#/$defs/GtaComponent/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              } else {
                if (data0.contract_version !== void 0) {
                  let data1 = data0.contract_version;
                  const _errs6 = errors;
                  if (errors === _errs6) {
                    if (typeof data1 === "string") {
                      if (!pattern45.test(data1)) {
                        const err1 = { instancePath: instancePath + "/gta/contract_version", schemaPath: "#/$defs/GtaComponent/properties/contract_version/pattern", keyword: "pattern", params: { pattern: "^\\d+\\.\\d+\\.\\d+$" }, message: 'must match pattern "^\\d+\\.\\d+\\.\\d+$"' };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                    } else {
                      const err2 = { instancePath: instancePath + "/gta/contract_version", schemaPath: "#/$defs/GtaComponent/properties/contract_version/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err2];
                      } else {
                        vErrors.push(err2);
                      }
                      errors++;
                    }
                  }
                  var valid3 = _errs6 === errors;
                } else {
                  var valid3 = true;
                }
                if (valid3) {
                  if (data0.environment_digest !== void 0) {
                    let data2 = data0.environment_digest;
                    const _errs8 = errors;
                    if (errors === _errs8) {
                      if (typeof data2 === "string") {
                        if (!pattern46.test(data2)) {
                          const err3 = { instancePath: instancePath + "/gta/environment_digest", schemaPath: "#/$defs/GtaComponent/properties/environment_digest/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                      } else {
                        const err4 = { instancePath: instancePath + "/gta/environment_digest", schemaPath: "#/$defs/GtaComponent/properties/environment_digest/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                      }
                    }
                    var valid3 = _errs8 === errors;
                  } else {
                    var valid3 = true;
                  }
                  if (valid3) {
                    if (data0.revision !== void 0) {
                      let data3 = data0.revision;
                      const _errs10 = errors;
                      const _errs11 = errors;
                      let valid4 = false;
                      const _errs12 = errors;
                      if (errors === _errs12) {
                        if (typeof data3 === "string") {
                          if (!pattern47.test(data3)) {
                            const err5 = { instancePath: instancePath + "/gta/revision", schemaPath: "#/$defs/GtaComponent/properties/revision/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{40}$" }, message: 'must match pattern "^[0-9a-f]{40}$"' };
                            if (vErrors === null) {
                              vErrors = [err5];
                            } else {
                              vErrors.push(err5);
                            }
                            errors++;
                          }
                        } else {
                          const err6 = { instancePath: instancePath + "/gta/revision", schemaPath: "#/$defs/GtaComponent/properties/revision/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err6];
                          } else {
                            vErrors.push(err6);
                          }
                          errors++;
                        }
                      }
                      var _valid1 = _errs12 === errors;
                      valid4 = valid4 || _valid1;
                      const _errs14 = errors;
                      if (data3 !== null) {
                        const err7 = { instancePath: instancePath + "/gta/revision", schemaPath: "#/$defs/GtaComponent/properties/revision/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      var _valid1 = _errs14 === errors;
                      valid4 = valid4 || _valid1;
                      if (!valid4) {
                        const err8 = { instancePath: instancePath + "/gta/revision", schemaPath: "#/$defs/GtaComponent/properties/revision/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      } else {
                        errors = _errs11;
                        if (vErrors !== null) {
                          if (_errs11) {
                            vErrors.length = _errs11;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid3 = _errs10 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data0.version !== void 0) {
                        let data4 = data0.version;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        let valid5 = false;
                        const _errs18 = errors;
                        if (errors === _errs18) {
                          if (typeof data4 === "string") {
                            if (func2(data4) > 200) {
                              const err9 = { instancePath: instancePath + "/gta/version", schemaPath: "#/$defs/GtaComponent/properties/version/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                              if (vErrors === null) {
                                vErrors = [err9];
                              } else {
                                vErrors.push(err9);
                              }
                              errors++;
                            } else {
                              if (func2(data4) < 1) {
                                const err10 = { instancePath: instancePath + "/gta/version", schemaPath: "#/$defs/GtaComponent/properties/version/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                  vErrors = [err10];
                                } else {
                                  vErrors.push(err10);
                                }
                                errors++;
                              }
                            }
                          } else {
                            const err11 = { instancePath: instancePath + "/gta/version", schemaPath: "#/$defs/GtaComponent/properties/version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err11];
                            } else {
                              vErrors.push(err11);
                            }
                            errors++;
                          }
                        }
                        var _valid2 = _errs18 === errors;
                        valid5 = valid5 || _valid2;
                        const _errs20 = errors;
                        if (data4 !== null) {
                          const err12 = { instancePath: instancePath + "/gta/version", schemaPath: "#/$defs/GtaComponent/properties/version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err12];
                          } else {
                            vErrors.push(err12);
                          }
                          errors++;
                        }
                        var _valid2 = _errs20 === errors;
                        valid5 = valid5 || _valid2;
                        if (!valid5) {
                          const err13 = { instancePath: instancePath + "/gta/version", schemaPath: "#/$defs/GtaComponent/properties/version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err13];
                          } else {
                            vErrors.push(err13);
                          }
                          errors++;
                        } else {
                          errors = _errs17;
                          if (vErrors !== null) {
                            if (_errs17) {
                              vErrors.length = _errs17;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid3 = _errs16 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  }
                }
              }
            } else {
              const err14 = { instancePath: instancePath + "/gta", schemaPath: "#/$defs/GtaComponent/type", keyword: "type", params: { type: "object" }, message: "must be object" };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
          }
          var _valid0 = _errs3 === errors;
          valid1 = valid1 || _valid0;
          if (_valid0) {
            var props0 = {};
            props0.contract_version = true;
            props0.environment_digest = true;
            props0.revision = true;
            props0.version = true;
          }
          const _errs22 = errors;
          if (data0 !== null) {
            const err15 = { instancePath: instancePath + "/gta", schemaPath: "#/properties/gta/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
          var _valid0 = _errs22 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const err16 = { instancePath: instancePath + "/gta", schemaPath: "#/properties/gta/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
            validate74.errors = vErrors;
            return false;
          } else {
            errors = _errs2;
            if (vErrors !== null) {
              if (_errs2) {
                vErrors.length = _errs2;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.model_id !== void 0) {
            let data5 = data.model_id;
            const _errs24 = errors;
            const _errs25 = errors;
            let valid6 = false;
            const _errs26 = errors;
            if (errors === _errs26) {
              if (typeof data5 === "string") {
                if (func2(data5) > 200) {
                  const err17 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                } else {
                  if (func2(data5) < 1) {
                    const err18 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  }
                }
              } else {
                const err19 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            var _valid3 = _errs26 === errors;
            valid6 = valid6 || _valid3;
            const _errs28 = errors;
            if (data5 !== null) {
              const err20 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            var _valid3 = _errs28 === errors;
            valid6 = valid6 || _valid3;
            if (!valid6) {
              const err21 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
              validate74.errors = vErrors;
              return false;
            } else {
              errors = _errs25;
              if (vErrors !== null) {
                if (_errs25) {
                  vErrors.length = _errs25;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs24 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.name !== void 0) {
              let data6 = data.name;
              const _errs30 = errors;
              if (errors === _errs30) {
                if (typeof data6 === "string") {
                  if (func2(data6) > 200) {
                    validate74.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                    return false;
                  } else {
                    if (func2(data6) < 1) {
                      validate74.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                      return false;
                    }
                  }
                } else {
                  validate74.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
              }
              var valid0 = _errs30 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.version !== void 0) {
                let data7 = data.version;
                const _errs32 = errors;
                const _errs33 = errors;
                let valid7 = false;
                const _errs34 = errors;
                if (errors === _errs34) {
                  if (typeof data7 === "string") {
                    if (func2(data7) > 200) {
                      const err22 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                      if (vErrors === null) {
                        vErrors = [err22];
                      } else {
                        vErrors.push(err22);
                      }
                      errors++;
                    } else {
                      if (func2(data7) < 1) {
                        const err23 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                          vErrors = [err23];
                        } else {
                          vErrors.push(err23);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err24 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err24];
                    } else {
                      vErrors.push(err24);
                    }
                    errors++;
                  }
                }
                var _valid4 = _errs34 === errors;
                valid7 = valid7 || _valid4;
                const _errs36 = errors;
                if (data7 !== null) {
                  const err25 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err25];
                  } else {
                    vErrors.push(err25);
                  }
                  errors++;
                }
                var _valid4 = _errs36 === errors;
                valid7 = valid7 || _valid4;
                if (!valid7) {
                  const err26 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                  validate74.errors = vErrors;
                  return false;
                } else {
                  errors = _errs33;
                  if (vErrors !== null) {
                    if (_errs33) {
                      vErrors.length = _errs33;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs32 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate74.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate74.errors = vErrors;
  return errors === 0;
}
validate74.evaluated = { "props": { "gta": true, "model_id": true, "name": true, "version": true }, "dynamicProps": false, "dynamicItems": false };
var schema112 = { "description": "How DMW's skills reached the agent (processes.md P-10).", "enum": ["mcp", "folder"], "title": "SkillDelivery", "type": "string" };
function validate77(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate77.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.instructions_sha256 === void 0 && (missing0 = "instructions_sha256") || data.skills === void 0 && (missing0 = "skills") || data.skills_offered_by === void 0 && (missing0 = "skills_offered_by")) {
        validate77.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.instructions_sha256 !== void 0) {
          let data0 = data.instructions_sha256;
          const _errs1 = errors;
          const _errs2 = errors;
          let valid1 = false;
          const _errs3 = errors;
          if (errors === _errs3) {
            if (typeof data0 === "string") {
              if (!pattern46.test(data0)) {
                const err0 = { instancePath: instancePath + "/instructions_sha256", schemaPath: "#/properties/instructions_sha256/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
            } else {
              const err1 = { instancePath: instancePath + "/instructions_sha256", schemaPath: "#/properties/instructions_sha256/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          var _valid0 = _errs3 === errors;
          valid1 = valid1 || _valid0;
          const _errs5 = errors;
          if (data0 !== null) {
            const err2 = { instancePath: instancePath + "/instructions_sha256", schemaPath: "#/properties/instructions_sha256/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var _valid0 = _errs5 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const err3 = { instancePath: instancePath + "/instructions_sha256", schemaPath: "#/properties/instructions_sha256/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
            validate77.errors = vErrors;
            return false;
          } else {
            errors = _errs2;
            if (vErrors !== null) {
              if (_errs2) {
                vErrors.length = _errs2;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.skills !== void 0) {
            let data1 = data.skills;
            const _errs7 = errors;
            if (errors === _errs7) {
              if (Array.isArray(data1)) {
                var valid2 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs9 = errors;
                  const _errs10 = errors;
                  if (errors === _errs10) {
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                      let missing1;
                      if (data2.name === void 0 && (missing1 = "name") || data2.version === void 0 && (missing1 = "version") || data2.sha256 === void 0 && (missing1 = "sha256")) {
                        validate77.errors = [{ instancePath: instancePath + "/skills/" + i0, schemaPath: "#/$defs/DmwSkillRecord/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                        return false;
                      } else {
                        if (data2.name !== void 0) {
                          let data3 = data2.name;
                          const _errs12 = errors;
                          if (errors === _errs12) {
                            if (typeof data3 === "string") {
                              if (func2(data3) > 200) {
                                validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/name", schemaPath: "#/$defs/DmwSkillRecord/properties/name/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                return false;
                              } else {
                                if (func2(data3) < 1) {
                                  validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/name", schemaPath: "#/$defs/DmwSkillRecord/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                  return false;
                                }
                              }
                            } else {
                              validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/name", schemaPath: "#/$defs/DmwSkillRecord/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                          }
                          var valid4 = _errs12 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data2.sha256 !== void 0) {
                            let data4 = data2.sha256;
                            const _errs14 = errors;
                            if (errors === _errs14) {
                              if (typeof data4 === "string") {
                                if (!pattern46.test(data4)) {
                                  validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/sha256", schemaPath: "#/$defs/DmwSkillRecord/properties/sha256/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' }];
                                  return false;
                                }
                              } else {
                                validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/sha256", schemaPath: "#/$defs/DmwSkillRecord/properties/sha256/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                            }
                            var valid4 = _errs14 === errors;
                          } else {
                            var valid4 = true;
                          }
                          if (valid4) {
                            if (data2.version !== void 0) {
                              let data5 = data2.version;
                              const _errs16 = errors;
                              if (errors === _errs16) {
                                if (typeof data5 === "string") {
                                  if (func2(data5) > 200) {
                                    validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/version", schemaPath: "#/$defs/DmwSkillRecord/properties/version/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                    return false;
                                  } else {
                                    if (func2(data5) < 1) {
                                      validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/version", schemaPath: "#/$defs/DmwSkillRecord/properties/version/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                      return false;
                                    }
                                  }
                                } else {
                                  validate77.errors = [{ instancePath: instancePath + "/skills/" + i0 + "/version", schemaPath: "#/$defs/DmwSkillRecord/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                              }
                              var valid4 = _errs16 === errors;
                            } else {
                              var valid4 = true;
                            }
                          }
                        }
                      }
                    } else {
                      validate77.errors = [{ instancePath: instancePath + "/skills/" + i0, schemaPath: "#/$defs/DmwSkillRecord/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                      return false;
                    }
                  }
                  var valid2 = _errs9 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              } else {
                validate77.errors = [{ instancePath: instancePath + "/skills", schemaPath: "#/properties/skills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs7 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.skills_offered_by !== void 0) {
              let data6 = data.skills_offered_by;
              const _errs18 = errors;
              if (typeof data6 !== "string") {
                validate77.errors = [{ instancePath: instancePath + "/skills_offered_by", schemaPath: "#/$defs/SkillDelivery/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data6 === "mcp" || data6 === "folder")) {
                validate77.errors = [{ instancePath: instancePath + "/skills_offered_by", schemaPath: "#/$defs/SkillDelivery/enum", keyword: "enum", params: { allowedValues: schema112.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs18 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate77.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate77.errors = vErrors;
  return errors === 0;
}
validate77.evaluated = { "props": { "instructions_sha256": true, "skills": true, "skills_offered_by": true }, "dynamicProps": false, "dynamicItems": false };
var schema116 = { "enum": ["on", "off"], "title": "MemoryUse", "type": "string" };
function validate79(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate79.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.instruction_files === void 0 && (missing0 = "instruction_files") || data.skills === void 0 && (missing0 = "skills") || data.mcp_servers === void 0 && (missing0 = "mcp_servers") || data.plugins === void 0 && (missing0 = "plugins") || data.hooks === void 0 && (missing0 = "hooks") || data.memory_read === void 0 && (missing0 = "memory_read") || data.memory_write === void 0 && (missing0 = "memory_write")) {
        validate79.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.hooks !== void 0) {
          let data0 = data.hooks;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
              for (const key0 in data0) {
                const _errs3 = errors;
                if (typeof key0 === "string") {
                  if (func2(key0) > 200) {
                    const err0 = { instancePath: instancePath + "/hooks", schemaPath: "#/properties/hooks/propertyNames/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters", propertyName: key0 };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  } else {
                    if (func2(key0) < 1) {
                      const err1 = { instancePath: instancePath + "/hooks", schemaPath: "#/properties/hooks/propertyNames/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", propertyName: key0 };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                  }
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  const err2 = { instancePath: instancePath + "/hooks", schemaPath: "#/properties/hooks/propertyNames", keyword: "propertyNames", params: { propertyName: key0 }, message: "property name must be valid" };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                  validate79.errors = vErrors;
                  return false;
                  break;
                }
              }
              if (valid1) {
                for (const key1 in data0) {
                  let data1 = data0[key1];
                  const _errs5 = errors;
                  if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                    validate79.errors = [{ instancePath: instancePath + "/hooks/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/hooks/additionalProperties/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                    return false;
                  }
                  if (errors === _errs5) {
                    if (typeof data1 == "number") {
                      if (data1 < 0 || isNaN(data1)) {
                        validate79.errors = [{ instancePath: instancePath + "/hooks/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/hooks/additionalProperties/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" }];
                        return false;
                      }
                    }
                  }
                  var valid2 = _errs5 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              }
            } else {
              validate79.errors = [{ instancePath: instancePath + "/hooks", schemaPath: "#/properties/hooks/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.instruction_files !== void 0) {
            let data2 = data.instruction_files;
            const _errs7 = errors;
            if (errors === _errs7) {
              if (Array.isArray(data2)) {
                var valid3 = true;
                const len0 = data2.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data3 = data2[i0];
                  const _errs9 = errors;
                  const _errs10 = errors;
                  if (errors === _errs10) {
                    if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                      let missing1;
                      if (data3.scope === void 0 && (missing1 = "scope") || data3.sha256 === void 0 && (missing1 = "sha256") || data3.bytes === void 0 && (missing1 = "bytes")) {
                        validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0, schemaPath: "#/$defs/PersonalInstructionFile/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                        return false;
                      } else {
                        if (data3.bytes !== void 0) {
                          let data4 = data3.bytes;
                          const _errs12 = errors;
                          if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)))) {
                            validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0 + "/bytes", schemaPath: "#/$defs/PersonalInstructionFile/properties/bytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                            return false;
                          }
                          if (errors === _errs12) {
                            if (typeof data4 == "number") {
                              if (data4 < 0 || isNaN(data4)) {
                                validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0 + "/bytes", schemaPath: "#/$defs/PersonalInstructionFile/properties/bytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" }];
                                return false;
                              }
                            }
                          }
                          var valid5 = _errs12 === errors;
                        } else {
                          var valid5 = true;
                        }
                        if (valid5) {
                          if (data3.scope !== void 0) {
                            let data5 = data3.scope;
                            const _errs14 = errors;
                            if (typeof data5 !== "string") {
                              validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0 + "/scope", schemaPath: "#/$defs/PersonalInstructionFile/properties/scope/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            if ("user" !== data5) {
                              validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0 + "/scope", schemaPath: "#/$defs/PersonalInstructionFile/properties/scope/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" }];
                              return false;
                            }
                            var valid5 = _errs14 === errors;
                          } else {
                            var valid5 = true;
                          }
                          if (valid5) {
                            if (data3.sha256 !== void 0) {
                              let data6 = data3.sha256;
                              const _errs16 = errors;
                              if (errors === _errs16) {
                                if (typeof data6 === "string") {
                                  if (!pattern46.test(data6)) {
                                    validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0 + "/sha256", schemaPath: "#/$defs/PersonalInstructionFile/properties/sha256/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' }];
                                    return false;
                                  }
                                } else {
                                  validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0 + "/sha256", schemaPath: "#/$defs/PersonalInstructionFile/properties/sha256/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                              }
                              var valid5 = _errs16 === errors;
                            } else {
                              var valid5 = true;
                            }
                          }
                        }
                      }
                    } else {
                      validate79.errors = [{ instancePath: instancePath + "/instruction_files/" + i0, schemaPath: "#/$defs/PersonalInstructionFile/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                      return false;
                    }
                  }
                  var valid3 = _errs9 === errors;
                  if (!valid3) {
                    break;
                  }
                }
              } else {
                validate79.errors = [{ instancePath: instancePath + "/instruction_files", schemaPath: "#/properties/instruction_files/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs7 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.mcp_servers !== void 0) {
              let data7 = data.mcp_servers;
              const _errs18 = errors;
              if (errors === _errs18) {
                if (Array.isArray(data7)) {
                  var valid6 = true;
                  const len1 = data7.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    let data8 = data7[i1];
                    const _errs20 = errors;
                    const _errs21 = errors;
                    if (errors === _errs21) {
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        let missing2;
                        if (data8.name === void 0 && (missing2 = "name") || data8.loaded === void 0 && (missing2 = "loaded")) {
                          validate79.errors = [{ instancePath: instancePath + "/mcp_servers/" + i1, schemaPath: "#/$defs/PersonalServer/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" }];
                          return false;
                        } else {
                          if (data8.loaded !== void 0) {
                            const _errs23 = errors;
                            if (typeof data8.loaded !== "boolean") {
                              validate79.errors = [{ instancePath: instancePath + "/mcp_servers/" + i1 + "/loaded", schemaPath: "#/$defs/PersonalServer/properties/loaded/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid8 = _errs23 === errors;
                          } else {
                            var valid8 = true;
                          }
                          if (valid8) {
                            if (data8.name !== void 0) {
                              let data10 = data8.name;
                              const _errs25 = errors;
                              if (errors === _errs25) {
                                if (typeof data10 === "string") {
                                  if (func2(data10) > 200) {
                                    validate79.errors = [{ instancePath: instancePath + "/mcp_servers/" + i1 + "/name", schemaPath: "#/$defs/PersonalServer/properties/name/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                    return false;
                                  } else {
                                    if (func2(data10) < 1) {
                                      validate79.errors = [{ instancePath: instancePath + "/mcp_servers/" + i1 + "/name", schemaPath: "#/$defs/PersonalServer/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                      return false;
                                    }
                                  }
                                } else {
                                  validate79.errors = [{ instancePath: instancePath + "/mcp_servers/" + i1 + "/name", schemaPath: "#/$defs/PersonalServer/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                              }
                              var valid8 = _errs25 === errors;
                            } else {
                              var valid8 = true;
                            }
                          }
                        }
                      } else {
                        validate79.errors = [{ instancePath: instancePath + "/mcp_servers/" + i1, schemaPath: "#/$defs/PersonalServer/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid6 = _errs20 === errors;
                    if (!valid6) {
                      break;
                    }
                  }
                } else {
                  validate79.errors = [{ instancePath: instancePath + "/mcp_servers", schemaPath: "#/properties/mcp_servers/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs18 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.memory_read !== void 0) {
                let data11 = data.memory_read;
                const _errs27 = errors;
                if (typeof data11 !== "string") {
                  validate79.errors = [{ instancePath: instancePath + "/memory_read", schemaPath: "#/$defs/MemoryUse/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data11 === "on" || data11 === "off")) {
                  validate79.errors = [{ instancePath: instancePath + "/memory_read", schemaPath: "#/$defs/MemoryUse/enum", keyword: "enum", params: { allowedValues: schema116.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs27 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.memory_write !== void 0) {
                  let data12 = data.memory_write;
                  const _errs30 = errors;
                  if (typeof data12 !== "string") {
                    validate79.errors = [{ instancePath: instancePath + "/memory_write", schemaPath: "#/properties/memory_write/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if ("off" !== data12) {
                    validate79.errors = [{ instancePath: instancePath + "/memory_write", schemaPath: "#/properties/memory_write/const", keyword: "const", params: { allowedValue: "off" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs30 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.plugins !== void 0) {
                    let data13 = data.plugins;
                    const _errs32 = errors;
                    if (errors === _errs32) {
                      if (Array.isArray(data13)) {
                        var valid10 = true;
                        const len2 = data13.length;
                        for (let i2 = 0; i2 < len2; i2++) {
                          let data14 = data13[i2];
                          const _errs34 = errors;
                          const _errs35 = errors;
                          if (errors === _errs35) {
                            if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                              let missing3;
                              if (data14.name === void 0 && (missing3 = "name") || data14.version === void 0 && (missing3 = "version") || data14.loaded === void 0 && (missing3 = "loaded")) {
                                validate79.errors = [{ instancePath: instancePath + "/plugins/" + i2, schemaPath: "#/$defs/PersonalPlugin/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" }];
                                return false;
                              } else {
                                if (data14.loaded !== void 0) {
                                  const _errs37 = errors;
                                  if (typeof data14.loaded !== "boolean") {
                                    validate79.errors = [{ instancePath: instancePath + "/plugins/" + i2 + "/loaded", schemaPath: "#/$defs/PersonalPlugin/properties/loaded/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                    return false;
                                  }
                                  var valid12 = _errs37 === errors;
                                } else {
                                  var valid12 = true;
                                }
                                if (valid12) {
                                  if (data14.name !== void 0) {
                                    let data16 = data14.name;
                                    const _errs39 = errors;
                                    if (errors === _errs39) {
                                      if (typeof data16 === "string") {
                                        if (func2(data16) > 200) {
                                          validate79.errors = [{ instancePath: instancePath + "/plugins/" + i2 + "/name", schemaPath: "#/$defs/PersonalPlugin/properties/name/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                          return false;
                                        } else {
                                          if (func2(data16) < 1) {
                                            validate79.errors = [{ instancePath: instancePath + "/plugins/" + i2 + "/name", schemaPath: "#/$defs/PersonalPlugin/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                            return false;
                                          }
                                        }
                                      } else {
                                        validate79.errors = [{ instancePath: instancePath + "/plugins/" + i2 + "/name", schemaPath: "#/$defs/PersonalPlugin/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                    }
                                    var valid12 = _errs39 === errors;
                                  } else {
                                    var valid12 = true;
                                  }
                                  if (valid12) {
                                    if (data14.version !== void 0) {
                                      let data17 = data14.version;
                                      const _errs41 = errors;
                                      const _errs42 = errors;
                                      let valid13 = false;
                                      const _errs43 = errors;
                                      if (errors === _errs43) {
                                        if (typeof data17 === "string") {
                                          if (func2(data17) > 200) {
                                            const err3 = { instancePath: instancePath + "/plugins/" + i2 + "/version", schemaPath: "#/$defs/PersonalPlugin/properties/version/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data17) < 1) {
                                              const err4 = { instancePath: instancePath + "/plugins/" + i2 + "/version", schemaPath: "#/$defs/PersonalPlugin/properties/version/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err4];
                                              } else {
                                                vErrors.push(err4);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err5 = { instancePath: instancePath + "/plugins/" + i2 + "/version", schemaPath: "#/$defs/PersonalPlugin/properties/version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err5];
                                          } else {
                                            vErrors.push(err5);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid0 = _errs43 === errors;
                                      valid13 = valid13 || _valid0;
                                      const _errs45 = errors;
                                      if (data17 !== null) {
                                        const err6 = { instancePath: instancePath + "/plugins/" + i2 + "/version", schemaPath: "#/$defs/PersonalPlugin/properties/version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err6];
                                        } else {
                                          vErrors.push(err6);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs45 === errors;
                                      valid13 = valid13 || _valid0;
                                      if (!valid13) {
                                        const err7 = { instancePath: instancePath + "/plugins/" + i2 + "/version", schemaPath: "#/$defs/PersonalPlugin/properties/version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err7];
                                        } else {
                                          vErrors.push(err7);
                                        }
                                        errors++;
                                        validate79.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs42;
                                        if (vErrors !== null) {
                                          if (_errs42) {
                                            vErrors.length = _errs42;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid12 = _errs41 === errors;
                                    } else {
                                      var valid12 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              validate79.errors = [{ instancePath: instancePath + "/plugins/" + i2, schemaPath: "#/$defs/PersonalPlugin/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                              return false;
                            }
                          }
                          var valid10 = _errs34 === errors;
                          if (!valid10) {
                            break;
                          }
                        }
                      } else {
                        validate79.errors = [{ instancePath: instancePath + "/plugins", schemaPath: "#/properties/plugins/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs32 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.skills !== void 0) {
                      let data18 = data.skills;
                      const _errs47 = errors;
                      if (errors === _errs47) {
                        if (Array.isArray(data18)) {
                          var valid14 = true;
                          const len3 = data18.length;
                          for (let i3 = 0; i3 < len3; i3++) {
                            let data19 = data18[i3];
                            const _errs49 = errors;
                            const _errs50 = errors;
                            if (errors === _errs50) {
                              if (data19 && typeof data19 == "object" && !Array.isArray(data19)) {
                                let missing4;
                                if (data19.name === void 0 && (missing4 = "name") || data19.sha256 === void 0 && (missing4 = "sha256")) {
                                  validate79.errors = [{ instancePath: instancePath + "/skills/" + i3, schemaPath: "#/$defs/PersonalSkill/required", keyword: "required", params: { missingProperty: missing4 }, message: "must have required property '" + missing4 + "'" }];
                                  return false;
                                } else {
                                  if (data19.name !== void 0) {
                                    let data20 = data19.name;
                                    const _errs52 = errors;
                                    if (errors === _errs52) {
                                      if (typeof data20 === "string") {
                                        if (func2(data20) > 200) {
                                          validate79.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/name", schemaPath: "#/$defs/PersonalSkill/properties/name/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                          return false;
                                        } else {
                                          if (func2(data20) < 1) {
                                            validate79.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/name", schemaPath: "#/$defs/PersonalSkill/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                            return false;
                                          }
                                        }
                                      } else {
                                        validate79.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/name", schemaPath: "#/$defs/PersonalSkill/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                    }
                                    var valid16 = _errs52 === errors;
                                  } else {
                                    var valid16 = true;
                                  }
                                  if (valid16) {
                                    if (data19.sha256 !== void 0) {
                                      let data21 = data19.sha256;
                                      const _errs54 = errors;
                                      if (errors === _errs54) {
                                        if (typeof data21 === "string") {
                                          if (!pattern46.test(data21)) {
                                            validate79.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/sha256", schemaPath: "#/$defs/PersonalSkill/properties/sha256/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' }];
                                            return false;
                                          }
                                        } else {
                                          validate79.errors = [{ instancePath: instancePath + "/skills/" + i3 + "/sha256", schemaPath: "#/$defs/PersonalSkill/properties/sha256/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                      }
                                      var valid16 = _errs54 === errors;
                                    } else {
                                      var valid16 = true;
                                    }
                                  }
                                }
                              } else {
                                validate79.errors = [{ instancePath: instancePath + "/skills/" + i3, schemaPath: "#/$defs/PersonalSkill/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                            var valid14 = _errs49 === errors;
                            if (!valid14) {
                              break;
                            }
                          }
                        } else {
                          validate79.errors = [{ instancePath: instancePath + "/skills", schemaPath: "#/properties/skills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs47 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate79.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate79.errors = vErrors;
  return errors === 0;
}
validate79.evaluated = { "props": { "hooks": true, "instruction_files": true, "mcp_servers": true, "memory_read": true, "memory_write": true, "plugins": true, "skills": true }, "dynamicProps": false, "dynamicItems": false };
function validate76(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate76.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.setup === void 0 && (missing0 = "setup") || data.personal_layer === void 0 && (missing0 = "personal_layer") || data.dmw_layer === void 0 && (missing0 = "dmw_layer") || data.setup_digest === void 0 && (missing0 = "setup_digest")) {
        validate76.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.dmw_layer !== void 0) {
          const _errs1 = errors;
          if (!validate77(data.dmw_layer, { instancePath: instancePath + "/dmw_layer", parentData: data, parentDataProperty: "dmw_layer", rootData, dynamicAnchors })) {
            vErrors = vErrors === null ? validate77.errors : vErrors.concat(validate77.errors);
            errors = vErrors.length;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.personal_layer !== void 0) {
            let data1 = data.personal_layer;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!validate79(data1, { instancePath: instancePath + "/personal_layer", parentData: data, parentDataProperty: "personal_layer", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate79.errors : vErrors.concat(validate79.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            if (_valid0) {
              var props0 = {};
              props0.hooks = true;
              props0.instruction_files = true;
              props0.mcp_servers = true;
              props0.memory_read = true;
              props0.memory_write = true;
              props0.plugins = true;
              props0.skills = true;
            }
            const _errs5 = errors;
            if (data1 !== null) {
              const err0 = { instancePath: instancePath + "/personal_layer", schemaPath: "#/properties/personal_layer/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err1 = { instancePath: instancePath + "/personal_layer", schemaPath: "#/properties/personal_layer/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              validate76.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.setup !== void 0) {
              let data2 = data.setup;
              const _errs7 = errors;
              if (typeof data2 !== "string") {
                validate76.errors = [{ instancePath: instancePath + "/setup", schemaPath: "#/$defs/AgentSetupKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data2 === "extend" || data2 === "dmw_only")) {
                validate76.errors = [{ instancePath: instancePath + "/setup", schemaPath: "#/$defs/AgentSetupKind/enum", keyword: "enum", params: { allowedValues: schema43.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.setup_digest !== void 0) {
                let data3 = data.setup_digest;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (typeof data3 === "string") {
                    if (!pattern24.test(data3)) {
                      validate76.errors = [{ instancePath: instancePath + "/setup_digest", schemaPath: "#/properties/setup_digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' }];
                      return false;
                    }
                  } else {
                    validate76.errors = [{ instancePath: instancePath + "/setup_digest", schemaPath: "#/properties/setup_digest/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate76.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate76.errors = vErrors;
  return errors === 0;
}
validate76.evaluated = { "props": { "dmw_layer": true, "personal_layer": true, "setup": true, "setup_digest": true }, "dynamicProps": false, "dynamicItems": false };
var schema121 = { "enum": ["pending", "in_progress", "completed", "failed"], "title": "ToolCallStatus", "type": "string" };
var schema122 = { "description": "ACP's tool kinds.", "enum": ["read", "edit", "delete", "move", "search", "execute", "think", "fetch", "switch_mode", "other"], "title": "ToolKind", "type": "string" };
function validate82(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate82.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.tool_call_id === void 0 && (missing0 = "tool_call_id") || data.title === void 0 && (missing0 = "title") || data.tool_kind === void 0 && (missing0 = "tool_kind") || data.status === void 0 && (missing0 = "status") || data.locations === void 0 && (missing0 = "locations")) {
        validate82.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.locations !== void 0) {
          let data0 = data.locations;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (typeof data0[i0] !== "string") {
                  validate82.errors = [{ instancePath: instancePath + "/locations/" + i0, schemaPath: "#/properties/locations/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate82.errors = [{ instancePath: instancePath + "/locations", schemaPath: "#/properties/locations/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.status !== void 0) {
            let data2 = data.status;
            const _errs5 = errors;
            if (typeof data2 !== "string") {
              validate82.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/ToolCallStatus/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data2 === "pending" || data2 === "in_progress" || data2 === "completed" || data2 === "failed")) {
              validate82.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/ToolCallStatus/enum", keyword: "enum", params: { allowedValues: schema121.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.title !== void 0) {
              const _errs8 = errors;
              if (typeof data.title !== "string") {
                validate82.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.tool_call_id !== void 0) {
                let data4 = data.tool_call_id;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (typeof data4 === "string") {
                    if (func2(data4) > 200) {
                      validate82.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                      return false;
                    } else {
                      if (func2(data4) < 1) {
                        validate82.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                        return false;
                      }
                    }
                  } else {
                    validate82.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.tool_kind !== void 0) {
                  let data5 = data.tool_kind;
                  const _errs12 = errors;
                  if (typeof data5 !== "string") {
                    validate82.errors = [{ instancePath: instancePath + "/tool_kind", schemaPath: "#/$defs/ToolKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data5 === "read" || data5 === "edit" || data5 === "delete" || data5 === "move" || data5 === "search" || data5 === "execute" || data5 === "think" || data5 === "fetch" || data5 === "switch_mode" || data5 === "other")) {
                    validate82.errors = [{ instancePath: instancePath + "/tool_kind", schemaPath: "#/$defs/ToolKind/enum", keyword: "enum", params: { allowedValues: schema122.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate82.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate82.errors = vErrors;
  return errors === 0;
}
validate82.evaluated = { "props": { "locations": true, "status": true, "title": true, "tool_call_id": true, "tool_kind": true }, "dynamicProps": false, "dynamicItems": false };
function validate84(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate84.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.code === void 0 && (missing0 = "code") || data.title === void 0 && (missing0 = "title") || data.status === void 0 && (missing0 = "status") || data.detail === void 0 && (missing0 = "detail") || data.details === void 0 && (missing0 = "details")) {
        validate84.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "code" || key0 === "detail" || key0 === "details" || key0 === "status" || key0 === "title")) {
            validate84.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.code !== void 0) {
            const _errs2 = errors;
            if (typeof data.code !== "string") {
              validate84.errors = [{ instancePath: instancePath + "/code", schemaPath: "#/properties/code/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.detail !== void 0) {
              const _errs4 = errors;
              if (typeof data.detail !== "string") {
                validate84.errors = [{ instancePath: instancePath + "/detail", schemaPath: "#/properties/detail/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.details !== void 0) {
                let data2 = data.details;
                const _errs6 = errors;
                if (errors === _errs6) {
                  if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                    for (const key1 in data2) {
                      const _errs9 = errors;
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate84.errors = [{ instancePath: instancePath + "/details", schemaPath: "#/properties/details/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                    return false;
                  }
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.status !== void 0) {
                  let data4 = data.status;
                  const _errs10 = errors;
                  if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)))) {
                    validate84.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.title !== void 0) {
                    const _errs12 = errors;
                    if (typeof data.title !== "string") {
                      validate84.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate84.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate84.errors = vErrors;
  return errors === 0;
}
validate84.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema133 = { "enum": ["agent", "api_key"], "title": "RouteKind", "type": "string" };
var schema134 = { "enum": ["provider_reported", "agent_reported"], "title": "UsageSource", "type": "string" };
var pattern55 = new RegExp("^[A-Z]{3}$", "u");
function validate87(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate87.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.route_kind === void 0 && (missing0 = "route_kind") || data.agent_name === void 0 && (missing0 = "agent_name") || data.agent_version === void 0 && (missing0 = "agent_version") || data.provider === void 0 && (missing0 = "provider") || data.model_id === void 0 && (missing0 = "model_id") || data.input_tokens === void 0 && (missing0 = "input_tokens") || data.output_tokens === void 0 && (missing0 = "output_tokens") || data.cached_input_tokens === void 0 && (missing0 = "cached_input_tokens") || data.reasoning_tokens === void 0 && (missing0 = "reasoning_tokens") || data.cost === void 0 && (missing0 = "cost") || data.source === void 0 && (missing0 = "source")) {
        validate87.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.agent_name !== void 0) {
          let data0 = data.agent_name;
          const _errs1 = errors;
          const _errs2 = errors;
          let valid1 = false;
          const _errs3 = errors;
          if (errors === _errs3) {
            if (typeof data0 === "string") {
              if (func2(data0) > 200) {
                const err0 = { instancePath: instancePath + "/agent_name", schemaPath: "#/properties/agent_name/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              } else {
                if (func2(data0) < 1) {
                  const err1 = { instancePath: instancePath + "/agent_name", schemaPath: "#/properties/agent_name/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
              }
            } else {
              const err2 = { instancePath: instancePath + "/agent_name", schemaPath: "#/properties/agent_name/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
          }
          var _valid0 = _errs3 === errors;
          valid1 = valid1 || _valid0;
          const _errs5 = errors;
          if (data0 !== null) {
            const err3 = { instancePath: instancePath + "/agent_name", schemaPath: "#/properties/agent_name/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
          var _valid0 = _errs5 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const err4 = { instancePath: instancePath + "/agent_name", schemaPath: "#/properties/agent_name/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
            validate87.errors = vErrors;
            return false;
          } else {
            errors = _errs2;
            if (vErrors !== null) {
              if (_errs2) {
                vErrors.length = _errs2;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.agent_version !== void 0) {
            let data1 = data.agent_version;
            const _errs7 = errors;
            const _errs8 = errors;
            let valid2 = false;
            const _errs9 = errors;
            if (errors === _errs9) {
              if (typeof data1 === "string") {
                if (func2(data1) > 200) {
                  const err5 = { instancePath: instancePath + "/agent_version", schemaPath: "#/properties/agent_version/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                } else {
                  if (func2(data1) < 1) {
                    const err6 = { instancePath: instancePath + "/agent_version", schemaPath: "#/properties/agent_version/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                  }
                }
              } else {
                const err7 = { instancePath: instancePath + "/agent_version", schemaPath: "#/properties/agent_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
            var _valid1 = _errs9 === errors;
            valid2 = valid2 || _valid1;
            const _errs11 = errors;
            if (data1 !== null) {
              const err8 = { instancePath: instancePath + "/agent_version", schemaPath: "#/properties/agent_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            var _valid1 = _errs11 === errors;
            valid2 = valid2 || _valid1;
            if (!valid2) {
              const err9 = { instancePath: instancePath + "/agent_version", schemaPath: "#/properties/agent_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
              validate87.errors = vErrors;
              return false;
            } else {
              errors = _errs8;
              if (vErrors !== null) {
                if (_errs8) {
                  vErrors.length = _errs8;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs7 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cache_write_input_tokens !== void 0) {
              let data2 = data.cache_write_input_tokens;
              const _errs13 = errors;
              const _errs14 = errors;
              let valid3 = false;
              const _errs15 = errors;
              if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                const err10 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (errors === _errs15) {
                if (typeof data2 == "number") {
                  if (data2 < 0 || isNaN(data2)) {
                    const err11 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                    if (vErrors === null) {
                      vErrors = [err11];
                    } else {
                      vErrors.push(err11);
                    }
                    errors++;
                  }
                }
              }
              var _valid2 = _errs15 === errors;
              valid3 = valid3 || _valid2;
              const _errs17 = errors;
              if (data2 !== null) {
                const err12 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
              var _valid2 = _errs17 === errors;
              valid3 = valid3 || _valid2;
              if (!valid3) {
                const err13 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
                validate87.errors = vErrors;
                return false;
              } else {
                errors = _errs14;
                if (vErrors !== null) {
                  if (_errs14) {
                    vErrors.length = _errs14;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs13 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.cached_input_tokens !== void 0) {
                let data3 = data.cached_input_tokens;
                const _errs19 = errors;
                const _errs20 = errors;
                let valid4 = false;
                const _errs21 = errors;
                if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                  const err14 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                }
                if (errors === _errs21) {
                  if (typeof data3 == "number") {
                    if (data3 < 0 || isNaN(data3)) {
                      const err15 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                  }
                }
                var _valid3 = _errs21 === errors;
                valid4 = valid4 || _valid3;
                const _errs23 = errors;
                if (data3 !== null) {
                  const err16 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
                var _valid3 = _errs23 === errors;
                valid4 = valid4 || _valid3;
                if (!valid4) {
                  const err17 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                  validate87.errors = vErrors;
                  return false;
                } else {
                  errors = _errs20;
                  if (vErrors !== null) {
                    if (_errs20) {
                      vErrors.length = _errs20;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs19 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.cost !== void 0) {
                  let data4 = data.cost;
                  const _errs25 = errors;
                  const _errs26 = errors;
                  let valid5 = false;
                  const _errs27 = errors;
                  const _errs28 = errors;
                  if (errors === _errs28) {
                    if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                      let missing1;
                      if (data4.amount === void 0 && (missing1 = "amount") || data4.currency === void 0 && (missing1 = "currency")) {
                        const err18 = { instancePath: instancePath + "/cost", schemaPath: "#/$defs/UsageCost/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                        if (vErrors === null) {
                          vErrors = [err18];
                        } else {
                          vErrors.push(err18);
                        }
                        errors++;
                      } else {
                        if (data4.amount !== void 0) {
                          let data5 = data4.amount;
                          const _errs30 = errors;
                          if (errors === _errs30) {
                            if (typeof data5 == "number") {
                              if (data5 < 0 || isNaN(data5)) {
                                const err19 = { instancePath: instancePath + "/cost/amount", schemaPath: "#/$defs/UsageCost/properties/amount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                              }
                            } else {
                              const err20 = { instancePath: instancePath + "/cost/amount", schemaPath: "#/$defs/UsageCost/properties/amount/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                              if (vErrors === null) {
                                vErrors = [err20];
                              } else {
                                vErrors.push(err20);
                              }
                              errors++;
                            }
                          }
                          var valid7 = _errs30 === errors;
                        } else {
                          var valid7 = true;
                        }
                        if (valid7) {
                          if (data4.currency !== void 0) {
                            let data6 = data4.currency;
                            const _errs32 = errors;
                            if (errors === _errs32) {
                              if (typeof data6 === "string") {
                                if (!pattern55.test(data6)) {
                                  const err21 = { instancePath: instancePath + "/cost/currency", schemaPath: "#/$defs/UsageCost/properties/currency/pattern", keyword: "pattern", params: { pattern: "^[A-Z]{3}$" }, message: 'must match pattern "^[A-Z]{3}$"' };
                                  if (vErrors === null) {
                                    vErrors = [err21];
                                  } else {
                                    vErrors.push(err21);
                                  }
                                  errors++;
                                }
                              } else {
                                const err22 = { instancePath: instancePath + "/cost/currency", schemaPath: "#/$defs/UsageCost/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err22];
                                } else {
                                  vErrors.push(err22);
                                }
                                errors++;
                              }
                            }
                            var valid7 = _errs32 === errors;
                          } else {
                            var valid7 = true;
                          }
                        }
                      }
                    } else {
                      const err23 = { instancePath: instancePath + "/cost", schemaPath: "#/$defs/UsageCost/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                      if (vErrors === null) {
                        vErrors = [err23];
                      } else {
                        vErrors.push(err23);
                      }
                      errors++;
                    }
                  }
                  var _valid4 = _errs27 === errors;
                  valid5 = valid5 || _valid4;
                  if (_valid4) {
                    var props0 = {};
                    props0.amount = true;
                    props0.currency = true;
                  }
                  const _errs34 = errors;
                  if (data4 !== null) {
                    const err24 = { instancePath: instancePath + "/cost", schemaPath: "#/properties/cost/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err24];
                    } else {
                      vErrors.push(err24);
                    }
                    errors++;
                  }
                  var _valid4 = _errs34 === errors;
                  valid5 = valid5 || _valid4;
                  if (!valid5) {
                    const err25 = { instancePath: instancePath + "/cost", schemaPath: "#/properties/cost/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err25];
                    } else {
                      vErrors.push(err25);
                    }
                    errors++;
                    validate87.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs26;
                    if (vErrors !== null) {
                      if (_errs26) {
                        vErrors.length = _errs26;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs25 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.input_tokens !== void 0) {
                    let data7 = data.input_tokens;
                    const _errs36 = errors;
                    const _errs37 = errors;
                    let valid8 = false;
                    const _errs38 = errors;
                    if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)))) {
                      const err26 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                      if (vErrors === null) {
                        vErrors = [err26];
                      } else {
                        vErrors.push(err26);
                      }
                      errors++;
                    }
                    if (errors === _errs38) {
                      if (typeof data7 == "number") {
                        if (data7 < 0 || isNaN(data7)) {
                          const err27 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                          if (vErrors === null) {
                            vErrors = [err27];
                          } else {
                            vErrors.push(err27);
                          }
                          errors++;
                        }
                      }
                    }
                    var _valid5 = _errs38 === errors;
                    valid8 = valid8 || _valid5;
                    const _errs40 = errors;
                    if (data7 !== null) {
                      const err28 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err28];
                      } else {
                        vErrors.push(err28);
                      }
                      errors++;
                    }
                    var _valid5 = _errs40 === errors;
                    valid8 = valid8 || _valid5;
                    if (!valid8) {
                      const err29 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err29];
                      } else {
                        vErrors.push(err29);
                      }
                      errors++;
                      validate87.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs37;
                      if (vErrors !== null) {
                        if (_errs37) {
                          vErrors.length = _errs37;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs36 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.model_id !== void 0) {
                      let data8 = data.model_id;
                      const _errs42 = errors;
                      const _errs43 = errors;
                      let valid9 = false;
                      const _errs44 = errors;
                      if (errors === _errs44) {
                        if (typeof data8 === "string") {
                          if (func2(data8) > 200) {
                            const err30 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                            if (vErrors === null) {
                              vErrors = [err30];
                            } else {
                              vErrors.push(err30);
                            }
                            errors++;
                          } else {
                            if (func2(data8) < 1) {
                              const err31 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                              if (vErrors === null) {
                                vErrors = [err31];
                              } else {
                                vErrors.push(err31);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err32 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err32];
                          } else {
                            vErrors.push(err32);
                          }
                          errors++;
                        }
                      }
                      var _valid6 = _errs44 === errors;
                      valid9 = valid9 || _valid6;
                      const _errs46 = errors;
                      if (data8 !== null) {
                        const err33 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err33];
                        } else {
                          vErrors.push(err33);
                        }
                        errors++;
                      }
                      var _valid6 = _errs46 === errors;
                      valid9 = valid9 || _valid6;
                      if (!valid9) {
                        const err34 = { instancePath: instancePath + "/model_id", schemaPath: "#/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err34];
                        } else {
                          vErrors.push(err34);
                        }
                        errors++;
                        validate87.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs43;
                        if (vErrors !== null) {
                          if (_errs43) {
                            vErrors.length = _errs43;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs42 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.output_tokens !== void 0) {
                        let data9 = data.output_tokens;
                        const _errs48 = errors;
                        const _errs49 = errors;
                        let valid10 = false;
                        const _errs50 = errors;
                        if (!(typeof data9 == "number" && (!(data9 % 1) && !isNaN(data9)))) {
                          const err35 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                          if (vErrors === null) {
                            vErrors = [err35];
                          } else {
                            vErrors.push(err35);
                          }
                          errors++;
                        }
                        if (errors === _errs50) {
                          if (typeof data9 == "number") {
                            if (data9 < 0 || isNaN(data9)) {
                              const err36 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                              if (vErrors === null) {
                                vErrors = [err36];
                              } else {
                                vErrors.push(err36);
                              }
                              errors++;
                            }
                          }
                        }
                        var _valid7 = _errs50 === errors;
                        valid10 = valid10 || _valid7;
                        const _errs52 = errors;
                        if (data9 !== null) {
                          const err37 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err37];
                          } else {
                            vErrors.push(err37);
                          }
                          errors++;
                        }
                        var _valid7 = _errs52 === errors;
                        valid10 = valid10 || _valid7;
                        if (!valid10) {
                          const err38 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err38];
                          } else {
                            vErrors.push(err38);
                          }
                          errors++;
                          validate87.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs49;
                          if (vErrors !== null) {
                            if (_errs49) {
                              vErrors.length = _errs49;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs48 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.payer !== void 0) {
                          let data10 = data.payer;
                          const _errs54 = errors;
                          const _errs55 = errors;
                          let valid11 = false;
                          const _errs56 = errors;
                          const _errs57 = errors;
                          if (errors === _errs57) {
                            if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                              let missing2;
                              if (data10.user_id === void 0 && (missing2 = "user_id") || data10.key_id === void 0 && (missing2 = "key_id")) {
                                const err39 = { instancePath: instancePath + "/payer", schemaPath: "#/$defs/UsagePayer/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err39];
                                } else {
                                  vErrors.push(err39);
                                }
                                errors++;
                              } else {
                                if (data10.key_id !== void 0) {
                                  let data11 = data10.key_id;
                                  const _errs59 = errors;
                                  if (errors === _errs59) {
                                    if (typeof data11 === "string") {
                                      if (!pattern31.test(data11)) {
                                        const err40 = { instancePath: instancePath + "/payer/key_id", schemaPath: "#/$defs/UsagePayer/properties/key_id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" }, message: 'must match pattern "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"' };
                                        if (vErrors === null) {
                                          vErrors = [err40];
                                        } else {
                                          vErrors.push(err40);
                                        }
                                        errors++;
                                      }
                                    } else {
                                      const err41 = { instancePath: instancePath + "/payer/key_id", schemaPath: "#/$defs/UsagePayer/properties/key_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err41];
                                      } else {
                                        vErrors.push(err41);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid13 = _errs59 === errors;
                                } else {
                                  var valid13 = true;
                                }
                                if (valid13) {
                                  if (data10.user_id !== void 0) {
                                    let data12 = data10.user_id;
                                    const _errs61 = errors;
                                    if (errors === _errs61) {
                                      if (typeof data12 === "string") {
                                        if (!pattern31.test(data12)) {
                                          const err42 = { instancePath: instancePath + "/payer/user_id", schemaPath: "#/$defs/UsagePayer/properties/user_id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" }, message: 'must match pattern "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"' };
                                          if (vErrors === null) {
                                            vErrors = [err42];
                                          } else {
                                            vErrors.push(err42);
                                          }
                                          errors++;
                                        }
                                      } else {
                                        const err43 = { instancePath: instancePath + "/payer/user_id", schemaPath: "#/$defs/UsagePayer/properties/user_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err43];
                                        } else {
                                          vErrors.push(err43);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid13 = _errs61 === errors;
                                  } else {
                                    var valid13 = true;
                                  }
                                }
                              }
                            } else {
                              const err44 = { instancePath: instancePath + "/payer", schemaPath: "#/$defs/UsagePayer/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err44];
                              } else {
                                vErrors.push(err44);
                              }
                              errors++;
                            }
                          }
                          var _valid8 = _errs56 === errors;
                          valid11 = valid11 || _valid8;
                          if (_valid8) {
                            var props1 = {};
                            props1.key_id = true;
                            props1.user_id = true;
                          }
                          const _errs63 = errors;
                          if (data10 !== null) {
                            const err45 = { instancePath: instancePath + "/payer", schemaPath: "#/properties/payer/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err45];
                            } else {
                              vErrors.push(err45);
                            }
                            errors++;
                          }
                          var _valid8 = _errs63 === errors;
                          valid11 = valid11 || _valid8;
                          if (!valid11) {
                            const err46 = { instancePath: instancePath + "/payer", schemaPath: "#/properties/payer/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err46];
                            } else {
                              vErrors.push(err46);
                            }
                            errors++;
                            validate87.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs55;
                            if (vErrors !== null) {
                              if (_errs55) {
                                vErrors.length = _errs55;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs54 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.provider !== void 0) {
                            let data13 = data.provider;
                            const _errs65 = errors;
                            const _errs66 = errors;
                            let valid14 = false;
                            const _errs67 = errors;
                            if (errors === _errs67) {
                              if (typeof data13 === "string") {
                                if (func2(data13) > 200) {
                                  const err47 = { instancePath: instancePath + "/provider", schemaPath: "#/properties/provider/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                  if (vErrors === null) {
                                    vErrors = [err47];
                                  } else {
                                    vErrors.push(err47);
                                  }
                                  errors++;
                                } else {
                                  if (func2(data13) < 1) {
                                    const err48 = { instancePath: instancePath + "/provider", schemaPath: "#/properties/provider/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                    if (vErrors === null) {
                                      vErrors = [err48];
                                    } else {
                                      vErrors.push(err48);
                                    }
                                    errors++;
                                  }
                                }
                              } else {
                                const err49 = { instancePath: instancePath + "/provider", schemaPath: "#/properties/provider/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err49];
                                } else {
                                  vErrors.push(err49);
                                }
                                errors++;
                              }
                            }
                            var _valid9 = _errs67 === errors;
                            valid14 = valid14 || _valid9;
                            const _errs69 = errors;
                            if (data13 !== null) {
                              const err50 = { instancePath: instancePath + "/provider", schemaPath: "#/properties/provider/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err50];
                              } else {
                                vErrors.push(err50);
                              }
                              errors++;
                            }
                            var _valid9 = _errs69 === errors;
                            valid14 = valid14 || _valid9;
                            if (!valid14) {
                              const err51 = { instancePath: instancePath + "/provider", schemaPath: "#/properties/provider/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err51];
                              } else {
                                vErrors.push(err51);
                              }
                              errors++;
                              validate87.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs66;
                              if (vErrors !== null) {
                                if (_errs66) {
                                  vErrors.length = _errs66;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs65 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.reasoning_tokens !== void 0) {
                              let data14 = data.reasoning_tokens;
                              const _errs71 = errors;
                              const _errs72 = errors;
                              let valid15 = false;
                              const _errs73 = errors;
                              if (!(typeof data14 == "number" && (!(data14 % 1) && !isNaN(data14)))) {
                                const err52 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err52];
                                } else {
                                  vErrors.push(err52);
                                }
                                errors++;
                              }
                              if (errors === _errs73) {
                                if (typeof data14 == "number") {
                                  if (data14 < 0 || isNaN(data14)) {
                                    const err53 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                    if (vErrors === null) {
                                      vErrors = [err53];
                                    } else {
                                      vErrors.push(err53);
                                    }
                                    errors++;
                                  }
                                }
                              }
                              var _valid10 = _errs73 === errors;
                              valid15 = valid15 || _valid10;
                              const _errs75 = errors;
                              if (data14 !== null) {
                                const err54 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err54];
                                } else {
                                  vErrors.push(err54);
                                }
                                errors++;
                              }
                              var _valid10 = _errs75 === errors;
                              valid15 = valid15 || _valid10;
                              if (!valid15) {
                                const err55 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err55];
                                } else {
                                  vErrors.push(err55);
                                }
                                errors++;
                                validate87.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs72;
                                if (vErrors !== null) {
                                  if (_errs72) {
                                    vErrors.length = _errs72;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs71 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.route_kind !== void 0) {
                                let data15 = data.route_kind;
                                const _errs77 = errors;
                                if (typeof data15 !== "string") {
                                  validate87.errors = [{ instancePath: instancePath + "/route_kind", schemaPath: "#/$defs/RouteKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                if (!(data15 === "agent" || data15 === "api_key")) {
                                  validate87.errors = [{ instancePath: instancePath + "/route_kind", schemaPath: "#/$defs/RouteKind/enum", keyword: "enum", params: { allowedValues: schema133.enum }, message: "must be equal to one of the allowed values" }];
                                  return false;
                                }
                                var valid0 = _errs77 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.source !== void 0) {
                                  let data16 = data.source;
                                  const _errs80 = errors;
                                  if (typeof data16 !== "string") {
                                    validate87.errors = [{ instancePath: instancePath + "/source", schemaPath: "#/$defs/UsageSource/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  if (!(data16 === "provider_reported" || data16 === "agent_reported")) {
                                    validate87.errors = [{ instancePath: instancePath + "/source", schemaPath: "#/$defs/UsageSource/enum", keyword: "enum", params: { allowedValues: schema134.enum }, message: "must be equal to one of the allowed values" }];
                                    return false;
                                  }
                                  var valid0 = _errs80 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate87.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate87.errors = vErrors;
  return errors === 0;
}
validate87.evaluated = { "props": { "agent_name": true, "agent_version": true, "cache_write_input_tokens": true, "cached_input_tokens": true, "cost": true, "input_tokens": true, "model_id": true, "output_tokens": true, "payer": true, "provider": true, "reasoning_tokens": true, "route_kind": true, "source": true }, "dynamicProps": false, "dynamicItems": false };
function validate89(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate89.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.input_tokens === void 0 && (missing0 = "input_tokens") || data.output_tokens === void 0 && (missing0 = "output_tokens") || data.cached_input_tokens === void 0 && (missing0 = "cached_input_tokens") || data.reasoning_tokens === void 0 && (missing0 = "reasoning_tokens") || data.cost === void 0 && (missing0 = "cost")) {
        validate89.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.cache_write_input_tokens !== void 0) {
          let data0 = data.cache_write_input_tokens;
          const _errs1 = errors;
          const _errs2 = errors;
          let valid1 = false;
          const _errs3 = errors;
          if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
            const err0 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          if (errors === _errs3) {
            if (typeof data0 == "number") {
              if (data0 < 0 || isNaN(data0)) {
                const err1 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
            }
          }
          var _valid0 = _errs3 === errors;
          valid1 = valid1 || _valid0;
          const _errs5 = errors;
          if (data0 !== null) {
            const err2 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          var _valid0 = _errs5 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const err3 = { instancePath: instancePath + "/cache_write_input_tokens", schemaPath: "#/properties/cache_write_input_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
            validate89.errors = vErrors;
            return false;
          } else {
            errors = _errs2;
            if (vErrors !== null) {
              if (_errs2) {
                vErrors.length = _errs2;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.cached_input_tokens !== void 0) {
            let data1 = data.cached_input_tokens;
            const _errs7 = errors;
            const _errs8 = errors;
            let valid2 = false;
            const _errs9 = errors;
            if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
              const err4 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (errors === _errs9) {
              if (typeof data1 == "number") {
                if (data1 < 0 || isNaN(data1)) {
                  const err5 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
              }
            }
            var _valid1 = _errs9 === errors;
            valid2 = valid2 || _valid1;
            const _errs11 = errors;
            if (data1 !== null) {
              const err6 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var _valid1 = _errs11 === errors;
            valid2 = valid2 || _valid1;
            if (!valid2) {
              const err7 = { instancePath: instancePath + "/cached_input_tokens", schemaPath: "#/properties/cached_input_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
              validate89.errors = vErrors;
              return false;
            } else {
              errors = _errs8;
              if (vErrors !== null) {
                if (_errs8) {
                  vErrors.length = _errs8;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs7 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cost !== void 0) {
              let data2 = data.cost;
              const _errs13 = errors;
              const _errs14 = errors;
              let valid3 = false;
              const _errs15 = errors;
              const _errs16 = errors;
              if (errors === _errs16) {
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                  let missing1;
                  if (data2.amount === void 0 && (missing1 = "amount") || data2.currency === void 0 && (missing1 = "currency")) {
                    const err8 = { instancePath: instancePath + "/cost", schemaPath: "#/$defs/UsageCost/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  } else {
                    if (data2.amount !== void 0) {
                      let data3 = data2.amount;
                      const _errs18 = errors;
                      if (errors === _errs18) {
                        if (typeof data3 == "number") {
                          if (data3 < 0 || isNaN(data3)) {
                            const err9 = { instancePath: instancePath + "/cost/amount", schemaPath: "#/$defs/UsageCost/properties/amount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                          }
                        } else {
                          const err10 = { instancePath: instancePath + "/cost/amount", schemaPath: "#/$defs/UsageCost/properties/amount/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                        }
                      }
                      var valid5 = _errs18 === errors;
                    } else {
                      var valid5 = true;
                    }
                    if (valid5) {
                      if (data2.currency !== void 0) {
                        let data4 = data2.currency;
                        const _errs20 = errors;
                        if (errors === _errs20) {
                          if (typeof data4 === "string") {
                            if (!pattern55.test(data4)) {
                              const err11 = { instancePath: instancePath + "/cost/currency", schemaPath: "#/$defs/UsageCost/properties/currency/pattern", keyword: "pattern", params: { pattern: "^[A-Z]{3}$" }, message: 'must match pattern "^[A-Z]{3}$"' };
                              if (vErrors === null) {
                                vErrors = [err11];
                              } else {
                                vErrors.push(err11);
                              }
                              errors++;
                            }
                          } else {
                            const err12 = { instancePath: instancePath + "/cost/currency", schemaPath: "#/$defs/UsageCost/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err12];
                            } else {
                              vErrors.push(err12);
                            }
                            errors++;
                          }
                        }
                        var valid5 = _errs20 === errors;
                      } else {
                        var valid5 = true;
                      }
                    }
                  }
                } else {
                  const err13 = { instancePath: instancePath + "/cost", schemaPath: "#/$defs/UsageCost/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
              }
              var _valid2 = _errs15 === errors;
              valid3 = valid3 || _valid2;
              if (_valid2) {
                var props0 = {};
                props0.amount = true;
                props0.currency = true;
              }
              const _errs22 = errors;
              if (data2 !== null) {
                const err14 = { instancePath: instancePath + "/cost", schemaPath: "#/properties/cost/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              var _valid2 = _errs22 === errors;
              valid3 = valid3 || _valid2;
              if (!valid3) {
                const err15 = { instancePath: instancePath + "/cost", schemaPath: "#/properties/cost/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
                validate89.errors = vErrors;
                return false;
              } else {
                errors = _errs14;
                if (vErrors !== null) {
                  if (_errs14) {
                    vErrors.length = _errs14;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs13 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.input_tokens !== void 0) {
                let data5 = data.input_tokens;
                const _errs24 = errors;
                const _errs25 = errors;
                let valid6 = false;
                const _errs26 = errors;
                if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)))) {
                  const err16 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
                if (errors === _errs26) {
                  if (typeof data5 == "number") {
                    if (data5 < 0 || isNaN(data5)) {
                      const err17 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                      if (vErrors === null) {
                        vErrors = [err17];
                      } else {
                        vErrors.push(err17);
                      }
                      errors++;
                    }
                  }
                }
                var _valid3 = _errs26 === errors;
                valid6 = valid6 || _valid3;
                const _errs28 = errors;
                if (data5 !== null) {
                  const err18 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err18];
                  } else {
                    vErrors.push(err18);
                  }
                  errors++;
                }
                var _valid3 = _errs28 === errors;
                valid6 = valid6 || _valid3;
                if (!valid6) {
                  const err19 = { instancePath: instancePath + "/input_tokens", schemaPath: "#/properties/input_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err19];
                  } else {
                    vErrors.push(err19);
                  }
                  errors++;
                  validate89.errors = vErrors;
                  return false;
                } else {
                  errors = _errs25;
                  if (vErrors !== null) {
                    if (_errs25) {
                      vErrors.length = _errs25;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs24 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.output_tokens !== void 0) {
                  let data6 = data.output_tokens;
                  const _errs30 = errors;
                  const _errs31 = errors;
                  let valid7 = false;
                  const _errs32 = errors;
                  if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                    const err20 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err20];
                    } else {
                      vErrors.push(err20);
                    }
                    errors++;
                  }
                  if (errors === _errs32) {
                    if (typeof data6 == "number") {
                      if (data6 < 0 || isNaN(data6)) {
                        const err21 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                        if (vErrors === null) {
                          vErrors = [err21];
                        } else {
                          vErrors.push(err21);
                        }
                        errors++;
                      }
                    }
                  }
                  var _valid4 = _errs32 === errors;
                  valid7 = valid7 || _valid4;
                  const _errs34 = errors;
                  if (data6 !== null) {
                    const err22 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                  var _valid4 = _errs34 === errors;
                  valid7 = valid7 || _valid4;
                  if (!valid7) {
                    const err23 = { instancePath: instancePath + "/output_tokens", schemaPath: "#/properties/output_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                    validate89.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs31;
                    if (vErrors !== null) {
                      if (_errs31) {
                        vErrors.length = _errs31;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs30 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.reasoning_tokens !== void 0) {
                    let data7 = data.reasoning_tokens;
                    const _errs36 = errors;
                    const _errs37 = errors;
                    let valid8 = false;
                    const _errs38 = errors;
                    if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)))) {
                      const err24 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                      if (vErrors === null) {
                        vErrors = [err24];
                      } else {
                        vErrors.push(err24);
                      }
                      errors++;
                    }
                    if (errors === _errs38) {
                      if (typeof data7 == "number") {
                        if (data7 < 0 || isNaN(data7)) {
                          const err25 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                          if (vErrors === null) {
                            vErrors = [err25];
                          } else {
                            vErrors.push(err25);
                          }
                          errors++;
                        }
                      }
                    }
                    var _valid5 = _errs38 === errors;
                    valid8 = valid8 || _valid5;
                    const _errs40 = errors;
                    if (data7 !== null) {
                      const err26 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err26];
                      } else {
                        vErrors.push(err26);
                      }
                      errors++;
                    }
                    var _valid5 = _errs40 === errors;
                    valid8 = valid8 || _valid5;
                    if (!valid8) {
                      const err27 = { instancePath: instancePath + "/reasoning_tokens", schemaPath: "#/properties/reasoning_tokens/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err27];
                      } else {
                        vErrors.push(err27);
                      }
                      errors++;
                      validate89.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs37;
                      if (vErrors !== null) {
                        if (_errs37) {
                          vErrors.length = _errs37;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs36 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate89.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate89.errors = vErrors;
  return errors === 0;
}
validate89.evaluated = { "props": { "cache_write_input_tokens": true, "cached_input_tokens": true, "cost": true, "input_tokens": true, "output_tokens": true, "reasoning_tokens": true }, "dynamicProps": false, "dynamicItems": false };
function validate86(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate86.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.records === void 0 && (missing0 = "records") || data.total === void 0 && (missing0 = "total")) {
        validate86.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.records !== void 0) {
          let data0 = data.records;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (!validate87(data0[i0], { instancePath: instancePath + "/records/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate87.errors : vErrors.concat(validate87.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate86.errors = [{ instancePath: instancePath + "/records", schemaPath: "#/properties/records/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.total !== void 0) {
            const _errs4 = errors;
            if (!validate89(data.total, { instancePath: instancePath + "/total", parentData: data, parentDataProperty: "total", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate89.errors : vErrors.concat(validate89.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate86.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate86.errors = vErrors;
  return errors === 0;
}
validate86.evaluated = { "props": { "records": true, "total": true }, "dynamicProps": false, "dynamicItems": false };
function validate73(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate73.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.request_entry === void 0 && (missing0 = "request_entry") || data.outcome === void 0 && (missing0 = "outcome") || data.stop_reason === void 0 && (missing0 = "stop_reason") || data.agent_messages === void 0 && (missing0 = "agent_messages") || data.local_tool_calls === void 0 && (missing0 = "local_tool_calls") || data.output_entry === void 0 && (missing0 = "output_entry") || data.usage === void 0 && (missing0 = "usage") || data.agent === void 0 && (missing0 = "agent") || data.session_use === void 0 && (missing0 = "session_use") || data.agent_compacted_context === void 0 && (missing0 = "agent_compacted_context") || data.provider_contact === void 0 && (missing0 = "provider_contact") || data.problem === void 0 && (missing0 = "problem") || data.connector_id === void 0 && (missing0 = "connector_id") || data.permission_profile === void 0 && (missing0 = "permission_profile") || data.started_at === void 0 && (missing0 = "started_at") || data.finished_at === void 0 && (missing0 = "finished_at") || data.redacted_patterns === void 0 && (missing0 = "redacted_patterns") || data.reported_by === void 0 && (missing0 = "reported_by")) {
        validate73.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema106.properties, key0)) {
            validate73.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.agent !== void 0) {
            let data0 = data.agent;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!validate74(data0, { instancePath: instancePath + "/agent", parentData: data, parentDataProperty: "agent", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            if (_valid0) {
              var props0 = {};
              props0.gta = true;
              props0.model_id = true;
              props0.name = true;
              props0.version = true;
            }
            const _errs5 = errors;
            if (data0 !== null) {
              const err0 = { instancePath: instancePath + "/agent", schemaPath: "#/properties/agent/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err1 = { instancePath: instancePath + "/agent", schemaPath: "#/properties/agent/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              validate73.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.agent_compacted_context !== void 0) {
              const _errs7 = errors;
              if (typeof data.agent_compacted_context !== "boolean") {
                validate73.errors = [{ instancePath: instancePath + "/agent_compacted_context", schemaPath: "#/properties/agent_compacted_context/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.agent_messages !== void 0) {
                let data2 = data.agent_messages;
                const _errs9 = errors;
                if (errors === _errs9) {
                  if (Array.isArray(data2)) {
                    var valid2 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs11 = errors;
                      if (typeof data2[i0] !== "string") {
                        validate73.errors = [{ instancePath: instancePath + "/agent_messages/" + i0, schemaPath: "#/properties/agent_messages/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid2 = _errs11 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate73.errors = [{ instancePath: instancePath + "/agent_messages", schemaPath: "#/properties/agent_messages/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.agent_setup !== void 0) {
                  let data4 = data.agent_setup;
                  const _errs13 = errors;
                  const _errs14 = errors;
                  let valid3 = false;
                  const _errs15 = errors;
                  if (!validate76(data4, { instancePath: instancePath + "/agent_setup", parentData: data, parentDataProperty: "agent_setup", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate76.errors : vErrors.concat(validate76.errors);
                    errors = vErrors.length;
                  }
                  var _valid1 = _errs15 === errors;
                  valid3 = valid3 || _valid1;
                  if (_valid1) {
                    var props1 = {};
                    props1.dmw_layer = true;
                    props1.personal_layer = true;
                    props1.setup = true;
                    props1.setup_digest = true;
                  }
                  const _errs16 = errors;
                  if (data4 !== null) {
                    const err2 = { instancePath: instancePath + "/agent_setup", schemaPath: "#/properties/agent_setup/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  var _valid1 = _errs16 === errors;
                  valid3 = valid3 || _valid1;
                  if (!valid3) {
                    const err3 = { instancePath: instancePath + "/agent_setup", schemaPath: "#/properties/agent_setup/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                    validate73.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs14;
                    if (vErrors !== null) {
                      if (_errs14) {
                        vErrors.length = _errs14;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.connector_id !== void 0) {
                    let data5 = data.connector_id;
                    const _errs18 = errors;
                    const _errs19 = errors;
                    let valid4 = false;
                    const _errs20 = errors;
                    if (typeof data5 !== "string") {
                      const err4 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid2 = _errs20 === errors;
                    valid4 = valid4 || _valid2;
                    const _errs22 = errors;
                    if (data5 !== null) {
                      const err5 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                    }
                    var _valid2 = _errs22 === errors;
                    valid4 = valid4 || _valid2;
                    if (!valid4) {
                      const err6 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err6];
                      } else {
                        vErrors.push(err6);
                      }
                      errors++;
                      validate73.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs19;
                      if (vErrors !== null) {
                        if (_errs19) {
                          vErrors.length = _errs19;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.finished_at !== void 0) {
                      let data6 = data.finished_at;
                      const _errs24 = errors;
                      const _errs25 = errors;
                      let valid5 = false;
                      const _errs26 = errors;
                      if (typeof data6 !== "string") {
                        const err7 = { instancePath: instancePath + "/finished_at", schemaPath: "#/properties/finished_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      var _valid3 = _errs26 === errors;
                      valid5 = valid5 || _valid3;
                      const _errs28 = errors;
                      if (data6 !== null) {
                        const err8 = { instancePath: instancePath + "/finished_at", schemaPath: "#/properties/finished_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      }
                      var _valid3 = _errs28 === errors;
                      valid5 = valid5 || _valid3;
                      if (!valid5) {
                        const err9 = { instancePath: instancePath + "/finished_at", schemaPath: "#/properties/finished_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err9];
                        } else {
                          vErrors.push(err9);
                        }
                        errors++;
                        validate73.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs25;
                        if (vErrors !== null) {
                          if (_errs25) {
                            vErrors.length = _errs25;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs24 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.kind !== void 0) {
                        let data7 = data.kind;
                        const _errs30 = errors;
                        if (typeof data7 !== "string") {
                          validate73.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        if ("turn_finished" !== data7) {
                          validate73.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "turn_finished" }, message: "must be equal to constant" }];
                          return false;
                        }
                        var valid0 = _errs30 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.local_tool_calls !== void 0) {
                          let data8 = data.local_tool_calls;
                          const _errs32 = errors;
                          if (errors === _errs32) {
                            if (Array.isArray(data8)) {
                              var valid6 = true;
                              const len1 = data8.length;
                              for (let i1 = 0; i1 < len1; i1++) {
                                const _errs34 = errors;
                                if (!validate82(data8[i1], { instancePath: instancePath + "/local_tool_calls/" + i1, parentData: data8, parentDataProperty: i1, rootData, dynamicAnchors })) {
                                  vErrors = vErrors === null ? validate82.errors : vErrors.concat(validate82.errors);
                                  errors = vErrors.length;
                                }
                                var valid6 = _errs34 === errors;
                                if (!valid6) {
                                  break;
                                }
                              }
                            } else {
                              validate73.errors = [{ instancePath: instancePath + "/local_tool_calls", schemaPath: "#/properties/local_tool_calls/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid0 = _errs32 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.outcome !== void 0) {
                            let data10 = data.outcome;
                            const _errs35 = errors;
                            if (typeof data10 !== "string") {
                              validate73.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/TurnOutcome/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            if (!(data10 === "completed" || data10 === "failed" || data10 === "cancelled")) {
                              validate73.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/TurnOutcome/enum", keyword: "enum", params: { allowedValues: schema123.enum }, message: "must be equal to one of the allowed values" }];
                              return false;
                            }
                            var valid0 = _errs35 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.output_entry !== void 0) {
                              let data11 = data.output_entry;
                              const _errs38 = errors;
                              const _errs39 = errors;
                              let valid8 = false;
                              const _errs40 = errors;
                              if (!(typeof data11 == "number" && (!(data11 % 1) && !isNaN(data11)))) {
                                const err10 = { instancePath: instancePath + "/output_entry", schemaPath: "#/properties/output_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err10];
                                } else {
                                  vErrors.push(err10);
                                }
                                errors++;
                              }
                              if (errors === _errs40) {
                                if (typeof data11 == "number") {
                                  if (data11 < 1 || isNaN(data11)) {
                                    const err11 = { instancePath: instancePath + "/output_entry", schemaPath: "#/properties/output_entry/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                    if (vErrors === null) {
                                      vErrors = [err11];
                                    } else {
                                      vErrors.push(err11);
                                    }
                                    errors++;
                                  }
                                }
                              }
                              var _valid4 = _errs40 === errors;
                              valid8 = valid8 || _valid4;
                              const _errs42 = errors;
                              if (data11 !== null) {
                                const err12 = { instancePath: instancePath + "/output_entry", schemaPath: "#/properties/output_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err12];
                                } else {
                                  vErrors.push(err12);
                                }
                                errors++;
                              }
                              var _valid4 = _errs42 === errors;
                              valid8 = valid8 || _valid4;
                              if (!valid8) {
                                const err13 = { instancePath: instancePath + "/output_entry", schemaPath: "#/properties/output_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err13];
                                } else {
                                  vErrors.push(err13);
                                }
                                errors++;
                                validate73.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs39;
                                if (vErrors !== null) {
                                  if (_errs39) {
                                    vErrors.length = _errs39;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs38 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.permission_profile !== void 0) {
                                let data12 = data.permission_profile;
                                const _errs44 = errors;
                                if (errors === _errs44) {
                                  if (typeof data12 === "string") {
                                    if (!pattern4.test(data12)) {
                                      validate73.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                      return false;
                                    }
                                  } else {
                                    validate73.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                }
                                var valid0 = _errs44 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.problem !== void 0) {
                                  let data13 = data.problem;
                                  const _errs46 = errors;
                                  const _errs47 = errors;
                                  let valid9 = false;
                                  const _errs48 = errors;
                                  if (!validate84(data13, { instancePath: instancePath + "/problem", parentData: data, parentDataProperty: "problem", rootData, dynamicAnchors })) {
                                    vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
                                    errors = vErrors.length;
                                  }
                                  var _valid5 = _errs48 === errors;
                                  valid9 = valid9 || _valid5;
                                  const _errs49 = errors;
                                  if (data13 !== null) {
                                    const err14 = { instancePath: instancePath + "/problem", schemaPath: "#/properties/problem/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                  }
                                  var _valid5 = _errs49 === errors;
                                  valid9 = valid9 || _valid5;
                                  if (!valid9) {
                                    const err15 = { instancePath: instancePath + "/problem", schemaPath: "#/properties/problem/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err15];
                                    } else {
                                      vErrors.push(err15);
                                    }
                                    errors++;
                                    validate73.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs47;
                                    if (vErrors !== null) {
                                      if (_errs47) {
                                        vErrors.length = _errs47;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs46 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.provider_contact !== void 0) {
                                    let data14 = data.provider_contact;
                                    const _errs51 = errors;
                                    if (typeof data14 !== "string") {
                                      validate73.errors = [{ instancePath: instancePath + "/provider_contact", schemaPath: "#/$defs/ProviderContact/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    if (!(data14 === "none" || data14 === "possible" || data14 === "confirmed")) {
                                      validate73.errors = [{ instancePath: instancePath + "/provider_contact", schemaPath: "#/$defs/ProviderContact/enum", keyword: "enum", params: { allowedValues: schema126.enum }, message: "must be equal to one of the allowed values" }];
                                      return false;
                                    }
                                    var valid0 = _errs51 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.redacted_patterns !== void 0) {
                                      let data15 = data.redacted_patterns;
                                      const _errs54 = errors;
                                      if (errors === _errs54) {
                                        if (Array.isArray(data15)) {
                                          var valid11 = true;
                                          const len2 = data15.length;
                                          for (let i2 = 0; i2 < len2; i2++) {
                                            let data16 = data15[i2];
                                            const _errs56 = errors;
                                            if (errors === _errs56) {
                                              if (typeof data16 === "string") {
                                                if (!pattern8.test(data16)) {
                                                  validate73.errors = [{ instancePath: instancePath + "/redacted_patterns/" + i2, schemaPath: "#/properties/redacted_patterns/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                                  return false;
                                                }
                                              } else {
                                                validate73.errors = [{ instancePath: instancePath + "/redacted_patterns/" + i2, schemaPath: "#/properties/redacted_patterns/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                            }
                                            var valid11 = _errs56 === errors;
                                            if (!valid11) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate73.errors = [{ instancePath: instancePath + "/redacted_patterns", schemaPath: "#/properties/redacted_patterns/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                          return false;
                                        }
                                      }
                                      var valid0 = _errs54 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.reported_by !== void 0) {
                                        let data17 = data.reported_by;
                                        const _errs58 = errors;
                                        if (typeof data17 !== "string") {
                                          validate73.errors = [{ instancePath: instancePath + "/reported_by", schemaPath: "#/properties/reported_by/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                        if (!(data17 === "connector" || data17 === "server")) {
                                          validate73.errors = [{ instancePath: instancePath + "/reported_by", schemaPath: "#/properties/reported_by/enum", keyword: "enum", params: { allowedValues: schema106.properties.reported_by.enum }, message: "must be equal to one of the allowed values" }];
                                          return false;
                                        }
                                        var valid0 = _errs58 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.request_entry !== void 0) {
                                          let data18 = data.request_entry;
                                          const _errs60 = errors;
                                          if (!(typeof data18 == "number" && (!(data18 % 1) && !isNaN(data18)))) {
                                            validate73.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                            return false;
                                          }
                                          if (errors === _errs60) {
                                            if (typeof data18 == "number") {
                                              if (data18 < 1 || isNaN(data18)) {
                                                validate73.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                                return false;
                                              }
                                            }
                                          }
                                          var valid0 = _errs60 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.session_use !== void 0) {
                                            let data19 = data.session_use;
                                            const _errs62 = errors;
                                            const _errs63 = errors;
                                            let valid12 = false;
                                            const _errs64 = errors;
                                            if (typeof data19 !== "string") {
                                              const err16 = { instancePath: instancePath + "/session_use", schemaPath: "#/$defs/SessionUse/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                              if (vErrors === null) {
                                                vErrors = [err16];
                                              } else {
                                                vErrors.push(err16);
                                              }
                                              errors++;
                                            }
                                            if (!(data19 === "continued" || data19 === "fresh" || data19 === "isolated" || data19 === "resumed")) {
                                              const err17 = { instancePath: instancePath + "/session_use", schemaPath: "#/$defs/SessionUse/enum", keyword: "enum", params: { allowedValues: schema127.enum }, message: "must be equal to one of the allowed values" };
                                              if (vErrors === null) {
                                                vErrors = [err17];
                                              } else {
                                                vErrors.push(err17);
                                              }
                                              errors++;
                                            }
                                            var _valid6 = _errs64 === errors;
                                            valid12 = valid12 || _valid6;
                                            const _errs67 = errors;
                                            if (data19 !== null) {
                                              const err18 = { instancePath: instancePath + "/session_use", schemaPath: "#/properties/session_use/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                              if (vErrors === null) {
                                                vErrors = [err18];
                                              } else {
                                                vErrors.push(err18);
                                              }
                                              errors++;
                                            }
                                            var _valid6 = _errs67 === errors;
                                            valid12 = valid12 || _valid6;
                                            if (!valid12) {
                                              const err19 = { instancePath: instancePath + "/session_use", schemaPath: "#/properties/session_use/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                              if (vErrors === null) {
                                                vErrors = [err19];
                                              } else {
                                                vErrors.push(err19);
                                              }
                                              errors++;
                                              validate73.errors = vErrors;
                                              return false;
                                            } else {
                                              errors = _errs63;
                                              if (vErrors !== null) {
                                                if (_errs63) {
                                                  vErrors.length = _errs63;
                                                } else {
                                                  vErrors = null;
                                                }
                                              }
                                            }
                                            var valid0 = _errs62 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.started_at !== void 0) {
                                              let data20 = data.started_at;
                                              const _errs69 = errors;
                                              const _errs70 = errors;
                                              let valid14 = false;
                                              const _errs71 = errors;
                                              if (typeof data20 !== "string") {
                                                const err20 = { instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err20];
                                                } else {
                                                  vErrors.push(err20);
                                                }
                                                errors++;
                                              }
                                              var _valid7 = _errs71 === errors;
                                              valid14 = valid14 || _valid7;
                                              const _errs73 = errors;
                                              if (data20 !== null) {
                                                const err21 = { instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                if (vErrors === null) {
                                                  vErrors = [err21];
                                                } else {
                                                  vErrors.push(err21);
                                                }
                                                errors++;
                                              }
                                              var _valid7 = _errs73 === errors;
                                              valid14 = valid14 || _valid7;
                                              if (!valid14) {
                                                const err22 = { instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                if (vErrors === null) {
                                                  vErrors = [err22];
                                                } else {
                                                  vErrors.push(err22);
                                                }
                                                errors++;
                                                validate73.errors = vErrors;
                                                return false;
                                              } else {
                                                errors = _errs70;
                                                if (vErrors !== null) {
                                                  if (_errs70) {
                                                    vErrors.length = _errs70;
                                                  } else {
                                                    vErrors = null;
                                                  }
                                                }
                                              }
                                              var valid0 = _errs69 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.stop_reason !== void 0) {
                                                let data21 = data.stop_reason;
                                                const _errs75 = errors;
                                                const _errs76 = errors;
                                                let valid15 = false;
                                                const _errs77 = errors;
                                                if (typeof data21 !== "string") {
                                                  const err23 = { instancePath: instancePath + "/stop_reason", schemaPath: "#/$defs/StopReason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err23];
                                                  } else {
                                                    vErrors.push(err23);
                                                  }
                                                  errors++;
                                                }
                                                if (!(data21 === "end_turn" || data21 === "max_tokens" || data21 === "max_turn_requests" || data21 === "refusal" || data21 === "cancelled")) {
                                                  const err24 = { instancePath: instancePath + "/stop_reason", schemaPath: "#/$defs/StopReason/enum", keyword: "enum", params: { allowedValues: schema128.enum }, message: "must be equal to one of the allowed values" };
                                                  if (vErrors === null) {
                                                    vErrors = [err24];
                                                  } else {
                                                    vErrors.push(err24);
                                                  }
                                                  errors++;
                                                }
                                                var _valid8 = _errs77 === errors;
                                                valid15 = valid15 || _valid8;
                                                const _errs80 = errors;
                                                if (data21 !== null) {
                                                  const err25 = { instancePath: instancePath + "/stop_reason", schemaPath: "#/properties/stop_reason/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                  if (vErrors === null) {
                                                    vErrors = [err25];
                                                  } else {
                                                    vErrors.push(err25);
                                                  }
                                                  errors++;
                                                }
                                                var _valid8 = _errs80 === errors;
                                                valid15 = valid15 || _valid8;
                                                if (!valid15) {
                                                  const err26 = { instancePath: instancePath + "/stop_reason", schemaPath: "#/properties/stop_reason/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                  if (vErrors === null) {
                                                    vErrors = [err26];
                                                  } else {
                                                    vErrors.push(err26);
                                                  }
                                                  errors++;
                                                  validate73.errors = vErrors;
                                                  return false;
                                                } else {
                                                  errors = _errs76;
                                                  if (vErrors !== null) {
                                                    if (_errs76) {
                                                      vErrors.length = _errs76;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid0 = _errs75 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (data.turn_id !== void 0) {
                                                  const _errs82 = errors;
                                                  if (typeof data.turn_id !== "string") {
                                                    validate73.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                    return false;
                                                  }
                                                  var valid0 = _errs82 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (data.usage !== void 0) {
                                                    const _errs84 = errors;
                                                    if (!validate86(data.usage, { instancePath: instancePath + "/usage", parentData: data, parentDataProperty: "usage", rootData, dynamicAnchors })) {
                                                      vErrors = vErrors === null ? validate86.errors : vErrors.concat(validate86.errors);
                                                      errors = vErrors.length;
                                                    }
                                                    var valid0 = _errs84 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate73.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate73.errors = vErrors;
  return errors === 0;
}
validate73.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema137 = { "additionalProperties": false, "description": "The frozen tool turn: a tool step of the Workflow or ad hoc, or a tool version run\nwithout a step (W2-6). Without a step it is a participant's run of a tool, which is the\nThread's open turn like any other, or the agent's `run_tool` call, which runs inside\nthe agent turn named by `called_in` and leaves the open turn alone.", "properties": { "based_on_entry": { "minimum": 1, "title": "Based On Entry", "type": "integer" }, "called_in": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "description": "The agent turn whose `run_tool` call asked for this run; absent otherwise.", "title": "Called In" }, "kind": { "const": "tool_turn_requested", "title": "Kind", "type": "string" }, "permission_profile": { "anyOf": [{ "pattern": "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$", "type": "string" }, { "type": "null" }], "description": "The host's profile for item tools; `None` for a built-in tool.", "title": "Permission Profile" }, "proposes": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}$", "type": "string" }, { "type": "null" }], "description": "The output the step proposes as a change set when the run completes.", "title": "Proposes" }, "requested_by": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Requested By" }, "route": { "$ref": "#/$defs/ToolTurnRoute" }, "run": { "$ref": "#/$defs/ToolRunPlan" }, "step": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Step" }, "step_key": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "type": "string" }, { "type": "null" }], "description": "`None` for a run without a step.", "title": "Step Key" }, "supersedes": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "default": null, "description": "A rerun's withdrawal of the waiting human step request after its step: that request\nshowed an older output (RF-03). One entry with the rerun, so neither takes effect\nalone; absent for other requests.", "title": "Supersedes" }, "turn_id": { "title": "Turn Id", "type": "string" }, "versions_used": { "$ref": "#/$defs/ToolVersionsUsed" } }, "required": ["kind", "turn_id", "step_key", "step", "based_on_entry", "route", "permission_profile", "run", "versions_used", "proposes", "requested_by"], "title": "ToolTurnRequestedPayload", "type": "object" };
var schema140 = { "enum": ["node", "python"], "title": "ToolRuntimeKind", "type": "string" };
function validate95(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate95.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.runtime === void 0 && (missing0 = "runtime")) {
        validate95.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.kind !== void 0) {
          let data0 = data.kind;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate95.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
            return false;
          }
          if ("tool_runtime" !== data0) {
            validate95.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "tool_runtime" }, message: "must be equal to constant" }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.runtime !== void 0) {
            let data1 = data.runtime;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate95.errors = [{ instancePath: instancePath + "/runtime", schemaPath: "#/$defs/ToolRuntimeKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data1 === "node" || data1 === "python")) {
              validate95.errors = [{ instancePath: instancePath + "/runtime", schemaPath: "#/$defs/ToolRuntimeKind/enum", keyword: "enum", params: { allowedValues: schema140.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate95.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate95.errors = vErrors;
  return errors === 0;
}
validate95.evaluated = { "props": { "kind": true, "runtime": true }, "dynamicProps": false, "dynamicItems": false };
function validate94(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate94.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  if (!validate95(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
    vErrors = vErrors === null ? validate95.errors : vErrors.concat(validate95.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = {};
    props0.kind = true;
    props0.runtime = true;
  }
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind")) {
        const err0 = { instancePath, schemaPath: "#/$defs/BuiltinToolRoute/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs5 = errors;
        for (const key0 in data) {
          if (!(key0 === "kind")) {
            const err1 = { instancePath, schemaPath: "#/$defs/BuiltinToolRoute/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs5 === errors) {
          if (data.kind !== void 0) {
            let data0 = data.kind;
            if (typeof data0 !== "string") {
              const err2 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/BuiltinToolRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if ("built_in" !== data0) {
              const err3 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/BuiltinToolRoute/properties/kind/const", keyword: "const", params: { allowedValue: "built_in" }, message: "must be equal to constant" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
          }
        }
      }
    } else {
      const err4 = { instancePath, schemaPath: "#/$defs/BuiltinToolRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
  }
  if (!valid0) {
    const err5 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
    validate94.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate94.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate94.evaluated = { "dynamicProps": true, "dynamicItems": false };
var schema142 = { "additionalProperties": false, "description": "The frozen input of a tool run: references and small values (P-6). The tool file\nitself is read from the content repository by its reference when the turn is sent.", "properties": { "inputs": { "patternProperties": { "^[a-z][a-z0-9_]{0,62}$": { "$ref": "#/$defs/ToolValue" } }, "title": "Inputs", "type": "object" }, "limits": { "anyOf": [{ "$ref": "#/$defs/ToolRunLimits" }, { "type": "null" }], "description": "`None` for a built-in tool." }, "model": { "anyOf": [{ "$ref": "#/$defs/ToolModelIdentity" }, { "type": "null" }], "default": null, "description": "An embedding tool's model, from its reviewed header; part of `run_digest`." }, "model_use": { "$ref": "#/$defs/ToolModelUse" }, "outputs": { "patternProperties": { "^[a-z][a-z0-9_]{0,62}$": { "$ref": "#/$defs/ValueKind" } }, "title": "Outputs", "type": "object" }, "parameters": { "description": "Every declared parameter, defaults filled in.", "patternProperties": { "^[a-z][a-z0-9_]{0,62}$": { "$ref": "#/$defs/JsonValue" } }, "title": "Parameters", "type": "object" }, "run_digest": { "pattern": "^sha256-jcs:[0-9a-f]{64}$", "title": "Run Digest", "type": "string" }, "tool": { "maxLength": 200, "minLength": 1, "title": "Tool", "type": "string" }, "tool_name": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "title": "Tool Name", "type": "string" } }, "required": ["tool", "tool_name", "model_use", "parameters", "inputs", "outputs", "limits", "run_digest"], "title": "ToolRunPlan", "type": "object" };
var schema149 = { "enum": ["none", "embedding"], "title": "ToolModelUse", "type": "string" };
function validate99(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate99.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.value === void 0 && (missing0 = "value") || data.digest === void 0 && (missing0 = "digest")) {
        validate99.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.digest !== void 0) {
          let data0 = data.digest;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (typeof data0 === "string") {
              if (!pattern24.test(data0)) {
                validate99.errors = [{ instancePath: instancePath + "/digest", schemaPath: "#/properties/digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' }];
                return false;
              }
            } else {
              validate99.errors = [{ instancePath: instancePath + "/digest", schemaPath: "#/properties/digest/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.kind !== void 0) {
            let data1 = data.kind;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate99.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/ValueKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data1 === "text" || data1 === "choice" || data1 === "annotations" || data1 === "instance_data" || data1 === "change_set" || data1 === "text_units" || data1 === "item" || data1 === "item_refs" || data1 === "term_cards" || data1 === "check_report" || data1 === "derived" || data1 === "workspace_file" || data1 === "corpus_import" || data1 === "source_version" || data1 === "release_request" || data1 === "release" || data1 === "html_page" || data1 === "derived_records" || data1 === "memory" || data1 === "result")) {
              validate99.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/ValueKind/enum", keyword: "enum", params: { allowedValues: schema94.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.value !== void 0) {
              const _errs6 = errors;
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate99.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate99.errors = vErrors;
  return errors === 0;
}
validate99.evaluated = { "props": { "digest": true, "kind": true, "value": true }, "dynamicProps": false, "dynamicItems": false };
var schema148 = { "enum": ["local", "api"], "title": "ToolModelLocation", "type": "string" };
var pattern63 = new RegExp("^[A-Za-z0-9][A-Za-z0-9_.-]*(/[A-Za-z0-9_.-]+)?$", "u");
function validate101(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate101.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.location === void 0 && (missing0 = "location") || data.id === void 0 && (missing0 = "id") || data.revision === void 0 && (missing0 = "revision") || data.dimension === void 0 && (missing0 = "dimension")) {
        validate101.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.dimension !== void 0) {
          let data0 = data.dimension;
          const _errs1 = errors;
          if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
            validate101.errors = [{ instancePath: instancePath + "/dimension", schemaPath: "#/properties/dimension/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
            return false;
          }
          if (errors === _errs1) {
            if (typeof data0 == "number") {
              if (data0 > 65536 || isNaN(data0)) {
                validate101.errors = [{ instancePath: instancePath + "/dimension", schemaPath: "#/properties/dimension/maximum", keyword: "maximum", params: { comparison: "<=", limit: 65536 }, message: "must be <= 65536" }];
                return false;
              } else {
                if (data0 < 1 || isNaN(data0)) {
                  validate101.errors = [{ instancePath: instancePath + "/dimension", schemaPath: "#/properties/dimension/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                  return false;
                }
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== void 0) {
            let data1 = data.id;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (typeof data1 === "string") {
                if (func2(data1) > 200) {
                  validate101.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                  return false;
                } else {
                  if (func2(data1) < 1) {
                    validate101.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                    return false;
                  } else {
                    if (!pattern63.test(data1)) {
                      validate101.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]*(/[A-Za-z0-9_.-]+)?$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]*(/[A-Za-z0-9_.-]+)?$"' }];
                      return false;
                    }
                  }
                }
              } else {
                validate101.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.location !== void 0) {
              let data2 = data.location;
              const _errs5 = errors;
              if (typeof data2 !== "string") {
                validate101.errors = [{ instancePath: instancePath + "/location", schemaPath: "#/$defs/ToolModelLocation/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data2 === "local" || data2 === "api")) {
                validate101.errors = [{ instancePath: instancePath + "/location", schemaPath: "#/$defs/ToolModelLocation/enum", keyword: "enum", params: { allowedValues: schema148.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.revision !== void 0) {
                let data3 = data.revision;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (typeof data3 === "string") {
                    if (!pattern47.test(data3)) {
                      validate101.errors = [{ instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{40}$" }, message: 'must match pattern "^[0-9a-f]{40}$"' }];
                      return false;
                    }
                  } else {
                    validate101.errors = [{ instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate101.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate101.errors = vErrors;
  return errors === 0;
}
validate101.evaluated = { "props": { "dimension": true, "id": true, "location": true, "revision": true }, "dynamicProps": false, "dynamicItems": false };
function validate98(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate98.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.tool === void 0 && (missing0 = "tool") || data.tool_name === void 0 && (missing0 = "tool_name") || data.model_use === void 0 && (missing0 = "model_use") || data.parameters === void 0 && (missing0 = "parameters") || data.inputs === void 0 && (missing0 = "inputs") || data.outputs === void 0 && (missing0 = "outputs") || data.limits === void 0 && (missing0 = "limits") || data.run_digest === void 0 && (missing0 = "run_digest")) {
        validate98.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema142.properties, key0)) {
            validate98.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.inputs !== void 0) {
            let data0 = data.inputs;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                var props0 = {};
                for (const key1 in data0) {
                  if (pattern8.test(key1)) {
                    if (!validate99(data0[key1], { instancePath: instancePath + "/inputs/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data0, parentDataProperty: key1, rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate99.errors : vErrors.concat(validate99.errors);
                      errors = vErrors.length;
                    }
                    props0[key1] = true;
                  }
                }
              } else {
                validate98.errors = [{ instancePath: instancePath + "/inputs", schemaPath: "#/properties/inputs/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.limits !== void 0) {
              let data2 = data.limits;
              const _errs5 = errors;
              const _errs6 = errors;
              let valid2 = false;
              const _errs7 = errors;
              const _errs8 = errors;
              if (errors === _errs8) {
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                  let missing1;
                  if (data2.timeout_seconds === void 0 && (missing1 = "timeout_seconds") || data2.memory_megabytes === void 0 && (missing1 = "memory_megabytes") || data2.output_megabytes === void 0 && (missing1 = "output_megabytes")) {
                    const err0 = { instancePath: instancePath + "/limits", schemaPath: "#/$defs/ToolRunLimits/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  } else {
                    if (data2.memory_megabytes !== void 0) {
                      let data3 = data2.memory_megabytes;
                      const _errs10 = errors;
                      if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                        const err1 = { instancePath: instancePath + "/limits/memory_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/memory_megabytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      if (errors === _errs10) {
                        if (typeof data3 == "number") {
                          if (data3 < 16 || isNaN(data3)) {
                            const err2 = { instancePath: instancePath + "/limits/memory_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/memory_megabytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 16 }, message: "must be >= 16" };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                          }
                        }
                      }
                      var valid4 = _errs10 === errors;
                    } else {
                      var valid4 = true;
                    }
                    if (valid4) {
                      if (data2.output_megabytes !== void 0) {
                        let data4 = data2.output_megabytes;
                        const _errs12 = errors;
                        if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)))) {
                          const err3 = { instancePath: instancePath + "/limits/output_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/output_megabytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                        if (errors === _errs12) {
                          if (typeof data4 == "number") {
                            if (data4 < 1 || isNaN(data4)) {
                              const err4 = { instancePath: instancePath + "/limits/output_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/output_megabytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                              if (vErrors === null) {
                                vErrors = [err4];
                              } else {
                                vErrors.push(err4);
                              }
                              errors++;
                            }
                          }
                        }
                        var valid4 = _errs12 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data2.timeout_seconds !== void 0) {
                          let data5 = data2.timeout_seconds;
                          const _errs14 = errors;
                          if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)))) {
                            const err5 = { instancePath: instancePath + "/limits/timeout_seconds", schemaPath: "#/$defs/ToolRunLimits/properties/timeout_seconds/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err5];
                            } else {
                              vErrors.push(err5);
                            }
                            errors++;
                          }
                          if (errors === _errs14) {
                            if (typeof data5 == "number") {
                              if (data5 < 1 || isNaN(data5)) {
                                const err6 = { instancePath: instancePath + "/limits/timeout_seconds", schemaPath: "#/$defs/ToolRunLimits/properties/timeout_seconds/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                if (vErrors === null) {
                                  vErrors = [err6];
                                } else {
                                  vErrors.push(err6);
                                }
                                errors++;
                              }
                            }
                          }
                          var valid4 = _errs14 === errors;
                        } else {
                          var valid4 = true;
                        }
                      }
                    }
                  }
                } else {
                  const err7 = { instancePath: instancePath + "/limits", schemaPath: "#/$defs/ToolRunLimits/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err7];
                  } else {
                    vErrors.push(err7);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs7 === errors;
              valid2 = valid2 || _valid0;
              if (_valid0) {
                var props1 = {};
                props1.memory_megabytes = true;
                props1.output_megabytes = true;
                props1.timeout_seconds = true;
              }
              const _errs16 = errors;
              if (data2 !== null) {
                const err8 = { instancePath: instancePath + "/limits", schemaPath: "#/properties/limits/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              var _valid0 = _errs16 === errors;
              valid2 = valid2 || _valid0;
              if (!valid2) {
                const err9 = { instancePath: instancePath + "/limits", schemaPath: "#/properties/limits/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
                validate98.errors = vErrors;
                return false;
              } else {
                errors = _errs6;
                if (vErrors !== null) {
                  if (_errs6) {
                    vErrors.length = _errs6;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.model !== void 0) {
                let data6 = data.model;
                const _errs18 = errors;
                const _errs19 = errors;
                let valid5 = false;
                const _errs20 = errors;
                if (!validate101(data6, { instancePath: instancePath + "/model", parentData: data, parentDataProperty: "model", rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate101.errors : vErrors.concat(validate101.errors);
                  errors = vErrors.length;
                }
                var _valid1 = _errs20 === errors;
                valid5 = valid5 || _valid1;
                if (_valid1) {
                  var props2 = {};
                  props2.dimension = true;
                  props2.id = true;
                  props2.location = true;
                  props2.revision = true;
                }
                const _errs21 = errors;
                if (data6 !== null) {
                  const err10 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                var _valid1 = _errs21 === errors;
                valid5 = valid5 || _valid1;
                if (!valid5) {
                  const err11 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                  validate98.errors = vErrors;
                  return false;
                } else {
                  errors = _errs19;
                  if (vErrors !== null) {
                    if (_errs19) {
                      vErrors.length = _errs19;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs18 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.model_use !== void 0) {
                  let data7 = data.model_use;
                  const _errs23 = errors;
                  if (typeof data7 !== "string") {
                    validate98.errors = [{ instancePath: instancePath + "/model_use", schemaPath: "#/$defs/ToolModelUse/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data7 === "none" || data7 === "embedding")) {
                    validate98.errors = [{ instancePath: instancePath + "/model_use", schemaPath: "#/$defs/ToolModelUse/enum", keyword: "enum", params: { allowedValues: schema149.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs23 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.outputs !== void 0) {
                    let data8 = data.outputs;
                    const _errs26 = errors;
                    if (errors === _errs26) {
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        var props3 = {};
                        for (const key2 in data8) {
                          if (pattern8.test(key2)) {
                            let data9 = data8[key2];
                            if (typeof data9 !== "string") {
                              validate98.errors = [{ instancePath: instancePath + "/outputs/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ValueKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            if (!(data9 === "text" || data9 === "choice" || data9 === "annotations" || data9 === "instance_data" || data9 === "change_set" || data9 === "text_units" || data9 === "item" || data9 === "item_refs" || data9 === "term_cards" || data9 === "check_report" || data9 === "derived" || data9 === "workspace_file" || data9 === "corpus_import" || data9 === "source_version" || data9 === "release_request" || data9 === "release" || data9 === "html_page" || data9 === "derived_records" || data9 === "memory" || data9 === "result")) {
                              validate98.errors = [{ instancePath: instancePath + "/outputs/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ValueKind/enum", keyword: "enum", params: { allowedValues: schema94.enum }, message: "must be equal to one of the allowed values" }];
                              return false;
                            }
                            props3[key2] = true;
                          }
                        }
                      } else {
                        validate98.errors = [{ instancePath: instancePath + "/outputs", schemaPath: "#/properties/outputs/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs26 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.parameters !== void 0) {
                      let data10 = data.parameters;
                      const _errs31 = errors;
                      if (errors === _errs31) {
                        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                          var props4 = {};
                          for (const key3 in data10) {
                            if (pattern8.test(key3)) {
                              props4[key3] = true;
                            }
                          }
                        } else {
                          validate98.errors = [{ instancePath: instancePath + "/parameters", schemaPath: "#/properties/parameters/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                          return false;
                        }
                      }
                      var valid0 = _errs31 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.run_digest !== void 0) {
                        let data12 = data.run_digest;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                          if (typeof data12 === "string") {
                            if (!pattern24.test(data12)) {
                              validate98.errors = [{ instancePath: instancePath + "/run_digest", schemaPath: "#/properties/run_digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' }];
                              return false;
                            }
                          } else {
                            validate98.errors = [{ instancePath: instancePath + "/run_digest", schemaPath: "#/properties/run_digest/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                        }
                        var valid0 = _errs34 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.tool !== void 0) {
                          let data13 = data.tool;
                          const _errs36 = errors;
                          if (errors === _errs36) {
                            if (typeof data13 === "string") {
                              if (func2(data13) > 200) {
                                validate98.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                return false;
                              } else {
                                if (func2(data13) < 1) {
                                  validate98.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                  return false;
                                }
                              }
                            } else {
                              validate98.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                          }
                          var valid0 = _errs36 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.tool_name !== void 0) {
                            let data14 = data.tool_name;
                            const _errs38 = errors;
                            if (errors === _errs38) {
                              if (typeof data14 === "string") {
                                if (!pattern8.test(data14)) {
                                  validate98.errors = [{ instancePath: instancePath + "/tool_name", schemaPath: "#/properties/tool_name/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                  return false;
                                }
                              } else {
                                validate98.errors = [{ instancePath: instancePath + "/tool_name", schemaPath: "#/properties/tool_name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                            }
                            var valid0 = _errs38 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate98.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate98.errors = vErrors;
  return errors === 0;
}
validate98.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema152 = { "additionalProperties": false, "description": "Every exact version a tool turn's input was built from (invariant 2, NFR-16).", "properties": { "content_version": { "title": "Content Version", "type": "string" }, "corpus_version": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Corpus Version" }, "inputs": { "items": { "$ref": "#/$defs/ToolInputUse" }, "title": "Inputs", "type": "array" }, "server_version": { "title": "Server Version", "type": "string" }, "source_version": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "description": "The Thread's bound source commit, when a tool input read it.", "title": "Source Version" }, "step": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "`None` for a run of a tool without a step (`ToolTurnRequestedPayload`).", "title": "Step" }, "subject": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Subject" }, "tool": { "maxLength": 200, "minLength": 1, "title": "Tool", "type": "string" }, "workflow": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Workflow" } }, "required": ["workflow", "step", "tool", "content_version", "corpus_version", "subject", "inputs", "server_version"], "title": "ToolVersionsUsed", "type": "object" };
var schema153 = { "additionalProperties": false, "description": "How one tool input was filled: by which selector or input slot, reading what.", "properties": { "input": { "pattern": "^[a-z][a-z0-9_]{0,62}$", "title": "Input", "type": "string" }, "input_entry": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "description": "The `step_output` or other entry an input slot was bound to.", "title": "Input Entry" }, "references_read": { "description": "Every `VersionRef`, `SegmentRef` or `CollectionVersionRef` the value came from.", "items": { "type": "string" }, "title": "References Read", "type": "array" }, "selector_kind": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Selector Kind" }, "selector_version": { "anyOf": [{ "type": "integer" }, { "type": "null" }], "title": "Selector Version" }, "source": { "enum": ["selector", "input"], "title": "Source", "type": "string" } }, "required": ["input", "source", "selector_kind", "selector_version", "references_read", "input_entry"], "title": "ToolInputUse", "type": "object" };
function validate104(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate104.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.workflow === void 0 && (missing0 = "workflow") || data.step === void 0 && (missing0 = "step") || data.tool === void 0 && (missing0 = "tool") || data.content_version === void 0 && (missing0 = "content_version") || data.corpus_version === void 0 && (missing0 = "corpus_version") || data.subject === void 0 && (missing0 = "subject") || data.inputs === void 0 && (missing0 = "inputs") || data.server_version === void 0 && (missing0 = "server_version")) {
        validate104.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema152.properties, key0)) {
            validate104.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.content_version !== void 0) {
            const _errs2 = errors;
            if (typeof data.content_version !== "string") {
              validate104.errors = [{ instancePath: instancePath + "/content_version", schemaPath: "#/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.corpus_version !== void 0) {
              let data1 = data.corpus_version;
              const _errs4 = errors;
              const _errs5 = errors;
              let valid1 = false;
              const _errs6 = errors;
              if (typeof data1 !== "string") {
                const err0 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs6 === errors;
              valid1 = valid1 || _valid0;
              const _errs8 = errors;
              if (data1 !== null) {
                const err1 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs8 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const err2 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
                validate104.errors = vErrors;
                return false;
              } else {
                errors = _errs5;
                if (vErrors !== null) {
                  if (_errs5) {
                    vErrors.length = _errs5;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.inputs !== void 0) {
                let data2 = data.inputs;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (Array.isArray(data2)) {
                    var valid2 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data3 = data2[i0];
                      const _errs12 = errors;
                      const _errs13 = errors;
                      if (errors === _errs13) {
                        if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                          let missing1;
                          if (data3.input === void 0 && (missing1 = "input") || data3.source === void 0 && (missing1 = "source") || data3.selector_kind === void 0 && (missing1 = "selector_kind") || data3.selector_version === void 0 && (missing1 = "selector_version") || data3.references_read === void 0 && (missing1 = "references_read") || data3.input_entry === void 0 && (missing1 = "input_entry")) {
                            validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0, schemaPath: "#/$defs/ToolInputUse/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                            return false;
                          } else {
                            const _errs15 = errors;
                            for (const key1 in data3) {
                              if (!(key1 === "input" || key1 === "input_entry" || key1 === "references_read" || key1 === "selector_kind" || key1 === "selector_version" || key1 === "source")) {
                                validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0, schemaPath: "#/$defs/ToolInputUse/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                                return false;
                                break;
                              }
                            }
                            if (_errs15 === errors) {
                              if (data3.input !== void 0) {
                                let data4 = data3.input;
                                const _errs16 = errors;
                                if (errors === _errs16) {
                                  if (typeof data4 === "string") {
                                    if (!pattern8.test(data4)) {
                                      validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0 + "/input", schemaPath: "#/$defs/ToolInputUse/properties/input/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                      return false;
                                    }
                                  } else {
                                    validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0 + "/input", schemaPath: "#/$defs/ToolInputUse/properties/input/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                }
                                var valid4 = _errs16 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data3.input_entry !== void 0) {
                                  let data5 = data3.input_entry;
                                  const _errs18 = errors;
                                  const _errs19 = errors;
                                  let valid5 = false;
                                  const _errs20 = errors;
                                  if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)))) {
                                    const err3 = { instancePath: instancePath + "/inputs/" + i0 + "/input_entry", schemaPath: "#/$defs/ToolInputUse/properties/input_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err3];
                                    } else {
                                      vErrors.push(err3);
                                    }
                                    errors++;
                                  }
                                  if (errors === _errs20) {
                                    if (typeof data5 == "number") {
                                      if (data5 < 1 || isNaN(data5)) {
                                        const err4 = { instancePath: instancePath + "/inputs/" + i0 + "/input_entry", schemaPath: "#/$defs/ToolInputUse/properties/input_entry/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                          vErrors = [err4];
                                        } else {
                                          vErrors.push(err4);
                                        }
                                        errors++;
                                      }
                                    }
                                  }
                                  var _valid1 = _errs20 === errors;
                                  valid5 = valid5 || _valid1;
                                  const _errs22 = errors;
                                  if (data5 !== null) {
                                    const err5 = { instancePath: instancePath + "/inputs/" + i0 + "/input_entry", schemaPath: "#/$defs/ToolInputUse/properties/input_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err5];
                                    } else {
                                      vErrors.push(err5);
                                    }
                                    errors++;
                                  }
                                  var _valid1 = _errs22 === errors;
                                  valid5 = valid5 || _valid1;
                                  if (!valid5) {
                                    const err6 = { instancePath: instancePath + "/inputs/" + i0 + "/input_entry", schemaPath: "#/$defs/ToolInputUse/properties/input_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err6];
                                    } else {
                                      vErrors.push(err6);
                                    }
                                    errors++;
                                    validate104.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs19;
                                    if (vErrors !== null) {
                                      if (_errs19) {
                                        vErrors.length = _errs19;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid4 = _errs18 === errors;
                                } else {
                                  var valid4 = true;
                                }
                                if (valid4) {
                                  if (data3.references_read !== void 0) {
                                    let data6 = data3.references_read;
                                    const _errs24 = errors;
                                    if (errors === _errs24) {
                                      if (Array.isArray(data6)) {
                                        var valid6 = true;
                                        const len1 = data6.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                          const _errs26 = errors;
                                          if (typeof data6[i1] !== "string") {
                                            validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0 + "/references_read/" + i1, schemaPath: "#/$defs/ToolInputUse/properties/references_read/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                          var valid6 = _errs26 === errors;
                                          if (!valid6) {
                                            break;
                                          }
                                        }
                                      } else {
                                        validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0 + "/references_read", schemaPath: "#/$defs/ToolInputUse/properties/references_read/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                        return false;
                                      }
                                    }
                                    var valid4 = _errs24 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                  if (valid4) {
                                    if (data3.selector_kind !== void 0) {
                                      let data8 = data3.selector_kind;
                                      const _errs28 = errors;
                                      const _errs29 = errors;
                                      let valid7 = false;
                                      const _errs30 = errors;
                                      if (typeof data8 !== "string") {
                                        const err7 = { instancePath: instancePath + "/inputs/" + i0 + "/selector_kind", schemaPath: "#/$defs/ToolInputUse/properties/selector_kind/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err7];
                                        } else {
                                          vErrors.push(err7);
                                        }
                                        errors++;
                                      }
                                      var _valid2 = _errs30 === errors;
                                      valid7 = valid7 || _valid2;
                                      const _errs32 = errors;
                                      if (data8 !== null) {
                                        const err8 = { instancePath: instancePath + "/inputs/" + i0 + "/selector_kind", schemaPath: "#/$defs/ToolInputUse/properties/selector_kind/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err8];
                                        } else {
                                          vErrors.push(err8);
                                        }
                                        errors++;
                                      }
                                      var _valid2 = _errs32 === errors;
                                      valid7 = valid7 || _valid2;
                                      if (!valid7) {
                                        const err9 = { instancePath: instancePath + "/inputs/" + i0 + "/selector_kind", schemaPath: "#/$defs/ToolInputUse/properties/selector_kind/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err9];
                                        } else {
                                          vErrors.push(err9);
                                        }
                                        errors++;
                                        validate104.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs29;
                                        if (vErrors !== null) {
                                          if (_errs29) {
                                            vErrors.length = _errs29;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid4 = _errs28 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                    if (valid4) {
                                      if (data3.selector_version !== void 0) {
                                        let data9 = data3.selector_version;
                                        const _errs34 = errors;
                                        const _errs35 = errors;
                                        let valid8 = false;
                                        const _errs36 = errors;
                                        if (!(typeof data9 == "number" && (!(data9 % 1) && !isNaN(data9)))) {
                                          const err10 = { instancePath: instancePath + "/inputs/" + i0 + "/selector_version", schemaPath: "#/$defs/ToolInputUse/properties/selector_version/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                          if (vErrors === null) {
                                            vErrors = [err10];
                                          } else {
                                            vErrors.push(err10);
                                          }
                                          errors++;
                                        }
                                        var _valid3 = _errs36 === errors;
                                        valid8 = valid8 || _valid3;
                                        const _errs38 = errors;
                                        if (data9 !== null) {
                                          const err11 = { instancePath: instancePath + "/inputs/" + i0 + "/selector_version", schemaPath: "#/$defs/ToolInputUse/properties/selector_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err11];
                                          } else {
                                            vErrors.push(err11);
                                          }
                                          errors++;
                                        }
                                        var _valid3 = _errs38 === errors;
                                        valid8 = valid8 || _valid3;
                                        if (!valid8) {
                                          const err12 = { instancePath: instancePath + "/inputs/" + i0 + "/selector_version", schemaPath: "#/$defs/ToolInputUse/properties/selector_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err12];
                                          } else {
                                            vErrors.push(err12);
                                          }
                                          errors++;
                                          validate104.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs35;
                                          if (vErrors !== null) {
                                            if (_errs35) {
                                              vErrors.length = _errs35;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid4 = _errs34 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                      if (valid4) {
                                        if (data3.source !== void 0) {
                                          let data10 = data3.source;
                                          const _errs40 = errors;
                                          if (typeof data10 !== "string") {
                                            validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0 + "/source", schemaPath: "#/$defs/ToolInputUse/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                          if (!(data10 === "selector" || data10 === "input")) {
                                            validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0 + "/source", schemaPath: "#/$defs/ToolInputUse/properties/source/enum", keyword: "enum", params: { allowedValues: schema153.properties.source.enum }, message: "must be equal to one of the allowed values" }];
                                            return false;
                                          }
                                          var valid4 = _errs40 === errors;
                                        } else {
                                          var valid4 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          validate104.errors = [{ instancePath: instancePath + "/inputs/" + i0, schemaPath: "#/$defs/ToolInputUse/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                          return false;
                        }
                      }
                      var valid2 = _errs12 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate104.errors = [{ instancePath: instancePath + "/inputs", schemaPath: "#/properties/inputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.server_version !== void 0) {
                  const _errs42 = errors;
                  if (typeof data.server_version !== "string") {
                    validate104.errors = [{ instancePath: instancePath + "/server_version", schemaPath: "#/properties/server_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs42 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.source_version !== void 0) {
                    let data12 = data.source_version;
                    const _errs44 = errors;
                    const _errs45 = errors;
                    let valid9 = false;
                    const _errs46 = errors;
                    if (typeof data12 !== "string") {
                      const err13 = { instancePath: instancePath + "/source_version", schemaPath: "#/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                    var _valid4 = _errs46 === errors;
                    valid9 = valid9 || _valid4;
                    const _errs48 = errors;
                    if (data12 !== null) {
                      const err14 = { instancePath: instancePath + "/source_version", schemaPath: "#/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err14];
                      } else {
                        vErrors.push(err14);
                      }
                      errors++;
                    }
                    var _valid4 = _errs48 === errors;
                    valid9 = valid9 || _valid4;
                    if (!valid9) {
                      const err15 = { instancePath: instancePath + "/source_version", schemaPath: "#/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                      validate104.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs45;
                      if (vErrors !== null) {
                        if (_errs45) {
                          vErrors.length = _errs45;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs44 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.step !== void 0) {
                      let data13 = data.step;
                      const _errs50 = errors;
                      const _errs51 = errors;
                      let valid10 = false;
                      const _errs52 = errors;
                      if (typeof data13 !== "string") {
                        const err16 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err16];
                        } else {
                          vErrors.push(err16);
                        }
                        errors++;
                      }
                      var _valid5 = _errs52 === errors;
                      valid10 = valid10 || _valid5;
                      const _errs54 = errors;
                      if (data13 !== null) {
                        const err17 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err17];
                        } else {
                          vErrors.push(err17);
                        }
                        errors++;
                      }
                      var _valid5 = _errs54 === errors;
                      valid10 = valid10 || _valid5;
                      if (!valid10) {
                        const err18 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err18];
                        } else {
                          vErrors.push(err18);
                        }
                        errors++;
                        validate104.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs51;
                        if (vErrors !== null) {
                          if (_errs51) {
                            vErrors.length = _errs51;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs50 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.subject !== void 0) {
                        let data14 = data.subject;
                        const _errs56 = errors;
                        const _errs57 = errors;
                        let valid11 = false;
                        const _errs58 = errors;
                        if (typeof data14 !== "string") {
                          const err19 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err19];
                          } else {
                            vErrors.push(err19);
                          }
                          errors++;
                        }
                        var _valid6 = _errs58 === errors;
                        valid11 = valid11 || _valid6;
                        const _errs60 = errors;
                        if (data14 !== null) {
                          const err20 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err20];
                          } else {
                            vErrors.push(err20);
                          }
                          errors++;
                        }
                        var _valid6 = _errs60 === errors;
                        valid11 = valid11 || _valid6;
                        if (!valid11) {
                          const err21 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err21];
                          } else {
                            vErrors.push(err21);
                          }
                          errors++;
                          validate104.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs57;
                          if (vErrors !== null) {
                            if (_errs57) {
                              vErrors.length = _errs57;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs56 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.tool !== void 0) {
                          let data15 = data.tool;
                          const _errs62 = errors;
                          if (errors === _errs62) {
                            if (typeof data15 === "string") {
                              if (func2(data15) > 200) {
                                validate104.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                                return false;
                              } else {
                                if (func2(data15) < 1) {
                                  validate104.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                  return false;
                                }
                              }
                            } else {
                              validate104.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                          }
                          var valid0 = _errs62 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.workflow !== void 0) {
                            let data16 = data.workflow;
                            const _errs64 = errors;
                            const _errs65 = errors;
                            let valid12 = false;
                            const _errs66 = errors;
                            if (typeof data16 !== "string") {
                              const err22 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err22];
                              } else {
                                vErrors.push(err22);
                              }
                              errors++;
                            }
                            var _valid7 = _errs66 === errors;
                            valid12 = valid12 || _valid7;
                            const _errs68 = errors;
                            if (data16 !== null) {
                              const err23 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err23];
                              } else {
                                vErrors.push(err23);
                              }
                              errors++;
                            }
                            var _valid7 = _errs68 === errors;
                            valid12 = valid12 || _valid7;
                            if (!valid12) {
                              const err24 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err24];
                              } else {
                                vErrors.push(err24);
                              }
                              errors++;
                              validate104.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs65;
                              if (vErrors !== null) {
                                if (_errs65) {
                                  vErrors.length = _errs65;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs64 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate104.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate104.errors = vErrors;
  return errors === 0;
}
validate104.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate93(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate93.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.step_key === void 0 && (missing0 = "step_key") || data.step === void 0 && (missing0 = "step") || data.based_on_entry === void 0 && (missing0 = "based_on_entry") || data.route === void 0 && (missing0 = "route") || data.permission_profile === void 0 && (missing0 = "permission_profile") || data.run === void 0 && (missing0 = "run") || data.versions_used === void 0 && (missing0 = "versions_used") || data.proposes === void 0 && (missing0 = "proposes") || data.requested_by === void 0 && (missing0 = "requested_by")) {
        validate93.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema137.properties, key0)) {
            validate93.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.based_on_entry !== void 0) {
            let data0 = data.based_on_entry;
            const _errs2 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              validate93.errors = [{ instancePath: instancePath + "/based_on_entry", schemaPath: "#/properties/based_on_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
              return false;
            }
            if (errors === _errs2) {
              if (typeof data0 == "number") {
                if (data0 < 1 || isNaN(data0)) {
                  validate93.errors = [{ instancePath: instancePath + "/based_on_entry", schemaPath: "#/properties/based_on_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                  return false;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.called_in !== void 0) {
              let data1 = data.called_in;
              const _errs4 = errors;
              const _errs5 = errors;
              let valid1 = false;
              const _errs6 = errors;
              if (typeof data1 !== "string") {
                const err0 = { instancePath: instancePath + "/called_in", schemaPath: "#/properties/called_in/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs6 === errors;
              valid1 = valid1 || _valid0;
              const _errs8 = errors;
              if (data1 !== null) {
                const err1 = { instancePath: instancePath + "/called_in", schemaPath: "#/properties/called_in/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs8 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const err2 = { instancePath: instancePath + "/called_in", schemaPath: "#/properties/called_in/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
                validate93.errors = vErrors;
                return false;
              } else {
                errors = _errs5;
                if (vErrors !== null) {
                  if (_errs5) {
                    vErrors.length = _errs5;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.kind !== void 0) {
                let data2 = data.kind;
                const _errs10 = errors;
                if (typeof data2 !== "string") {
                  validate93.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("tool_turn_requested" !== data2) {
                  validate93.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "tool_turn_requested" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.permission_profile !== void 0) {
                  let data3 = data.permission_profile;
                  const _errs12 = errors;
                  const _errs13 = errors;
                  let valid2 = false;
                  const _errs14 = errors;
                  if (errors === _errs14) {
                    if (typeof data3 === "string") {
                      if (!pattern4.test(data3)) {
                        const err3 = { instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      }
                    } else {
                      const err4 = { instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                  }
                  var _valid1 = _errs14 === errors;
                  valid2 = valid2 || _valid1;
                  const _errs16 = errors;
                  if (data3 !== null) {
                    const err5 = { instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                  var _valid1 = _errs16 === errors;
                  valid2 = valid2 || _valid1;
                  if (!valid2) {
                    const err6 = { instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                    validate93.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs13;
                    if (vErrors !== null) {
                      if (_errs13) {
                        vErrors.length = _errs13;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.proposes !== void 0) {
                    let data4 = data.proposes;
                    const _errs18 = errors;
                    const _errs19 = errors;
                    let valid3 = false;
                    const _errs20 = errors;
                    if (errors === _errs20) {
                      if (typeof data4 === "string") {
                        if (!pattern8.test(data4)) {
                          const err7 = { instancePath: instancePath + "/proposes", schemaPath: "#/properties/proposes/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                          if (vErrors === null) {
                            vErrors = [err7];
                          } else {
                            vErrors.push(err7);
                          }
                          errors++;
                        }
                      } else {
                        const err8 = { instancePath: instancePath + "/proposes", schemaPath: "#/properties/proposes/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      }
                    }
                    var _valid2 = _errs20 === errors;
                    valid3 = valid3 || _valid2;
                    const _errs22 = errors;
                    if (data4 !== null) {
                      const err9 = { instancePath: instancePath + "/proposes", schemaPath: "#/properties/proposes/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err9];
                      } else {
                        vErrors.push(err9);
                      }
                      errors++;
                    }
                    var _valid2 = _errs22 === errors;
                    valid3 = valid3 || _valid2;
                    if (!valid3) {
                      const err10 = { instancePath: instancePath + "/proposes", schemaPath: "#/properties/proposes/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err10];
                      } else {
                        vErrors.push(err10);
                      }
                      errors++;
                      validate93.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs19;
                      if (vErrors !== null) {
                        if (_errs19) {
                          vErrors.length = _errs19;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.requested_by !== void 0) {
                      let data5 = data.requested_by;
                      const _errs24 = errors;
                      const _errs25 = errors;
                      let valid4 = false;
                      const _errs26 = errors;
                      if (typeof data5 !== "string") {
                        const err11 = { instancePath: instancePath + "/requested_by", schemaPath: "#/properties/requested_by/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err11];
                        } else {
                          vErrors.push(err11);
                        }
                        errors++;
                      }
                      var _valid3 = _errs26 === errors;
                      valid4 = valid4 || _valid3;
                      const _errs28 = errors;
                      if (data5 !== null) {
                        const err12 = { instancePath: instancePath + "/requested_by", schemaPath: "#/properties/requested_by/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err12];
                        } else {
                          vErrors.push(err12);
                        }
                        errors++;
                      }
                      var _valid3 = _errs28 === errors;
                      valid4 = valid4 || _valid3;
                      if (!valid4) {
                        const err13 = { instancePath: instancePath + "/requested_by", schemaPath: "#/properties/requested_by/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err13];
                        } else {
                          vErrors.push(err13);
                        }
                        errors++;
                        validate93.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs25;
                        if (vErrors !== null) {
                          if (_errs25) {
                            vErrors.length = _errs25;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs24 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.route !== void 0) {
                        const _errs30 = errors;
                        if (!validate94(data.route, { instancePath: instancePath + "/route", parentData: data, parentDataProperty: "route", rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate94.errors : vErrors.concat(validate94.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs30 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.run !== void 0) {
                          const _errs31 = errors;
                          if (!validate98(data.run, { instancePath: instancePath + "/run", parentData: data, parentDataProperty: "run", rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate98.errors : vErrors.concat(validate98.errors);
                            errors = vErrors.length;
                          }
                          var valid0 = _errs31 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.step !== void 0) {
                            let data8 = data.step;
                            const _errs32 = errors;
                            const _errs33 = errors;
                            let valid5 = false;
                            const _errs34 = errors;
                            if (typeof data8 !== "string") {
                              const err14 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err14];
                              } else {
                                vErrors.push(err14);
                              }
                              errors++;
                            }
                            var _valid4 = _errs34 === errors;
                            valid5 = valid5 || _valid4;
                            const _errs36 = errors;
                            if (data8 !== null) {
                              const err15 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err15];
                              } else {
                                vErrors.push(err15);
                              }
                              errors++;
                            }
                            var _valid4 = _errs36 === errors;
                            valid5 = valid5 || _valid4;
                            if (!valid5) {
                              const err16 = { instancePath: instancePath + "/step", schemaPath: "#/properties/step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                              validate93.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs33;
                              if (vErrors !== null) {
                                if (_errs33) {
                                  vErrors.length = _errs33;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs32 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.step_key !== void 0) {
                              let data9 = data.step_key;
                              const _errs38 = errors;
                              const _errs39 = errors;
                              let valid6 = false;
                              const _errs40 = errors;
                              if (errors === _errs40) {
                                if (typeof data9 === "string") {
                                  if (!pattern14.test(data9)) {
                                    const err17 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                                    if (vErrors === null) {
                                      vErrors = [err17];
                                    } else {
                                      vErrors.push(err17);
                                    }
                                    errors++;
                                  }
                                } else {
                                  const err18 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err18];
                                  } else {
                                    vErrors.push(err18);
                                  }
                                  errors++;
                                }
                              }
                              var _valid5 = _errs40 === errors;
                              valid6 = valid6 || _valid5;
                              const _errs42 = errors;
                              if (data9 !== null) {
                                const err19 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                              }
                              var _valid5 = _errs42 === errors;
                              valid6 = valid6 || _valid5;
                              if (!valid6) {
                                const err20 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                                validate93.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs39;
                                if (vErrors !== null) {
                                  if (_errs39) {
                                    vErrors.length = _errs39;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs38 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.supersedes !== void 0) {
                                let data10 = data.supersedes;
                                const _errs44 = errors;
                                const _errs45 = errors;
                                let valid7 = false;
                                const _errs46 = errors;
                                if (!(typeof data10 == "number" && (!(data10 % 1) && !isNaN(data10)))) {
                                  const err21 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                  if (vErrors === null) {
                                    vErrors = [err21];
                                  } else {
                                    vErrors.push(err21);
                                  }
                                  errors++;
                                }
                                if (errors === _errs46) {
                                  if (typeof data10 == "number") {
                                    if (data10 < 1 || isNaN(data10)) {
                                      const err22 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                      if (vErrors === null) {
                                        vErrors = [err22];
                                      } else {
                                        vErrors.push(err22);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                var _valid6 = _errs46 === errors;
                                valid7 = valid7 || _valid6;
                                const _errs48 = errors;
                                if (data10 !== null) {
                                  const err23 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err23];
                                  } else {
                                    vErrors.push(err23);
                                  }
                                  errors++;
                                }
                                var _valid6 = _errs48 === errors;
                                valid7 = valid7 || _valid6;
                                if (!valid7) {
                                  const err24 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err24];
                                  } else {
                                    vErrors.push(err24);
                                  }
                                  errors++;
                                  validate93.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs45;
                                  if (vErrors !== null) {
                                    if (_errs45) {
                                      vErrors.length = _errs45;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs44 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.turn_id !== void 0) {
                                  const _errs50 = errors;
                                  if (typeof data.turn_id !== "string") {
                                    validate93.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid0 = _errs50 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.versions_used !== void 0) {
                                    const _errs52 = errors;
                                    if (!validate104(data.versions_used, { instancePath: instancePath + "/versions_used", parentData: data, parentDataProperty: "versions_used", rootData, dynamicAnchors })) {
                                      vErrors = vErrors === null ? validate104.errors : vErrors.concat(validate104.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid0 = _errs52 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate93.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate93.errors = vErrors;
  return errors === 0;
}
validate93.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema154 = { "additionalProperties": false, "description": "The result of a tool turn, appended once (key `turn-finished:<turn id>`).", "properties": { "connector_id": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Connector Id" }, "finished_at": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Finished At" }, "input_files": { "description": "Per `workspace_file` input, the file the connector read for it.", "patternProperties": { "^[a-z][a-z0-9_]{0,62}$": { "$ref": "#/$defs/ToolInputFile" } }, "title": "Input Files", "type": "object" }, "kind": { "const": "tool_turn_finished", "title": "Kind", "type": "string" }, "memoized": { "title": "Memoized", "type": "boolean" }, "outcome": { "$ref": "#/$defs/TurnOutcome" }, "output_entries": { "description": "The `step_output` entries of this run, one per output, then the proposal.", "items": { "minimum": 1, "type": "integer" }, "title": "Output Entries", "type": "array" }, "problem": { "anyOf": [{ "$ref": "#/$defs/RecordedProblem" }, { "type": "null" }] }, "provider_contact": { "$ref": "#/$defs/ProviderContact" }, "reported_by": { "enum": ["connector", "server"], "title": "Reported By", "type": "string" }, "request_entry": { "minimum": 1, "title": "Request Entry", "type": "integer" }, "runtime": { "anyOf": [{ "$ref": "#/$defs/ToolRuntimeUsed" }, { "type": "null" }], "description": "`None` when nothing ran." }, "started_at": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Started At" }, "summary": { "anyOf": [{ "$ref": "#/$defs/ToolCallLine" }, { "type": "null" }], "default": null, "description": "The built-in tool's own line, in each UI language; old recordings may omit it." }, "turn_id": { "title": "Turn Id", "type": "string" }, "usage": { "$ref": "#/$defs/TurnUsage" } }, "required": ["kind", "turn_id", "request_entry", "outcome", "output_entries", "runtime", "memoized", "usage", "provider_contact", "problem", "connector_id", "started_at", "finished_at", "reported_by"], "title": "ToolTurnFinishedPayload", "type": "object" };
var schema158 = { "additionalProperties": false, "properties": { "environment_digest": { "anyOf": [{ "pattern": "^sha256:[0-9a-f]{64}$", "type": "string" }, { "type": "null" }], "default": null, "description": "A Python tool's installed environment: `sha256:` of its lock file.", "title": "Environment Digest" }, "model": { "anyOf": [{ "$ref": "#/$defs/ToolModelIdentity" }, { "type": "null" }], "default": null, "description": "The local model the connector handed an embedding tool: its checkpoint was in the\nPC's model folder at admission (vector-search.md V-4)." }, "runtime": { "enum": ["node", "python", "built_in"], "title": "Runtime", "type": "string" }, "sdk_digest": { "anyOf": [{ "pattern": "^sha256-jcs:[0-9a-f]{64}$", "type": "string" }, { "type": "null" }], "default": null, "description": "The SDK the connector staged, by the identity the PC owner approved (`tool_runs/2`);\nabsent before it and for built-in tools.", "title": "Sdk Digest" }, "sdk_version": { "anyOf": [{ "maxLength": 200, "minLength": 1, "type": "string" }, { "type": "null" }], "title": "Sdk Version" }, "version": { "description": "The runtime's version, or DMW's server version for a built-in tool.", "maxLength": 200, "minLength": 1, "title": "Version", "type": "string" } }, "required": ["runtime", "version", "sdk_version"], "title": "ToolRuntimeUsed", "type": "object" };
function validate109(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate109.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.runtime === void 0 && (missing0 = "runtime") || data.version === void 0 && (missing0 = "version") || data.sdk_version === void 0 && (missing0 = "sdk_version")) {
        validate109.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "environment_digest" || key0 === "model" || key0 === "runtime" || key0 === "sdk_digest" || key0 === "sdk_version" || key0 === "version")) {
            validate109.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.environment_digest !== void 0) {
            let data0 = data.environment_digest;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (errors === _errs4) {
              if (typeof data0 === "string") {
                if (!pattern46.test(data0)) {
                  const err0 = { instancePath: instancePath + "/environment_digest", schemaPath: "#/properties/environment_digest/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
              } else {
                const err1 = { instancePath: instancePath + "/environment_digest", schemaPath: "#/properties/environment_digest/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err2 = { instancePath: instancePath + "/environment_digest", schemaPath: "#/properties/environment_digest/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err3 = { instancePath: instancePath + "/environment_digest", schemaPath: "#/properties/environment_digest/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
              validate109.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.model !== void 0) {
              let data1 = data.model;
              const _errs8 = errors;
              const _errs9 = errors;
              let valid2 = false;
              const _errs10 = errors;
              if (!validate101(data1, { instancePath: instancePath + "/model", parentData: data, parentDataProperty: "model", rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate101.errors : vErrors.concat(validate101.errors);
                errors = vErrors.length;
              }
              var _valid1 = _errs10 === errors;
              valid2 = valid2 || _valid1;
              if (_valid1) {
                var props0 = {};
                props0.dimension = true;
                props0.id = true;
                props0.location = true;
                props0.revision = true;
              }
              const _errs11 = errors;
              if (data1 !== null) {
                const err4 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var _valid1 = _errs11 === errors;
              valid2 = valid2 || _valid1;
              if (!valid2) {
                const err5 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
                validate109.errors = vErrors;
                return false;
              } else {
                errors = _errs9;
                if (vErrors !== null) {
                  if (_errs9) {
                    vErrors.length = _errs9;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.runtime !== void 0) {
                let data2 = data.runtime;
                const _errs13 = errors;
                if (typeof data2 !== "string") {
                  validate109.errors = [{ instancePath: instancePath + "/runtime", schemaPath: "#/properties/runtime/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data2 === "node" || data2 === "python" || data2 === "built_in")) {
                  validate109.errors = [{ instancePath: instancePath + "/runtime", schemaPath: "#/properties/runtime/enum", keyword: "enum", params: { allowedValues: schema158.properties.runtime.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs13 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.sdk_digest !== void 0) {
                  let data3 = data.sdk_digest;
                  const _errs15 = errors;
                  const _errs16 = errors;
                  let valid3 = false;
                  const _errs17 = errors;
                  if (errors === _errs17) {
                    if (typeof data3 === "string") {
                      if (!pattern24.test(data3)) {
                        const err6 = { instancePath: instancePath + "/sdk_digest", schemaPath: "#/properties/sdk_digest/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                    } else {
                      const err7 = { instancePath: instancePath + "/sdk_digest", schemaPath: "#/properties/sdk_digest/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                  }
                  var _valid2 = _errs17 === errors;
                  valid3 = valid3 || _valid2;
                  const _errs19 = errors;
                  if (data3 !== null) {
                    const err8 = { instancePath: instancePath + "/sdk_digest", schemaPath: "#/properties/sdk_digest/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                  var _valid2 = _errs19 === errors;
                  valid3 = valid3 || _valid2;
                  if (!valid3) {
                    const err9 = { instancePath: instancePath + "/sdk_digest", schemaPath: "#/properties/sdk_digest/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err9];
                    } else {
                      vErrors.push(err9);
                    }
                    errors++;
                    validate109.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs16;
                    if (vErrors !== null) {
                      if (_errs16) {
                        vErrors.length = _errs16;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.sdk_version !== void 0) {
                    let data4 = data.sdk_version;
                    const _errs21 = errors;
                    const _errs22 = errors;
                    let valid4 = false;
                    const _errs23 = errors;
                    if (errors === _errs23) {
                      if (typeof data4 === "string") {
                        if (func2(data4) > 200) {
                          const err10 = { instancePath: instancePath + "/sdk_version", schemaPath: "#/properties/sdk_version/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                        } else {
                          if (func2(data4) < 1) {
                            const err11 = { instancePath: instancePath + "/sdk_version", schemaPath: "#/properties/sdk_version/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                            if (vErrors === null) {
                              vErrors = [err11];
                            } else {
                              vErrors.push(err11);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err12 = { instancePath: instancePath + "/sdk_version", schemaPath: "#/properties/sdk_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err12];
                        } else {
                          vErrors.push(err12);
                        }
                        errors++;
                      }
                    }
                    var _valid3 = _errs23 === errors;
                    valid4 = valid4 || _valid3;
                    const _errs25 = errors;
                    if (data4 !== null) {
                      const err13 = { instancePath: instancePath + "/sdk_version", schemaPath: "#/properties/sdk_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                    var _valid3 = _errs25 === errors;
                    valid4 = valid4 || _valid3;
                    if (!valid4) {
                      const err14 = { instancePath: instancePath + "/sdk_version", schemaPath: "#/properties/sdk_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err14];
                      } else {
                        vErrors.push(err14);
                      }
                      errors++;
                      validate109.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs22;
                      if (vErrors !== null) {
                        if (_errs22) {
                          vErrors.length = _errs22;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs21 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.version !== void 0) {
                      let data5 = data.version;
                      const _errs27 = errors;
                      if (errors === _errs27) {
                        if (typeof data5 === "string") {
                          if (func2(data5) > 200) {
                            validate109.errors = [{ instancePath: instancePath + "/version", schemaPath: "#/properties/version/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                            return false;
                          } else {
                            if (func2(data5) < 1) {
                              validate109.errors = [{ instancePath: instancePath + "/version", schemaPath: "#/properties/version/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                              return false;
                            }
                          }
                        } else {
                          validate109.errors = [{ instancePath: instancePath + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                      }
                      var valid0 = _errs27 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate109.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate109.errors = vErrors;
  return errors === 0;
}
validate109.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate107(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate107.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.request_entry === void 0 && (missing0 = "request_entry") || data.outcome === void 0 && (missing0 = "outcome") || data.output_entries === void 0 && (missing0 = "output_entries") || data.runtime === void 0 && (missing0 = "runtime") || data.memoized === void 0 && (missing0 = "memoized") || data.usage === void 0 && (missing0 = "usage") || data.provider_contact === void 0 && (missing0 = "provider_contact") || data.problem === void 0 && (missing0 = "problem") || data.connector_id === void 0 && (missing0 = "connector_id") || data.started_at === void 0 && (missing0 = "started_at") || data.finished_at === void 0 && (missing0 = "finished_at") || data.reported_by === void 0 && (missing0 = "reported_by")) {
        validate107.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema154.properties, key0)) {
            validate107.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.connector_id !== void 0) {
            let data0 = data.connector_id;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate107.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.finished_at !== void 0) {
              let data1 = data.finished_at;
              const _errs8 = errors;
              const _errs9 = errors;
              let valid2 = false;
              const _errs10 = errors;
              if (typeof data1 !== "string") {
                const err3 = { instancePath: instancePath + "/finished_at", schemaPath: "#/properties/finished_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var _valid1 = _errs10 === errors;
              valid2 = valid2 || _valid1;
              const _errs12 = errors;
              if (data1 !== null) {
                const err4 = { instancePath: instancePath + "/finished_at", schemaPath: "#/properties/finished_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var _valid1 = _errs12 === errors;
              valid2 = valid2 || _valid1;
              if (!valid2) {
                const err5 = { instancePath: instancePath + "/finished_at", schemaPath: "#/properties/finished_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
                validate107.errors = vErrors;
                return false;
              } else {
                errors = _errs9;
                if (vErrors !== null) {
                  if (_errs9) {
                    vErrors.length = _errs9;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.input_files !== void 0) {
                let data2 = data.input_files;
                const _errs14 = errors;
                if (errors === _errs14) {
                  if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                    var props0 = {};
                    for (const key1 in data2) {
                      if (pattern8.test(key1)) {
                        let data3 = data2[key1];
                        const _errs17 = errors;
                        if (errors === _errs17) {
                          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                            let missing1;
                            if (data3.path === void 0 && (missing1 = "path") || data3.sha256 === void 0 && (missing1 = "sha256") || data3.size_bytes === void 0 && (missing1 = "size_bytes")) {
                              validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ToolInputFile/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                              return false;
                            } else {
                              const _errs19 = errors;
                              for (const key2 in data3) {
                                if (!(key2 === "path" || key2 === "sha256" || key2 === "size_bytes")) {
                                  validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ToolInputFile/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" }];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs19 === errors) {
                                if (data3.path !== void 0) {
                                  let data4 = data3.path;
                                  const _errs20 = errors;
                                  if (errors === _errs20) {
                                    if (typeof data4 === "string") {
                                      if (func2(data4) > 1e3) {
                                        validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/path", schemaPath: "#/$defs/ToolInputFile/properties/path/maxLength", keyword: "maxLength", params: { limit: 1e3 }, message: "must NOT have more than 1000 characters" }];
                                        return false;
                                      } else {
                                        if (func2(data4) < 1) {
                                          validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/path", schemaPath: "#/$defs/ToolInputFile/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                                          return false;
                                        }
                                      }
                                    } else {
                                      validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/path", schemaPath: "#/$defs/ToolInputFile/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                  }
                                  var valid5 = _errs20 === errors;
                                } else {
                                  var valid5 = true;
                                }
                                if (valid5) {
                                  if (data3.sha256 !== void 0) {
                                    let data5 = data3.sha256;
                                    const _errs22 = errors;
                                    if (errors === _errs22) {
                                      if (typeof data5 === "string") {
                                        if (!pattern46.test(data5)) {
                                          validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/sha256", schemaPath: "#/$defs/ToolInputFile/properties/sha256/pattern", keyword: "pattern", params: { pattern: "^sha256:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256:[0-9a-f]{64}$"' }];
                                          return false;
                                        }
                                      } else {
                                        validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/sha256", schemaPath: "#/$defs/ToolInputFile/properties/sha256/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                    }
                                    var valid5 = _errs22 === errors;
                                  } else {
                                    var valid5 = true;
                                  }
                                  if (valid5) {
                                    if (data3.size_bytes !== void 0) {
                                      let data6 = data3.size_bytes;
                                      const _errs24 = errors;
                                      if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                                        validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/size_bytes", schemaPath: "#/$defs/ToolInputFile/properties/size_bytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                        return false;
                                      }
                                      if (errors === _errs24) {
                                        if (typeof data6 == "number") {
                                          if (data6 < 0 || isNaN(data6)) {
                                            validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/size_bytes", schemaPath: "#/$defs/ToolInputFile/properties/size_bytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" }];
                                            return false;
                                          }
                                        }
                                      }
                                      var valid5 = _errs24 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate107.errors = [{ instancePath: instancePath + "/input_files/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ToolInputFile/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                            return false;
                          }
                        }
                        props0[key1] = true;
                      }
                    }
                  } else {
                    validate107.errors = [{ instancePath: instancePath + "/input_files", schemaPath: "#/properties/input_files/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                    return false;
                  }
                }
                var valid0 = _errs14 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.kind !== void 0) {
                  let data7 = data.kind;
                  const _errs26 = errors;
                  if (typeof data7 !== "string") {
                    validate107.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if ("tool_turn_finished" !== data7) {
                    validate107.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "tool_turn_finished" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs26 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.memoized !== void 0) {
                    const _errs28 = errors;
                    if (typeof data.memoized !== "boolean") {
                      validate107.errors = [{ instancePath: instancePath + "/memoized", schemaPath: "#/properties/memoized/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                      return false;
                    }
                    var valid0 = _errs28 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.outcome !== void 0) {
                      let data9 = data.outcome;
                      const _errs30 = errors;
                      if (typeof data9 !== "string") {
                        validate107.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/TurnOutcome/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      if (!(data9 === "completed" || data9 === "failed" || data9 === "cancelled")) {
                        validate107.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/TurnOutcome/enum", keyword: "enum", params: { allowedValues: schema123.enum }, message: "must be equal to one of the allowed values" }];
                        return false;
                      }
                      var valid0 = _errs30 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.output_entries !== void 0) {
                        let data10 = data.output_entries;
                        const _errs33 = errors;
                        if (errors === _errs33) {
                          if (Array.isArray(data10)) {
                            var valid7 = true;
                            const len0 = data10.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              let data11 = data10[i0];
                              const _errs35 = errors;
                              if (!(typeof data11 == "number" && (!(data11 % 1) && !isNaN(data11)))) {
                                validate107.errors = [{ instancePath: instancePath + "/output_entries/" + i0, schemaPath: "#/properties/output_entries/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                return false;
                              }
                              if (errors === _errs35) {
                                if (typeof data11 == "number") {
                                  if (data11 < 1 || isNaN(data11)) {
                                    validate107.errors = [{ instancePath: instancePath + "/output_entries/" + i0, schemaPath: "#/properties/output_entries/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                    return false;
                                  }
                                }
                              }
                              var valid7 = _errs35 === errors;
                              if (!valid7) {
                                break;
                              }
                            }
                          } else {
                            validate107.errors = [{ instancePath: instancePath + "/output_entries", schemaPath: "#/properties/output_entries/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs33 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.problem !== void 0) {
                          let data12 = data.problem;
                          const _errs37 = errors;
                          const _errs38 = errors;
                          let valid8 = false;
                          const _errs39 = errors;
                          if (!validate84(data12, { instancePath: instancePath + "/problem", parentData: data, parentDataProperty: "problem", rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
                            errors = vErrors.length;
                          }
                          var _valid2 = _errs39 === errors;
                          valid8 = valid8 || _valid2;
                          const _errs40 = errors;
                          if (data12 !== null) {
                            const err6 = { instancePath: instancePath + "/problem", schemaPath: "#/properties/problem/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err6];
                            } else {
                              vErrors.push(err6);
                            }
                            errors++;
                          }
                          var _valid2 = _errs40 === errors;
                          valid8 = valid8 || _valid2;
                          if (!valid8) {
                            const err7 = { instancePath: instancePath + "/problem", schemaPath: "#/properties/problem/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                            validate107.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs38;
                            if (vErrors !== null) {
                              if (_errs38) {
                                vErrors.length = _errs38;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs37 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.provider_contact !== void 0) {
                            let data13 = data.provider_contact;
                            const _errs42 = errors;
                            if (typeof data13 !== "string") {
                              validate107.errors = [{ instancePath: instancePath + "/provider_contact", schemaPath: "#/$defs/ProviderContact/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            if (!(data13 === "none" || data13 === "possible" || data13 === "confirmed")) {
                              validate107.errors = [{ instancePath: instancePath + "/provider_contact", schemaPath: "#/$defs/ProviderContact/enum", keyword: "enum", params: { allowedValues: schema126.enum }, message: "must be equal to one of the allowed values" }];
                              return false;
                            }
                            var valid0 = _errs42 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.reported_by !== void 0) {
                              let data14 = data.reported_by;
                              const _errs45 = errors;
                              if (typeof data14 !== "string") {
                                validate107.errors = [{ instancePath: instancePath + "/reported_by", schemaPath: "#/properties/reported_by/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (!(data14 === "connector" || data14 === "server")) {
                                validate107.errors = [{ instancePath: instancePath + "/reported_by", schemaPath: "#/properties/reported_by/enum", keyword: "enum", params: { allowedValues: schema154.properties.reported_by.enum }, message: "must be equal to one of the allowed values" }];
                                return false;
                              }
                              var valid0 = _errs45 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.request_entry !== void 0) {
                                let data15 = data.request_entry;
                                const _errs47 = errors;
                                if (!(typeof data15 == "number" && (!(data15 % 1) && !isNaN(data15)))) {
                                  validate107.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                  return false;
                                }
                                if (errors === _errs47) {
                                  if (typeof data15 == "number") {
                                    if (data15 < 1 || isNaN(data15)) {
                                      validate107.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                      return false;
                                    }
                                  }
                                }
                                var valid0 = _errs47 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.runtime !== void 0) {
                                  let data16 = data.runtime;
                                  const _errs49 = errors;
                                  const _errs50 = errors;
                                  let valid10 = false;
                                  const _errs51 = errors;
                                  if (!validate109(data16, { instancePath: instancePath + "/runtime", parentData: data, parentDataProperty: "runtime", rootData, dynamicAnchors })) {
                                    vErrors = vErrors === null ? validate109.errors : vErrors.concat(validate109.errors);
                                    errors = vErrors.length;
                                  }
                                  var _valid3 = _errs51 === errors;
                                  valid10 = valid10 || _valid3;
                                  const _errs52 = errors;
                                  if (data16 !== null) {
                                    const err8 = { instancePath: instancePath + "/runtime", schemaPath: "#/properties/runtime/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err8];
                                    } else {
                                      vErrors.push(err8);
                                    }
                                    errors++;
                                  }
                                  var _valid3 = _errs52 === errors;
                                  valid10 = valid10 || _valid3;
                                  if (!valid10) {
                                    const err9 = { instancePath: instancePath + "/runtime", schemaPath: "#/properties/runtime/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err9];
                                    } else {
                                      vErrors.push(err9);
                                    }
                                    errors++;
                                    validate107.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs50;
                                    if (vErrors !== null) {
                                      if (_errs50) {
                                        vErrors.length = _errs50;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs49 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.started_at !== void 0) {
                                    let data17 = data.started_at;
                                    const _errs54 = errors;
                                    const _errs55 = errors;
                                    let valid11 = false;
                                    const _errs56 = errors;
                                    if (typeof data17 !== "string") {
                                      const err10 = { instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err10];
                                      } else {
                                        vErrors.push(err10);
                                      }
                                      errors++;
                                    }
                                    var _valid4 = _errs56 === errors;
                                    valid11 = valid11 || _valid4;
                                    const _errs58 = errors;
                                    if (data17 !== null) {
                                      const err11 = { instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                      if (vErrors === null) {
                                        vErrors = [err11];
                                      } else {
                                        vErrors.push(err11);
                                      }
                                      errors++;
                                    }
                                    var _valid4 = _errs58 === errors;
                                    valid11 = valid11 || _valid4;
                                    if (!valid11) {
                                      const err12 = { instancePath: instancePath + "/started_at", schemaPath: "#/properties/started_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err12];
                                      } else {
                                        vErrors.push(err12);
                                      }
                                      errors++;
                                      validate107.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs55;
                                      if (vErrors !== null) {
                                        if (_errs55) {
                                          vErrors.length = _errs55;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid0 = _errs54 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.summary !== void 0) {
                                      let data18 = data.summary;
                                      const _errs60 = errors;
                                      const _errs61 = errors;
                                      let valid12 = false;
                                      const _errs62 = errors;
                                      const _errs63 = errors;
                                      if (errors === _errs63) {
                                        if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                                          let missing2;
                                          if (data18.en === void 0 && (missing2 = "en") || data18.de === void 0 && (missing2 = "de")) {
                                            const err13 = { instancePath: instancePath + "/summary", schemaPath: "#/$defs/ToolCallLine/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                          } else {
                                            const _errs65 = errors;
                                            for (const key3 in data18) {
                                              if (!(key3 === "de" || key3 === "en")) {
                                                const err14 = { instancePath: instancePath + "/summary", schemaPath: "#/$defs/ToolCallLine/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                                if (vErrors === null) {
                                                  vErrors = [err14];
                                                } else {
                                                  vErrors.push(err14);
                                                }
                                                errors++;
                                                break;
                                              }
                                            }
                                            if (_errs65 === errors) {
                                              if (data18.de !== void 0) {
                                                let data19 = data18.de;
                                                const _errs66 = errors;
                                                if (errors === _errs66) {
                                                  if (typeof data19 === "string") {
                                                    if (func2(data19) > 300) {
                                                      const err15 = { instancePath: instancePath + "/summary/de", schemaPath: "#/$defs/ToolCallLine/properties/de/maxLength", keyword: "maxLength", params: { limit: 300 }, message: "must NOT have more than 300 characters" };
                                                      if (vErrors === null) {
                                                        vErrors = [err15];
                                                      } else {
                                                        vErrors.push(err15);
                                                      }
                                                      errors++;
                                                    } else {
                                                      if (func2(data19) < 1) {
                                                        const err16 = { instancePath: instancePath + "/summary/de", schemaPath: "#/$defs/ToolCallLine/properties/de/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err16];
                                                        } else {
                                                          vErrors.push(err16);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                  } else {
                                                    const err17 = { instancePath: instancePath + "/summary/de", schemaPath: "#/$defs/ToolCallLine/properties/de/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err17];
                                                    } else {
                                                      vErrors.push(err17);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var valid14 = _errs66 === errors;
                                              } else {
                                                var valid14 = true;
                                              }
                                              if (valid14) {
                                                if (data18.en !== void 0) {
                                                  let data20 = data18.en;
                                                  const _errs68 = errors;
                                                  if (errors === _errs68) {
                                                    if (typeof data20 === "string") {
                                                      if (func2(data20) > 300) {
                                                        const err18 = { instancePath: instancePath + "/summary/en", schemaPath: "#/$defs/ToolCallLine/properties/en/maxLength", keyword: "maxLength", params: { limit: 300 }, message: "must NOT have more than 300 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err18];
                                                        } else {
                                                          vErrors.push(err18);
                                                        }
                                                        errors++;
                                                      } else {
                                                        if (func2(data20) < 1) {
                                                          const err19 = { instancePath: instancePath + "/summary/en", schemaPath: "#/$defs/ToolCallLine/properties/en/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err19];
                                                          } else {
                                                            vErrors.push(err19);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                    } else {
                                                      const err20 = { instancePath: instancePath + "/summary/en", schemaPath: "#/$defs/ToolCallLine/properties/en/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                      if (vErrors === null) {
                                                        vErrors = [err20];
                                                      } else {
                                                        vErrors.push(err20);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var valid14 = _errs68 === errors;
                                                } else {
                                                  var valid14 = true;
                                                }
                                              }
                                            }
                                          }
                                        } else {
                                          const err21 = { instancePath: instancePath + "/summary", schemaPath: "#/$defs/ToolCallLine/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                          if (vErrors === null) {
                                            vErrors = [err21];
                                          } else {
                                            vErrors.push(err21);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid5 = _errs62 === errors;
                                      valid12 = valid12 || _valid5;
                                      const _errs70 = errors;
                                      if (data18 !== null) {
                                        const err22 = { instancePath: instancePath + "/summary", schemaPath: "#/properties/summary/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err22];
                                        } else {
                                          vErrors.push(err22);
                                        }
                                        errors++;
                                      }
                                      var _valid5 = _errs70 === errors;
                                      valid12 = valid12 || _valid5;
                                      if (!valid12) {
                                        const err23 = { instancePath: instancePath + "/summary", schemaPath: "#/properties/summary/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err23];
                                        } else {
                                          vErrors.push(err23);
                                        }
                                        errors++;
                                        validate107.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs61;
                                        if (vErrors !== null) {
                                          if (_errs61) {
                                            vErrors.length = _errs61;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid0 = _errs60 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.turn_id !== void 0) {
                                        const _errs72 = errors;
                                        if (typeof data.turn_id !== "string") {
                                          validate107.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                        var valid0 = _errs72 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.usage !== void 0) {
                                          const _errs74 = errors;
                                          if (!validate86(data.usage, { instancePath: instancePath + "/usage", parentData: data, parentDataProperty: "usage", rootData, dynamicAnchors })) {
                                            vErrors = vErrors === null ? validate86.errors : vErrors.concat(validate86.errors);
                                            errors = vErrors.length;
                                          }
                                          var valid0 = _errs74 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate107.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate107.errors = vErrors;
  return errors === 0;
}
validate107.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema160 = { "additionalProperties": false, "properties": { "answered_talk": { "anyOf": [{ "$ref": "#/$defs/AnsweredTalk" }, { "type": "null" }], "default": null, "description": "A renewed review after a talk: the person's request and the agent's answer, shown\nwith the review. Absent otherwise, so earlier requests keep their bytes." }, "inputs": { "items": { "$ref": "#/$defs/HumanStepInput" }, "title": "Inputs", "type": "array" }, "instructions": { "title": "Instructions", "type": "string" }, "kind": { "const": "human_step_requested", "title": "Kind", "type": "string" }, "placement": { "anyOf": [{ "$ref": "#/$defs/StepPlacement" }, { "type": "null" }], "default": null, "description": "Where the step is placed in the Workflow; `None` in requests recorded before W-13." }, "response": { "additionalProperties": { "$ref": "#/$defs/JsonValue" }, "description": "The step's response definition: text, choice or review_output.", "title": "Response", "type": "object" }, "step": { "title": "Step", "type": "string" }, "step_key": { "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "title": "Step Key", "type": "string" }, "translations": { "anyOf": [{ "additionalProperties": { "$ref": "#/$defs/RequestTranslation" }, "type": "object" }, { "type": "null" }], "default": null, "description": "By BCP 47 language, so the web app shows the person's without reading the item (W-22,\nT-1b); absent without any, as in requests recorded before.", "title": "Translations" } }, "required": ["kind", "step_key", "step", "instructions", "inputs", "response"], "title": "HumanStepRequestedPayload", "type": "object" };
function validate115(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate115.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.slot === void 0 && (missing0 = "slot") || data.from_entry === void 0 && (missing0 = "from_entry") || data.part === void 0 && (missing0 = "part") || data.text === void 0 && (missing0 = "text") || data.value === void 0 && (missing0 = "value")) {
        validate115.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "from_entry" || key0 === "label" || key0 === "part" || key0 === "slot" || key0 === "text" || key0 === "value")) {
            validate115.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.from_entry !== void 0) {
            let data0 = data.from_entry;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              const err0 = { instancePath: instancePath + "/from_entry", schemaPath: "#/properties/from_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            if (errors === _errs4) {
              if (typeof data0 == "number") {
                if (data0 < 1 || isNaN(data0)) {
                  const err1 = { instancePath: instancePath + "/from_entry", schemaPath: "#/properties/from_entry/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
              }
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err2 = { instancePath: instancePath + "/from_entry", schemaPath: "#/properties/from_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err3 = { instancePath: instancePath + "/from_entry", schemaPath: "#/properties/from_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
              validate115.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.label !== void 0) {
              let data1 = data.label;
              const _errs8 = errors;
              const _errs9 = errors;
              let valid2 = false;
              const _errs10 = errors;
              if (typeof data1 !== "string") {
                const err4 = { instancePath: instancePath + "/label", schemaPath: "#/properties/label/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var _valid1 = _errs10 === errors;
              valid2 = valid2 || _valid1;
              const _errs12 = errors;
              if (data1 !== null) {
                const err5 = { instancePath: instancePath + "/label", schemaPath: "#/properties/label/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
              var _valid1 = _errs12 === errors;
              valid2 = valid2 || _valid1;
              if (!valid2) {
                const err6 = { instancePath: instancePath + "/label", schemaPath: "#/properties/label/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
                validate115.errors = vErrors;
                return false;
              } else {
                errors = _errs9;
                if (vErrors !== null) {
                  if (_errs9) {
                    vErrors.length = _errs9;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.part !== void 0) {
                let data2 = data.part;
                const _errs14 = errors;
                const _errs15 = errors;
                let valid3 = false;
                const _errs16 = errors;
                if (errors === _errs16) {
                  if (typeof data2 === "string") {
                    if (!pattern8.test(data2)) {
                      const err7 = { instancePath: instancePath + "/part", schemaPath: "#/properties/part/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                  } else {
                    const err8 = { instancePath: instancePath + "/part", schemaPath: "#/properties/part/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                }
                var _valid2 = _errs16 === errors;
                valid3 = valid3 || _valid2;
                const _errs18 = errors;
                if (data2 !== null) {
                  const err9 = { instancePath: instancePath + "/part", schemaPath: "#/properties/part/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                }
                var _valid2 = _errs18 === errors;
                valid3 = valid3 || _valid2;
                if (!valid3) {
                  const err10 = { instancePath: instancePath + "/part", schemaPath: "#/properties/part/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                  validate115.errors = vErrors;
                  return false;
                } else {
                  errors = _errs15;
                  if (vErrors !== null) {
                    if (_errs15) {
                      vErrors.length = _errs15;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs14 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.slot !== void 0) {
                  let data3 = data.slot;
                  const _errs20 = errors;
                  if (errors === _errs20) {
                    if (typeof data3 === "string") {
                      if (!pattern8.test(data3)) {
                        validate115.errors = [{ instancePath: instancePath + "/slot", schemaPath: "#/properties/slot/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                        return false;
                      }
                    } else {
                      validate115.errors = [{ instancePath: instancePath + "/slot", schemaPath: "#/properties/slot/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                  var valid0 = _errs20 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.text !== void 0) {
                    const _errs22 = errors;
                    if (typeof data.text !== "string") {
                      validate115.errors = [{ instancePath: instancePath + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs22 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.value !== void 0) {
                      let data5 = data.value;
                      const _errs24 = errors;
                      const _errs25 = errors;
                      let valid4 = false;
                      const _errs26 = errors;
                      if (!validate57(data5, { instancePath: instancePath + "/value", parentData: data, parentDataProperty: "value", rootData, dynamicAnchors })) {
                        vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                        errors = vErrors.length;
                      }
                      var _valid3 = _errs26 === errors;
                      valid4 = valid4 || _valid3;
                      const _errs27 = errors;
                      if (data5 !== null) {
                        const err11 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err11];
                        } else {
                          vErrors.push(err11);
                        }
                        errors++;
                      }
                      var _valid3 = _errs27 === errors;
                      valid4 = valid4 || _valid3;
                      if (!valid4) {
                        const err12 = { instancePath: instancePath + "/value", schemaPath: "#/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err12];
                        } else {
                          vErrors.push(err12);
                        }
                        errors++;
                        validate115.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs25;
                        if (vErrors !== null) {
                          if (_errs25) {
                            vErrors.length = _errs25;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs24 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate115.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate115.errors = vErrors;
  return errors === 0;
}
validate115.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate114(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate114.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.step_key === void 0 && (missing0 = "step_key") || data.step === void 0 && (missing0 = "step") || data.instructions === void 0 && (missing0 = "instructions") || data.inputs === void 0 && (missing0 = "inputs") || data.response === void 0 && (missing0 = "response")) {
        validate114.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema160.properties, key0)) {
            validate114.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.answered_talk !== void 0) {
            let data0 = data.answered_talk;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                let missing1;
                if (data0.request === void 0 && (missing1 = "request") || data0.answer === void 0 && (missing1 = "answer")) {
                  const err0 = { instancePath: instancePath + "/answered_talk", schemaPath: "#/$defs/AnsweredTalk/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                } else {
                  const _errs7 = errors;
                  for (const key1 in data0) {
                    if (!(key1 === "answer" || key1 === "request")) {
                      const err1 = { instancePath: instancePath + "/answered_talk", schemaPath: "#/$defs/AnsweredTalk/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                      break;
                    }
                  }
                  if (_errs7 === errors) {
                    if (data0.answer !== void 0) {
                      let data1 = data0.answer;
                      const _errs8 = errors;
                      const _errs9 = errors;
                      let valid4 = false;
                      const _errs10 = errors;
                      if (typeof data1 !== "string") {
                        const err2 = { instancePath: instancePath + "/answered_talk/answer", schemaPath: "#/$defs/AnsweredTalk/properties/answer/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      }
                      var _valid1 = _errs10 === errors;
                      valid4 = valid4 || _valid1;
                      const _errs12 = errors;
                      if (data1 !== null) {
                        const err3 = { instancePath: instancePath + "/answered_talk/answer", schemaPath: "#/$defs/AnsweredTalk/properties/answer/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      }
                      var _valid1 = _errs12 === errors;
                      valid4 = valid4 || _valid1;
                      if (!valid4) {
                        const err4 = { instancePath: instancePath + "/answered_talk/answer", schemaPath: "#/$defs/AnsweredTalk/properties/answer/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                      } else {
                        errors = _errs9;
                        if (vErrors !== null) {
                          if (_errs9) {
                            vErrors.length = _errs9;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid3 = _errs8 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data0.request !== void 0) {
                        const _errs14 = errors;
                        if (typeof data0.request !== "string") {
                          const err5 = { instancePath: instancePath + "/answered_talk/request", schemaPath: "#/$defs/AnsweredTalk/properties/request/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                        var valid3 = _errs14 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  }
                }
              } else {
                const err6 = { instancePath: instancePath + "/answered_talk", schemaPath: "#/$defs/AnsweredTalk/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs16 = errors;
            if (data0 !== null) {
              const err7 = { instancePath: instancePath + "/answered_talk", schemaPath: "#/properties/answered_talk/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            var _valid0 = _errs16 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err8 = { instancePath: instancePath + "/answered_talk", schemaPath: "#/properties/answered_talk/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
              validate114.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.inputs !== void 0) {
              let data3 = data.inputs;
              const _errs18 = errors;
              if (errors === _errs18) {
                if (Array.isArray(data3)) {
                  var valid5 = true;
                  const len0 = data3.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs20 = errors;
                    if (!validate115(data3[i0], { instancePath: instancePath + "/inputs/" + i0, parentData: data3, parentDataProperty: i0, rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate115.errors : vErrors.concat(validate115.errors);
                      errors = vErrors.length;
                    }
                    var valid5 = _errs20 === errors;
                    if (!valid5) {
                      break;
                    }
                  }
                } else {
                  validate114.errors = [{ instancePath: instancePath + "/inputs", schemaPath: "#/properties/inputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs18 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.instructions !== void 0) {
                const _errs21 = errors;
                if (typeof data.instructions !== "string") {
                  validate114.errors = [{ instancePath: instancePath + "/instructions", schemaPath: "#/properties/instructions/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs21 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.kind !== void 0) {
                  let data6 = data.kind;
                  const _errs23 = errors;
                  if (typeof data6 !== "string") {
                    validate114.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if ("human_step_requested" !== data6) {
                    validate114.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "human_step_requested" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs23 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.placement !== void 0) {
                    let data7 = data.placement;
                    const _errs25 = errors;
                    const _errs26 = errors;
                    let valid6 = false;
                    const _errs27 = errors;
                    const _errs28 = errors;
                    if (errors === _errs28) {
                      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                        let missing2;
                        if (data7.workflow === void 0 && (missing2 = "workflow") || data7.key === void 0 && (missing2 = "key")) {
                          const err9 = { instancePath: instancePath + "/placement", schemaPath: "#/$defs/StepPlacement/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                          if (vErrors === null) {
                            vErrors = [err9];
                          } else {
                            vErrors.push(err9);
                          }
                          errors++;
                        } else {
                          const _errs30 = errors;
                          for (const key2 in data7) {
                            if (!(key2 === "key" || key2 === "workflow")) {
                              const err10 = { instancePath: instancePath + "/placement", schemaPath: "#/$defs/StepPlacement/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                              if (vErrors === null) {
                                vErrors = [err10];
                              } else {
                                vErrors.push(err10);
                              }
                              errors++;
                              break;
                            }
                          }
                          if (_errs30 === errors) {
                            if (data7.key !== void 0) {
                              let data8 = data7.key;
                              const _errs31 = errors;
                              if (errors === _errs31) {
                                if (typeof data8 === "string") {
                                  if (!pattern8.test(data8)) {
                                    const err11 = { instancePath: instancePath + "/placement/key", schemaPath: "#/$defs/StepPlacement/properties/key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                                    if (vErrors === null) {
                                      vErrors = [err11];
                                    } else {
                                      vErrors.push(err11);
                                    }
                                    errors++;
                                  }
                                } else {
                                  const err12 = { instancePath: instancePath + "/placement/key", schemaPath: "#/$defs/StepPlacement/properties/key/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err12];
                                  } else {
                                    vErrors.push(err12);
                                  }
                                  errors++;
                                }
                              }
                              var valid8 = _errs31 === errors;
                            } else {
                              var valid8 = true;
                            }
                            if (valid8) {
                              if (data7.workflow !== void 0) {
                                const _errs33 = errors;
                                if (typeof data7.workflow !== "string") {
                                  const err13 = { instancePath: instancePath + "/placement/workflow", schemaPath: "#/$defs/StepPlacement/properties/workflow/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err13];
                                  } else {
                                    vErrors.push(err13);
                                  }
                                  errors++;
                                }
                                var valid8 = _errs33 === errors;
                              } else {
                                var valid8 = true;
                              }
                            }
                          }
                        }
                      } else {
                        const err14 = { instancePath: instancePath + "/placement", schemaPath: "#/$defs/StepPlacement/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err14];
                        } else {
                          vErrors.push(err14);
                        }
                        errors++;
                      }
                    }
                    var _valid2 = _errs27 === errors;
                    valid6 = valid6 || _valid2;
                    const _errs35 = errors;
                    if (data7 !== null) {
                      const err15 = { instancePath: instancePath + "/placement", schemaPath: "#/properties/placement/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                    var _valid2 = _errs35 === errors;
                    valid6 = valid6 || _valid2;
                    if (!valid6) {
                      const err16 = { instancePath: instancePath + "/placement", schemaPath: "#/properties/placement/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                      validate114.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs26;
                      if (vErrors !== null) {
                        if (_errs26) {
                          vErrors.length = _errs26;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs25 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.response !== void 0) {
                      let data10 = data.response;
                      const _errs37 = errors;
                      if (errors === _errs37) {
                        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                          for (const key3 in data10) {
                            const _errs40 = errors;
                            var valid9 = _errs40 === errors;
                            if (!valid9) {
                              break;
                            }
                          }
                        } else {
                          validate114.errors = [{ instancePath: instancePath + "/response", schemaPath: "#/properties/response/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                          return false;
                        }
                      }
                      var valid0 = _errs37 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.step !== void 0) {
                        const _errs41 = errors;
                        if (typeof data.step !== "string") {
                          validate114.errors = [{ instancePath: instancePath + "/step", schemaPath: "#/properties/step/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid0 = _errs41 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.step_key !== void 0) {
                          let data13 = data.step_key;
                          const _errs43 = errors;
                          if (errors === _errs43) {
                            if (typeof data13 === "string") {
                              if (!pattern14.test(data13)) {
                                validate114.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' }];
                                return false;
                              }
                            } else {
                              validate114.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                          }
                          var valid0 = _errs43 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.translations !== void 0) {
                            let data14 = data.translations;
                            const _errs45 = errors;
                            const _errs46 = errors;
                            let valid11 = false;
                            const _errs47 = errors;
                            if (errors === _errs47) {
                              if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                                for (const key4 in data14) {
                                  let data15 = data14[key4];
                                  const _errs50 = errors;
                                  const _errs51 = errors;
                                  if (errors === _errs51) {
                                    if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                                      const _errs53 = errors;
                                      for (const key5 in data15) {
                                        if (!(key5 === "choice_labels" || key5 === "input_labels" || key5 === "instructions")) {
                                          const err17 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/RequestTranslation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                                          if (vErrors === null) {
                                            vErrors = [err17];
                                          } else {
                                            vErrors.push(err17);
                                          }
                                          errors++;
                                          break;
                                        }
                                      }
                                      if (_errs53 === errors) {
                                        if (data15.choice_labels !== void 0) {
                                          let data16 = data15.choice_labels;
                                          const _errs54 = errors;
                                          const _errs55 = errors;
                                          let valid15 = false;
                                          const _errs56 = errors;
                                          if (errors === _errs56) {
                                            if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                                              for (const key6 in data16) {
                                                const _errs59 = errors;
                                                if (typeof data16[key6] !== "string") {
                                                  const err18 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/choice_labels/" + key6.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/RequestTranslation/properties/choice_labels/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err18];
                                                  } else {
                                                    vErrors.push(err18);
                                                  }
                                                  errors++;
                                                }
                                                var valid16 = _errs59 === errors;
                                                if (!valid16) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              const err19 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/choice_labels", schemaPath: "#/$defs/RequestTranslation/properties/choice_labels/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                              if (vErrors === null) {
                                                vErrors = [err19];
                                              } else {
                                                vErrors.push(err19);
                                              }
                                              errors++;
                                            }
                                          }
                                          var _valid4 = _errs56 === errors;
                                          valid15 = valid15 || _valid4;
                                          const _errs61 = errors;
                                          if (data16 !== null) {
                                            const err20 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/choice_labels", schemaPath: "#/$defs/RequestTranslation/properties/choice_labels/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                            if (vErrors === null) {
                                              vErrors = [err20];
                                            } else {
                                              vErrors.push(err20);
                                            }
                                            errors++;
                                          }
                                          var _valid4 = _errs61 === errors;
                                          valid15 = valid15 || _valid4;
                                          if (!valid15) {
                                            const err21 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/choice_labels", schemaPath: "#/$defs/RequestTranslation/properties/choice_labels/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                            if (vErrors === null) {
                                              vErrors = [err21];
                                            } else {
                                              vErrors.push(err21);
                                            }
                                            errors++;
                                          } else {
                                            errors = _errs55;
                                            if (vErrors !== null) {
                                              if (_errs55) {
                                                vErrors.length = _errs55;
                                              } else {
                                                vErrors = null;
                                              }
                                            }
                                          }
                                          var valid14 = _errs54 === errors;
                                        } else {
                                          var valid14 = true;
                                        }
                                        if (valid14) {
                                          if (data15.input_labels !== void 0) {
                                            let data18 = data15.input_labels;
                                            const _errs63 = errors;
                                            const _errs64 = errors;
                                            let valid17 = false;
                                            const _errs65 = errors;
                                            if (errors === _errs65) {
                                              if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                                                for (const key7 in data18) {
                                                  const _errs68 = errors;
                                                  if (typeof data18[key7] !== "string") {
                                                    const err22 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/input_labels/" + key7.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/RequestTranslation/properties/input_labels/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err22];
                                                    } else {
                                                      vErrors.push(err22);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid18 = _errs68 === errors;
                                                  if (!valid18) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                const err23 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/input_labels", schemaPath: "#/$defs/RequestTranslation/properties/input_labels/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                if (vErrors === null) {
                                                  vErrors = [err23];
                                                } else {
                                                  vErrors.push(err23);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid5 = _errs65 === errors;
                                            valid17 = valid17 || _valid5;
                                            const _errs70 = errors;
                                            if (data18 !== null) {
                                              const err24 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/input_labels", schemaPath: "#/$defs/RequestTranslation/properties/input_labels/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                              if (vErrors === null) {
                                                vErrors = [err24];
                                              } else {
                                                vErrors.push(err24);
                                              }
                                              errors++;
                                            }
                                            var _valid5 = _errs70 === errors;
                                            valid17 = valid17 || _valid5;
                                            if (!valid17) {
                                              const err25 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/input_labels", schemaPath: "#/$defs/RequestTranslation/properties/input_labels/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                              if (vErrors === null) {
                                                vErrors = [err25];
                                              } else {
                                                vErrors.push(err25);
                                              }
                                              errors++;
                                            } else {
                                              errors = _errs64;
                                              if (vErrors !== null) {
                                                if (_errs64) {
                                                  vErrors.length = _errs64;
                                                } else {
                                                  vErrors = null;
                                                }
                                              }
                                            }
                                            var valid14 = _errs63 === errors;
                                          } else {
                                            var valid14 = true;
                                          }
                                          if (valid14) {
                                            if (data15.instructions !== void 0) {
                                              let data20 = data15.instructions;
                                              const _errs72 = errors;
                                              const _errs73 = errors;
                                              let valid19 = false;
                                              const _errs74 = errors;
                                              if (typeof data20 !== "string") {
                                                const err26 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/instructions", schemaPath: "#/$defs/RequestTranslation/properties/instructions/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err26];
                                                } else {
                                                  vErrors.push(err26);
                                                }
                                                errors++;
                                              }
                                              var _valid6 = _errs74 === errors;
                                              valid19 = valid19 || _valid6;
                                              const _errs76 = errors;
                                              if (data20 !== null) {
                                                const err27 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/instructions", schemaPath: "#/$defs/RequestTranslation/properties/instructions/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                if (vErrors === null) {
                                                  vErrors = [err27];
                                                } else {
                                                  vErrors.push(err27);
                                                }
                                                errors++;
                                              }
                                              var _valid6 = _errs76 === errors;
                                              valid19 = valid19 || _valid6;
                                              if (!valid19) {
                                                const err28 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1") + "/instructions", schemaPath: "#/$defs/RequestTranslation/properties/instructions/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                if (vErrors === null) {
                                                  vErrors = [err28];
                                                } else {
                                                  vErrors.push(err28);
                                                }
                                                errors++;
                                              } else {
                                                errors = _errs73;
                                                if (vErrors !== null) {
                                                  if (_errs73) {
                                                    vErrors.length = _errs73;
                                                  } else {
                                                    vErrors = null;
                                                  }
                                                }
                                              }
                                              var valid14 = _errs72 === errors;
                                            } else {
                                              var valid14 = true;
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      const err29 = { instancePath: instancePath + "/translations/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/RequestTranslation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                      if (vErrors === null) {
                                        vErrors = [err29];
                                      } else {
                                        vErrors.push(err29);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid12 = _errs50 === errors;
                                  if (!valid12) {
                                    break;
                                  }
                                }
                              } else {
                                const err30 = { instancePath: instancePath + "/translations", schemaPath: "#/properties/translations/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                if (vErrors === null) {
                                  vErrors = [err30];
                                } else {
                                  vErrors.push(err30);
                                }
                                errors++;
                              }
                            }
                            var _valid3 = _errs47 === errors;
                            valid11 = valid11 || _valid3;
                            const _errs78 = errors;
                            if (data14 !== null) {
                              const err31 = { instancePath: instancePath + "/translations", schemaPath: "#/properties/translations/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err31];
                              } else {
                                vErrors.push(err31);
                              }
                              errors++;
                            }
                            var _valid3 = _errs78 === errors;
                            valid11 = valid11 || _valid3;
                            if (!valid11) {
                              const err32 = { instancePath: instancePath + "/translations", schemaPath: "#/properties/translations/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err32];
                              } else {
                                vErrors.push(err32);
                              }
                              errors++;
                              validate114.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs46;
                              if (vErrors !== null) {
                                if (_errs46) {
                                  vErrors.length = _errs46;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs45 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate114.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate114.errors = vErrors;
  return errors === 0;
}
validate114.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema169 = { "enum": ["approve", "request_changes", "scrap", "merge"], "title": "ReviewDecisionKind", "type": "string" };
var schema171 = { "description": "How big a merged change is (semver.org), least to most.", "enum": ["patch", "minor", "major"], "title": "VersionBump", "type": "string" };
function validate122(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate122.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.note === void 0 && (missing0 = "note") || data.version_bump === void 0 && (missing0 = "version_bump")) {
        validate122.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "item_bumps" || key0 === "note" || key0 === "version_bump")) {
            validate122.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.item_bumps !== void 0) {
            let data0 = data.item_bumps;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                for (const key1 in data0) {
                  let data1 = data0[key1];
                  const _errs5 = errors;
                  if (typeof data1 !== "string") {
                    validate122.errors = [{ instancePath: instancePath + "/item_bumps/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/VersionBump/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data1 === "patch" || data1 === "minor" || data1 === "major")) {
                    validate122.errors = [{ instancePath: instancePath + "/item_bumps/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/VersionBump/enum", keyword: "enum", params: { allowedValues: schema171.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid1 = _errs5 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate122.errors = [{ instancePath: instancePath + "/item_bumps", schemaPath: "#/properties/item_bumps/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.note !== void 0) {
              const _errs8 = errors;
              if (typeof data.note !== "string") {
                validate122.errors = [{ instancePath: instancePath + "/note", schemaPath: "#/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.version_bump !== void 0) {
                let data3 = data.version_bump;
                const _errs10 = errors;
                const _errs11 = errors;
                let valid3 = false;
                const _errs12 = errors;
                if (typeof data3 !== "string") {
                  const err0 = { instancePath: instancePath + "/version_bump", schemaPath: "#/$defs/VersionBump/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                if (!(data3 === "patch" || data3 === "minor" || data3 === "major")) {
                  const err1 = { instancePath: instancePath + "/version_bump", schemaPath: "#/$defs/VersionBump/enum", keyword: "enum", params: { allowedValues: schema171.enum }, message: "must be equal to one of the allowed values" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var _valid0 = _errs12 === errors;
                valid3 = valid3 || _valid0;
                const _errs15 = errors;
                if (data3 !== null) {
                  const err2 = { instancePath: instancePath + "/version_bump", schemaPath: "#/properties/version_bump/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var _valid0 = _errs15 === errors;
                valid3 = valid3 || _valid0;
                if (!valid3) {
                  const err3 = { instancePath: instancePath + "/version_bump", schemaPath: "#/properties/version_bump/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                  validate122.errors = vErrors;
                  return false;
                } else {
                  errors = _errs11;
                  if (vErrors !== null) {
                    if (_errs11) {
                      vErrors.length = _errs11;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate122.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate122.errors = vErrors;
  return errors === 0;
}
validate122.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate121(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate121.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.decision === void 0 && (missing0 = "decision")) {
        validate121.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "acknowledgement" || key0 === "decision" || key0 === "release" || key0 === "send_back_to")) {
            validate121.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.acknowledgement !== void 0) {
            let data0 = data.acknowledgement;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                let missing1;
                if (data0.check_run_id === void 0 && (missing1 = "check_run_id") || data0.conflict_check_id === void 0 && (missing1 = "conflict_check_id") || data0.note === void 0 && (missing1 = "note")) {
                  const err0 = { instancePath: instancePath + "/acknowledgement", schemaPath: "#/$defs/MergeAcknowledgementAnswer/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                } else {
                  const _errs7 = errors;
                  for (const key1 in data0) {
                    if (!(key1 === "check_run_id" || key1 === "conflict_check_id" || key1 === "note")) {
                      const err1 = { instancePath: instancePath + "/acknowledgement", schemaPath: "#/$defs/MergeAcknowledgementAnswer/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                      break;
                    }
                  }
                  if (_errs7 === errors) {
                    if (data0.check_run_id !== void 0) {
                      let data1 = data0.check_run_id;
                      const _errs8 = errors;
                      const _errs9 = errors;
                      let valid4 = false;
                      const _errs10 = errors;
                      if (typeof data1 !== "string") {
                        const err2 = { instancePath: instancePath + "/acknowledgement/check_run_id", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/check_run_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      }
                      var _valid1 = _errs10 === errors;
                      valid4 = valid4 || _valid1;
                      const _errs12 = errors;
                      if (data1 !== null) {
                        const err3 = { instancePath: instancePath + "/acknowledgement/check_run_id", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/check_run_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      }
                      var _valid1 = _errs12 === errors;
                      valid4 = valid4 || _valid1;
                      if (!valid4) {
                        const err4 = { instancePath: instancePath + "/acknowledgement/check_run_id", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/check_run_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                      } else {
                        errors = _errs9;
                        if (vErrors !== null) {
                          if (_errs9) {
                            vErrors.length = _errs9;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid3 = _errs8 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data0.conflict_check_id !== void 0) {
                        let data2 = data0.conflict_check_id;
                        const _errs14 = errors;
                        const _errs15 = errors;
                        let valid5 = false;
                        const _errs16 = errors;
                        if (typeof data2 !== "string") {
                          const err5 = { instancePath: instancePath + "/acknowledgement/conflict_check_id", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/conflict_check_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                        var _valid2 = _errs16 === errors;
                        valid5 = valid5 || _valid2;
                        const _errs18 = errors;
                        if (data2 !== null) {
                          const err6 = { instancePath: instancePath + "/acknowledgement/conflict_check_id", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/conflict_check_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err6];
                          } else {
                            vErrors.push(err6);
                          }
                          errors++;
                        }
                        var _valid2 = _errs18 === errors;
                        valid5 = valid5 || _valid2;
                        if (!valid5) {
                          const err7 = { instancePath: instancePath + "/acknowledgement/conflict_check_id", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/conflict_check_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err7];
                          } else {
                            vErrors.push(err7);
                          }
                          errors++;
                        } else {
                          errors = _errs15;
                          if (vErrors !== null) {
                            if (_errs15) {
                              vErrors.length = _errs15;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid3 = _errs14 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data0.note !== void 0) {
                          let data3 = data0.note;
                          const _errs20 = errors;
                          if (errors === _errs20) {
                            if (typeof data3 === "string") {
                              if (func2(data3) < 1) {
                                const err8 = { instancePath: instancePath + "/acknowledgement/note", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/note/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                  vErrors = [err8];
                                } else {
                                  vErrors.push(err8);
                                }
                                errors++;
                              }
                            } else {
                              const err9 = { instancePath: instancePath + "/acknowledgement/note", schemaPath: "#/$defs/MergeAcknowledgementAnswer/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err9];
                              } else {
                                vErrors.push(err9);
                              }
                              errors++;
                            }
                          }
                          var valid3 = _errs20 === errors;
                        } else {
                          var valid3 = true;
                        }
                      }
                    }
                  }
                }
              } else {
                const err10 = { instancePath: instancePath + "/acknowledgement", schemaPath: "#/$defs/MergeAcknowledgementAnswer/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs22 = errors;
            if (data0 !== null) {
              const err11 = { instancePath: instancePath + "/acknowledgement", schemaPath: "#/properties/acknowledgement/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            var _valid0 = _errs22 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err12 = { instancePath: instancePath + "/acknowledgement", schemaPath: "#/properties/acknowledgement/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
              validate121.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.decision !== void 0) {
              let data4 = data.decision;
              const _errs24 = errors;
              if (typeof data4 !== "string") {
                validate121.errors = [{ instancePath: instancePath + "/decision", schemaPath: "#/$defs/ReviewDecisionKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data4 === "approve" || data4 === "request_changes" || data4 === "scrap" || data4 === "merge")) {
                validate121.errors = [{ instancePath: instancePath + "/decision", schemaPath: "#/$defs/ReviewDecisionKind/enum", keyword: "enum", params: { allowedValues: schema169.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs24 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.release !== void 0) {
                let data5 = data.release;
                const _errs27 = errors;
                const _errs28 = errors;
                let valid7 = false;
                const _errs29 = errors;
                if (!validate122(data5, { instancePath: instancePath + "/release", parentData: data, parentDataProperty: "release", rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate122.errors : vErrors.concat(validate122.errors);
                  errors = vErrors.length;
                }
                var _valid3 = _errs29 === errors;
                valid7 = valid7 || _valid3;
                const _errs30 = errors;
                if (data5 !== null) {
                  const err13 = { instancePath: instancePath + "/release", schemaPath: "#/properties/release/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
                var _valid3 = _errs30 === errors;
                valid7 = valid7 || _valid3;
                if (!valid7) {
                  const err14 = { instancePath: instancePath + "/release", schemaPath: "#/properties/release/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                  validate121.errors = vErrors;
                  return false;
                } else {
                  errors = _errs28;
                  if (vErrors !== null) {
                    if (_errs28) {
                      vErrors.length = _errs28;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs27 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.send_back_to !== void 0) {
                  let data6 = data.send_back_to;
                  const _errs32 = errors;
                  const _errs33 = errors;
                  let valid8 = false;
                  const _errs34 = errors;
                  if (errors === _errs34) {
                    if (typeof data6 === "string") {
                      if (!pattern14.test(data6)) {
                        const err15 = { instancePath: instancePath + "/send_back_to", schemaPath: "#/properties/send_back_to/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                        if (vErrors === null) {
                          vErrors = [err15];
                        } else {
                          vErrors.push(err15);
                        }
                        errors++;
                      }
                    } else {
                      const err16 = { instancePath: instancePath + "/send_back_to", schemaPath: "#/properties/send_back_to/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                    }
                  }
                  var _valid4 = _errs34 === errors;
                  valid8 = valid8 || _valid4;
                  const _errs36 = errors;
                  if (data6 !== null) {
                    const err17 = { instancePath: instancePath + "/send_back_to", schemaPath: "#/properties/send_back_to/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err17];
                    } else {
                      vErrors.push(err17);
                    }
                    errors++;
                  }
                  var _valid4 = _errs36 === errors;
                  valid8 = valid8 || _valid4;
                  if (!valid8) {
                    const err18 = { instancePath: instancePath + "/send_back_to", schemaPath: "#/properties/send_back_to/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                    validate121.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs33;
                    if (vErrors !== null) {
                      if (_errs33) {
                        vErrors.length = _errs33;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate121.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate121.errors = vErrors;
  return errors === 0;
}
validate121.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate119(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate119.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.answers_entry === void 0 && (missing0 = "answers_entry") || data.comment === void 0 && (missing0 = "comment") || data.choice === void 0 && (missing0 = "choice") || data.result === void 0 && (missing0 = "result")) {
        validate119.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "answers_entry" || key0 === "choice" || key0 === "comment" || key0 === "ends_workflow" || key0 === "kind" || key0 === "result" || key0 === "review")) {
            validate119.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.answers_entry !== void 0) {
            let data0 = data.answers_entry;
            const _errs2 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              validate119.errors = [{ instancePath: instancePath + "/answers_entry", schemaPath: "#/properties/answers_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
              return false;
            }
            if (errors === _errs2) {
              if (typeof data0 == "number") {
                if (data0 < 1 || isNaN(data0)) {
                  validate119.errors = [{ instancePath: instancePath + "/answers_entry", schemaPath: "#/properties/answers_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                  return false;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.choice !== void 0) {
              let data1 = data.choice;
              const _errs4 = errors;
              const _errs5 = errors;
              let valid1 = false;
              const _errs6 = errors;
              if (errors === _errs6) {
                if (typeof data1 === "string") {
                  if (!pattern8.test(data1)) {
                    const err0 = { instancePath: instancePath + "/choice", schemaPath: "#/properties/choice/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  }
                } else {
                  const err1 = { instancePath: instancePath + "/choice", schemaPath: "#/properties/choice/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs6 === errors;
              valid1 = valid1 || _valid0;
              const _errs8 = errors;
              if (data1 !== null) {
                const err2 = { instancePath: instancePath + "/choice", schemaPath: "#/properties/choice/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var _valid0 = _errs8 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const err3 = { instancePath: instancePath + "/choice", schemaPath: "#/properties/choice/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
                validate119.errors = vErrors;
                return false;
              } else {
                errors = _errs5;
                if (vErrors !== null) {
                  if (_errs5) {
                    vErrors.length = _errs5;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.comment !== void 0) {
                let data2 = data.comment;
                const _errs10 = errors;
                const _errs11 = errors;
                let valid2 = false;
                const _errs12 = errors;
                if (typeof data2 !== "string") {
                  const err4 = { instancePath: instancePath + "/comment", schemaPath: "#/properties/comment/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var _valid1 = _errs12 === errors;
                valid2 = valid2 || _valid1;
                const _errs14 = errors;
                if (data2 !== null) {
                  const err5 = { instancePath: instancePath + "/comment", schemaPath: "#/properties/comment/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                var _valid1 = _errs14 === errors;
                valid2 = valid2 || _valid1;
                if (!valid2) {
                  const err6 = { instancePath: instancePath + "/comment", schemaPath: "#/properties/comment/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                  validate119.errors = vErrors;
                  return false;
                } else {
                  errors = _errs11;
                  if (vErrors !== null) {
                    if (_errs11) {
                      vErrors.length = _errs11;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.ends_workflow !== void 0) {
                  const _errs16 = errors;
                  if (typeof data.ends_workflow !== "boolean") {
                    validate119.errors = [{ instancePath: instancePath + "/ends_workflow", schemaPath: "#/properties/ends_workflow/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                    return false;
                  }
                  var valid0 = _errs16 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.kind !== void 0) {
                    let data4 = data.kind;
                    const _errs18 = errors;
                    if (typeof data4 !== "string") {
                      validate119.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    if ("human_input" !== data4) {
                      validate119.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "human_input" }, message: "must be equal to constant" }];
                      return false;
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.result !== void 0) {
                      let data5 = data.result;
                      const _errs20 = errors;
                      const _errs21 = errors;
                      let valid3 = false;
                      const _errs22 = errors;
                      if (!validate57(data5, { instancePath: instancePath + "/result", parentData: data, parentDataProperty: "result", rootData, dynamicAnchors })) {
                        vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                        errors = vErrors.length;
                      }
                      var _valid2 = _errs22 === errors;
                      valid3 = valid3 || _valid2;
                      const _errs23 = errors;
                      if (data5 !== null) {
                        const err7 = { instancePath: instancePath + "/result", schemaPath: "#/properties/result/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      var _valid2 = _errs23 === errors;
                      valid3 = valid3 || _valid2;
                      if (!valid3) {
                        const err8 = { instancePath: instancePath + "/result", schemaPath: "#/properties/result/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                        validate119.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs21;
                        if (vErrors !== null) {
                          if (_errs21) {
                            vErrors.length = _errs21;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs20 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.review !== void 0) {
                        let data6 = data.review;
                        const _errs25 = errors;
                        const _errs26 = errors;
                        let valid4 = false;
                        const _errs27 = errors;
                        if (!validate121(data6, { instancePath: instancePath + "/review", parentData: data, parentDataProperty: "review", rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate121.errors : vErrors.concat(validate121.errors);
                          errors = vErrors.length;
                        }
                        var _valid3 = _errs27 === errors;
                        valid4 = valid4 || _valid3;
                        const _errs28 = errors;
                        if (data6 !== null) {
                          const err9 = { instancePath: instancePath + "/review", schemaPath: "#/properties/review/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err9];
                          } else {
                            vErrors.push(err9);
                          }
                          errors++;
                        }
                        var _valid3 = _errs28 === errors;
                        valid4 = valid4 || _valid3;
                        if (!valid4) {
                          const err10 = { instancePath: instancePath + "/review", schemaPath: "#/properties/review/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                          validate119.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs26;
                          if (vErrors !== null) {
                            if (_errs26) {
                              vErrors.length = _errs26;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs25 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate119.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate119.errors = vErrors;
  return errors === 0;
}
validate119.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate126(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate126.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.settings === void 0 && (missing0 = "settings") || data.bindings === void 0 && (missing0 = "bindings") || data.previous_entry === void 0 && (missing0 = "previous_entry")) {
        validate126.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "bindings" || key0 === "kind" || key0 === "previous_entry" || key0 === "settings")) {
            validate126.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.bindings !== void 0) {
            let data0 = data.bindings;
            const _errs2 = errors;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                let missing1;
                if (data0.content_version === void 0 && (missing1 = "content_version") || data0.corpus_version === void 0 && (missing1 = "corpus_version") || data0.subject === void 0 && (missing1 = "subject")) {
                  validate126.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                  return false;
                } else {
                  const _errs5 = errors;
                  for (const key1 in data0) {
                    if (!(key1 === "content_version" || key1 === "context_outputs" || key1 === "corpus_version" || key1 === "selection" || key1 === "source_version" || key1 === "subject")) {
                      validate126.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                      return false;
                      break;
                    }
                  }
                  if (_errs5 === errors) {
                    if (data0.content_version !== void 0) {
                      const _errs6 = errors;
                      if (typeof data0.content_version !== "string") {
                        validate126.errors = [{ instancePath: instancePath + "/bindings/content_version", schemaPath: "#/$defs/ThreadBindings/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid2 = _errs6 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data0.context_outputs !== void 0) {
                        let data2 = data0.context_outputs;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                          if (Array.isArray(data2)) {
                            var valid3 = true;
                            const len0 = data2.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                              const _errs10 = errors;
                              if (typeof data2[i0] !== "string") {
                                validate126.errors = [{ instancePath: instancePath + "/bindings/context_outputs/" + i0, schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                              if (!valid3) {
                                break;
                              }
                            }
                          } else {
                            validate126.errors = [{ instancePath: instancePath + "/bindings/context_outputs", schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid2 = _errs8 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data0.corpus_version !== void 0) {
                          let data4 = data0.corpus_version;
                          const _errs12 = errors;
                          const _errs13 = errors;
                          let valid4 = false;
                          const _errs14 = errors;
                          if (typeof data4 !== "string") {
                            const err0 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err0];
                            } else {
                              vErrors.push(err0);
                            }
                            errors++;
                          }
                          var _valid0 = _errs14 === errors;
                          valid4 = valid4 || _valid0;
                          const _errs16 = errors;
                          if (data4 !== null) {
                            const err1 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          var _valid0 = _errs16 === errors;
                          valid4 = valid4 || _valid0;
                          if (!valid4) {
                            const err2 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                            validate126.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs13;
                            if (vErrors !== null) {
                              if (_errs13) {
                                vErrors.length = _errs13;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid2 = _errs12 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data0.selection !== void 0) {
                            let data5 = data0.selection;
                            const _errs18 = errors;
                            if (errors === _errs18) {
                              if (Array.isArray(data5)) {
                                if (data5.length > 200) {
                                  validate126.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" }];
                                  return false;
                                } else {
                                  var valid5 = true;
                                  const len1 = data5.length;
                                  for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs20 = errors;
                                    if (typeof data5[i1] !== "string") {
                                      validate126.errors = [{ instancePath: instancePath + "/bindings/selection/" + i1, schemaPath: "#/$defs/ThreadBindings/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid5 = _errs20 === errors;
                                    if (!valid5) {
                                      break;
                                    }
                                  }
                                }
                              } else {
                                validate126.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                return false;
                              }
                            }
                            var valid2 = _errs18 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data0.source_version !== void 0) {
                              let data7 = data0.source_version;
                              const _errs22 = errors;
                              const _errs23 = errors;
                              let valid6 = false;
                              const _errs24 = errors;
                              if (typeof data7 !== "string") {
                                const err3 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                              }
                              var _valid1 = _errs24 === errors;
                              valid6 = valid6 || _valid1;
                              const _errs26 = errors;
                              if (data7 !== null) {
                                const err4 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err4];
                                } else {
                                  vErrors.push(err4);
                                }
                                errors++;
                              }
                              var _valid1 = _errs26 === errors;
                              valid6 = valid6 || _valid1;
                              if (!valid6) {
                                const err5 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err5];
                                } else {
                                  vErrors.push(err5);
                                }
                                errors++;
                                validate126.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs23;
                                if (vErrors !== null) {
                                  if (_errs23) {
                                    vErrors.length = _errs23;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid2 = _errs22 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data0.subject !== void 0) {
                                let data8 = data0.subject;
                                const _errs28 = errors;
                                const _errs29 = errors;
                                let valid7 = false;
                                const _errs30 = errors;
                                if (typeof data8 !== "string") {
                                  const err6 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs30 === errors;
                                valid7 = valid7 || _valid2;
                                const _errs32 = errors;
                                if (data8 !== null) {
                                  const err7 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs32 === errors;
                                valid7 = valid7 || _valid2;
                                if (!valid7) {
                                  const err8 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                  validate126.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs29;
                                  if (vErrors !== null) {
                                    if (_errs29) {
                                      vErrors.length = _errs29;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid2 = _errs28 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate126.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.kind !== void 0) {
              let data9 = data.kind;
              const _errs34 = errors;
              if (typeof data9 !== "string") {
                validate126.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if ("settings_changed" !== data9) {
                validate126.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "settings_changed" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs34 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.previous_entry !== void 0) {
                let data10 = data.previous_entry;
                const _errs36 = errors;
                if (!(typeof data10 == "number" && (!(data10 % 1) && !isNaN(data10)))) {
                  validate126.errors = [{ instancePath: instancePath + "/previous_entry", schemaPath: "#/properties/previous_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                if (errors === _errs36) {
                  if (typeof data10 == "number") {
                    if (data10 < 1 || isNaN(data10)) {
                      validate126.errors = [{ instancePath: instancePath + "/previous_entry", schemaPath: "#/properties/previous_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                      return false;
                    }
                  }
                }
                var valid0 = _errs36 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.settings !== void 0) {
                  const _errs38 = errors;
                  if (!validate27(data.settings, { instancePath: instancePath + "/settings", parentData: data, parentDataProperty: "settings", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs38 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate126.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate126.errors = vErrors;
  return errors === 0;
}
validate126.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema176 = { "additionalProperties": false, "properties": { "after_step": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "type": "string" }, { "type": "null" }], "default": null, "description": "With `from_workflow`: the step of it that settled last, as the switch was made.", "title": "After Step" }, "carried": { "default": [], "description": "With `started`: the outputs made so far that fill inputs of the Workflow started; at\nmost one for each of its step inputs, which the definition limits bound.", "items": { "$ref": "#/$defs/CarriedOutput" }, "title": "Carried", "type": "array" }, "event": { "$ref": "#/$defs/WorkflowEventKind" }, "from_workflow": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "description": "With `started` on a Thread that followed a Workflow: that Workflow, which the Thread\nleaves for `workflow` (F126). Absent on a free Thread, and in older logs, where a\nWorkflow was only ever attached to a free Thread.", "title": "From Workflow" }, "input_values": { "additionalProperties": { "$ref": "#/$defs/JsonValue" }, "description": "With `started`: the values given the Workflow's step inputs, by destination, as a\nstart's `input_values`; each step run of that Workflow takes its own.", "maxProperties": 60, "title": "Input Values", "type": "object" }, "kind": { "const": "workflow_event", "title": "Kind", "type": "string" }, "run_values": { "anyOf": [{ "$ref": "#/$defs/RunValues" }, { "type": "null" }], "default": null, "description": "With `run_to`: the current step's typed values, which its run takes as Run's do (PC-3);\nabsent without them, and in older logs." }, "step_key": { "anyOf": [{ "pattern": "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$", "type": "string" }, { "type": "null" }], "title": "Step Key" }, "supersedes": { "anyOf": [{ "minimum": 1, "type": "integer" }, { "type": "null" }], "default": null, "description": "With `started`: the waiting human step request the switch withdraws (RF-03).", "title": "Supersedes" }, "workflow": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Workflow" } }, "required": ["kind", "event", "step_key", "workflow"], "title": "WorkflowEventPayload", "type": "object" };
var schema178 = { "enum": ["started", "skipped", "left", "resumed", "completed", "run_to"], "title": "WorkflowEventKind", "type": "string" };
function validate130(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate130.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.step_key === void 0 && (missing0 = "step_key") || data.values === void 0 && (missing0 = "values")) {
        validate130.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "step_key" || key0 === "values")) {
            validate130.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.step_key !== void 0) {
            let data0 = data.step_key;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (typeof data0 === "string") {
                if (!pattern14.test(data0)) {
                  validate130.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' }];
                  return false;
                }
              } else {
                validate130.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.values !== void 0) {
              let data1 = data.values;
              const _errs4 = errors;
              if (errors === _errs4) {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  var props0 = {};
                  for (const key1 in data1) {
                    if (pattern8.test(key1)) {
                      props0[key1] = true;
                    }
                  }
                } else {
                  validate130.errors = [{ instancePath: instancePath + "/values", schemaPath: "#/properties/values/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate130.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate130.errors = vErrors;
  return errors === 0;
}
validate130.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate129(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate129.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.event === void 0 && (missing0 = "event") || data.step_key === void 0 && (missing0 = "step_key") || data.workflow === void 0 && (missing0 = "workflow")) {
        validate129.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema176.properties, key0)) {
            validate129.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.after_step !== void 0) {
            let data0 = data.after_step;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (errors === _errs4) {
              if (typeof data0 === "string") {
                if (!pattern14.test(data0)) {
                  const err0 = { instancePath: instancePath + "/after_step", schemaPath: "#/properties/after_step/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
              } else {
                const err1 = { instancePath: instancePath + "/after_step", schemaPath: "#/properties/after_step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err2 = { instancePath: instancePath + "/after_step", schemaPath: "#/properties/after_step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err3 = { instancePath: instancePath + "/after_step", schemaPath: "#/properties/after_step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
              validate129.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.carried !== void 0) {
              let data1 = data.carried;
              const _errs8 = errors;
              if (errors === _errs8) {
                if (Array.isArray(data1)) {
                  var valid2 = true;
                  const len0 = data1.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    const _errs10 = errors;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        let missing1;
                        if (data2.destination === void 0 && (missing1 = "destination") || data2.entry === void 0 && (missing1 = "entry") || data2.part === void 0 && (missing1 = "part")) {
                          validate129.errors = [{ instancePath: instancePath + "/carried/" + i0, schemaPath: "#/$defs/CarriedOutput/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          const _errs13 = errors;
                          for (const key1 in data2) {
                            if (!(key1 === "destination" || key1 === "entry" || key1 === "part")) {
                              validate129.errors = [{ instancePath: instancePath + "/carried/" + i0, schemaPath: "#/$defs/CarriedOutput/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs13 === errors) {
                            if (data2.destination !== void 0) {
                              let data3 = data2.destination;
                              const _errs14 = errors;
                              if (errors === _errs14) {
                                if (typeof data3 === "string") {
                                  if (func2(data3) > 700) {
                                    validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/destination", schemaPath: "#/$defs/CarriedOutput/properties/destination/maxLength", keyword: "maxLength", params: { limit: 700 }, message: "must NOT have more than 700 characters" }];
                                    return false;
                                  } else {
                                    if (func2(data3) < 3) {
                                      validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/destination", schemaPath: "#/$defs/CarriedOutput/properties/destination/minLength", keyword: "minLength", params: { limit: 3 }, message: "must NOT have fewer than 3 characters" }];
                                      return false;
                                    }
                                  }
                                } else {
                                  validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/destination", schemaPath: "#/$defs/CarriedOutput/properties/destination/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                              }
                              var valid4 = _errs14 === errors;
                            } else {
                              var valid4 = true;
                            }
                            if (valid4) {
                              if (data2.entry !== void 0) {
                                let data4 = data2.entry;
                                const _errs16 = errors;
                                if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)))) {
                                  validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/entry", schemaPath: "#/$defs/CarriedOutput/properties/entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                  return false;
                                }
                                if (errors === _errs16) {
                                  if (typeof data4 == "number") {
                                    if (data4 < 1 || isNaN(data4)) {
                                      validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/entry", schemaPath: "#/$defs/CarriedOutput/properties/entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                                      return false;
                                    }
                                  }
                                }
                                var valid4 = _errs16 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data2.part !== void 0) {
                                  let data5 = data2.part;
                                  const _errs18 = errors;
                                  if (errors === _errs18) {
                                    if (typeof data5 === "string") {
                                      if (!pattern8.test(data5)) {
                                        validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/part", schemaPath: "#/$defs/CarriedOutput/properties/part/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                        return false;
                                      }
                                    } else {
                                      validate129.errors = [{ instancePath: instancePath + "/carried/" + i0 + "/part", schemaPath: "#/$defs/CarriedOutput/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                  }
                                  var valid4 = _errs18 === errors;
                                } else {
                                  var valid4 = true;
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate129.errors = [{ instancePath: instancePath + "/carried/" + i0, schemaPath: "#/$defs/CarriedOutput/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid2 = _errs10 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate129.errors = [{ instancePath: instancePath + "/carried", schemaPath: "#/properties/carried/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.event !== void 0) {
                let data6 = data.event;
                const _errs20 = errors;
                if (typeof data6 !== "string") {
                  validate129.errors = [{ instancePath: instancePath + "/event", schemaPath: "#/$defs/WorkflowEventKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data6 === "started" || data6 === "skipped" || data6 === "left" || data6 === "resumed" || data6 === "completed" || data6 === "run_to")) {
                  validate129.errors = [{ instancePath: instancePath + "/event", schemaPath: "#/$defs/WorkflowEventKind/enum", keyword: "enum", params: { allowedValues: schema178.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs20 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.from_workflow !== void 0) {
                  let data7 = data.from_workflow;
                  const _errs23 = errors;
                  const _errs24 = errors;
                  let valid6 = false;
                  const _errs25 = errors;
                  if (typeof data7 !== "string") {
                    const err4 = { instancePath: instancePath + "/from_workflow", schemaPath: "#/properties/from_workflow/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var _valid1 = _errs25 === errors;
                  valid6 = valid6 || _valid1;
                  const _errs27 = errors;
                  if (data7 !== null) {
                    const err5 = { instancePath: instancePath + "/from_workflow", schemaPath: "#/properties/from_workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                  var _valid1 = _errs27 === errors;
                  valid6 = valid6 || _valid1;
                  if (!valid6) {
                    const err6 = { instancePath: instancePath + "/from_workflow", schemaPath: "#/properties/from_workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                    validate129.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs24;
                    if (vErrors !== null) {
                      if (_errs24) {
                        vErrors.length = _errs24;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs23 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.input_values !== void 0) {
                    let data8 = data.input_values;
                    const _errs29 = errors;
                    if (errors === _errs29) {
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        if (Object.keys(data8).length > 60) {
                          validate129.errors = [{ instancePath: instancePath + "/input_values", schemaPath: "#/properties/input_values/maxProperties", keyword: "maxProperties", params: { limit: 60 }, message: "must NOT have more than 60 properties" }];
                          return false;
                        } else {
                          for (const key2 in data8) {
                            const _errs32 = errors;
                            var valid7 = _errs32 === errors;
                            if (!valid7) {
                              break;
                            }
                          }
                        }
                      } else {
                        validate129.errors = [{ instancePath: instancePath + "/input_values", schemaPath: "#/properties/input_values/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs29 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.kind !== void 0) {
                      let data10 = data.kind;
                      const _errs33 = errors;
                      if (typeof data10 !== "string") {
                        validate129.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      if ("workflow_event" !== data10) {
                        validate129.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "workflow_event" }, message: "must be equal to constant" }];
                        return false;
                      }
                      var valid0 = _errs33 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.run_values !== void 0) {
                        let data11 = data.run_values;
                        const _errs35 = errors;
                        const _errs36 = errors;
                        let valid9 = false;
                        const _errs37 = errors;
                        if (!validate130(data11, { instancePath: instancePath + "/run_values", parentData: data, parentDataProperty: "run_values", rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate130.errors : vErrors.concat(validate130.errors);
                          errors = vErrors.length;
                        }
                        var _valid2 = _errs37 === errors;
                        valid9 = valid9 || _valid2;
                        const _errs38 = errors;
                        if (data11 !== null) {
                          const err7 = { instancePath: instancePath + "/run_values", schemaPath: "#/properties/run_values/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err7];
                          } else {
                            vErrors.push(err7);
                          }
                          errors++;
                        }
                        var _valid2 = _errs38 === errors;
                        valid9 = valid9 || _valid2;
                        if (!valid9) {
                          const err8 = { instancePath: instancePath + "/run_values", schemaPath: "#/properties/run_values/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err8];
                          } else {
                            vErrors.push(err8);
                          }
                          errors++;
                          validate129.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs36;
                          if (vErrors !== null) {
                            if (_errs36) {
                              vErrors.length = _errs36;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs35 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.step_key !== void 0) {
                          let data12 = data.step_key;
                          const _errs40 = errors;
                          const _errs41 = errors;
                          let valid10 = false;
                          const _errs42 = errors;
                          if (errors === _errs42) {
                            if (typeof data12 === "string") {
                              if (!pattern14.test(data12)) {
                                const err9 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                                if (vErrors === null) {
                                  vErrors = [err9];
                                } else {
                                  vErrors.push(err9);
                                }
                                errors++;
                              }
                            } else {
                              const err10 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err10];
                              } else {
                                vErrors.push(err10);
                              }
                              errors++;
                            }
                          }
                          var _valid3 = _errs42 === errors;
                          valid10 = valid10 || _valid3;
                          const _errs44 = errors;
                          if (data12 !== null) {
                            const err11 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err11];
                            } else {
                              vErrors.push(err11);
                            }
                            errors++;
                          }
                          var _valid3 = _errs44 === errors;
                          valid10 = valid10 || _valid3;
                          if (!valid10) {
                            const err12 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err12];
                            } else {
                              vErrors.push(err12);
                            }
                            errors++;
                            validate129.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs41;
                            if (vErrors !== null) {
                              if (_errs41) {
                                vErrors.length = _errs41;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs40 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.supersedes !== void 0) {
                            let data13 = data.supersedes;
                            const _errs46 = errors;
                            const _errs47 = errors;
                            let valid11 = false;
                            const _errs48 = errors;
                            if (!(typeof data13 == "number" && (!(data13 % 1) && !isNaN(data13)))) {
                              const err13 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                              if (vErrors === null) {
                                vErrors = [err13];
                              } else {
                                vErrors.push(err13);
                              }
                              errors++;
                            }
                            if (errors === _errs48) {
                              if (typeof data13 == "number") {
                                if (data13 < 1 || isNaN(data13)) {
                                  const err14 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                  if (vErrors === null) {
                                    vErrors = [err14];
                                  } else {
                                    vErrors.push(err14);
                                  }
                                  errors++;
                                }
                              }
                            }
                            var _valid4 = _errs48 === errors;
                            valid11 = valid11 || _valid4;
                            const _errs50 = errors;
                            if (data13 !== null) {
                              const err15 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err15];
                              } else {
                                vErrors.push(err15);
                              }
                              errors++;
                            }
                            var _valid4 = _errs50 === errors;
                            valid11 = valid11 || _valid4;
                            if (!valid11) {
                              const err16 = { instancePath: instancePath + "/supersedes", schemaPath: "#/properties/supersedes/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                              validate129.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs47;
                              if (vErrors !== null) {
                                if (_errs47) {
                                  vErrors.length = _errs47;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs46 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.workflow !== void 0) {
                              let data14 = data.workflow;
                              const _errs52 = errors;
                              const _errs53 = errors;
                              let valid12 = false;
                              const _errs54 = errors;
                              if (typeof data14 !== "string") {
                                const err17 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err17];
                                } else {
                                  vErrors.push(err17);
                                }
                                errors++;
                              }
                              var _valid5 = _errs54 === errors;
                              valid12 = valid12 || _valid5;
                              const _errs56 = errors;
                              if (data14 !== null) {
                                const err18 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                              var _valid5 = _errs56 === errors;
                              valid12 = valid12 || _valid5;
                              if (!valid12) {
                                const err19 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                                validate129.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs53;
                                if (vErrors !== null) {
                                  if (_errs53) {
                                    vErrors.length = _errs53;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs52 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate129.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate129.errors = vErrors;
  return errors === 0;
}
validate129.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema184 = { "enum": ["went_live", "saved", "closed", "reopened"], "title": "HostingChange", "type": "string" };
var schema185 = { "enum": ["attached", "detached", "connector_offline", "connector_returned", "connector_revoked", "hand_off", "closed_by_participant", "reopened_by_host"], "title": "HostingReason", "type": "string" };
function validate133(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate133.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.change === void 0 && (missing0 = "change") || data.connector_id === void 0 && (missing0 = "connector_id") || data.reason === void 0 && (missing0 = "reason")) {
        validate133.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "change" || key0 === "connector_id" || key0 === "kind" || key0 === "reason")) {
            validate133.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.change !== void 0) {
            let data0 = data.change;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate133.errors = [{ instancePath: instancePath + "/change", schemaPath: "#/$defs/HostingChange/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "went_live" || data0 === "saved" || data0 === "closed" || data0 === "reopened")) {
              validate133.errors = [{ instancePath: instancePath + "/change", schemaPath: "#/$defs/HostingChange/enum", keyword: "enum", params: { allowedValues: schema184.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.connector_id !== void 0) {
              let data1 = data.connector_id;
              const _errs5 = errors;
              const _errs6 = errors;
              let valid2 = false;
              const _errs7 = errors;
              if (typeof data1 !== "string") {
                const err0 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs7 === errors;
              valid2 = valid2 || _valid0;
              const _errs9 = errors;
              if (data1 !== null) {
                const err1 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              valid2 = valid2 || _valid0;
              if (!valid2) {
                const err2 = { instancePath: instancePath + "/connector_id", schemaPath: "#/properties/connector_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
                validate133.errors = vErrors;
                return false;
              } else {
                errors = _errs6;
                if (vErrors !== null) {
                  if (_errs6) {
                    vErrors.length = _errs6;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.kind !== void 0) {
                let data2 = data.kind;
                const _errs11 = errors;
                if (typeof data2 !== "string") {
                  validate133.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("hosting_changed" !== data2) {
                  validate133.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "hosting_changed" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs11 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.reason !== void 0) {
                  let data3 = data.reason;
                  const _errs13 = errors;
                  if (typeof data3 !== "string") {
                    validate133.errors = [{ instancePath: instancePath + "/reason", schemaPath: "#/$defs/HostingReason/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data3 === "attached" || data3 === "detached" || data3 === "connector_offline" || data3 === "connector_returned" || data3 === "connector_revoked" || data3 === "hand_off" || data3 === "closed_by_participant" || data3 === "reopened_by_host")) {
                    validate133.errors = [{ instancePath: instancePath + "/reason", schemaPath: "#/$defs/HostingReason/enum", keyword: "enum", params: { allowedValues: schema185.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate133.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate133.errors = vErrors;
  return errors === 0;
}
validate133.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate135(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate135.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.problem === void 0 && (missing0 = "problem") || data.concerns === void 0 && (missing0 = "concerns")) {
        validate135.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "concerns" || key0 === "kind" || key0 === "problem")) {
            validate135.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.concerns !== void 0) {
            let data0 = data.concerns;
            const _errs2 = errors;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                let missing1;
                if (data0.candidate === void 0 && (missing1 = "candidate") || data0.step_key === void 0 && (missing1 = "step_key") || data0.thread_id === void 0 && (missing1 = "thread_id")) {
                  validate135.errors = [{ instancePath: instancePath + "/concerns", schemaPath: "#/$defs/ProblemConcern/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                  return false;
                } else {
                  const _errs5 = errors;
                  for (const key1 in data0) {
                    if (!(key1 === "candidate" || key1 === "step_key" || key1 === "thread_id")) {
                      validate135.errors = [{ instancePath: instancePath + "/concerns", schemaPath: "#/$defs/ProblemConcern/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                      return false;
                      break;
                    }
                  }
                  if (_errs5 === errors) {
                    if (data0.candidate !== void 0) {
                      let data1 = data0.candidate;
                      const _errs6 = errors;
                      const _errs7 = errors;
                      let valid3 = false;
                      const _errs8 = errors;
                      if (typeof data1 !== "string") {
                        const err0 = { instancePath: instancePath + "/concerns/candidate", schemaPath: "#/$defs/ProblemConcern/properties/candidate/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      }
                      var _valid0 = _errs8 === errors;
                      valid3 = valid3 || _valid0;
                      const _errs10 = errors;
                      if (data1 !== null) {
                        const err1 = { instancePath: instancePath + "/concerns/candidate", schemaPath: "#/$defs/ProblemConcern/properties/candidate/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      var _valid0 = _errs10 === errors;
                      valid3 = valid3 || _valid0;
                      if (!valid3) {
                        const err2 = { instancePath: instancePath + "/concerns/candidate", schemaPath: "#/$defs/ProblemConcern/properties/candidate/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                        validate135.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs7;
                        if (vErrors !== null) {
                          if (_errs7) {
                            vErrors.length = _errs7;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid2 = _errs6 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data0.step_key !== void 0) {
                        let data2 = data0.step_key;
                        const _errs12 = errors;
                        const _errs13 = errors;
                        let valid4 = false;
                        const _errs14 = errors;
                        if (errors === _errs14) {
                          if (typeof data2 === "string") {
                            if (!pattern14.test(data2)) {
                              const err3 = { instancePath: instancePath + "/concerns/step_key", schemaPath: "#/$defs/ProblemConcern/properties/step_key/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' };
                              if (vErrors === null) {
                                vErrors = [err3];
                              } else {
                                vErrors.push(err3);
                              }
                              errors++;
                            }
                          } else {
                            const err4 = { instancePath: instancePath + "/concerns/step_key", schemaPath: "#/$defs/ProblemConcern/properties/step_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err4];
                            } else {
                              vErrors.push(err4);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs14 === errors;
                        valid4 = valid4 || _valid1;
                        const _errs16 = errors;
                        if (data2 !== null) {
                          const err5 = { instancePath: instancePath + "/concerns/step_key", schemaPath: "#/$defs/ProblemConcern/properties/step_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                        var _valid1 = _errs16 === errors;
                        valid4 = valid4 || _valid1;
                        if (!valid4) {
                          const err6 = { instancePath: instancePath + "/concerns/step_key", schemaPath: "#/$defs/ProblemConcern/properties/step_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err6];
                          } else {
                            vErrors.push(err6);
                          }
                          errors++;
                          validate135.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs13;
                          if (vErrors !== null) {
                            if (_errs13) {
                              vErrors.length = _errs13;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid2 = _errs12 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data0.thread_id !== void 0) {
                          let data3 = data0.thread_id;
                          const _errs18 = errors;
                          const _errs19 = errors;
                          let valid5 = false;
                          const _errs20 = errors;
                          if (typeof data3 !== "string") {
                            const err7 = { instancePath: instancePath + "/concerns/thread_id", schemaPath: "#/$defs/ProblemConcern/properties/thread_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                          }
                          var _valid2 = _errs20 === errors;
                          valid5 = valid5 || _valid2;
                          const _errs22 = errors;
                          if (data3 !== null) {
                            const err8 = { instancePath: instancePath + "/concerns/thread_id", schemaPath: "#/$defs/ProblemConcern/properties/thread_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err8];
                            } else {
                              vErrors.push(err8);
                            }
                            errors++;
                          }
                          var _valid2 = _errs22 === errors;
                          valid5 = valid5 || _valid2;
                          if (!valid5) {
                            const err9 = { instancePath: instancePath + "/concerns/thread_id", schemaPath: "#/$defs/ProblemConcern/properties/thread_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                            validate135.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs19;
                            if (vErrors !== null) {
                              if (_errs19) {
                                vErrors.length = _errs19;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid2 = _errs18 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  }
                }
              } else {
                validate135.errors = [{ instancePath: instancePath + "/concerns", schemaPath: "#/$defs/ProblemConcern/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.kind !== void 0) {
              let data4 = data.kind;
              const _errs24 = errors;
              if (typeof data4 !== "string") {
                validate135.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if ("problem" !== data4) {
                validate135.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "problem" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs24 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.problem !== void 0) {
                const _errs26 = errors;
                if (!validate84(data.problem, { instancePath: instancePath + "/problem", parentData: data, parentDataProperty: "problem", rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs26 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate135.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate135.errors = vErrors;
  return errors === 0;
}
validate135.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema190 = { "enum": ["send_back", "resubmit", "merge", "scrap", "reopen"], "title": "ChangeSetEvent", "type": "string" };
function validate138(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate138.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.change_set_id === void 0 && (missing0 = "change_set_id") || data.outcome === void 0 && (missing0 = "outcome") || data.by === void 0 && (missing0 = "by") || data.reason === void 0 && (missing0 = "reason")) {
        validate138.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "by" || key0 === "change_set_id" || key0 === "kind" || key0 === "merged_head" || key0 === "outcome" || key0 === "reason")) {
            validate138.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.by !== void 0) {
            const _errs2 = errors;
            if (typeof data.by !== "string") {
              validate138.errors = [{ instancePath: instancePath + "/by", schemaPath: "#/properties/by/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.change_set_id !== void 0) {
              const _errs4 = errors;
              if (typeof data.change_set_id !== "string") {
                validate138.errors = [{ instancePath: instancePath + "/change_set_id", schemaPath: "#/properties/change_set_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.kind !== void 0) {
                let data2 = data.kind;
                const _errs6 = errors;
                if (typeof data2 !== "string") {
                  validate138.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("outcome_notice" !== data2) {
                  validate138.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "outcome_notice" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.merged_head !== void 0) {
                  let data3 = data.merged_head;
                  const _errs8 = errors;
                  const _errs9 = errors;
                  let valid1 = false;
                  const _errs10 = errors;
                  if (typeof data3 !== "string") {
                    const err0 = { instancePath: instancePath + "/merged_head", schemaPath: "#/properties/merged_head/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  }
                  var _valid0 = _errs10 === errors;
                  valid1 = valid1 || _valid0;
                  const _errs12 = errors;
                  if (data3 !== null) {
                    const err1 = { instancePath: instancePath + "/merged_head", schemaPath: "#/properties/merged_head/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err1];
                    } else {
                      vErrors.push(err1);
                    }
                    errors++;
                  }
                  var _valid0 = _errs12 === errors;
                  valid1 = valid1 || _valid0;
                  if (!valid1) {
                    const err2 = { instancePath: instancePath + "/merged_head", schemaPath: "#/properties/merged_head/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                    validate138.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs9;
                    if (vErrors !== null) {
                      if (_errs9) {
                        vErrors.length = _errs9;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.outcome !== void 0) {
                    let data4 = data.outcome;
                    const _errs14 = errors;
                    if (typeof data4 !== "string") {
                      validate138.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/ChangeSetEvent/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    if (!(data4 === "send_back" || data4 === "resubmit" || data4 === "merge" || data4 === "scrap" || data4 === "reopen")) {
                      validate138.errors = [{ instancePath: instancePath + "/outcome", schemaPath: "#/$defs/ChangeSetEvent/enum", keyword: "enum", params: { allowedValues: schema190.enum }, message: "must be equal to one of the allowed values" }];
                      return false;
                    }
                    var valid0 = _errs14 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.reason !== void 0) {
                      const _errs17 = errors;
                      if (typeof data.reason !== "string") {
                        validate138.errors = [{ instancePath: instancePath + "/reason", schemaPath: "#/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate138.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate138.errors = vErrors;
  return errors === 0;
}
validate138.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate25.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  if (!validate26(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
    vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs2 = errors;
  if (!validate30(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
    vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
    const _errs3 = errors;
    if (!validate39(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
      vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs3 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
        if (props0 !== true) {
          props0 = true;
        }
      }
      const _errs4 = errors;
      if (!validate43(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
        vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs4 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
          if (props0 !== true) {
            props0 = true;
          }
        }
        const _errs5 = errors;
        if (!validate68(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
          vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs5 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
            if (props0 !== true) {
              props0 = true;
            }
          }
          const _errs6 = errors;
          if (!validate70(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
            vErrors = vErrors === null ? validate70.errors : vErrors.concat(validate70.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs6 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
              if (props0 !== true) {
                props0 = true;
              }
            }
            const _errs7 = errors;
            if (!validate73(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate73.errors : vErrors.concat(validate73.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs7 === errors;
            if (_valid0 && valid0) {
              valid0 = false;
              passing0 = [passing0, 6];
            } else {
              if (_valid0) {
                valid0 = true;
                passing0 = 6;
                if (props0 !== true) {
                  props0 = true;
                }
              }
              const _errs8 = errors;
              if (!validate93(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate93.errors : vErrors.concat(validate93.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs8 === errors;
              if (_valid0 && valid0) {
                valid0 = false;
                passing0 = [passing0, 7];
              } else {
                if (_valid0) {
                  valid0 = true;
                  passing0 = 7;
                  if (props0 !== true) {
                    props0 = true;
                  }
                }
                const _errs9 = errors;
                if (!validate107(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate107.errors : vErrors.concat(validate107.errors);
                  errors = vErrors.length;
                }
                var _valid0 = _errs9 === errors;
                if (_valid0 && valid0) {
                  valid0 = false;
                  passing0 = [passing0, 8];
                } else {
                  if (_valid0) {
                    valid0 = true;
                    passing0 = 8;
                    if (props0 !== true) {
                      props0 = true;
                    }
                  }
                  const _errs10 = errors;
                  if (!validate114(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate114.errors : vErrors.concat(validate114.errors);
                    errors = vErrors.length;
                  }
                  var _valid0 = _errs10 === errors;
                  if (_valid0 && valid0) {
                    valid0 = false;
                    passing0 = [passing0, 9];
                  } else {
                    if (_valid0) {
                      valid0 = true;
                      passing0 = 9;
                      if (props0 !== true) {
                        props0 = true;
                      }
                    }
                    const _errs11 = errors;
                    if (!validate119(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate119.errors : vErrors.concat(validate119.errors);
                      errors = vErrors.length;
                    }
                    var _valid0 = _errs11 === errors;
                    if (_valid0 && valid0) {
                      valid0 = false;
                      passing0 = [passing0, 10];
                    } else {
                      if (_valid0) {
                        valid0 = true;
                        passing0 = 10;
                        if (props0 !== true) {
                          props0 = true;
                        }
                      }
                      const _errs12 = errors;
                      if (!validate126(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                        vErrors = vErrors === null ? validate126.errors : vErrors.concat(validate126.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs12 === errors;
                      if (_valid0 && valid0) {
                        valid0 = false;
                        passing0 = [passing0, 11];
                      } else {
                        if (_valid0) {
                          valid0 = true;
                          passing0 = 11;
                          if (props0 !== true) {
                            props0 = true;
                          }
                        }
                        const _errs13 = errors;
                        const _errs14 = errors;
                        if (errors === _errs14) {
                          if (data && typeof data == "object" && !Array.isArray(data)) {
                            let missing0;
                            if (data.kind === void 0 && (missing0 = "kind") || data.title === void 0 && (missing0 = "title") || data.previous_entry === void 0 && (missing0 = "previous_entry")) {
                              const err0 = { instancePath, schemaPath: "#/$defs/TitleChangedPayload/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
                              if (vErrors === null) {
                                vErrors = [err0];
                              } else {
                                vErrors.push(err0);
                              }
                              errors++;
                            } else {
                              const _errs16 = errors;
                              for (const key0 in data) {
                                if (!(key0 === "kind" || key0 === "previous_entry" || key0 === "title")) {
                                  const err1 = { instancePath, schemaPath: "#/$defs/TitleChangedPayload/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                                  if (vErrors === null) {
                                    vErrors = [err1];
                                  } else {
                                    vErrors.push(err1);
                                  }
                                  errors++;
                                  break;
                                }
                              }
                              if (_errs16 === errors) {
                                if (data.kind !== void 0) {
                                  let data0 = data.kind;
                                  const _errs17 = errors;
                                  if (typeof data0 !== "string") {
                                    const err2 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/TitleChangedPayload/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err2];
                                    } else {
                                      vErrors.push(err2);
                                    }
                                    errors++;
                                  }
                                  if ("title_changed" !== data0) {
                                    const err3 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/TitleChangedPayload/properties/kind/const", keyword: "const", params: { allowedValue: "title_changed" }, message: "must be equal to constant" };
                                    if (vErrors === null) {
                                      vErrors = [err3];
                                    } else {
                                      vErrors.push(err3);
                                    }
                                    errors++;
                                  }
                                  var valid2 = _errs17 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data.previous_entry !== void 0) {
                                    let data1 = data.previous_entry;
                                    const _errs19 = errors;
                                    if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                                      const err4 = { instancePath: instancePath + "/previous_entry", schemaPath: "#/$defs/TitleChangedPayload/properties/previous_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    }
                                    if (errors === _errs19) {
                                      if (typeof data1 == "number") {
                                        if (data1 < 1 || isNaN(data1)) {
                                          const err5 = { instancePath: instancePath + "/previous_entry", schemaPath: "#/$defs/TitleChangedPayload/properties/previous_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                          if (vErrors === null) {
                                            vErrors = [err5];
                                          } else {
                                            vErrors.push(err5);
                                          }
                                          errors++;
                                        }
                                      }
                                    }
                                    var valid2 = _errs19 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data.title !== void 0) {
                                      let data2 = data.title;
                                      const _errs21 = errors;
                                      if (errors === _errs21) {
                                        if (typeof data2 === "string") {
                                          if (func2(data2) > 200) {
                                            const err6 = { instancePath: instancePath + "/title", schemaPath: "#/$defs/TitleChangedPayload/properties/title/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err6];
                                            } else {
                                              vErrors.push(err6);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data2) < 1) {
                                              const err7 = { instancePath: instancePath + "/title", schemaPath: "#/$defs/TitleChangedPayload/properties/title/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err7];
                                              } else {
                                                vErrors.push(err7);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err8 = { instancePath: instancePath + "/title", schemaPath: "#/$defs/TitleChangedPayload/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err8];
                                          } else {
                                            vErrors.push(err8);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid2 = _errs21 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            const err9 = { instancePath, schemaPath: "#/$defs/TitleChangedPayload/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                          }
                        }
                        var _valid0 = _errs13 === errors;
                        if (_valid0 && valid0) {
                          valid0 = false;
                          passing0 = [passing0, 12];
                        } else {
                          if (_valid0) {
                            valid0 = true;
                            passing0 = 12;
                            if (props0 !== true) {
                              props0 = true;
                            }
                          }
                          const _errs23 = errors;
                          if (!validate129(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate129.errors : vErrors.concat(validate129.errors);
                            errors = vErrors.length;
                          }
                          var _valid0 = _errs23 === errors;
                          if (_valid0 && valid0) {
                            valid0 = false;
                            passing0 = [passing0, 13];
                          } else {
                            if (_valid0) {
                              valid0 = true;
                              passing0 = 13;
                              if (props0 !== true) {
                                props0 = true;
                              }
                            }
                            const _errs24 = errors;
                            const _errs25 = errors;
                            if (errors === _errs25) {
                              if (data && typeof data == "object" && !Array.isArray(data)) {
                                let missing1;
                                if (data.kind === void 0 && (missing1 = "kind") || data.from_user === void 0 && (missing1 = "from_user") || data.to_user === void 0 && (missing1 = "to_user") || data.connector_id === void 0 && (missing1 = "connector_id") || data.offer_id === void 0 && (missing1 = "offer_id")) {
                                  const err10 = { instancePath, schemaPath: "#/$defs/HostChangedPayload/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                                  if (vErrors === null) {
                                    vErrors = [err10];
                                  } else {
                                    vErrors.push(err10);
                                  }
                                  errors++;
                                } else {
                                  const _errs27 = errors;
                                  for (const key1 in data) {
                                    if (!(key1 === "connector_id" || key1 === "from_user" || key1 === "kind" || key1 === "offer_id" || key1 === "to_user")) {
                                      const err11 = { instancePath, schemaPath: "#/$defs/HostChangedPayload/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                                      if (vErrors === null) {
                                        vErrors = [err11];
                                      } else {
                                        vErrors.push(err11);
                                      }
                                      errors++;
                                      break;
                                    }
                                  }
                                  if (_errs27 === errors) {
                                    if (data.connector_id !== void 0) {
                                      const _errs28 = errors;
                                      if (typeof data.connector_id !== "string") {
                                        const err12 = { instancePath: instancePath + "/connector_id", schemaPath: "#/$defs/HostChangedPayload/properties/connector_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err12];
                                        } else {
                                          vErrors.push(err12);
                                        }
                                        errors++;
                                      }
                                      var valid4 = _errs28 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                    if (valid4) {
                                      if (data.from_user !== void 0) {
                                        const _errs30 = errors;
                                        if (typeof data.from_user !== "string") {
                                          const err13 = { instancePath: instancePath + "/from_user", schemaPath: "#/$defs/HostChangedPayload/properties/from_user/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err13];
                                          } else {
                                            vErrors.push(err13);
                                          }
                                          errors++;
                                        }
                                        var valid4 = _errs30 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                      if (valid4) {
                                        if (data.kind !== void 0) {
                                          let data5 = data.kind;
                                          const _errs32 = errors;
                                          if (typeof data5 !== "string") {
                                            const err14 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/HostChangedPayload/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                              vErrors = [err14];
                                            } else {
                                              vErrors.push(err14);
                                            }
                                            errors++;
                                          }
                                          if ("host_changed" !== data5) {
                                            const err15 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/HostChangedPayload/properties/kind/const", keyword: "const", params: { allowedValue: "host_changed" }, message: "must be equal to constant" };
                                            if (vErrors === null) {
                                              vErrors = [err15];
                                            } else {
                                              vErrors.push(err15);
                                            }
                                            errors++;
                                          }
                                          var valid4 = _errs32 === errors;
                                        } else {
                                          var valid4 = true;
                                        }
                                        if (valid4) {
                                          if (data.offer_id !== void 0) {
                                            const _errs34 = errors;
                                            if (typeof data.offer_id !== "string") {
                                              const err16 = { instancePath: instancePath + "/offer_id", schemaPath: "#/$defs/HostChangedPayload/properties/offer_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                              if (vErrors === null) {
                                                vErrors = [err16];
                                              } else {
                                                vErrors.push(err16);
                                              }
                                              errors++;
                                            }
                                            var valid4 = _errs34 === errors;
                                          } else {
                                            var valid4 = true;
                                          }
                                          if (valid4) {
                                            if (data.to_user !== void 0) {
                                              const _errs36 = errors;
                                              if (typeof data.to_user !== "string") {
                                                const err17 = { instancePath: instancePath + "/to_user", schemaPath: "#/$defs/HostChangedPayload/properties/to_user/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err17];
                                                } else {
                                                  vErrors.push(err17);
                                                }
                                                errors++;
                                              }
                                              var valid4 = _errs36 === errors;
                                            } else {
                                              var valid4 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                const err18 = { instancePath, schemaPath: "#/$defs/HostChangedPayload/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                            }
                            var _valid0 = _errs24 === errors;
                            if (_valid0 && valid0) {
                              valid0 = false;
                              passing0 = [passing0, 14];
                            } else {
                              if (_valid0) {
                                valid0 = true;
                                passing0 = 14;
                                if (props0 !== true) {
                                  props0 = true;
                                }
                              }
                              const _errs38 = errors;
                              if (!validate133(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                                vErrors = vErrors === null ? validate133.errors : vErrors.concat(validate133.errors);
                                errors = vErrors.length;
                              }
                              var _valid0 = _errs38 === errors;
                              if (_valid0 && valid0) {
                                valid0 = false;
                                passing0 = [passing0, 15];
                              } else {
                                if (_valid0) {
                                  valid0 = true;
                                  passing0 = 15;
                                  if (props0 !== true) {
                                    props0 = true;
                                  }
                                }
                                const _errs39 = errors;
                                const _errs40 = errors;
                                if (errors === _errs40) {
                                  if (data && typeof data == "object" && !Array.isArray(data)) {
                                    let missing2;
                                    if (data.kind === void 0 && (missing2 = "kind") || data.to_user === void 0 && (missing2 = "to_user") || data.at_entry === void 0 && (missing2 = "at_entry")) {
                                      const err19 = { instancePath, schemaPath: "#/$defs/ForkOfferedPayload/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                                      if (vErrors === null) {
                                        vErrors = [err19];
                                      } else {
                                        vErrors.push(err19);
                                      }
                                      errors++;
                                    } else {
                                      const _errs42 = errors;
                                      for (const key2 in data) {
                                        if (!(key2 === "at_entry" || key2 === "kind" || key2 === "to_user")) {
                                          const err20 = { instancePath, schemaPath: "#/$defs/ForkOfferedPayload/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                          if (vErrors === null) {
                                            vErrors = [err20];
                                          } else {
                                            vErrors.push(err20);
                                          }
                                          errors++;
                                          break;
                                        }
                                      }
                                      if (_errs42 === errors) {
                                        if (data.at_entry !== void 0) {
                                          let data8 = data.at_entry;
                                          const _errs43 = errors;
                                          if (!(typeof data8 == "number" && (!(data8 % 1) && !isNaN(data8)))) {
                                            const err21 = { instancePath: instancePath + "/at_entry", schemaPath: "#/$defs/ForkOfferedPayload/properties/at_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                            if (vErrors === null) {
                                              vErrors = [err21];
                                            } else {
                                              vErrors.push(err21);
                                            }
                                            errors++;
                                          }
                                          if (errors === _errs43) {
                                            if (typeof data8 == "number") {
                                              if (data8 < 1 || isNaN(data8)) {
                                                const err22 = { instancePath: instancePath + "/at_entry", schemaPath: "#/$defs/ForkOfferedPayload/properties/at_entry/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                                if (vErrors === null) {
                                                  vErrors = [err22];
                                                } else {
                                                  vErrors.push(err22);
                                                }
                                                errors++;
                                              }
                                            }
                                          }
                                          var valid6 = _errs43 === errors;
                                        } else {
                                          var valid6 = true;
                                        }
                                        if (valid6) {
                                          if (data.kind !== void 0) {
                                            let data9 = data.kind;
                                            const _errs45 = errors;
                                            if (typeof data9 !== "string") {
                                              const err23 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ForkOfferedPayload/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                              if (vErrors === null) {
                                                vErrors = [err23];
                                              } else {
                                                vErrors.push(err23);
                                              }
                                              errors++;
                                            }
                                            if ("fork_offered" !== data9) {
                                              const err24 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ForkOfferedPayload/properties/kind/const", keyword: "const", params: { allowedValue: "fork_offered" }, message: "must be equal to constant" };
                                              if (vErrors === null) {
                                                vErrors = [err24];
                                              } else {
                                                vErrors.push(err24);
                                              }
                                              errors++;
                                            }
                                            var valid6 = _errs45 === errors;
                                          } else {
                                            var valid6 = true;
                                          }
                                          if (valid6) {
                                            if (data.to_user !== void 0) {
                                              const _errs47 = errors;
                                              if (typeof data.to_user !== "string") {
                                                const err25 = { instancePath: instancePath + "/to_user", schemaPath: "#/$defs/ForkOfferedPayload/properties/to_user/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err25];
                                                } else {
                                                  vErrors.push(err25);
                                                }
                                                errors++;
                                              }
                                              var valid6 = _errs47 === errors;
                                            } else {
                                              var valid6 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    const err26 = { instancePath, schemaPath: "#/$defs/ForkOfferedPayload/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                      vErrors = [err26];
                                    } else {
                                      vErrors.push(err26);
                                    }
                                    errors++;
                                  }
                                }
                                var _valid0 = _errs39 === errors;
                                if (_valid0 && valid0) {
                                  valid0 = false;
                                  passing0 = [passing0, 16];
                                } else {
                                  if (_valid0) {
                                    valid0 = true;
                                    passing0 = 16;
                                    if (props0 !== true) {
                                      props0 = true;
                                    }
                                  }
                                  const _errs49 = errors;
                                  if (!validate135(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                                    vErrors = vErrors === null ? validate135.errors : vErrors.concat(validate135.errors);
                                    errors = vErrors.length;
                                  }
                                  var _valid0 = _errs49 === errors;
                                  if (_valid0 && valid0) {
                                    valid0 = false;
                                    passing0 = [passing0, 17];
                                  } else {
                                    if (_valid0) {
                                      valid0 = true;
                                      passing0 = 17;
                                      if (props0 !== true) {
                                        props0 = true;
                                      }
                                    }
                                    const _errs50 = errors;
                                    if (!validate138(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                                      vErrors = vErrors === null ? validate138.errors : vErrors.concat(validate138.errors);
                                      errors = vErrors.length;
                                    }
                                    var _valid0 = _errs50 === errors;
                                    if (_valid0 && valid0) {
                                      valid0 = false;
                                      passing0 = [passing0, 18];
                                    } else {
                                      if (_valid0) {
                                        valid0 = true;
                                        passing0 = 18;
                                        if (props0 !== true) {
                                          props0 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err27 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err27];
    } else {
      vErrors.push(err27);
    }
    errors++;
    validate25.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate25.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate25.evaluated = { "dynamicProps": true, "dynamicItems": false };
function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate22.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.thread_id === void 0 && (missing0 = "thread_id") || data.number === void 0 && (missing0 = "number") || data.at === void 0 && (missing0 = "at") || data.author === void 0 && (missing0 = "author") || data.payload === void 0 && (missing0 = "payload")) {
        validate22.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "at" || key0 === "author" || key0 === "number" || key0 === "payload" || key0 === "thread_id")) {
            validate22.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.at !== void 0) {
            let data0 = data.at;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (errors === _errs2) {
                if (typeof data0 === "string") {
                  if (!formats0.validate(data0)) {
                    validate22.errors = [{ instancePath: instancePath + "/at", schemaPath: "#/properties/at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                    return false;
                  }
                } else {
                  validate22.errors = [{ instancePath: instancePath + "/at", schemaPath: "#/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.author !== void 0) {
              const _errs4 = errors;
              if (!validate23(data.author, { instancePath: instancePath + "/author", parentData: data, parentDataProperty: "author", rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.number !== void 0) {
                let data2 = data.number;
                const _errs5 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  validate22.errors = [{ instancePath: instancePath + "/number", schemaPath: "#/properties/number/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                if (errors === _errs5) {
                  if (typeof data2 == "number") {
                    if (data2 < 1 || isNaN(data2)) {
                      validate22.errors = [{ instancePath: instancePath + "/number", schemaPath: "#/properties/number/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                      return false;
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.payload !== void 0) {
                  const _errs7 = errors;
                  if (!validate25(data.payload, { instancePath: instancePath + "/payload", parentData: data, parentDataProperty: "payload", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.thread_id !== void 0) {
                    const _errs8 = errors;
                    if (typeof data.thread_id !== "string") {
                      validate22.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs8 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate22.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate22.errors = vErrors;
  return errors === 0;
}
validate22.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate21.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.thread_id === void 0 && (missing0 = "thread_id") || data.entries === void 0 && (missing0 = "entries")) {
        validate21.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "entries" || key0 === "thread_id" || key0 === "type")) {
            validate21.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.entries !== void 0) {
            let data0 = data.entries;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs4 = errors;
                  if (!validate22(data0[i0], { instancePath: instancePath + "/entries/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate21.errors = [{ instancePath: instancePath + "/entries", schemaPath: "#/properties/entries/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.thread_id !== void 0) {
              const _errs5 = errors;
              if (typeof data.thread_id !== "string") {
                validate21.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.type !== void 0) {
                let data3 = data.type;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate21.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("entries" !== data3) {
                  validate21.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "entries" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate21.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate21.errors = vErrors;
  return errors === 0;
}
validate21.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema193 = { "additionalProperties": false, "description": "What a Thread's overview and its live state both say of it now. The newer of the two\nby `projection.revision` is current, so nothing is read again for an entry.", "properties": { "attached_connector": { "anyOf": [{ "type": "string" }, { "type": "null" }], "title": "Attached Connector" }, "bindings": { "$ref": "#/$defs/ThreadBindings" }, "connector_online": { "title": "Connector Online", "type": "boolean" }, "departures": { "description": "Each switch away from a Workflow, in order (F126).", "items": { "$ref": "#/$defs/Departure" }, "title": "Departures", "type": "array" }, "detail": { "$ref": "#/$defs/ThreadDetail" }, "host": { "title": "Host", "type": "string" }, "kept_input_changes": { "description": "Steps kept at the fork that read an item with a newer version now, until they run\nagain: a quiet note on the kept result.", "items": { "$ref": "#/$defs/KeptInputChange" }, "title": "Kept Input Changes", "type": "array" }, "latest_outcome": { "anyOf": [{ "$ref": "#/$defs/OutcomeNoticePayload" }, { "type": "null" }], "default": null, "description": "What became of the latest change set the Thread proposed or reviews (ADR-0026-D4)." }, "projection": { "$ref": "#/$defs/ThreadProjection" }, "route_unavailable_because": { "anyOf": [{ "$ref": "#/$defs/RouteUnavailability" }, { "type": "null" }], "description": "Why the attached connector can't run the Thread's replies now, by its latest report,\nas preparation and dispatch decide it (CP-11, Q-93); `None` when it can, or when no\nconnector is attached or no route is chosen." }, "serves_participants": { "description": "The attached connector also runs other participants' turns (a server host,\nADR-0023); a PC's runs only its host's (R2).", "title": "Serves Participants", "type": "boolean" }, "settings": { "$ref": "#/$defs/ThreadSettings" }, "state": { "$ref": "#/$defs/ThreadState" }, "title": { "title": "Title", "type": "string" }, "waiting_for_sender": { "description": "Messages, by entry number, that wait until their sender holds the Thread (T-6, R2).", "items": { "type": "integer" }, "title": "Waiting For Sender", "type": "array" } }, "required": ["state", "host", "attached_connector", "connector_online", "route_unavailable_because", "title", "settings", "bindings", "serves_participants", "projection", "detail"], "title": "ThreadFacts", "type": "object" };
var schema240 = { "description": "Why a connector can't run a route now (CP-11): the one answer route options, dispatch,\nthe connector listing, setup, the provider cards and a Thread's facts give.", "enum": ["not_installed", "not_logged_in", "failed", "no_key", "blocked", "model_unavailable"], "title": "RouteUnavailability", "type": "string" };
var schema241 = { "enum": ["saved", "live", "closed"], "title": "ThreadState", "type": "string" };
var schema198 = { "description": "What one Workflow step shows: its progress (T-7), split where a person sees a\ndifference that progress alone does not name.", "enum": ["upcoming", "ready", "needs_input", "input", "approval", "offline", "slot", "queued", "running", "done", "failed", "skipped"], "title": "StepDisplayState", "type": "string" };
function validate146(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate146.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.group_key === void 0 && (missing0 = "group_key") || data.display_state === void 0 && (missing0 = "display_state") || data.settled_steps === void 0 && (missing0 = "settled_steps") || data.steps === void 0 && (missing0 = "steps")) {
        validate146.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "display_state" || key0 === "group_key" || key0 === "settled_steps" || key0 === "steps")) {
            validate146.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.display_state !== void 0) {
            let data0 = data.display_state;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate146.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "upcoming" || data0 === "ready" || data0 === "needs_input" || data0 === "input" || data0 === "approval" || data0 === "offline" || data0 === "slot" || data0 === "queued" || data0 === "running" || data0 === "done" || data0 === "failed" || data0 === "skipped")) {
              validate146.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/enum", keyword: "enum", params: { allowedValues: schema198.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.group_key !== void 0) {
              const _errs5 = errors;
              if (typeof data.group_key !== "string") {
                validate146.errors = [{ instancePath: instancePath + "/group_key", schemaPath: "#/properties/group_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.settled_steps !== void 0) {
                let data2 = data.settled_steps;
                const _errs7 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  validate146.errors = [{ instancePath: instancePath + "/settled_steps", schemaPath: "#/properties/settled_steps/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.steps !== void 0) {
                  let data3 = data.steps;
                  const _errs9 = errors;
                  if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                    validate146.errors = [{ instancePath: instancePath + "/steps", schemaPath: "#/properties/steps/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate146.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate146.errors = vErrors;
  return errors === 0;
}
validate146.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate148(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate148.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.turn_id === void 0 && (missing0 = "turn_id") || data.request_entry === void 0 && (missing0 = "request_entry") || data.display_state === void 0 && (missing0 = "display_state")) {
        validate148.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "display_state" || key0 === "request_entry" || key0 === "turn_id")) {
            validate148.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.display_state !== void 0) {
            let data0 = data.display_state;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate148.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "upcoming" || data0 === "ready" || data0 === "needs_input" || data0 === "input" || data0 === "approval" || data0 === "offline" || data0 === "slot" || data0 === "queued" || data0 === "running" || data0 === "done" || data0 === "failed" || data0 === "skipped")) {
              validate148.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/enum", keyword: "enum", params: { allowedValues: schema198.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.request_entry !== void 0) {
              let data1 = data.request_entry;
              const _errs5 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                validate148.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.turn_id !== void 0) {
                const _errs7 = errors;
                if (typeof data.turn_id !== "string") {
                  validate148.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate148.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate148.errors = vErrors;
  return errors === 0;
}
validate148.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema203 = { "description": `What runs a turn: the host's agent, or a pinned tool on the host's PC or the server
(processes.md P-1). A tool turn has no agent, so nobody says "Agent working" for it.`, "enum": ["agent", "tool"], "title": "TurnExecutor", "type": "string" };
var schema204 = { "enum": ["queued", "dispatched", "running", "cancelling", "completed", "failed", "cancelled"], "title": "TurnState", "type": "string" };
function validate150(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate150.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.turn_id === void 0 && (missing0 = "turn_id") || data.turn_kind === void 0 && (missing0 = "turn_kind") || data.executor === void 0 && (missing0 = "executor") || data.step_key === void 0 && (missing0 = "step_key") || data.request_entry === void 0 && (missing0 = "request_entry") || data.requested_at === void 0 && (missing0 = "requested_at") || data.state === void 0 && (missing0 = "state") || data.display_state === void 0 && (missing0 = "display_state")) {
        validate150.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "display_state" || key0 === "executor" || key0 === "request_entry" || key0 === "requested_at" || key0 === "state" || key0 === "step_key" || key0 === "turn_id" || key0 === "turn_kind")) {
            validate150.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.display_state !== void 0) {
            let data0 = data.display_state;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate150.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "upcoming" || data0 === "ready" || data0 === "needs_input" || data0 === "input" || data0 === "approval" || data0 === "offline" || data0 === "slot" || data0 === "queued" || data0 === "running" || data0 === "done" || data0 === "failed" || data0 === "skipped")) {
              validate150.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/enum", keyword: "enum", params: { allowedValues: schema198.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.executor !== void 0) {
              let data1 = data.executor;
              const _errs5 = errors;
              if (typeof data1 !== "string") {
                validate150.errors = [{ instancePath: instancePath + "/executor", schemaPath: "#/$defs/TurnExecutor/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "agent" || data1 === "tool")) {
                validate150.errors = [{ instancePath: instancePath + "/executor", schemaPath: "#/$defs/TurnExecutor/enum", keyword: "enum", params: { allowedValues: schema203.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.request_entry !== void 0) {
                let data2 = data.request_entry;
                const _errs8 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  validate150.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.requested_at !== void 0) {
                  let data3 = data.requested_at;
                  const _errs10 = errors;
                  if (errors === _errs10) {
                    if (errors === _errs10) {
                      if (typeof data3 === "string") {
                        if (!formats0.validate(data3)) {
                          validate150.errors = [{ instancePath: instancePath + "/requested_at", schemaPath: "#/properties/requested_at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                          return false;
                        }
                      } else {
                        validate150.errors = [{ instancePath: instancePath + "/requested_at", schemaPath: "#/properties/requested_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                    }
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.state !== void 0) {
                    let data4 = data.state;
                    const _errs12 = errors;
                    const _errs13 = errors;
                    let valid3 = false;
                    const _errs14 = errors;
                    if (typeof data4 !== "string") {
                      const err0 = { instancePath: instancePath + "/state", schemaPath: "#/$defs/TurnState/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err0];
                      } else {
                        vErrors.push(err0);
                      }
                      errors++;
                    }
                    if (!(data4 === "queued" || data4 === "dispatched" || data4 === "running" || data4 === "cancelling" || data4 === "completed" || data4 === "failed" || data4 === "cancelled")) {
                      const err1 = { instancePath: instancePath + "/state", schemaPath: "#/$defs/TurnState/enum", keyword: "enum", params: { allowedValues: schema204.enum }, message: "must be equal to one of the allowed values" };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                    var _valid0 = _errs14 === errors;
                    valid3 = valid3 || _valid0;
                    const _errs17 = errors;
                    if (data4 !== null) {
                      const err2 = { instancePath: instancePath + "/state", schemaPath: "#/properties/state/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err2];
                      } else {
                        vErrors.push(err2);
                      }
                      errors++;
                    }
                    var _valid0 = _errs17 === errors;
                    valid3 = valid3 || _valid0;
                    if (!valid3) {
                      const err3 = { instancePath: instancePath + "/state", schemaPath: "#/properties/state/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err3];
                      } else {
                        vErrors.push(err3);
                      }
                      errors++;
                      validate150.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs13;
                      if (vErrors !== null) {
                        if (_errs13) {
                          vErrors.length = _errs13;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.step_key !== void 0) {
                      let data5 = data.step_key;
                      const _errs19 = errors;
                      const _errs20 = errors;
                      let valid5 = false;
                      const _errs21 = errors;
                      if (typeof data5 !== "string") {
                        const err4 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                      }
                      var _valid1 = _errs21 === errors;
                      valid5 = valid5 || _valid1;
                      const _errs23 = errors;
                      if (data5 !== null) {
                        const err5 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err5];
                        } else {
                          vErrors.push(err5);
                        }
                        errors++;
                      }
                      var _valid1 = _errs23 === errors;
                      valid5 = valid5 || _valid1;
                      if (!valid5) {
                        const err6 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                        validate150.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs20;
                        if (vErrors !== null) {
                          if (_errs20) {
                            vErrors.length = _errs20;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs19 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.turn_id !== void 0) {
                        const _errs25 = errors;
                        if (typeof data.turn_id !== "string") {
                          validate150.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid0 = _errs25 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.turn_kind !== void 0) {
                          let data7 = data.turn_kind;
                          const _errs27 = errors;
                          if (typeof data7 !== "string") {
                            validate150.errors = [{ instancePath: instancePath + "/turn_kind", schemaPath: "#/$defs/TurnKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          if (!(data7 === "reply" || data7 === "step")) {
                            validate150.errors = [{ instancePath: instancePath + "/turn_kind", schemaPath: "#/$defs/TurnKind/enum", keyword: "enum", params: { allowedValues: schema96.enum }, message: "must be equal to one of the allowed values" }];
                            return false;
                          }
                          var valid0 = _errs27 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate150.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate150.errors = vErrors;
  return errors === 0;
}
validate150.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema213 = { "enum": ["not_due", "due", "in_progress", "done", "failed", "skipped"], "title": "StepProgressState", "type": "string" };
function validate154(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate154.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.kind === void 0 && (missing0 = "kind") || data.entry === void 0 && (missing0 = "entry")) {
        validate154.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "count" || key0 === "entry" || key0 === "kind" || key0 === "name" || key0 === "text")) {
            validate154.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.count !== void 0) {
            let data0 = data.count;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              const err0 = { instancePath: instancePath + "/count", schemaPath: "#/properties/count/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/count", schemaPath: "#/properties/count/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/count", schemaPath: "#/properties/count/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate154.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.entry !== void 0) {
              let data1 = data.entry;
              const _errs8 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                validate154.errors = [{ instancePath: instancePath + "/entry", schemaPath: "#/properties/entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.kind !== void 0) {
                let data2 = data.kind;
                const _errs10 = errors;
                if (typeof data2 !== "string") {
                  validate154.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/ValueKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data2 === "text" || data2 === "choice" || data2 === "annotations" || data2 === "instance_data" || data2 === "change_set" || data2 === "text_units" || data2 === "item" || data2 === "item_refs" || data2 === "term_cards" || data2 === "check_report" || data2 === "derived" || data2 === "workspace_file" || data2 === "corpus_import" || data2 === "source_version" || data2 === "release_request" || data2 === "release" || data2 === "html_page" || data2 === "derived_records" || data2 === "memory" || data2 === "result")) {
                  validate154.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/ValueKind/enum", keyword: "enum", params: { allowedValues: schema94.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== void 0) {
                  const _errs13 = errors;
                  if (typeof data.name !== "string") {
                    validate154.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.text !== void 0) {
                    let data4 = data.text;
                    const _errs15 = errors;
                    const _errs16 = errors;
                    let valid3 = false;
                    const _errs17 = errors;
                    if (typeof data4 !== "string") {
                      const err3 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err3];
                      } else {
                        vErrors.push(err3);
                      }
                      errors++;
                    }
                    var _valid1 = _errs17 === errors;
                    valid3 = valid3 || _valid1;
                    const _errs19 = errors;
                    if (data4 !== null) {
                      const err4 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid1 = _errs19 === errors;
                    valid3 = valid3 || _valid1;
                    if (!valid3) {
                      const err5 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                      validate154.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs16;
                      if (vErrors !== null) {
                        if (_errs16) {
                          vErrors.length = _errs16;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs15 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate154.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate154.errors = vErrors;
  return errors === 0;
}
validate154.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate156(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate156.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.turn_id === void 0 && (missing0 = "turn_id") || data.request_entry === void 0 && (missing0 = "request_entry") || data.tool === void 0 && (missing0 = "tool") || data.tool_name === void 0 && (missing0 = "tool_name") || data.display_state === void 0 && (missing0 = "display_state")) {
        validate156.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "display_state" || key0 === "finished_entry" || key0 === "left_open" || key0 === "request_entry" || key0 === "tool" || key0 === "tool_name" || key0 === "turn_id")) {
            validate156.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.display_state !== void 0) {
            let data0 = data.display_state;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            if (!(data0 === "upcoming" || data0 === "ready" || data0 === "needs_input" || data0 === "input" || data0 === "approval" || data0 === "offline" || data0 === "slot" || data0 === "queued" || data0 === "running" || data0 === "done" || data0 === "failed" || data0 === "skipped")) {
              const err1 = { instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/enum", keyword: "enum", params: { allowedValues: schema198.enum }, message: "must be equal to one of the allowed values" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs7 = errors;
            if (data0 !== null) {
              const err2 = { instancePath: instancePath + "/display_state", schemaPath: "#/properties/display_state/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var _valid0 = _errs7 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err3 = { instancePath: instancePath + "/display_state", schemaPath: "#/properties/display_state/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
              validate156.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.finished_entry !== void 0) {
              let data1 = data.finished_entry;
              const _errs9 = errors;
              const _errs10 = errors;
              let valid3 = false;
              const _errs11 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                const err4 = { instancePath: instancePath + "/finished_entry", schemaPath: "#/properties/finished_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var _valid1 = _errs11 === errors;
              valid3 = valid3 || _valid1;
              const _errs13 = errors;
              if (data1 !== null) {
                const err5 = { instancePath: instancePath + "/finished_entry", schemaPath: "#/properties/finished_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
              var _valid1 = _errs13 === errors;
              valid3 = valid3 || _valid1;
              if (!valid3) {
                const err6 = { instancePath: instancePath + "/finished_entry", schemaPath: "#/properties/finished_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
                validate156.errors = vErrors;
                return false;
              } else {
                errors = _errs10;
                if (vErrors !== null) {
                  if (_errs10) {
                    vErrors.length = _errs10;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs9 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.left_open !== void 0) {
                const _errs15 = errors;
                if (typeof data.left_open !== "boolean") {
                  validate156.errors = [{ instancePath: instancePath + "/left_open", schemaPath: "#/properties/left_open/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs15 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.request_entry !== void 0) {
                  let data3 = data.request_entry;
                  const _errs17 = errors;
                  if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                    validate156.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                    return false;
                  }
                  var valid0 = _errs17 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.tool !== void 0) {
                    const _errs19 = errors;
                    if (typeof data.tool !== "string") {
                      validate156.errors = [{ instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs19 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.tool_name !== void 0) {
                      const _errs21 = errors;
                      if (typeof data.tool_name !== "string") {
                        validate156.errors = [{ instancePath: instancePath + "/tool_name", schemaPath: "#/properties/tool_name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs21 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.turn_id !== void 0) {
                        const _errs23 = errors;
                        if (typeof data.turn_id !== "string") {
                          validate156.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid0 = _errs23 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate156.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate156.errors = vErrors;
  return errors === 0;
}
validate156.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate153(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate153.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.request_entry === void 0 && (missing0 = "request_entry")) {
        validate153.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "outputs" || key0 === "outputs_omitted" || key0 === "request_entry" || key0 === "tool_runs" || key0 === "tool_runs_omitted")) {
            validate153.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.outputs !== void 0) {
            let data0 = data.outputs;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs4 = errors;
                  if (!validate154(data0[i0], { instancePath: instancePath + "/outputs/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate153.errors = [{ instancePath: instancePath + "/outputs", schemaPath: "#/properties/outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.outputs_omitted !== void 0) {
              let data2 = data.outputs_omitted;
              const _errs5 = errors;
              if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                validate153.errors = [{ instancePath: instancePath + "/outputs_omitted", schemaPath: "#/properties/outputs_omitted/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.request_entry !== void 0) {
                let data3 = data.request_entry;
                const _errs7 = errors;
                if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                  validate153.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.tool_runs !== void 0) {
                  let data4 = data.tool_runs;
                  const _errs9 = errors;
                  if (errors === _errs9) {
                    if (Array.isArray(data4)) {
                      var valid2 = true;
                      const len1 = data4.length;
                      for (let i1 = 0; i1 < len1; i1++) {
                        const _errs11 = errors;
                        if (!validate156(data4[i1], { instancePath: instancePath + "/tool_runs/" + i1, parentData: data4, parentDataProperty: i1, rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate156.errors : vErrors.concat(validate156.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs11 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    } else {
                      validate153.errors = [{ instancePath: instancePath + "/tool_runs", schemaPath: "#/properties/tool_runs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.tool_runs_omitted !== void 0) {
                    let data6 = data.tool_runs_omitted;
                    const _errs12 = errors;
                    if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                      validate153.errors = [{ instancePath: instancePath + "/tool_runs_omitted", schemaPath: "#/properties/tool_runs_omitted/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate153.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate153.errors = vErrors;
  return errors === 0;
}
validate153.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate152(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate152.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.step_key === void 0 && (missing0 = "step_key") || data.progress === void 0 && (missing0 = "progress") || data.display_state === void 0 && (missing0 = "display_state")) {
        validate152.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "attempt" || key0 === "display_state" || key0 === "missing_inputs" || key0 === "progress" || key0 === "step_key")) {
            validate152.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.attempt !== void 0) {
            let data0 = data.attempt;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!validate153(data0, { instancePath: instancePath + "/attempt", parentData: data, parentDataProperty: "attempt", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate153.errors : vErrors.concat(validate153.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs5 = errors;
            if (data0 !== null) {
              const err0 = { instancePath: instancePath + "/attempt", schemaPath: "#/properties/attempt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err1 = { instancePath: instancePath + "/attempt", schemaPath: "#/properties/attempt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              validate152.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.display_state !== void 0) {
              let data1 = data.display_state;
              const _errs7 = errors;
              if (typeof data1 !== "string") {
                validate152.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "upcoming" || data1 === "ready" || data1 === "needs_input" || data1 === "input" || data1 === "approval" || data1 === "offline" || data1 === "slot" || data1 === "queued" || data1 === "running" || data1 === "done" || data1 === "failed" || data1 === "skipped")) {
                validate152.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/enum", keyword: "enum", params: { allowedValues: schema198.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.missing_inputs !== void 0) {
                let data2 = data.missing_inputs;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (Array.isArray(data2)) {
                    var valid3 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs12 = errors;
                      if (typeof data2[i0] !== "string") {
                        validate152.errors = [{ instancePath: instancePath + "/missing_inputs/" + i0, schemaPath: "#/properties/missing_inputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid3 = _errs12 === errors;
                      if (!valid3) {
                        break;
                      }
                    }
                  } else {
                    validate152.errors = [{ instancePath: instancePath + "/missing_inputs", schemaPath: "#/properties/missing_inputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.progress !== void 0) {
                  let data4 = data.progress;
                  const _errs14 = errors;
                  if (typeof data4 !== "string") {
                    validate152.errors = [{ instancePath: instancePath + "/progress", schemaPath: "#/$defs/StepProgressState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data4 === "not_due" || data4 === "due" || data4 === "in_progress" || data4 === "done" || data4 === "failed" || data4 === "skipped")) {
                    validate152.errors = [{ instancePath: instancePath + "/progress", schemaPath: "#/$defs/StepProgressState/enum", keyword: "enum", params: { allowedValues: schema213.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.step_key !== void 0) {
                    const _errs17 = errors;
                    if (typeof data.step_key !== "string") {
                      validate152.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate152.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate152.errors = vErrors;
  return errors === 0;
}
validate152.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate145(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate145.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      const _errs1 = errors;
      for (const key0 in data) {
        if (!(key0 === "groups" || key0 === "open_runs" || key0 === "open_turn" || key0 === "run_skips" || key0 === "run_to" || key0 === "steps" || key0 === "superseded_requests")) {
          validate145.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
          return false;
          break;
        }
      }
      if (_errs1 === errors) {
        if (data.groups !== void 0) {
          let data0 = data.groups;
          const _errs2 = errors;
          if (errors === _errs2) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs4 = errors;
                if (!validate146(data0[i0], { instancePath: instancePath + "/groups/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate146.errors : vErrors.concat(validate146.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs4 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate145.errors = [{ instancePath: instancePath + "/groups", schemaPath: "#/properties/groups/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
              return false;
            }
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.open_runs !== void 0) {
            let data2 = data.open_runs;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (Array.isArray(data2)) {
                var valid2 = true;
                const len1 = data2.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  const _errs7 = errors;
                  if (!validate148(data2[i1], { instancePath: instancePath + "/open_runs/" + i1, parentData: data2, parentDataProperty: i1, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate148.errors : vErrors.concat(validate148.errors);
                    errors = vErrors.length;
                  }
                  var valid2 = _errs7 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              } else {
                validate145.errors = [{ instancePath: instancePath + "/open_runs", schemaPath: "#/properties/open_runs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.open_turn !== void 0) {
              let data4 = data.open_turn;
              const _errs8 = errors;
              const _errs9 = errors;
              let valid3 = false;
              const _errs10 = errors;
              if (!validate150(data4, { instancePath: instancePath + "/open_turn", parentData: data, parentDataProperty: "open_turn", rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate150.errors : vErrors.concat(validate150.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs10 === errors;
              valid3 = valid3 || _valid0;
              const _errs11 = errors;
              if (data4 !== null) {
                const err0 = { instancePath: instancePath + "/open_turn", schemaPath: "#/properties/open_turn/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs11 === errors;
              valid3 = valid3 || _valid0;
              if (!valid3) {
                const err1 = { instancePath: instancePath + "/open_turn", schemaPath: "#/properties/open_turn/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
                validate145.errors = vErrors;
                return false;
              } else {
                errors = _errs9;
                if (vErrors !== null) {
                  if (_errs9) {
                    vErrors.length = _errs9;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.run_skips !== void 0) {
                let data5 = data.run_skips;
                const _errs13 = errors;
                if (errors === _errs13) {
                  if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                    for (const key1 in data5) {
                      let data6 = data5[key1];
                      const _errs16 = errors;
                      if (errors === _errs16) {
                        if (Array.isArray(data6)) {
                          var valid5 = true;
                          const len2 = data6.length;
                          for (let i2 = 0; i2 < len2; i2++) {
                            const _errs18 = errors;
                            if (typeof data6[i2] !== "string") {
                              validate145.errors = [{ instancePath: instancePath + "/run_skips/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i2, schemaPath: "#/properties/run_skips/additionalProperties/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            var valid5 = _errs18 === errors;
                            if (!valid5) {
                              break;
                            }
                          }
                        } else {
                          validate145.errors = [{ instancePath: instancePath + "/run_skips/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/run_skips/additionalProperties/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid4 = _errs16 === errors;
                      if (!valid4) {
                        break;
                      }
                    }
                  } else {
                    validate145.errors = [{ instancePath: instancePath + "/run_skips", schemaPath: "#/properties/run_skips/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                    return false;
                  }
                }
                var valid0 = _errs13 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.run_to !== void 0) {
                  let data8 = data.run_to;
                  const _errs20 = errors;
                  const _errs21 = errors;
                  let valid6 = false;
                  const _errs22 = errors;
                  if (typeof data8 !== "string") {
                    const err2 = { instancePath: instancePath + "/run_to", schemaPath: "#/properties/run_to/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  var _valid1 = _errs22 === errors;
                  valid6 = valid6 || _valid1;
                  const _errs24 = errors;
                  if (data8 !== null) {
                    const err3 = { instancePath: instancePath + "/run_to", schemaPath: "#/properties/run_to/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var _valid1 = _errs24 === errors;
                  valid6 = valid6 || _valid1;
                  if (!valid6) {
                    const err4 = { instancePath: instancePath + "/run_to", schemaPath: "#/properties/run_to/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                    validate145.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs21;
                    if (vErrors !== null) {
                      if (_errs21) {
                        vErrors.length = _errs21;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs20 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.steps !== void 0) {
                    let data9 = data.steps;
                    const _errs26 = errors;
                    if (errors === _errs26) {
                      if (Array.isArray(data9)) {
                        var valid7 = true;
                        const len3 = data9.length;
                        for (let i3 = 0; i3 < len3; i3++) {
                          const _errs28 = errors;
                          if (!validate152(data9[i3], { instancePath: instancePath + "/steps/" + i3, parentData: data9, parentDataProperty: i3, rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate152.errors : vErrors.concat(validate152.errors);
                            errors = vErrors.length;
                          }
                          var valid7 = _errs28 === errors;
                          if (!valid7) {
                            break;
                          }
                        }
                      } else {
                        validate145.errors = [{ instancePath: instancePath + "/steps", schemaPath: "#/properties/steps/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs26 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.superseded_requests !== void 0) {
                      let data11 = data.superseded_requests;
                      const _errs29 = errors;
                      if (errors === _errs29) {
                        if (Array.isArray(data11)) {
                          var valid8 = true;
                          const len4 = data11.length;
                          for (let i4 = 0; i4 < len4; i4++) {
                            let data12 = data11[i4];
                            const _errs31 = errors;
                            if (!(typeof data12 == "number" && (!(data12 % 1) && !isNaN(data12)))) {
                              validate145.errors = [{ instancePath: instancePath + "/superseded_requests/" + i4, schemaPath: "#/properties/superseded_requests/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                              return false;
                            }
                            var valid8 = _errs31 === errors;
                            if (!valid8) {
                              break;
                            }
                          }
                        } else {
                          validate145.errors = [{ instancePath: instancePath + "/superseded_requests", schemaPath: "#/properties/superseded_requests/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs29 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate145.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate145.errors = vErrors;
  return errors === 0;
}
validate145.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema219 = { "description": 'The one status of a Thread: its progress (FR-UI-3; F54\'s names where T3 Code has them).\nWhether it is connected is its `ThreadState`, no status (Johannes, 4 Nov 09:28: "i feel\nlike some spillover has happened"; accepted 09:41 and 09:43).', "enum": ["closed", "approval", "waiting", "offline", "working", "input", "ready", "failed", "done"], "title": "ThreadDisplayStatus", "type": "string" };
function validate163(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate163.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.step_key === void 0 && (missing0 = "step_key") || data.progress === void 0 && (missing0 = "progress") || data.display_state === void 0 && (missing0 = "display_state")) {
        validate163.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "display_state" || key0 === "missing_inputs" || key0 === "progress" || key0 === "step_key")) {
            validate163.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.display_state !== void 0) {
            let data0 = data.display_state;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate163.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "upcoming" || data0 === "ready" || data0 === "needs_input" || data0 === "input" || data0 === "approval" || data0 === "offline" || data0 === "slot" || data0 === "queued" || data0 === "running" || data0 === "done" || data0 === "failed" || data0 === "skipped")) {
              validate163.errors = [{ instancePath: instancePath + "/display_state", schemaPath: "#/$defs/StepDisplayState/enum", keyword: "enum", params: { allowedValues: schema198.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.missing_inputs !== void 0) {
              let data1 = data.missing_inputs;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data1)) {
                  var valid2 = true;
                  const len0 = data1.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs7 = errors;
                    if (typeof data1[i0] !== "string") {
                      validate163.errors = [{ instancePath: instancePath + "/missing_inputs/" + i0, schemaPath: "#/properties/missing_inputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid2 = _errs7 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate163.errors = [{ instancePath: instancePath + "/missing_inputs", schemaPath: "#/properties/missing_inputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.progress !== void 0) {
                let data3 = data.progress;
                const _errs9 = errors;
                if (typeof data3 !== "string") {
                  validate163.errors = [{ instancePath: instancePath + "/progress", schemaPath: "#/$defs/StepProgressState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data3 === "not_due" || data3 === "due" || data3 === "in_progress" || data3 === "done" || data3 === "failed" || data3 === "skipped")) {
                  validate163.errors = [{ instancePath: instancePath + "/progress", schemaPath: "#/$defs/StepProgressState/enum", keyword: "enum", params: { allowedValues: schema213.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.step_key !== void 0) {
                  const _errs12 = errors;
                  if (typeof data.step_key !== "string") {
                    validate163.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate163.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate163.errors = vErrors;
  return errors === 0;
}
validate163.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema221 = { "description": "Who may answer a person step's request (W-22 slice 1): the one its response kind names,\nwhoever hosts, or else whoever may write in the Run.", "enum": ["host", "participants", "change_set_curators", "result_curators", "memory_owner"], "title": "RequestAudience", "type": "string" };
function validate165(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate165.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.request_entry === void 0 && (missing0 = "request_entry") || data.step_key === void 0 && (missing0 = "step_key") || data.response_kind === void 0 && (missing0 = "response_kind") || data.audience === void 0 && (missing0 = "audience")) {
        validate165.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "audience" || key0 === "change_set_id" || key0 === "request_entry" || key0 === "response_kind" || key0 === "step_key" || key0 === "workflow_left")) {
            validate165.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.audience !== void 0) {
            let data0 = data.audience;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate165.errors = [{ instancePath: instancePath + "/audience", schemaPath: "#/$defs/RequestAudience/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "host" || data0 === "participants" || data0 === "change_set_curators" || data0 === "result_curators" || data0 === "memory_owner")) {
              validate165.errors = [{ instancePath: instancePath + "/audience", schemaPath: "#/$defs/RequestAudience/enum", keyword: "enum", params: { allowedValues: schema221.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.change_set_id !== void 0) {
              let data1 = data.change_set_id;
              const _errs5 = errors;
              const _errs6 = errors;
              let valid2 = false;
              const _errs7 = errors;
              if (typeof data1 !== "string") {
                const err0 = { instancePath: instancePath + "/change_set_id", schemaPath: "#/properties/change_set_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs7 === errors;
              valid2 = valid2 || _valid0;
              const _errs9 = errors;
              if (data1 !== null) {
                const err1 = { instancePath: instancePath + "/change_set_id", schemaPath: "#/properties/change_set_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              valid2 = valid2 || _valid0;
              if (!valid2) {
                const err2 = { instancePath: instancePath + "/change_set_id", schemaPath: "#/properties/change_set_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
                validate165.errors = vErrors;
                return false;
              } else {
                errors = _errs6;
                if (vErrors !== null) {
                  if (_errs6) {
                    vErrors.length = _errs6;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.request_entry !== void 0) {
                let data2 = data.request_entry;
                const _errs11 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  validate165.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                var valid0 = _errs11 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.response_kind !== void 0) {
                  const _errs13 = errors;
                  if (typeof data.response_kind !== "string") {
                    validate165.errors = [{ instancePath: instancePath + "/response_kind", schemaPath: "#/properties/response_kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.step_key !== void 0) {
                    const _errs15 = errors;
                    if (typeof data.step_key !== "string") {
                      validate165.errors = [{ instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs15 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.workflow_left !== void 0) {
                      const _errs17 = errors;
                      if (typeof data.workflow_left !== "boolean") {
                        validate165.errors = [{ instancePath: instancePath + "/workflow_left", schemaPath: "#/properties/workflow_left/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate165.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate165.errors = vErrors;
  return errors === 0;
}
validate165.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema229 = { "enum": ["approval", "slot"], "title": "WaitKind", "type": "string" };
var pattern89 = new RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\\.[0-9]{3}Z$", "u");
var schema226 = { "description": "What a tool version uses a model for, as its owner is told.", "enum": ["none", "local_embedding", "api_embedding"], "title": "ToolModelUseShown", "type": "string" };
var pattern94 = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}@([0-9a-f]{40}|[0-9a-f]{64})$", "u");
function validate169(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate169.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.tool_ref === void 0 && (missing0 = "tool_ref") || data.tool_name === void 0 && (missing0 = "tool_name") || data.description === void 0 && (missing0 = "description") || data.runtime === void 0 && (missing0 = "runtime") || data.requires_python === void 0 && (missing0 = "requires_python") || data.dependencies === void 0 && (missing0 = "dependencies") || data.author === void 0 && (missing0 = "author") || data.reviewers === void 0 && (missing0 = "reviewers") || data.provenance_known === void 0 && (missing0 = "provenance_known") || data.model_use === void 0 && (missing0 = "model_use") || data.model === void 0 && (missing0 = "model") || data.limits === void 0 && (missing0 = "limits") || data.input_kinds === void 0 && (missing0 = "input_kinds") || data.workspace_files === void 0 && (missing0 = "workspace_files") || data.reads_sources === void 0 && (missing0 = "reads_sources")) {
        validate169.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.author !== void 0) {
          let data0 = data.author;
          const _errs1 = errors;
          const _errs2 = errors;
          let valid1 = false;
          const _errs3 = errors;
          if (typeof data0 !== "string") {
            const err0 = { instancePath: instancePath + "/author", schemaPath: "#/properties/author/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          var _valid0 = _errs3 === errors;
          valid1 = valid1 || _valid0;
          const _errs5 = errors;
          if (data0 !== null) {
            const err1 = { instancePath: instancePath + "/author", schemaPath: "#/properties/author/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          var _valid0 = _errs5 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const err2 = { instancePath: instancePath + "/author", schemaPath: "#/properties/author/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
            validate169.errors = vErrors;
            return false;
          } else {
            errors = _errs2;
            if (vErrors !== null) {
              if (_errs2) {
                vErrors.length = _errs2;
              } else {
                vErrors = null;
              }
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.dependencies !== void 0) {
            let data1 = data.dependencies;
            const _errs7 = errors;
            if (errors === _errs7) {
              if (Array.isArray(data1)) {
                var valid2 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs9 = errors;
                  if (typeof data1[i0] !== "string") {
                    validate169.errors = [{ instancePath: instancePath + "/dependencies/" + i0, schemaPath: "#/properties/dependencies/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid2 = _errs9 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              } else {
                validate169.errors = [{ instancePath: instancePath + "/dependencies", schemaPath: "#/properties/dependencies/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs7 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.description !== void 0) {
              let data3 = data.description;
              const _errs11 = errors;
              const _errs12 = errors;
              let valid3 = false;
              const _errs13 = errors;
              if (typeof data3 !== "string") {
                const err3 = { instancePath: instancePath + "/description", schemaPath: "#/properties/description/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var _valid1 = _errs13 === errors;
              valid3 = valid3 || _valid1;
              const _errs15 = errors;
              if (data3 !== null) {
                const err4 = { instancePath: instancePath + "/description", schemaPath: "#/properties/description/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
              var _valid1 = _errs15 === errors;
              valid3 = valid3 || _valid1;
              if (!valid3) {
                const err5 = { instancePath: instancePath + "/description", schemaPath: "#/properties/description/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
                validate169.errors = vErrors;
                return false;
              } else {
                errors = _errs12;
                if (vErrors !== null) {
                  if (_errs12) {
                    vErrors.length = _errs12;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs11 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.input_kinds !== void 0) {
                let data4 = data.input_kinds;
                const _errs17 = errors;
                if (errors === _errs17) {
                  if (Array.isArray(data4)) {
                    var valid4 = true;
                    const len1 = data4.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      const _errs19 = errors;
                      if (typeof data4[i1] !== "string") {
                        validate169.errors = [{ instancePath: instancePath + "/input_kinds/" + i1, schemaPath: "#/properties/input_kinds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid4 = _errs19 === errors;
                      if (!valid4) {
                        break;
                      }
                    }
                  } else {
                    validate169.errors = [{ instancePath: instancePath + "/input_kinds", schemaPath: "#/properties/input_kinds/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs17 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.limits !== void 0) {
                  let data6 = data.limits;
                  const _errs21 = errors;
                  const _errs22 = errors;
                  let valid5 = false;
                  const _errs23 = errors;
                  const _errs24 = errors;
                  if (errors === _errs24) {
                    if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                      let missing1;
                      if (data6.timeout_seconds === void 0 && (missing1 = "timeout_seconds") || data6.memory_megabytes === void 0 && (missing1 = "memory_megabytes") || data6.output_megabytes === void 0 && (missing1 = "output_megabytes")) {
                        const err6 = { instancePath: instancePath + "/limits", schemaPath: "#/$defs/ToolRunLimits/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      } else {
                        if (data6.memory_megabytes !== void 0) {
                          let data7 = data6.memory_megabytes;
                          const _errs26 = errors;
                          if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)))) {
                            const err7 = { instancePath: instancePath + "/limits/memory_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/memory_megabytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                          }
                          if (errors === _errs26) {
                            if (typeof data7 == "number") {
                              if (data7 < 16 || isNaN(data7)) {
                                const err8 = { instancePath: instancePath + "/limits/memory_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/memory_megabytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 16 }, message: "must be >= 16" };
                                if (vErrors === null) {
                                  vErrors = [err8];
                                } else {
                                  vErrors.push(err8);
                                }
                                errors++;
                              }
                            }
                          }
                          var valid7 = _errs26 === errors;
                        } else {
                          var valid7 = true;
                        }
                        if (valid7) {
                          if (data6.output_megabytes !== void 0) {
                            let data8 = data6.output_megabytes;
                            const _errs28 = errors;
                            if (!(typeof data8 == "number" && (!(data8 % 1) && !isNaN(data8)))) {
                              const err9 = { instancePath: instancePath + "/limits/output_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/output_megabytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                              if (vErrors === null) {
                                vErrors = [err9];
                              } else {
                                vErrors.push(err9);
                              }
                              errors++;
                            }
                            if (errors === _errs28) {
                              if (typeof data8 == "number") {
                                if (data8 < 1 || isNaN(data8)) {
                                  const err10 = { instancePath: instancePath + "/limits/output_megabytes", schemaPath: "#/$defs/ToolRunLimits/properties/output_megabytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                  if (vErrors === null) {
                                    vErrors = [err10];
                                  } else {
                                    vErrors.push(err10);
                                  }
                                  errors++;
                                }
                              }
                            }
                            var valid7 = _errs28 === errors;
                          } else {
                            var valid7 = true;
                          }
                          if (valid7) {
                            if (data6.timeout_seconds !== void 0) {
                              let data9 = data6.timeout_seconds;
                              const _errs30 = errors;
                              if (!(typeof data9 == "number" && (!(data9 % 1) && !isNaN(data9)))) {
                                const err11 = { instancePath: instancePath + "/limits/timeout_seconds", schemaPath: "#/$defs/ToolRunLimits/properties/timeout_seconds/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err11];
                                } else {
                                  vErrors.push(err11);
                                }
                                errors++;
                              }
                              if (errors === _errs30) {
                                if (typeof data9 == "number") {
                                  if (data9 < 1 || isNaN(data9)) {
                                    const err12 = { instancePath: instancePath + "/limits/timeout_seconds", schemaPath: "#/$defs/ToolRunLimits/properties/timeout_seconds/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                    if (vErrors === null) {
                                      vErrors = [err12];
                                    } else {
                                      vErrors.push(err12);
                                    }
                                    errors++;
                                  }
                                }
                              }
                              var valid7 = _errs30 === errors;
                            } else {
                              var valid7 = true;
                            }
                          }
                        }
                      }
                    } else {
                      const err13 = { instancePath: instancePath + "/limits", schemaPath: "#/$defs/ToolRunLimits/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                  }
                  var _valid2 = _errs23 === errors;
                  valid5 = valid5 || _valid2;
                  if (_valid2) {
                    var props0 = {};
                    props0.memory_megabytes = true;
                    props0.output_megabytes = true;
                    props0.timeout_seconds = true;
                  }
                  const _errs32 = errors;
                  if (data6 !== null) {
                    const err14 = { instancePath: instancePath + "/limits", schemaPath: "#/properties/limits/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                  }
                  var _valid2 = _errs32 === errors;
                  valid5 = valid5 || _valid2;
                  if (!valid5) {
                    const err15 = { instancePath: instancePath + "/limits", schemaPath: "#/properties/limits/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err15];
                    } else {
                      vErrors.push(err15);
                    }
                    errors++;
                    validate169.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs22;
                    if (vErrors !== null) {
                      if (_errs22) {
                        vErrors.length = _errs22;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs21 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.model !== void 0) {
                    let data10 = data.model;
                    const _errs34 = errors;
                    const _errs35 = errors;
                    let valid8 = false;
                    const _errs36 = errors;
                    if (typeof data10 !== "string") {
                      const err16 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                    }
                    var _valid3 = _errs36 === errors;
                    valid8 = valid8 || _valid3;
                    const _errs38 = errors;
                    if (data10 !== null) {
                      const err17 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err17];
                      } else {
                        vErrors.push(err17);
                      }
                      errors++;
                    }
                    var _valid3 = _errs38 === errors;
                    valid8 = valid8 || _valid3;
                    if (!valid8) {
                      const err18 = { instancePath: instancePath + "/model", schemaPath: "#/properties/model/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err18];
                      } else {
                        vErrors.push(err18);
                      }
                      errors++;
                      validate169.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs35;
                      if (vErrors !== null) {
                        if (_errs35) {
                          vErrors.length = _errs35;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.model_use !== void 0) {
                      let data11 = data.model_use;
                      const _errs40 = errors;
                      if (typeof data11 !== "string") {
                        validate169.errors = [{ instancePath: instancePath + "/model_use", schemaPath: "#/$defs/ToolModelUseShown/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      if (!(data11 === "none" || data11 === "local_embedding" || data11 === "api_embedding")) {
                        validate169.errors = [{ instancePath: instancePath + "/model_use", schemaPath: "#/$defs/ToolModelUseShown/enum", keyword: "enum", params: { allowedValues: schema226.enum }, message: "must be equal to one of the allowed values" }];
                        return false;
                      }
                      var valid0 = _errs40 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.provenance_known !== void 0) {
                        const _errs43 = errors;
                        if (typeof data.provenance_known !== "boolean") {
                          validate169.errors = [{ instancePath: instancePath + "/provenance_known", schemaPath: "#/properties/provenance_known/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs43 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.reads_sources !== void 0) {
                          const _errs45 = errors;
                          if (typeof data.reads_sources !== "boolean") {
                            validate169.errors = [{ instancePath: instancePath + "/reads_sources", schemaPath: "#/properties/reads_sources/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs45 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.requires_python !== void 0) {
                            let data14 = data.requires_python;
                            const _errs47 = errors;
                            const _errs48 = errors;
                            let valid10 = false;
                            const _errs49 = errors;
                            if (typeof data14 !== "string") {
                              const err19 = { instancePath: instancePath + "/requires_python", schemaPath: "#/properties/requires_python/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err19];
                              } else {
                                vErrors.push(err19);
                              }
                              errors++;
                            }
                            var _valid4 = _errs49 === errors;
                            valid10 = valid10 || _valid4;
                            const _errs51 = errors;
                            if (data14 !== null) {
                              const err20 = { instancePath: instancePath + "/requires_python", schemaPath: "#/properties/requires_python/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err20];
                              } else {
                                vErrors.push(err20);
                              }
                              errors++;
                            }
                            var _valid4 = _errs51 === errors;
                            valid10 = valid10 || _valid4;
                            if (!valid10) {
                              const err21 = { instancePath: instancePath + "/requires_python", schemaPath: "#/properties/requires_python/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err21];
                              } else {
                                vErrors.push(err21);
                              }
                              errors++;
                              validate169.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs48;
                              if (vErrors !== null) {
                                if (_errs48) {
                                  vErrors.length = _errs48;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs47 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.reviewers !== void 0) {
                              let data15 = data.reviewers;
                              const _errs53 = errors;
                              if (errors === _errs53) {
                                if (Array.isArray(data15)) {
                                  var valid11 = true;
                                  const len2 = data15.length;
                                  for (let i2 = 0; i2 < len2; i2++) {
                                    const _errs55 = errors;
                                    if (typeof data15[i2] !== "string") {
                                      validate169.errors = [{ instancePath: instancePath + "/reviewers/" + i2, schemaPath: "#/properties/reviewers/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid11 = _errs55 === errors;
                                    if (!valid11) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate169.errors = [{ instancePath: instancePath + "/reviewers", schemaPath: "#/properties/reviewers/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs53 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.runtime !== void 0) {
                                let data17 = data.runtime;
                                const _errs57 = errors;
                                if (typeof data17 !== "string") {
                                  validate169.errors = [{ instancePath: instancePath + "/runtime", schemaPath: "#/$defs/ToolRuntimeKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                if (!(data17 === "node" || data17 === "python")) {
                                  validate169.errors = [{ instancePath: instancePath + "/runtime", schemaPath: "#/$defs/ToolRuntimeKind/enum", keyword: "enum", params: { allowedValues: schema140.enum }, message: "must be equal to one of the allowed values" }];
                                  return false;
                                }
                                var valid0 = _errs57 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.sdk !== void 0) {
                                  let data18 = data.sdk;
                                  const _errs60 = errors;
                                  const _errs61 = errors;
                                  let valid13 = false;
                                  const _errs62 = errors;
                                  const _errs63 = errors;
                                  if (errors === _errs63) {
                                    if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                                      let missing2;
                                      if (data18.version === void 0 && (missing2 = "version") || data18.digest === void 0 && (missing2 = "digest") || data18.files === void 0 && (missing2 = "files")) {
                                        const err22 = { instancePath: instancePath + "/sdk", schemaPath: "#/$defs/ToolApprovalSdk/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                                        if (vErrors === null) {
                                          vErrors = [err22];
                                        } else {
                                          vErrors.push(err22);
                                        }
                                        errors++;
                                      } else {
                                        if (data18.digest !== void 0) {
                                          let data19 = data18.digest;
                                          const _errs65 = errors;
                                          if (errors === _errs65) {
                                            if (typeof data19 === "string") {
                                              if (!pattern24.test(data19)) {
                                                const err23 = { instancePath: instancePath + "/sdk/digest", schemaPath: "#/$defs/ToolApprovalSdk/properties/digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' };
                                                if (vErrors === null) {
                                                  vErrors = [err23];
                                                } else {
                                                  vErrors.push(err23);
                                                }
                                                errors++;
                                              }
                                            } else {
                                              const err24 = { instancePath: instancePath + "/sdk/digest", schemaPath: "#/$defs/ToolApprovalSdk/properties/digest/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                              if (vErrors === null) {
                                                vErrors = [err24];
                                              } else {
                                                vErrors.push(err24);
                                              }
                                              errors++;
                                            }
                                          }
                                          var valid15 = _errs65 === errors;
                                        } else {
                                          var valid15 = true;
                                        }
                                        if (valid15) {
                                          if (data18.files !== void 0) {
                                            let data20 = data18.files;
                                            const _errs67 = errors;
                                            if (errors === _errs67) {
                                              if (Array.isArray(data20)) {
                                                var valid16 = true;
                                                const len3 = data20.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                  const _errs69 = errors;
                                                  if (typeof data20[i3] !== "string") {
                                                    const err25 = { instancePath: instancePath + "/sdk/files/" + i3, schemaPath: "#/$defs/ToolApprovalSdk/properties/files/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err25];
                                                    } else {
                                                      vErrors.push(err25);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid16 = _errs69 === errors;
                                                  if (!valid16) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                const err26 = { instancePath: instancePath + "/sdk/files", schemaPath: "#/$defs/ToolApprovalSdk/properties/files/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err26];
                                                } else {
                                                  vErrors.push(err26);
                                                }
                                                errors++;
                                              }
                                            }
                                            var valid15 = _errs67 === errors;
                                          } else {
                                            var valid15 = true;
                                          }
                                          if (valid15) {
                                            if (data18.version !== void 0) {
                                              let data22 = data18.version;
                                              const _errs71 = errors;
                                              if (errors === _errs71) {
                                                if (typeof data22 === "string") {
                                                  if (func2(data22) > 100) {
                                                    const err27 = { instancePath: instancePath + "/sdk/version", schemaPath: "#/$defs/ToolApprovalSdk/properties/version/maxLength", keyword: "maxLength", params: { limit: 100 }, message: "must NOT have more than 100 characters" };
                                                    if (vErrors === null) {
                                                      vErrors = [err27];
                                                    } else {
                                                      vErrors.push(err27);
                                                    }
                                                    errors++;
                                                  } else {
                                                    if (func2(data22) < 1) {
                                                      const err28 = { instancePath: instancePath + "/sdk/version", schemaPath: "#/$defs/ToolApprovalSdk/properties/version/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                      if (vErrors === null) {
                                                        vErrors = [err28];
                                                      } else {
                                                        vErrors.push(err28);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                } else {
                                                  const err29 = { instancePath: instancePath + "/sdk/version", schemaPath: "#/$defs/ToolApprovalSdk/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err29];
                                                  } else {
                                                    vErrors.push(err29);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var valid15 = _errs71 === errors;
                                            } else {
                                              var valid15 = true;
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      const err30 = { instancePath: instancePath + "/sdk", schemaPath: "#/$defs/ToolApprovalSdk/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                      if (vErrors === null) {
                                        vErrors = [err30];
                                      } else {
                                        vErrors.push(err30);
                                      }
                                      errors++;
                                    }
                                  }
                                  var _valid5 = _errs62 === errors;
                                  valid13 = valid13 || _valid5;
                                  if (_valid5) {
                                    var props1 = {};
                                    props1.digest = true;
                                    props1.files = true;
                                    props1.version = true;
                                  }
                                  const _errs73 = errors;
                                  if (data18 !== null) {
                                    const err31 = { instancePath: instancePath + "/sdk", schemaPath: "#/properties/sdk/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err31];
                                    } else {
                                      vErrors.push(err31);
                                    }
                                    errors++;
                                  }
                                  var _valid5 = _errs73 === errors;
                                  valid13 = valid13 || _valid5;
                                  if (!valid13) {
                                    const err32 = { instancePath: instancePath + "/sdk", schemaPath: "#/properties/sdk/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err32];
                                    } else {
                                      vErrors.push(err32);
                                    }
                                    errors++;
                                    validate169.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs61;
                                    if (vErrors !== null) {
                                      if (_errs61) {
                                        vErrors.length = _errs61;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid0 = _errs60 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.tool_name !== void 0) {
                                    let data23 = data.tool_name;
                                    const _errs75 = errors;
                                    if (errors === _errs75) {
                                      if (typeof data23 === "string") {
                                        if (!pattern8.test(data23)) {
                                          validate169.errors = [{ instancePath: instancePath + "/tool_name", schemaPath: "#/properties/tool_name/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                          return false;
                                        }
                                      } else {
                                        validate169.errors = [{ instancePath: instancePath + "/tool_name", schemaPath: "#/properties/tool_name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                    }
                                    var valid0 = _errs75 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.tool_ref !== void 0) {
                                      let data24 = data.tool_ref;
                                      const _errs77 = errors;
                                      if (errors === _errs77) {
                                        if (typeof data24 === "string") {
                                          if (!pattern94.test(data24)) {
                                            validate169.errors = [{ instancePath: instancePath + "/tool_ref", schemaPath: "#/properties/tool_ref/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}@([0-9a-f]{40}|[0-9a-f]{64})$" }, message: 'must match pattern "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}@([0-9a-f]{40}|[0-9a-f]{64})$"' }];
                                            return false;
                                          }
                                        } else {
                                          validate169.errors = [{ instancePath: instancePath + "/tool_ref", schemaPath: "#/properties/tool_ref/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                      }
                                      var valid0 = _errs77 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.workspace_files !== void 0) {
                                        let data25 = data.workspace_files;
                                        const _errs79 = errors;
                                        if (errors === _errs79) {
                                          if (Array.isArray(data25)) {
                                            var valid17 = true;
                                            const len4 = data25.length;
                                            for (let i4 = 0; i4 < len4; i4++) {
                                              const _errs81 = errors;
                                              if (typeof data25[i4] !== "string") {
                                                validate169.errors = [{ instancePath: instancePath + "/workspace_files/" + i4, schemaPath: "#/properties/workspace_files/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid17 = _errs81 === errors;
                                              if (!valid17) {
                                                break;
                                              }
                                            }
                                          } else {
                                            validate169.errors = [{ instancePath: instancePath + "/workspace_files", schemaPath: "#/properties/workspace_files/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                            return false;
                                          }
                                        }
                                        var valid0 = _errs79 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate169.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate169.errors = vErrors;
  return errors === 0;
}
validate169.evaluated = { "props": { "author": true, "dependencies": true, "description": true, "input_kinds": true, "limits": true, "model": true, "model_use": true, "provenance_known": true, "reads_sources": true, "requires_python": true, "reviewers": true, "runtime": true, "sdk": true, "tool_name": true, "tool_ref": true, "workspace_files": true }, "dynamicProps": false, "dynamicItems": false };
function validate168(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate168.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.request_id === void 0 && (missing0 = "request_id") || data.input_digest === void 0 && (missing0 = "input_digest") || data.expires_at === void 0 && (missing0 = "expires_at") || data.tool === void 0 && (missing0 = "tool")) {
        validate168.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.expires_at !== void 0) {
          let data0 = data.expires_at;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (typeof data0 === "string") {
              if (!pattern89.test(data0)) {
                validate168.errors = [{ instancePath: instancePath + "/expires_at", schemaPath: "#/properties/expires_at/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\\.[0-9]{3}Z$" }, message: 'must match pattern "^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\\.[0-9]{3}Z$"' }];
                return false;
              }
            } else {
              validate168.errors = [{ instancePath: instancePath + "/expires_at", schemaPath: "#/properties/expires_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.input_digest !== void 0) {
            let data1 = data.input_digest;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (typeof data1 === "string") {
                if (!pattern24.test(data1)) {
                  validate168.errors = [{ instancePath: instancePath + "/input_digest", schemaPath: "#/properties/input_digest/pattern", keyword: "pattern", params: { pattern: "^sha256-jcs:[0-9a-f]{64}$" }, message: 'must match pattern "^sha256-jcs:[0-9a-f]{64}$"' }];
                  return false;
                }
              } else {
                validate168.errors = [{ instancePath: instancePath + "/input_digest", schemaPath: "#/properties/input_digest/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.request_id !== void 0) {
              let data2 = data.request_id;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (typeof data2 === "string") {
                  if (!pattern31.test(data2)) {
                    validate168.errors = [{ instancePath: instancePath + "/request_id", schemaPath: "#/properties/request_id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" }, message: 'must match pattern "^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"' }];
                    return false;
                  }
                } else {
                  validate168.errors = [{ instancePath: instancePath + "/request_id", schemaPath: "#/properties/request_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.tool !== void 0) {
                const _errs7 = errors;
                if (!validate169(data.tool, { instancePath: instancePath + "/tool", parentData: data, parentDataProperty: "tool", rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate169.errors : vErrors.concat(validate169.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate168.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate168.errors = vErrors;
  return errors === 0;
}
validate168.evaluated = { "props": { "expires_at": true, "input_digest": true, "request_id": true, "tool": true }, "dynamicProps": false, "dynamicItems": false };
function validate167(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate167.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.turn_id === void 0 && (missing0 = "turn_id") || data.request_entry === void 0 && (missing0 = "request_entry") || data.step_key === void 0 && (missing0 = "step_key")) {
        validate167.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "approval" || key0 === "kind" || key0 === "request_entry" || key0 === "since" || key0 === "step_key" || key0 === "tool" || key0 === "turn_id")) {
            validate167.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.approval !== void 0) {
            let data0 = data.approval;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!validate168(data0, { instancePath: instancePath + "/approval", parentData: data, parentDataProperty: "approval", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate168.errors : vErrors.concat(validate168.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            if (_valid0) {
              var props0 = {};
              props0.expires_at = true;
              props0.input_digest = true;
              props0.request_id = true;
              props0.tool = true;
            }
            const _errs5 = errors;
            if (data0 !== null) {
              const err0 = { instancePath: instancePath + "/approval", schemaPath: "#/properties/approval/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err1 = { instancePath: instancePath + "/approval", schemaPath: "#/properties/approval/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              validate167.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.kind !== void 0) {
              let data1 = data.kind;
              const _errs7 = errors;
              if (typeof data1 !== "string") {
                validate167.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/WaitKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "approval" || data1 === "slot")) {
                validate167.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/WaitKind/enum", keyword: "enum", params: { allowedValues: schema229.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.request_entry !== void 0) {
                let data2 = data.request_entry;
                const _errs10 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  validate167.errors = [{ instancePath: instancePath + "/request_entry", schemaPath: "#/properties/request_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.since !== void 0) {
                  let data3 = data.since;
                  const _errs12 = errors;
                  const _errs13 = errors;
                  let valid3 = false;
                  const _errs14 = errors;
                  if (errors === _errs14) {
                    if (errors === _errs14) {
                      if (typeof data3 === "string") {
                        if (!formats0.validate(data3)) {
                          const err2 = { instancePath: instancePath + "/since", schemaPath: "#/properties/since/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                          if (vErrors === null) {
                            vErrors = [err2];
                          } else {
                            vErrors.push(err2);
                          }
                          errors++;
                        }
                      } else {
                        const err3 = { instancePath: instancePath + "/since", schemaPath: "#/properties/since/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      }
                    }
                  }
                  var _valid1 = _errs14 === errors;
                  valid3 = valid3 || _valid1;
                  const _errs16 = errors;
                  if (data3 !== null) {
                    const err4 = { instancePath: instancePath + "/since", schemaPath: "#/properties/since/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var _valid1 = _errs16 === errors;
                  valid3 = valid3 || _valid1;
                  if (!valid3) {
                    const err5 = { instancePath: instancePath + "/since", schemaPath: "#/properties/since/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                    validate167.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs13;
                    if (vErrors !== null) {
                      if (_errs13) {
                        vErrors.length = _errs13;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.step_key !== void 0) {
                    let data4 = data.step_key;
                    const _errs18 = errors;
                    const _errs19 = errors;
                    let valid4 = false;
                    const _errs20 = errors;
                    if (typeof data4 !== "string") {
                      const err6 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err6];
                      } else {
                        vErrors.push(err6);
                      }
                      errors++;
                    }
                    var _valid2 = _errs20 === errors;
                    valid4 = valid4 || _valid2;
                    const _errs22 = errors;
                    if (data4 !== null) {
                      const err7 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                    var _valid2 = _errs22 === errors;
                    valid4 = valid4 || _valid2;
                    if (!valid4) {
                      const err8 = { instancePath: instancePath + "/step_key", schemaPath: "#/properties/step_key/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err8];
                      } else {
                        vErrors.push(err8);
                      }
                      errors++;
                      validate167.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs19;
                      if (vErrors !== null) {
                        if (_errs19) {
                          vErrors.length = _errs19;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.tool !== void 0) {
                      let data5 = data.tool;
                      const _errs24 = errors;
                      const _errs25 = errors;
                      let valid5 = false;
                      const _errs26 = errors;
                      const _errs27 = errors;
                      if (errors === _errs27) {
                        if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                          let missing1;
                          if (data5.reference === void 0 && (missing1 = "reference") || data5.name === void 0 && (missing1 = "name")) {
                            const err9 = { instancePath: instancePath + "/tool", schemaPath: "#/$defs/WaitingTool/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                          } else {
                            const _errs29 = errors;
                            for (const key1 in data5) {
                              if (!(key1 === "name" || key1 === "reference")) {
                                const err10 = { instancePath: instancePath + "/tool", schemaPath: "#/$defs/WaitingTool/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err10];
                                } else {
                                  vErrors.push(err10);
                                }
                                errors++;
                                break;
                              }
                            }
                            if (_errs29 === errors) {
                              if (data5.name !== void 0) {
                                const _errs30 = errors;
                                if (typeof data5.name !== "string") {
                                  const err11 = { instancePath: instancePath + "/tool/name", schemaPath: "#/$defs/WaitingTool/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                }
                                var valid7 = _errs30 === errors;
                              } else {
                                var valid7 = true;
                              }
                              if (valid7) {
                                if (data5.reference !== void 0) {
                                  const _errs32 = errors;
                                  if (typeof data5.reference !== "string") {
                                    const err12 = { instancePath: instancePath + "/tool/reference", schemaPath: "#/$defs/WaitingTool/properties/reference/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err12];
                                    } else {
                                      vErrors.push(err12);
                                    }
                                    errors++;
                                  }
                                  var valid7 = _errs32 === errors;
                                } else {
                                  var valid7 = true;
                                }
                              }
                            }
                          }
                        } else {
                          const err13 = { instancePath: instancePath + "/tool", schemaPath: "#/$defs/WaitingTool/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                          if (vErrors === null) {
                            vErrors = [err13];
                          } else {
                            vErrors.push(err13);
                          }
                          errors++;
                        }
                      }
                      var _valid3 = _errs26 === errors;
                      valid5 = valid5 || _valid3;
                      const _errs34 = errors;
                      if (data5 !== null) {
                        const err14 = { instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err14];
                        } else {
                          vErrors.push(err14);
                        }
                        errors++;
                      }
                      var _valid3 = _errs34 === errors;
                      valid5 = valid5 || _valid3;
                      if (!valid5) {
                        const err15 = { instancePath: instancePath + "/tool", schemaPath: "#/properties/tool/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err15];
                        } else {
                          vErrors.push(err15);
                        }
                        errors++;
                        validate167.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs25;
                        if (vErrors !== null) {
                          if (_errs25) {
                            vErrors.length = _errs25;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs24 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.turn_id !== void 0) {
                        const _errs36 = errors;
                        if (typeof data.turn_id !== "string") {
                          validate167.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid0 = _errs36 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate167.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate167.errors = vErrors;
  return errors === 0;
}
validate167.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema239 = { "enum": ["satisfied", "unsatisfied", "undetermined", "not_declared"], "title": "OutcomeState", "type": "string" };
var schema238 = { "enum": ["satisfied", "unsatisfied", "undetermined"], "title": "ConditionState", "type": "string" };
function validate176(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate176.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.step === void 0 && (missing0 = "step") || data.part === void 0 && (missing0 = "part")) {
        const err0 = { instancePath, schemaPath: "#/$defs/CheckPasses/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs4 = errors;
        for (const key0 in data) {
          if (!(key0 === "kind" || key0 === "part" || key0 === "step")) {
            const err1 = { instancePath, schemaPath: "#/$defs/CheckPasses/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs4 === errors) {
          if (data.kind !== void 0) {
            let data0 = data.kind;
            const _errs5 = errors;
            if (typeof data0 !== "string") {
              const err2 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/CheckPasses/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if ("check_passes" !== data0) {
              const err3 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/CheckPasses/properties/kind/const", keyword: "const", params: { allowedValue: "check_passes" }, message: "must be equal to constant" };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            var valid2 = _errs5 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.part !== void 0) {
              let data1 = data.part;
              const _errs7 = errors;
              if (errors === _errs7) {
                if (typeof data1 === "string") {
                  if (!pattern8.test(data1)) {
                    const err4 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/CheckPasses/properties/part/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                } else {
                  const err5 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/CheckPasses/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.step !== void 0) {
                let data2 = data.step;
                const _errs9 = errors;
                if (errors === _errs9) {
                  if (typeof data2 === "string") {
                    if (!pattern8.test(data2)) {
                      const err6 = { instancePath: instancePath + "/step", schemaPath: "#/$defs/CheckPasses/properties/step/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                      if (vErrors === null) {
                        vErrors = [err6];
                      } else {
                        vErrors.push(err6);
                      }
                      errors++;
                    }
                  } else {
                    const err7 = { instancePath: instancePath + "/step", schemaPath: "#/$defs/CheckPasses/properties/step/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                  }
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      }
    } else {
      const err8 = { instancePath, schemaPath: "#/$defs/CheckPasses/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs11 = errors;
  const _errs12 = errors;
  if (errors === _errs12) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing1;
      if (data.kind === void 0 && (missing1 = "kind") || data.step === void 0 && (missing1 = "step") || data.part === void 0 && (missing1 = "part")) {
        const err9 = { instancePath, schemaPath: "#/$defs/ChangeSetMerged/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      } else {
        const _errs14 = errors;
        for (const key1 in data) {
          if (!(key1 === "kind" || key1 === "part" || key1 === "step")) {
            const err10 = { instancePath, schemaPath: "#/$defs/ChangeSetMerged/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
            break;
          }
        }
        if (_errs14 === errors) {
          if (data.kind !== void 0) {
            let data3 = data.kind;
            const _errs15 = errors;
            if (typeof data3 !== "string") {
              const err11 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ChangeSetMerged/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if ("change_set_merged" !== data3) {
              const err12 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ChangeSetMerged/properties/kind/const", keyword: "const", params: { allowedValue: "change_set_merged" }, message: "must be equal to constant" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            var valid4 = _errs15 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.part !== void 0) {
              let data4 = data.part;
              const _errs17 = errors;
              if (errors === _errs17) {
                if (typeof data4 === "string") {
                  if (!pattern8.test(data4)) {
                    const err13 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/ChangeSetMerged/properties/part/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                } else {
                  const err14 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/ChangeSetMerged/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                }
              }
              var valid4 = _errs17 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.step !== void 0) {
                let data5 = data.step;
                const _errs19 = errors;
                if (errors === _errs19) {
                  if (typeof data5 === "string") {
                    if (!pattern8.test(data5)) {
                      const err15 = { instancePath: instancePath + "/step", schemaPath: "#/$defs/ChangeSetMerged/properties/step/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                  } else {
                    const err16 = { instancePath: instancePath + "/step", schemaPath: "#/$defs/ChangeSetMerged/properties/step/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err16];
                    } else {
                      vErrors.push(err16);
                    }
                    errors++;
                  }
                }
                var valid4 = _errs19 === errors;
              } else {
                var valid4 = true;
              }
            }
          }
        }
      }
    } else {
      const err17 = { instancePath, schemaPath: "#/$defs/ChangeSetMerged/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err17];
      } else {
        vErrors.push(err17);
      }
      errors++;
    }
  }
  var _valid0 = _errs11 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
    const _errs21 = errors;
    const _errs22 = errors;
    if (errors === _errs22) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        let missing2;
        if (data.kind === void 0 && (missing2 = "kind") || data.step === void 0 && (missing2 = "step") || data.choice === void 0 && (missing2 = "choice")) {
          const err18 = { instancePath, schemaPath: "#/$defs/ChoiceMade/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        } else {
          const _errs24 = errors;
          for (const key2 in data) {
            if (!(key2 === "choice" || key2 === "kind" || key2 === "part" || key2 === "step")) {
              const err19 = { instancePath, schemaPath: "#/$defs/ChoiceMade/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
              break;
            }
          }
          if (_errs24 === errors) {
            if (data.choice !== void 0) {
              let data6 = data.choice;
              const _errs25 = errors;
              if (errors === _errs25) {
                if (typeof data6 === "string") {
                  if (!pattern8.test(data6)) {
                    const err20 = { instancePath: instancePath + "/choice", schemaPath: "#/$defs/ChoiceMade/properties/choice/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                    if (vErrors === null) {
                      vErrors = [err20];
                    } else {
                      vErrors.push(err20);
                    }
                    errors++;
                  }
                } else {
                  const err21 = { instancePath: instancePath + "/choice", schemaPath: "#/$defs/ChoiceMade/properties/choice/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
              }
              var valid6 = _errs25 === errors;
            } else {
              var valid6 = true;
            }
            if (valid6) {
              if (data.kind !== void 0) {
                let data7 = data.kind;
                const _errs27 = errors;
                if (typeof data7 !== "string") {
                  const err22 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ChoiceMade/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
                if ("choice_made" !== data7) {
                  const err23 = { instancePath: instancePath + "/kind", schemaPath: "#/$defs/ChoiceMade/properties/kind/const", keyword: "const", params: { allowedValue: "choice_made" }, message: "must be equal to constant" };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
                var valid6 = _errs27 === errors;
              } else {
                var valid6 = true;
              }
              if (valid6) {
                if (data.part !== void 0) {
                  let data8 = data.part;
                  const _errs29 = errors;
                  const _errs30 = errors;
                  let valid7 = false;
                  const _errs31 = errors;
                  if (errors === _errs31) {
                    if (typeof data8 === "string") {
                      if (!pattern8.test(data8)) {
                        const err24 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/ChoiceMade/properties/part/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                        if (vErrors === null) {
                          vErrors = [err24];
                        } else {
                          vErrors.push(err24);
                        }
                        errors++;
                      }
                    } else {
                      const err25 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/ChoiceMade/properties/part/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err25];
                      } else {
                        vErrors.push(err25);
                      }
                      errors++;
                    }
                  }
                  var _valid1 = _errs31 === errors;
                  valid7 = valid7 || _valid1;
                  const _errs33 = errors;
                  if (data8 !== null) {
                    const err26 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/ChoiceMade/properties/part/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err26];
                    } else {
                      vErrors.push(err26);
                    }
                    errors++;
                  }
                  var _valid1 = _errs33 === errors;
                  valid7 = valid7 || _valid1;
                  if (!valid7) {
                    const err27 = { instancePath: instancePath + "/part", schemaPath: "#/$defs/ChoiceMade/properties/part/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err27];
                    } else {
                      vErrors.push(err27);
                    }
                    errors++;
                  } else {
                    errors = _errs30;
                    if (vErrors !== null) {
                      if (_errs30) {
                        vErrors.length = _errs30;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid6 = _errs29 === errors;
                } else {
                  var valid6 = true;
                }
                if (valid6) {
                  if (data.step !== void 0) {
                    let data9 = data.step;
                    const _errs35 = errors;
                    if (errors === _errs35) {
                      if (typeof data9 === "string") {
                        if (!pattern8.test(data9)) {
                          const err28 = { instancePath: instancePath + "/step", schemaPath: "#/$defs/ChoiceMade/properties/step/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' };
                          if (vErrors === null) {
                            vErrors = [err28];
                          } else {
                            vErrors.push(err28);
                          }
                          errors++;
                        }
                      } else {
                        const err29 = { instancePath: instancePath + "/step", schemaPath: "#/$defs/ChoiceMade/properties/step/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err29];
                        } else {
                          vErrors.push(err29);
                        }
                        errors++;
                      }
                    }
                    var valid6 = _errs35 === errors;
                  } else {
                    var valid6 = true;
                  }
                }
              }
            }
          }
        }
      } else {
        const err30 = { instancePath, schemaPath: "#/$defs/ChoiceMade/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
    }
    var _valid0 = _errs21 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
        if (props0 !== true) {
          props0 = true;
        }
      }
    }
  }
  if (!valid0) {
    const err31 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err31];
    } else {
      vErrors.push(err31);
    }
    errors++;
    validate176.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate176.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate176.evaluated = { "dynamicProps": true, "dynamicItems": false };
function validate175(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate175.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.condition === void 0 && (missing0 = "condition") || data.state === void 0 && (missing0 = "state")) {
        validate175.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "condition" || key0 === "evidence_entry" || key0 === "found" || key0 === "state")) {
            validate175.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.condition !== void 0) {
            const _errs2 = errors;
            if (!validate176(data.condition, { instancePath: instancePath + "/condition", parentData: data, parentDataProperty: "condition", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate176.errors : vErrors.concat(validate176.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.evidence_entry !== void 0) {
              let data1 = data.evidence_entry;
              const _errs3 = errors;
              const _errs4 = errors;
              let valid1 = false;
              const _errs5 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                const err0 = { instancePath: instancePath + "/evidence_entry", schemaPath: "#/properties/evidence_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs5 === errors;
              valid1 = valid1 || _valid0;
              const _errs7 = errors;
              if (data1 !== null) {
                const err1 = { instancePath: instancePath + "/evidence_entry", schemaPath: "#/properties/evidence_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs7 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const err2 = { instancePath: instancePath + "/evidence_entry", schemaPath: "#/properties/evidence_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
                validate175.errors = vErrors;
                return false;
              } else {
                errors = _errs4;
                if (vErrors !== null) {
                  if (_errs4) {
                    vErrors.length = _errs4;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.found !== void 0) {
                let data2 = data.found;
                const _errs9 = errors;
                const _errs10 = errors;
                let valid2 = false;
                const _errs11 = errors;
                if (typeof data2 !== "string") {
                  const err3 = { instancePath: instancePath + "/found", schemaPath: "#/properties/found/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var _valid1 = _errs11 === errors;
                valid2 = valid2 || _valid1;
                const _errs13 = errors;
                if (data2 !== null) {
                  const err4 = { instancePath: instancePath + "/found", schemaPath: "#/properties/found/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var _valid1 = _errs13 === errors;
                valid2 = valid2 || _valid1;
                if (!valid2) {
                  const err5 = { instancePath: instancePath + "/found", schemaPath: "#/properties/found/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                  validate175.errors = vErrors;
                  return false;
                } else {
                  errors = _errs10;
                  if (vErrors !== null) {
                    if (_errs10) {
                      vErrors.length = _errs10;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.state !== void 0) {
                  let data3 = data.state;
                  const _errs15 = errors;
                  if (typeof data3 !== "string") {
                    validate175.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ConditionState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data3 === "satisfied" || data3 === "unsatisfied" || data3 === "undetermined")) {
                    validate175.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ConditionState/enum", keyword: "enum", params: { allowedValues: schema238.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate175.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate175.errors = vErrors;
  return errors === 0;
}
validate175.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate174(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate174.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.state === void 0 && (missing0 = "state")) {
        validate174.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "conditions" || key0 === "state")) {
            validate174.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.conditions !== void 0) {
            let data0 = data.conditions;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs4 = errors;
                  if (!validate175(data0[i0], { instancePath: instancePath + "/conditions/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate174.errors = [{ instancePath: instancePath + "/conditions", schemaPath: "#/properties/conditions/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.state !== void 0) {
              let data2 = data.state;
              const _errs5 = errors;
              if (typeof data2 !== "string") {
                validate174.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/OutcomeState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data2 === "satisfied" || data2 === "unsatisfied" || data2 === "undetermined" || data2 === "not_declared")) {
                validate174.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/OutcomeState/enum", keyword: "enum", params: { allowedValues: schema239.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate174.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate174.errors = vErrors;
  return errors === 0;
}
validate174.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate173(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate173.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.reference === void 0 && (missing0 = "reference") || data.active === void 0 && (missing0 = "active") || data.completed === void 0 && (missing0 = "completed")) {
        validate173.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "active" || key0 === "completed" || key0 === "completed_entry" || key0 === "outcome" || key0 === "reference")) {
            validate173.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.active !== void 0) {
            const _errs2 = errors;
            if (typeof data.active !== "boolean") {
              validate173.errors = [{ instancePath: instancePath + "/active", schemaPath: "#/properties/active/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.completed !== void 0) {
              const _errs4 = errors;
              if (typeof data.completed !== "boolean") {
                validate173.errors = [{ instancePath: instancePath + "/completed", schemaPath: "#/properties/completed/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.completed_entry !== void 0) {
                let data2 = data.completed_entry;
                const _errs6 = errors;
                const _errs7 = errors;
                let valid1 = false;
                const _errs8 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  const err0 = { instancePath: instancePath + "/completed_entry", schemaPath: "#/properties/completed_entry/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                var _valid0 = _errs8 === errors;
                valid1 = valid1 || _valid0;
                const _errs10 = errors;
                if (data2 !== null) {
                  const err1 = { instancePath: instancePath + "/completed_entry", schemaPath: "#/properties/completed_entry/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var _valid0 = _errs10 === errors;
                valid1 = valid1 || _valid0;
                if (!valid1) {
                  const err2 = { instancePath: instancePath + "/completed_entry", schemaPath: "#/properties/completed_entry/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                  validate173.errors = vErrors;
                  return false;
                } else {
                  errors = _errs7;
                  if (vErrors !== null) {
                    if (_errs7) {
                      vErrors.length = _errs7;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.outcome !== void 0) {
                  const _errs12 = errors;
                  if (!validate174(data.outcome, { instancePath: instancePath + "/outcome", parentData: data, parentDataProperty: "outcome", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate174.errors : vErrors.concat(validate174.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.reference !== void 0) {
                    const _errs13 = errors;
                    if (typeof data.reference !== "string") {
                      validate173.errors = [{ instancePath: instancePath + "/reference", schemaPath: "#/properties/reference/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs13 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate173.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate173.errors = vErrors;
  return errors === 0;
}
validate173.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate162(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate162.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.revision === void 0 && (missing0 = "revision") || data.through_entry === void 0 && (missing0 = "through_entry") || data.display_status === void 0 && (missing0 = "display_status")) {
        validate162.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "current_step" || key0 === "display_status" || key0 === "open_human_step" || key0 === "revision" || key0 === "through_entry" || key0 === "waits" || key0 === "workflow")) {
            validate162.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.current_step !== void 0) {
            let data0 = data.current_step;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!validate163(data0, { instancePath: instancePath + "/current_step", parentData: data, parentDataProperty: "current_step", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate163.errors : vErrors.concat(validate163.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs5 = errors;
            if (data0 !== null) {
              const err0 = { instancePath: instancePath + "/current_step", schemaPath: "#/properties/current_step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs5 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err1 = { instancePath: instancePath + "/current_step", schemaPath: "#/properties/current_step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              validate162.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.display_status !== void 0) {
              let data1 = data.display_status;
              const _errs7 = errors;
              if (typeof data1 !== "string") {
                validate162.errors = [{ instancePath: instancePath + "/display_status", schemaPath: "#/$defs/ThreadDisplayStatus/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "closed" || data1 === "approval" || data1 === "waiting" || data1 === "offline" || data1 === "working" || data1 === "input" || data1 === "ready" || data1 === "failed" || data1 === "done")) {
                validate162.errors = [{ instancePath: instancePath + "/display_status", schemaPath: "#/$defs/ThreadDisplayStatus/enum", keyword: "enum", params: { allowedValues: schema219.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.open_human_step !== void 0) {
                let data2 = data.open_human_step;
                const _errs10 = errors;
                const _errs11 = errors;
                let valid3 = false;
                const _errs12 = errors;
                if (!validate165(data2, { instancePath: instancePath + "/open_human_step", parentData: data, parentDataProperty: "open_human_step", rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate165.errors : vErrors.concat(validate165.errors);
                  errors = vErrors.length;
                }
                var _valid1 = _errs12 === errors;
                valid3 = valid3 || _valid1;
                const _errs13 = errors;
                if (data2 !== null) {
                  const err2 = { instancePath: instancePath + "/open_human_step", schemaPath: "#/properties/open_human_step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var _valid1 = _errs13 === errors;
                valid3 = valid3 || _valid1;
                if (!valid3) {
                  const err3 = { instancePath: instancePath + "/open_human_step", schemaPath: "#/properties/open_human_step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                  validate162.errors = vErrors;
                  return false;
                } else {
                  errors = _errs11;
                  if (vErrors !== null) {
                    if (_errs11) {
                      vErrors.length = _errs11;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.revision !== void 0) {
                  let data3 = data.revision;
                  const _errs15 = errors;
                  if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                    validate162.errors = [{ instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.through_entry !== void 0) {
                    let data4 = data.through_entry;
                    const _errs17 = errors;
                    if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)))) {
                      validate162.errors = [{ instancePath: instancePath + "/through_entry", schemaPath: "#/properties/through_entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.waits !== void 0) {
                      let data5 = data.waits;
                      const _errs19 = errors;
                      if (errors === _errs19) {
                        if (Array.isArray(data5)) {
                          var valid4 = true;
                          const len0 = data5.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            const _errs21 = errors;
                            if (!validate167(data5[i0], { instancePath: instancePath + "/waits/" + i0, parentData: data5, parentDataProperty: i0, rootData, dynamicAnchors })) {
                              vErrors = vErrors === null ? validate167.errors : vErrors.concat(validate167.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs21 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        } else {
                          validate162.errors = [{ instancePath: instancePath + "/waits", schemaPath: "#/properties/waits/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs19 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.workflow !== void 0) {
                        let data7 = data.workflow;
                        const _errs22 = errors;
                        const _errs23 = errors;
                        let valid5 = false;
                        const _errs24 = errors;
                        if (!validate173(data7, { instancePath: instancePath + "/workflow", parentData: data, parentDataProperty: "workflow", rootData, dynamicAnchors })) {
                          vErrors = vErrors === null ? validate173.errors : vErrors.concat(validate173.errors);
                          errors = vErrors.length;
                        }
                        var _valid2 = _errs24 === errors;
                        valid5 = valid5 || _valid2;
                        const _errs25 = errors;
                        if (data7 !== null) {
                          const err4 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                          if (vErrors === null) {
                            vErrors = [err4];
                          } else {
                            vErrors.push(err4);
                          }
                          errors++;
                        }
                        var _valid2 = _errs25 === errors;
                        valid5 = valid5 || _valid2;
                        if (!valid5) {
                          const err5 = { instancePath: instancePath + "/workflow", schemaPath: "#/properties/workflow/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                          validate162.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs23;
                          if (vErrors !== null) {
                            if (_errs23) {
                              vErrors.length = _errs23;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs22 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate162.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate162.errors = vErrors;
  return errors === 0;
}
validate162.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate144(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate144.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.state === void 0 && (missing0 = "state") || data.host === void 0 && (missing0 = "host") || data.attached_connector === void 0 && (missing0 = "attached_connector") || data.connector_online === void 0 && (missing0 = "connector_online") || data.route_unavailable_because === void 0 && (missing0 = "route_unavailable_because") || data.title === void 0 && (missing0 = "title") || data.settings === void 0 && (missing0 = "settings") || data.bindings === void 0 && (missing0 = "bindings") || data.serves_participants === void 0 && (missing0 = "serves_participants") || data.projection === void 0 && (missing0 = "projection") || data.detail === void 0 && (missing0 = "detail")) {
        validate144.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema193.properties, key0)) {
            validate144.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.attached_connector !== void 0) {
            let data0 = data.attached_connector;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate144.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.bindings !== void 0) {
              let data1 = data.bindings;
              const _errs8 = errors;
              const _errs9 = errors;
              if (errors === _errs9) {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  let missing1;
                  if (data1.content_version === void 0 && (missing1 = "content_version") || data1.corpus_version === void 0 && (missing1 = "corpus_version") || data1.subject === void 0 && (missing1 = "subject")) {
                    validate144.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                    return false;
                  } else {
                    const _errs11 = errors;
                    for (const key1 in data1) {
                      if (!(key1 === "content_version" || key1 === "context_outputs" || key1 === "corpus_version" || key1 === "selection" || key1 === "source_version" || key1 === "subject")) {
                        validate144.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                        return false;
                        break;
                      }
                    }
                    if (_errs11 === errors) {
                      if (data1.content_version !== void 0) {
                        const _errs12 = errors;
                        if (typeof data1.content_version !== "string") {
                          validate144.errors = [{ instancePath: instancePath + "/bindings/content_version", schemaPath: "#/$defs/ThreadBindings/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid3 = _errs12 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.context_outputs !== void 0) {
                          let data3 = data1.context_outputs;
                          const _errs14 = errors;
                          if (errors === _errs14) {
                            if (Array.isArray(data3)) {
                              var valid4 = true;
                              const len0 = data3.length;
                              for (let i0 = 0; i0 < len0; i0++) {
                                const _errs16 = errors;
                                if (typeof data3[i0] !== "string") {
                                  validate144.errors = [{ instancePath: instancePath + "/bindings/context_outputs/" + i0, schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid4 = _errs16 === errors;
                                if (!valid4) {
                                  break;
                                }
                              }
                            } else {
                              validate144.errors = [{ instancePath: instancePath + "/bindings/context_outputs", schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid3 = _errs14 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data1.corpus_version !== void 0) {
                            let data5 = data1.corpus_version;
                            const _errs18 = errors;
                            const _errs19 = errors;
                            let valid5 = false;
                            const _errs20 = errors;
                            if (typeof data5 !== "string") {
                              const err3 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err3];
                              } else {
                                vErrors.push(err3);
                              }
                              errors++;
                            }
                            var _valid1 = _errs20 === errors;
                            valid5 = valid5 || _valid1;
                            const _errs22 = errors;
                            if (data5 !== null) {
                              const err4 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err4];
                              } else {
                                vErrors.push(err4);
                              }
                              errors++;
                            }
                            var _valid1 = _errs22 === errors;
                            valid5 = valid5 || _valid1;
                            if (!valid5) {
                              const err5 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err5];
                              } else {
                                vErrors.push(err5);
                              }
                              errors++;
                              validate144.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs19;
                              if (vErrors !== null) {
                                if (_errs19) {
                                  vErrors.length = _errs19;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid3 = _errs18 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.selection !== void 0) {
                              let data6 = data1.selection;
                              const _errs24 = errors;
                              if (errors === _errs24) {
                                if (Array.isArray(data6)) {
                                  if (data6.length > 200) {
                                    validate144.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" }];
                                    return false;
                                  } else {
                                    var valid6 = true;
                                    const len1 = data6.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                      const _errs26 = errors;
                                      if (typeof data6[i1] !== "string") {
                                        validate144.errors = [{ instancePath: instancePath + "/bindings/selection/" + i1, schemaPath: "#/$defs/ThreadBindings/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      var valid6 = _errs26 === errors;
                                      if (!valid6) {
                                        break;
                                      }
                                    }
                                  }
                                } else {
                                  validate144.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid3 = _errs24 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.source_version !== void 0) {
                                let data8 = data1.source_version;
                                const _errs28 = errors;
                                const _errs29 = errors;
                                let valid7 = false;
                                const _errs30 = errors;
                                if (typeof data8 !== "string") {
                                  const err6 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs30 === errors;
                                valid7 = valid7 || _valid2;
                                const _errs32 = errors;
                                if (data8 !== null) {
                                  const err7 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs32 === errors;
                                valid7 = valid7 || _valid2;
                                if (!valid7) {
                                  const err8 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                  validate144.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs29;
                                  if (vErrors !== null) {
                                    if (_errs29) {
                                      vErrors.length = _errs29;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid3 = _errs28 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.subject !== void 0) {
                                  let data9 = data1.subject;
                                  const _errs34 = errors;
                                  const _errs35 = errors;
                                  let valid8 = false;
                                  const _errs36 = errors;
                                  if (typeof data9 !== "string") {
                                    const err9 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err9];
                                    } else {
                                      vErrors.push(err9);
                                    }
                                    errors++;
                                  }
                                  var _valid3 = _errs36 === errors;
                                  valid8 = valid8 || _valid3;
                                  const _errs38 = errors;
                                  if (data9 !== null) {
                                    const err10 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                  var _valid3 = _errs38 === errors;
                                  valid8 = valid8 || _valid3;
                                  if (!valid8) {
                                    const err11 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err11];
                                    } else {
                                      vErrors.push(err11);
                                    }
                                    errors++;
                                    validate144.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs35;
                                    if (vErrors !== null) {
                                      if (_errs35) {
                                        vErrors.length = _errs35;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid3 = _errs34 === errors;
                                } else {
                                  var valid3 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate144.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                  return false;
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.connector_online !== void 0) {
                const _errs40 = errors;
                if (typeof data.connector_online !== "boolean") {
                  validate144.errors = [{ instancePath: instancePath + "/connector_online", schemaPath: "#/properties/connector_online/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs40 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.departures !== void 0) {
                  let data11 = data.departures;
                  const _errs42 = errors;
                  if (errors === _errs42) {
                    if (Array.isArray(data11)) {
                      var valid9 = true;
                      const len2 = data11.length;
                      for (let i2 = 0; i2 < len2; i2++) {
                        let data12 = data11[i2];
                        const _errs44 = errors;
                        const _errs45 = errors;
                        if (errors === _errs45) {
                          if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                            let missing2;
                            if (data12.workflow === void 0 && (missing2 = "workflow") || data12.after_step === void 0 && (missing2 = "after_step")) {
                              validate144.errors = [{ instancePath: instancePath + "/departures/" + i2, schemaPath: "#/$defs/Departure/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" }];
                              return false;
                            } else {
                              const _errs47 = errors;
                              for (const key2 in data12) {
                                if (!(key2 === "after_step" || key2 === "workflow")) {
                                  validate144.errors = [{ instancePath: instancePath + "/departures/" + i2, schemaPath: "#/$defs/Departure/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" }];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs47 === errors) {
                                if (data12.after_step !== void 0) {
                                  let data13 = data12.after_step;
                                  const _errs48 = errors;
                                  const _errs49 = errors;
                                  let valid12 = false;
                                  const _errs50 = errors;
                                  if (typeof data13 !== "string") {
                                    const err12 = { instancePath: instancePath + "/departures/" + i2 + "/after_step", schemaPath: "#/$defs/Departure/properties/after_step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err12];
                                    } else {
                                      vErrors.push(err12);
                                    }
                                    errors++;
                                  }
                                  var _valid4 = _errs50 === errors;
                                  valid12 = valid12 || _valid4;
                                  const _errs52 = errors;
                                  if (data13 !== null) {
                                    const err13 = { instancePath: instancePath + "/departures/" + i2 + "/after_step", schemaPath: "#/$defs/Departure/properties/after_step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err13];
                                    } else {
                                      vErrors.push(err13);
                                    }
                                    errors++;
                                  }
                                  var _valid4 = _errs52 === errors;
                                  valid12 = valid12 || _valid4;
                                  if (!valid12) {
                                    const err14 = { instancePath: instancePath + "/departures/" + i2 + "/after_step", schemaPath: "#/$defs/Departure/properties/after_step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                    validate144.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs49;
                                    if (vErrors !== null) {
                                      if (_errs49) {
                                        vErrors.length = _errs49;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid11 = _errs48 === errors;
                                } else {
                                  var valid11 = true;
                                }
                                if (valid11) {
                                  if (data12.workflow !== void 0) {
                                    const _errs54 = errors;
                                    if (typeof data12.workflow !== "string") {
                                      validate144.errors = [{ instancePath: instancePath + "/departures/" + i2 + "/workflow", schemaPath: "#/$defs/Departure/properties/workflow/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid11 = _errs54 === errors;
                                  } else {
                                    var valid11 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate144.errors = [{ instancePath: instancePath + "/departures/" + i2, schemaPath: "#/$defs/Departure/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                            return false;
                          }
                        }
                        var valid9 = _errs44 === errors;
                        if (!valid9) {
                          break;
                        }
                      }
                    } else {
                      validate144.errors = [{ instancePath: instancePath + "/departures", schemaPath: "#/properties/departures/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs42 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.detail !== void 0) {
                    const _errs56 = errors;
                    if (!validate145(data.detail, { instancePath: instancePath + "/detail", parentData: data, parentDataProperty: "detail", rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate145.errors : vErrors.concat(validate145.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs56 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.host !== void 0) {
                      const _errs57 = errors;
                      if (typeof data.host !== "string") {
                        validate144.errors = [{ instancePath: instancePath + "/host", schemaPath: "#/properties/host/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs57 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.kept_input_changes !== void 0) {
                        let data17 = data.kept_input_changes;
                        const _errs59 = errors;
                        if (errors === _errs59) {
                          if (Array.isArray(data17)) {
                            var valid13 = true;
                            const len3 = data17.length;
                            for (let i3 = 0; i3 < len3; i3++) {
                              let data18 = data17[i3];
                              const _errs61 = errors;
                              const _errs62 = errors;
                              if (errors === _errs62) {
                                if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                                  let missing3;
                                  if (data18.step_key === void 0 && (missing3 = "step_key") || data18.input === void 0 && (missing3 = "input") || data18.read === void 0 && (missing3 = "read") || data18.now === void 0 && (missing3 = "now")) {
                                    validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3, schemaPath: "#/$defs/KeptInputChange/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" }];
                                    return false;
                                  } else {
                                    const _errs64 = errors;
                                    for (const key3 in data18) {
                                      if (!(key3 === "input" || key3 === "now" || key3 === "read" || key3 === "step_key")) {
                                        validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3, schemaPath: "#/$defs/KeptInputChange/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" }];
                                        return false;
                                        break;
                                      }
                                    }
                                    if (_errs64 === errors) {
                                      if (data18.input !== void 0) {
                                        let data19 = data18.input;
                                        const _errs65 = errors;
                                        if (errors === _errs65) {
                                          if (typeof data19 === "string") {
                                            if (!pattern8.test(data19)) {
                                              validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/input", schemaPath: "#/$defs/KeptInputChange/properties/input/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                              return false;
                                            }
                                          } else {
                                            validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/input", schemaPath: "#/$defs/KeptInputChange/properties/input/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                        }
                                        var valid15 = _errs65 === errors;
                                      } else {
                                        var valid15 = true;
                                      }
                                      if (valid15) {
                                        if (data18.now !== void 0) {
                                          const _errs67 = errors;
                                          if (typeof data18.now !== "string") {
                                            validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/now", schemaPath: "#/$defs/KeptInputChange/properties/now/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                          var valid15 = _errs67 === errors;
                                        } else {
                                          var valid15 = true;
                                        }
                                        if (valid15) {
                                          if (data18.read !== void 0) {
                                            const _errs69 = errors;
                                            if (typeof data18.read !== "string") {
                                              validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/read", schemaPath: "#/$defs/KeptInputChange/properties/read/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid15 = _errs69 === errors;
                                          } else {
                                            var valid15 = true;
                                          }
                                          if (valid15) {
                                            if (data18.step_key !== void 0) {
                                              let data22 = data18.step_key;
                                              const _errs71 = errors;
                                              if (errors === _errs71) {
                                                if (typeof data22 === "string") {
                                                  if (!pattern14.test(data22)) {
                                                    validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/step_key", schemaPath: "#/$defs/KeptInputChange/properties/step_key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' }];
                                                    return false;
                                                  }
                                                } else {
                                                  validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/step_key", schemaPath: "#/$defs/KeptInputChange/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                              }
                                              var valid15 = _errs71 === errors;
                                            } else {
                                              var valid15 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate144.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3, schemaPath: "#/$defs/KeptInputChange/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                  return false;
                                }
                              }
                              var valid13 = _errs61 === errors;
                              if (!valid13) {
                                break;
                              }
                            }
                          } else {
                            validate144.errors = [{ instancePath: instancePath + "/kept_input_changes", schemaPath: "#/properties/kept_input_changes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs59 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.latest_outcome !== void 0) {
                          let data23 = data.latest_outcome;
                          const _errs73 = errors;
                          const _errs74 = errors;
                          let valid16 = false;
                          const _errs75 = errors;
                          if (!validate138(data23, { instancePath: instancePath + "/latest_outcome", parentData: data, parentDataProperty: "latest_outcome", rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate138.errors : vErrors.concat(validate138.errors);
                            errors = vErrors.length;
                          }
                          var _valid5 = _errs75 === errors;
                          valid16 = valid16 || _valid5;
                          const _errs76 = errors;
                          if (data23 !== null) {
                            const err15 = { instancePath: instancePath + "/latest_outcome", schemaPath: "#/properties/latest_outcome/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err15];
                            } else {
                              vErrors.push(err15);
                            }
                            errors++;
                          }
                          var _valid5 = _errs76 === errors;
                          valid16 = valid16 || _valid5;
                          if (!valid16) {
                            const err16 = { instancePath: instancePath + "/latest_outcome", schemaPath: "#/properties/latest_outcome/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err16];
                            } else {
                              vErrors.push(err16);
                            }
                            errors++;
                            validate144.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs74;
                            if (vErrors !== null) {
                              if (_errs74) {
                                vErrors.length = _errs74;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs73 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.projection !== void 0) {
                            const _errs78 = errors;
                            if (!validate162(data.projection, { instancePath: instancePath + "/projection", parentData: data, parentDataProperty: "projection", rootData, dynamicAnchors })) {
                              vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs78 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.route_unavailable_because !== void 0) {
                              let data25 = data.route_unavailable_because;
                              const _errs79 = errors;
                              const _errs80 = errors;
                              let valid17 = false;
                              const _errs81 = errors;
                              if (typeof data25 !== "string") {
                                const err17 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/$defs/RouteUnavailability/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err17];
                                } else {
                                  vErrors.push(err17);
                                }
                                errors++;
                              }
                              if (!(data25 === "not_installed" || data25 === "not_logged_in" || data25 === "failed" || data25 === "no_key" || data25 === "blocked" || data25 === "model_unavailable")) {
                                const err18 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/$defs/RouteUnavailability/enum", keyword: "enum", params: { allowedValues: schema240.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                              var _valid6 = _errs81 === errors;
                              valid17 = valid17 || _valid6;
                              const _errs84 = errors;
                              if (data25 !== null) {
                                const err19 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/properties/route_unavailable_because/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                              }
                              var _valid6 = _errs84 === errors;
                              valid17 = valid17 || _valid6;
                              if (!valid17) {
                                const err20 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/properties/route_unavailable_because/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                                validate144.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs80;
                                if (vErrors !== null) {
                                  if (_errs80) {
                                    vErrors.length = _errs80;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs79 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.serves_participants !== void 0) {
                                const _errs86 = errors;
                                if (typeof data.serves_participants !== "boolean") {
                                  validate144.errors = [{ instancePath: instancePath + "/serves_participants", schemaPath: "#/properties/serves_participants/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                  return false;
                                }
                                var valid0 = _errs86 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.settings !== void 0) {
                                  const _errs88 = errors;
                                  if (!validate27(data.settings, { instancePath: instancePath + "/settings", parentData: data, parentDataProperty: "settings", rootData, dynamicAnchors })) {
                                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid0 = _errs88 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.state !== void 0) {
                                    let data28 = data.state;
                                    const _errs89 = errors;
                                    if (typeof data28 !== "string") {
                                      validate144.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    if (!(data28 === "saved" || data28 === "live" || data28 === "closed")) {
                                      validate144.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/enum", keyword: "enum", params: { allowedValues: schema241.enum }, message: "must be equal to one of the allowed values" }];
                                      return false;
                                    }
                                    var valid0 = _errs89 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.title !== void 0) {
                                      const _errs92 = errors;
                                      if (typeof data.title !== "string") {
                                        validate144.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      var valid0 = _errs92 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.waiting_for_sender !== void 0) {
                                        let data30 = data.waiting_for_sender;
                                        const _errs94 = errors;
                                        if (errors === _errs94) {
                                          if (Array.isArray(data30)) {
                                            var valid20 = true;
                                            const len4 = data30.length;
                                            for (let i4 = 0; i4 < len4; i4++) {
                                              let data31 = data30[i4];
                                              const _errs96 = errors;
                                              if (!(typeof data31 == "number" && (!(data31 % 1) && !isNaN(data31)))) {
                                                validate144.errors = [{ instancePath: instancePath + "/waiting_for_sender/" + i4, schemaPath: "#/properties/waiting_for_sender/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                                return false;
                                              }
                                              var valid20 = _errs96 === errors;
                                              if (!valid20) {
                                                break;
                                              }
                                            }
                                          } else {
                                            validate144.errors = [{ instancePath: instancePath + "/waiting_for_sender", schemaPath: "#/properties/waiting_for_sender/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                            return false;
                                          }
                                        }
                                        var valid0 = _errs94 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate144.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate144.errors = vErrors;
  return errors === 0;
}
validate144.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema244 = { "enum": ["post_message", "request_reply", "cancel_turn", "answer_request", "run_step", "skip_step", "run_to", "stop_run_to", "reopen", "offer_hosting", "request_hosting", "attach", "move_hosting", "accept_hosting", "approve_hosting", "rename", "change_settings", "leave_workflow", "resume_workflow", "switch_workflow", "run_on_many", "fork", "save_as_workflow", "remove"], "title": "ViewerActionName", "type": "string" };
var schema245 = { "description": "What a refusal is about, so the web knows whether to offer the action at all.", "enum": ["viewer", "prerequisite", "state"], "title": "RefusalConcern", "type": "string" };
var schema246 = { "description": "Why an action is not open to a person now; the web says it, and where it can be done.", "enum": ["closed", "saved_not_host", "not_host", "not_own_route", "turn_open", "request_waiting", "already_host", "no_active_workflow", "step_not_skippable", "step_already_ran"], "title": "ActionRefusal", "type": "string" };
var schema247 = { "description": "Module A's refusal, served by every module that asks A (decided by A's access owner,\n1 Nov): the person lacks a permission the action needs, which A's `remedy` names. Here\nuntil A serves its own decisions (SOT-02 slice 3).", "enum": ["missing_permission"], "title": "PermissionRefusal", "type": "string" };
function validate185(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate185.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.action === void 0 && (missing0 = "action")) {
        validate185.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "action" || key0 === "allowed" || key0 === "concern" || key0 === "refusal" || key0 === "remedy" || key0 === "target")) {
            validate185.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.action !== void 0) {
            let data0 = data.action;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate185.errors = [{ instancePath: instancePath + "/action", schemaPath: "#/$defs/ViewerActionName/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "post_message" || data0 === "request_reply" || data0 === "cancel_turn" || data0 === "answer_request" || data0 === "run_step" || data0 === "skip_step" || data0 === "run_to" || data0 === "stop_run_to" || data0 === "reopen" || data0 === "offer_hosting" || data0 === "request_hosting" || data0 === "attach" || data0 === "move_hosting" || data0 === "accept_hosting" || data0 === "approve_hosting" || data0 === "rename" || data0 === "change_settings" || data0 === "leave_workflow" || data0 === "resume_workflow" || data0 === "switch_workflow" || data0 === "run_on_many" || data0 === "fork" || data0 === "save_as_workflow" || data0 === "remove")) {
              validate185.errors = [{ instancePath: instancePath + "/action", schemaPath: "#/$defs/ViewerActionName/enum", keyword: "enum", params: { allowedValues: schema244.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.allowed !== void 0) {
              const _errs5 = errors;
              if (typeof data.allowed !== "boolean") {
                validate185.errors = [{ instancePath: instancePath + "/allowed", schemaPath: "#/properties/allowed/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.concern !== void 0) {
                let data2 = data.concern;
                const _errs7 = errors;
                const _errs8 = errors;
                let valid2 = false;
                const _errs9 = errors;
                if (typeof data2 !== "string") {
                  const err0 = { instancePath: instancePath + "/concern", schemaPath: "#/$defs/RefusalConcern/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                if (!(data2 === "viewer" || data2 === "prerequisite" || data2 === "state")) {
                  const err1 = { instancePath: instancePath + "/concern", schemaPath: "#/$defs/RefusalConcern/enum", keyword: "enum", params: { allowedValues: schema245.enum }, message: "must be equal to one of the allowed values" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var _valid0 = _errs9 === errors;
                valid2 = valid2 || _valid0;
                const _errs12 = errors;
                if (data2 !== null) {
                  const err2 = { instancePath: instancePath + "/concern", schemaPath: "#/properties/concern/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var _valid0 = _errs12 === errors;
                valid2 = valid2 || _valid0;
                if (!valid2) {
                  const err3 = { instancePath: instancePath + "/concern", schemaPath: "#/properties/concern/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                  validate185.errors = vErrors;
                  return false;
                } else {
                  errors = _errs8;
                  if (vErrors !== null) {
                    if (_errs8) {
                      vErrors.length = _errs8;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.refusal !== void 0) {
                  let data3 = data.refusal;
                  const _errs14 = errors;
                  const _errs15 = errors;
                  let valid4 = false;
                  const _errs16 = errors;
                  if (typeof data3 !== "string") {
                    const err4 = { instancePath: instancePath + "/refusal", schemaPath: "#/$defs/ActionRefusal/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  if (!(data3 === "closed" || data3 === "saved_not_host" || data3 === "not_host" || data3 === "not_own_route" || data3 === "turn_open" || data3 === "request_waiting" || data3 === "already_host" || data3 === "no_active_workflow" || data3 === "step_not_skippable" || data3 === "step_already_ran")) {
                    const err5 = { instancePath: instancePath + "/refusal", schemaPath: "#/$defs/ActionRefusal/enum", keyword: "enum", params: { allowedValues: schema246.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                  var _valid1 = _errs16 === errors;
                  valid4 = valid4 || _valid1;
                  const _errs19 = errors;
                  if (typeof data3 !== "string") {
                    const err6 = { instancePath: instancePath + "/refusal", schemaPath: "#/$defs/PermissionRefusal/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                  }
                  if (!(data3 === "missing_permission")) {
                    const err7 = { instancePath: instancePath + "/refusal", schemaPath: "#/$defs/PermissionRefusal/enum", keyword: "enum", params: { allowedValues: schema247.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                  }
                  var _valid1 = _errs19 === errors;
                  valid4 = valid4 || _valid1;
                  const _errs22 = errors;
                  if (data3 !== null) {
                    const err8 = { instancePath: instancePath + "/refusal", schemaPath: "#/properties/refusal/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                  var _valid1 = _errs22 === errors;
                  valid4 = valid4 || _valid1;
                  if (!valid4) {
                    const err9 = { instancePath: instancePath + "/refusal", schemaPath: "#/properties/refusal/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err9];
                    } else {
                      vErrors.push(err9);
                    }
                    errors++;
                    validate185.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs15;
                    if (vErrors !== null) {
                      if (_errs15) {
                        vErrors.length = _errs15;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.remedy !== void 0) {
                    let data4 = data.remedy;
                    const _errs24 = errors;
                    const _errs25 = errors;
                    let valid7 = false;
                    const _errs26 = errors;
                    const _errs27 = errors;
                    if (errors === _errs27) {
                      if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                        let missing1;
                        if (data4.needs === void 0 && (missing1 = "needs") || data4.holders === void 0 && (missing1 = "holders") || data4.deciders === void 0 && (missing1 = "deciders") || data4.can_request === void 0 && (missing1 = "can_request")) {
                          const err10 = { instancePath: instancePath + "/remedy", schemaPath: "#/$defs/AccessRemedy/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                        } else {
                          const _errs29 = errors;
                          for (const key1 in data4) {
                            if (!(key1 === "can_request" || key1 === "deciders" || key1 === "holders" || key1 === "needs")) {
                              const err11 = { instancePath: instancePath + "/remedy", schemaPath: "#/$defs/AccessRemedy/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                              if (vErrors === null) {
                                vErrors = [err11];
                              } else {
                                vErrors.push(err11);
                              }
                              errors++;
                              break;
                            }
                          }
                          if (_errs29 === errors) {
                            if (data4.can_request !== void 0) {
                              const _errs30 = errors;
                              if (typeof data4.can_request !== "boolean") {
                                const err12 = { instancePath: instancePath + "/remedy/can_request", schemaPath: "#/$defs/AccessRemedy/properties/can_request/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                if (vErrors === null) {
                                  vErrors = [err12];
                                } else {
                                  vErrors.push(err12);
                                }
                                errors++;
                              }
                              var valid9 = _errs30 === errors;
                            } else {
                              var valid9 = true;
                            }
                            if (valid9) {
                              if (data4.deciders !== void 0) {
                                let data6 = data4.deciders;
                                const _errs32 = errors;
                                if (errors === _errs32) {
                                  if (Array.isArray(data6)) {
                                    var valid10 = true;
                                    const len0 = data6.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs34 = errors;
                                      if (typeof data6[i0] !== "string") {
                                        const err13 = { instancePath: instancePath + "/remedy/deciders/" + i0, schemaPath: "#/$defs/AccessRemedy/properties/deciders/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err13];
                                        } else {
                                          vErrors.push(err13);
                                        }
                                        errors++;
                                      }
                                      var valid10 = _errs34 === errors;
                                      if (!valid10) {
                                        break;
                                      }
                                    }
                                  } else {
                                    const err14 = { instancePath: instancePath + "/remedy/deciders", schemaPath: "#/$defs/AccessRemedy/properties/deciders/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                  }
                                }
                                var valid9 = _errs32 === errors;
                              } else {
                                var valid9 = true;
                              }
                              if (valid9) {
                                if (data4.holders !== void 0) {
                                  let data8 = data4.holders;
                                  const _errs36 = errors;
                                  if (errors === _errs36) {
                                    if (Array.isArray(data8)) {
                                      var valid11 = true;
                                      const len1 = data8.length;
                                      for (let i1 = 0; i1 < len1; i1++) {
                                        const _errs38 = errors;
                                        if (typeof data8[i1] !== "string") {
                                          const err15 = { instancePath: instancePath + "/remedy/holders/" + i1, schemaPath: "#/$defs/AccessRemedy/properties/holders/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err15];
                                          } else {
                                            vErrors.push(err15);
                                          }
                                          errors++;
                                        }
                                        var valid11 = _errs38 === errors;
                                        if (!valid11) {
                                          break;
                                        }
                                      }
                                    } else {
                                      const err16 = { instancePath: instancePath + "/remedy/holders", schemaPath: "#/$defs/AccessRemedy/properties/holders/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                      if (vErrors === null) {
                                        vErrors = [err16];
                                      } else {
                                        vErrors.push(err16);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid9 = _errs36 === errors;
                                } else {
                                  var valid9 = true;
                                }
                                if (valid9) {
                                  if (data4.needs !== void 0) {
                                    const _errs40 = errors;
                                    if (typeof data4.needs !== "string") {
                                      const err17 = { instancePath: instancePath + "/remedy/needs", schemaPath: "#/$defs/AccessRemedy/properties/needs/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err17];
                                      } else {
                                        vErrors.push(err17);
                                      }
                                      errors++;
                                    }
                                    var valid9 = _errs40 === errors;
                                  } else {
                                    var valid9 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        const err18 = { instancePath: instancePath + "/remedy", schemaPath: "#/$defs/AccessRemedy/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err18];
                        } else {
                          vErrors.push(err18);
                        }
                        errors++;
                      }
                    }
                    var _valid2 = _errs26 === errors;
                    valid7 = valid7 || _valid2;
                    const _errs42 = errors;
                    if (data4 !== null) {
                      const err19 = { instancePath: instancePath + "/remedy", schemaPath: "#/properties/remedy/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err19];
                      } else {
                        vErrors.push(err19);
                      }
                      errors++;
                    }
                    var _valid2 = _errs42 === errors;
                    valid7 = valid7 || _valid2;
                    if (!valid7) {
                      const err20 = { instancePath: instancePath + "/remedy", schemaPath: "#/properties/remedy/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err20];
                      } else {
                        vErrors.push(err20);
                      }
                      errors++;
                      validate185.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs25;
                      if (vErrors !== null) {
                        if (_errs25) {
                          vErrors.length = _errs25;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs24 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.target !== void 0) {
                      let data11 = data.target;
                      const _errs44 = errors;
                      const _errs45 = errors;
                      let valid12 = false;
                      const _errs46 = errors;
                      if (typeof data11 !== "string") {
                        const err21 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err21];
                        } else {
                          vErrors.push(err21);
                        }
                        errors++;
                      }
                      var _valid3 = _errs46 === errors;
                      valid12 = valid12 || _valid3;
                      const _errs48 = errors;
                      if (data11 !== null) {
                        const err22 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err22];
                        } else {
                          vErrors.push(err22);
                        }
                        errors++;
                      }
                      var _valid3 = _errs48 === errors;
                      valid12 = valid12 || _valid3;
                      if (!valid12) {
                        const err23 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err23];
                        } else {
                          vErrors.push(err23);
                        }
                        errors++;
                        validate185.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs45;
                        if (vErrors !== null) {
                          if (_errs45) {
                            vErrors.length = _errs45;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs44 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate185.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate185.errors = vErrors;
  return errors === 0;
}
validate185.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate184(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate184.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      const _errs1 = errors;
      for (const key0 in data) {
        if (!(key0 === "actions")) {
          validate184.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
          return false;
          break;
        }
      }
      if (_errs1 === errors) {
        if (data.actions !== void 0) {
          let data0 = data.actions;
          const _errs2 = errors;
          if (errors === _errs2) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs4 = errors;
                if (!validate185(data0[i0], { instancePath: instancePath + "/actions/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate185.errors : vErrors.concat(validate185.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs4 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate184.errors = [{ instancePath: instancePath + "/actions", schemaPath: "#/properties/actions/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
              return false;
            }
          }
        }
      }
    } else {
      validate184.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate184.errors = vErrors;
  return errors === 0;
}
validate184.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate143(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate143.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.thread_id === void 0 && (missing0 = "thread_id") || data.facts === void 0 && (missing0 = "facts") || data.viewer === void 0 && (missing0 = "viewer")) {
        validate143.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "facts" || key0 === "thread_id" || key0 === "type" || key0 === "viewer")) {
            validate143.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.facts !== void 0) {
            const _errs2 = errors;
            if (!validate144(data.facts, { instancePath: instancePath + "/facts", parentData: data, parentDataProperty: "facts", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate144.errors : vErrors.concat(validate144.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.thread_id !== void 0) {
              const _errs3 = errors;
              if (typeof data.thread_id !== "string") {
                validate143.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.type !== void 0) {
                let data2 = data.type;
                const _errs5 = errors;
                if (typeof data2 !== "string") {
                  validate143.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("thread_state" !== data2) {
                  validate143.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "thread_state" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.viewer !== void 0) {
                  const _errs7 = errors;
                  if (!validate184(data.viewer, { instancePath: instancePath + "/viewer", parentData: data, parentDataProperty: "viewer", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate184.errors : vErrors.concat(validate184.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate143.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate143.errors = vErrors;
  return errors === 0;
}
validate143.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate190(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate190.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.tool_call_id === void 0 && (missing0 = "tool_call_id") || data.title === void 0 && (missing0 = "title") || data.tool_kind === void 0 && (missing0 = "tool_kind") || data.status === void 0 && (missing0 = "status")) {
        validate190.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.kind !== void 0) {
          let data0 = data.kind;
          const _errs1 = errors;
          if (typeof data0 !== "string") {
            validate190.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
            return false;
          }
          if ("tool_call" !== data0) {
            validate190.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "tool_call" }, message: "must be equal to constant" }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.status !== void 0) {
            let data1 = data.status;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate190.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/ToolCallStatus/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data1 === "pending" || data1 === "in_progress" || data1 === "completed" || data1 === "failed")) {
              validate190.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/ToolCallStatus/enum", keyword: "enum", params: { allowedValues: schema121.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.title !== void 0) {
              const _errs6 = errors;
              if (typeof data.title !== "string") {
                validate190.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.tool_call_id !== void 0) {
                let data3 = data.tool_call_id;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (typeof data3 === "string") {
                    if (func2(data3) > 200) {
                      validate190.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" }];
                      return false;
                    } else {
                      if (func2(data3) < 1) {
                        validate190.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" }];
                        return false;
                      }
                    }
                  } else {
                    validate190.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.tool_kind !== void 0) {
                  let data4 = data.tool_kind;
                  const _errs10 = errors;
                  if (typeof data4 !== "string") {
                    validate190.errors = [{ instancePath: instancePath + "/tool_kind", schemaPath: "#/$defs/ToolKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data4 === "read" || data4 === "edit" || data4 === "delete" || data4 === "move" || data4 === "search" || data4 === "execute" || data4 === "think" || data4 === "fetch" || data4 === "switch_mode" || data4 === "other")) {
                    validate190.errors = [{ instancePath: instancePath + "/tool_kind", schemaPath: "#/$defs/ToolKind/enum", keyword: "enum", params: { allowedValues: schema122.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate190.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate190.errors = vErrors;
  return errors === 0;
}
validate190.evaluated = { "props": { "kind": true, "status": true, "title": true, "tool_call_id": true, "tool_kind": true }, "dynamicProps": false, "dynamicItems": false };
var schema256 = { "enum": ["high", "medium", "low"], "title": "PlanEntryPriority", "type": "string" };
var schema257 = { "enum": ["pending", "in_progress", "completed"], "title": "PlanEntryStatus", "type": "string" };
function validate193(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate193.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.content === void 0 && (missing0 = "content") || data.priority === void 0 && (missing0 = "priority") || data.status === void 0 && (missing0 = "status")) {
        validate193.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.content !== void 0) {
          const _errs1 = errors;
          if (typeof data.content !== "string") {
            validate193.errors = [{ instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.priority !== void 0) {
            let data1 = data.priority;
            const _errs3 = errors;
            if (typeof data1 !== "string") {
              validate193.errors = [{ instancePath: instancePath + "/priority", schemaPath: "#/$defs/PlanEntryPriority/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data1 === "high" || data1 === "medium" || data1 === "low")) {
              validate193.errors = [{ instancePath: instancePath + "/priority", schemaPath: "#/$defs/PlanEntryPriority/enum", keyword: "enum", params: { allowedValues: schema256.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.status !== void 0) {
              let data2 = data.status;
              const _errs6 = errors;
              if (typeof data2 !== "string") {
                validate193.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/PlanEntryStatus/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data2 === "pending" || data2 === "in_progress" || data2 === "completed")) {
                validate193.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/PlanEntryStatus/enum", keyword: "enum", params: { allowedValues: schema257.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate193.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate193.errors = vErrors;
  return errors === 0;
}
validate193.evaluated = { "props": { "content": true, "priority": true, "status": true }, "dynamicProps": false, "dynamicItems": false };
function validate192(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate192.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.kind === void 0 && (missing0 = "kind") || data.entries === void 0 && (missing0 = "entries")) {
        validate192.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        if (data.entries !== void 0) {
          let data0 = data.entries;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (!validate193(data0[i0], { instancePath: instancePath + "/entries/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                  vErrors = vErrors === null ? validate193.errors : vErrors.concat(validate193.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate192.errors = [{ instancePath: instancePath + "/entries", schemaPath: "#/properties/entries/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.kind !== void 0) {
            let data2 = data.kind;
            const _errs4 = errors;
            if (typeof data2 !== "string") {
              validate192.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if ("plan" !== data2) {
              validate192.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/properties/kind/const", keyword: "const", params: { allowedValue: "plan" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate192.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate192.errors = vErrors;
  return errors === 0;
}
validate192.evaluated = { "props": { "entries": true, "kind": true }, "dynamicProps": false, "dynamicItems": false };
function validate189(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate189.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.thread_id === void 0 && (missing0 = "thread_id") || data.turn_id === void 0 && (missing0 = "turn_id") || data.progress_sequence === void 0 && (missing0 = "progress_sequence") || data.events === void 0 && (missing0 = "events")) {
        validate189.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "events" || key0 === "progress_sequence" || key0 === "thread_id" || key0 === "turn_id" || key0 === "type")) {
            validate189.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.events !== void 0) {
            let data0 = data.events;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  const _errs5 = errors;
                  let valid2 = false;
                  let passing0 = null;
                  const _errs6 = errors;
                  const _errs7 = errors;
                  if (errors === _errs7) {
                    if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                      let missing1;
                      if (data1.kind === void 0 && (missing1 = "kind") || data1.message_index === void 0 && (missing1 = "message_index") || data1.text === void 0 && (missing1 = "text")) {
                        const err0 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/$defs/MessageDeltaEvent/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      } else {
                        if (data1.kind !== void 0) {
                          let data2 = data1.kind;
                          const _errs9 = errors;
                          if (typeof data2 !== "string") {
                            const err1 = { instancePath: instancePath + "/events/" + i0 + "/kind", schemaPath: "#/$defs/MessageDeltaEvent/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          if ("message_delta" !== data2) {
                            const err2 = { instancePath: instancePath + "/events/" + i0 + "/kind", schemaPath: "#/$defs/MessageDeltaEvent/properties/kind/const", keyword: "const", params: { allowedValue: "message_delta" }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                          }
                          var valid4 = _errs9 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data1.message_index !== void 0) {
                            let data3 = data1.message_index;
                            const _errs11 = errors;
                            if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)))) {
                              const err3 = { instancePath: instancePath + "/events/" + i0 + "/message_index", schemaPath: "#/$defs/MessageDeltaEvent/properties/message_index/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                              if (vErrors === null) {
                                vErrors = [err3];
                              } else {
                                vErrors.push(err3);
                              }
                              errors++;
                            }
                            if (errors === _errs11) {
                              if (typeof data3 == "number") {
                                if (data3 < 0 || isNaN(data3)) {
                                  const err4 = { instancePath: instancePath + "/events/" + i0 + "/message_index", schemaPath: "#/$defs/MessageDeltaEvent/properties/message_index/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                  if (vErrors === null) {
                                    vErrors = [err4];
                                  } else {
                                    vErrors.push(err4);
                                  }
                                  errors++;
                                }
                              }
                            }
                            var valid4 = _errs11 === errors;
                          } else {
                            var valid4 = true;
                          }
                          if (valid4) {
                            if (data1.text !== void 0) {
                              const _errs13 = errors;
                              if (typeof data1.text !== "string") {
                                const err5 = { instancePath: instancePath + "/events/" + i0 + "/text", schemaPath: "#/$defs/MessageDeltaEvent/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err5];
                                } else {
                                  vErrors.push(err5);
                                }
                                errors++;
                              }
                              var valid4 = _errs13 === errors;
                            } else {
                              var valid4 = true;
                            }
                          }
                        }
                      }
                    } else {
                      const err6 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/$defs/MessageDeltaEvent/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                      if (vErrors === null) {
                        vErrors = [err6];
                      } else {
                        vErrors.push(err6);
                      }
                      errors++;
                    }
                  }
                  var _valid0 = _errs6 === errors;
                  if (_valid0) {
                    valid2 = true;
                    passing0 = 0;
                    var props0 = {};
                    props0.kind = true;
                    props0.message_index = true;
                    props0.text = true;
                  }
                  const _errs15 = errors;
                  if (!validate190(data1, { instancePath: instancePath + "/events/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate190.errors : vErrors.concat(validate190.errors);
                    errors = vErrors.length;
                  }
                  var _valid0 = _errs15 === errors;
                  if (_valid0 && valid2) {
                    valid2 = false;
                    passing0 = [passing0, 1];
                  } else {
                    if (_valid0) {
                      valid2 = true;
                      passing0 = 1;
                      if (props0 !== true) {
                        props0 = props0 || {};
                        props0.kind = true;
                        props0.status = true;
                        props0.title = true;
                        props0.tool_call_id = true;
                        props0.tool_kind = true;
                      }
                    }
                    const _errs16 = errors;
                    if (!validate192(data1, { instancePath: instancePath + "/events/" + i0, parentData: data0, parentDataProperty: i0, rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate192.errors : vErrors.concat(validate192.errors);
                      errors = vErrors.length;
                    }
                    var _valid0 = _errs16 === errors;
                    if (_valid0 && valid2) {
                      valid2 = false;
                      passing0 = [passing0, 2];
                    } else {
                      if (_valid0) {
                        valid2 = true;
                        passing0 = 2;
                        if (props0 !== true) {
                          props0 = props0 || {};
                          props0.entries = true;
                          props0.kind = true;
                        }
                      }
                      const _errs17 = errors;
                      const _errs18 = errors;
                      if (errors === _errs18) {
                        if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                          let missing2;
                          if (data1.kind === void 0 && (missing2 = "kind") || data1.done === void 0 && (missing2 = "done") || data1.total === void 0 && (missing2 = "total")) {
                            const err7 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/$defs/WorkProgressEvent/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                          } else {
                            if (data1.done !== void 0) {
                              let data5 = data1.done;
                              const _errs20 = errors;
                              if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)))) {
                                const err8 = { instancePath: instancePath + "/events/" + i0 + "/done", schemaPath: "#/$defs/WorkProgressEvent/properties/done/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err8];
                                } else {
                                  vErrors.push(err8);
                                }
                                errors++;
                              }
                              if (errors === _errs20) {
                                if (typeof data5 == "number") {
                                  if (data5 < 0 || isNaN(data5)) {
                                    const err9 = { instancePath: instancePath + "/events/" + i0 + "/done", schemaPath: "#/$defs/WorkProgressEvent/properties/done/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                    if (vErrors === null) {
                                      vErrors = [err9];
                                    } else {
                                      vErrors.push(err9);
                                    }
                                    errors++;
                                  }
                                }
                              }
                              var valid6 = _errs20 === errors;
                            } else {
                              var valid6 = true;
                            }
                            if (valid6) {
                              if (data1.kind !== void 0) {
                                let data6 = data1.kind;
                                const _errs22 = errors;
                                if (typeof data6 !== "string") {
                                  const err10 = { instancePath: instancePath + "/events/" + i0 + "/kind", schemaPath: "#/$defs/WorkProgressEvent/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err10];
                                  } else {
                                    vErrors.push(err10);
                                  }
                                  errors++;
                                }
                                if ("work_progress" !== data6) {
                                  const err11 = { instancePath: instancePath + "/events/" + i0 + "/kind", schemaPath: "#/$defs/WorkProgressEvent/properties/kind/const", keyword: "const", params: { allowedValue: "work_progress" }, message: "must be equal to constant" };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                }
                                var valid6 = _errs22 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data1.total !== void 0) {
                                  let data7 = data1.total;
                                  const _errs24 = errors;
                                  if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)))) {
                                    const err12 = { instancePath: instancePath + "/events/" + i0 + "/total", schemaPath: "#/$defs/WorkProgressEvent/properties/total/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err12];
                                    } else {
                                      vErrors.push(err12);
                                    }
                                    errors++;
                                  }
                                  if (errors === _errs24) {
                                    if (typeof data7 == "number") {
                                      if (data7 < 1 || isNaN(data7)) {
                                        const err13 = { instancePath: instancePath + "/events/" + i0 + "/total", schemaPath: "#/$defs/WorkProgressEvent/properties/total/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                          vErrors = [err13];
                                        } else {
                                          vErrors.push(err13);
                                        }
                                        errors++;
                                      }
                                    }
                                  }
                                  var valid6 = _errs24 === errors;
                                } else {
                                  var valid6 = true;
                                }
                              }
                            }
                          }
                        } else {
                          const err14 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/$defs/WorkProgressEvent/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                          if (vErrors === null) {
                            vErrors = [err14];
                          } else {
                            vErrors.push(err14);
                          }
                          errors++;
                        }
                      }
                      var _valid0 = _errs17 === errors;
                      if (_valid0 && valid2) {
                        valid2 = false;
                        passing0 = [passing0, 3];
                      } else {
                        if (_valid0) {
                          valid2 = true;
                          passing0 = 3;
                          if (props0 !== true) {
                            props0 = props0 || {};
                            props0.done = true;
                            props0.kind = true;
                            props0.total = true;
                          }
                        }
                        const _errs26 = errors;
                        const _errs27 = errors;
                        if (errors === _errs27) {
                          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                            let missing3;
                            if (data1.kind === void 0 && (missing3 = "kind") || data1.received_bytes === void 0 && (missing3 = "received_bytes") || data1.finished === void 0 && (missing3 = "finished")) {
                              const err15 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/$defs/ModelDownloadEvent/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" };
                              if (vErrors === null) {
                                vErrors = [err15];
                              } else {
                                vErrors.push(err15);
                              }
                              errors++;
                            } else {
                              if (data1.finished !== void 0) {
                                const _errs29 = errors;
                                if (typeof data1.finished !== "boolean") {
                                  const err16 = { instancePath: instancePath + "/events/" + i0 + "/finished", schemaPath: "#/$defs/ModelDownloadEvent/properties/finished/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                  if (vErrors === null) {
                                    vErrors = [err16];
                                  } else {
                                    vErrors.push(err16);
                                  }
                                  errors++;
                                }
                                var valid8 = _errs29 === errors;
                              } else {
                                var valid8 = true;
                              }
                              if (valid8) {
                                if (data1.kind !== void 0) {
                                  let data9 = data1.kind;
                                  const _errs31 = errors;
                                  if (typeof data9 !== "string") {
                                    const err17 = { instancePath: instancePath + "/events/" + i0 + "/kind", schemaPath: "#/$defs/ModelDownloadEvent/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err17];
                                    } else {
                                      vErrors.push(err17);
                                    }
                                    errors++;
                                  }
                                  if ("model_download" !== data9) {
                                    const err18 = { instancePath: instancePath + "/events/" + i0 + "/kind", schemaPath: "#/$defs/ModelDownloadEvent/properties/kind/const", keyword: "const", params: { allowedValue: "model_download" }, message: "must be equal to constant" };
                                    if (vErrors === null) {
                                      vErrors = [err18];
                                    } else {
                                      vErrors.push(err18);
                                    }
                                    errors++;
                                  }
                                  var valid8 = _errs31 === errors;
                                } else {
                                  var valid8 = true;
                                }
                                if (valid8) {
                                  if (data1.received_bytes !== void 0) {
                                    let data10 = data1.received_bytes;
                                    const _errs33 = errors;
                                    if (!(typeof data10 == "number" && (!(data10 % 1) && !isNaN(data10)))) {
                                      const err19 = { instancePath: instancePath + "/events/" + i0 + "/received_bytes", schemaPath: "#/$defs/ModelDownloadEvent/properties/received_bytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                      if (vErrors === null) {
                                        vErrors = [err19];
                                      } else {
                                        vErrors.push(err19);
                                      }
                                      errors++;
                                    }
                                    if (errors === _errs33) {
                                      if (typeof data10 == "number") {
                                        if (data10 < 0 || isNaN(data10)) {
                                          const err20 = { instancePath: instancePath + "/events/" + i0 + "/received_bytes", schemaPath: "#/$defs/ModelDownloadEvent/properties/received_bytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                          if (vErrors === null) {
                                            vErrors = [err20];
                                          } else {
                                            vErrors.push(err20);
                                          }
                                          errors++;
                                        }
                                      }
                                    }
                                    var valid8 = _errs33 === errors;
                                  } else {
                                    var valid8 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            const err21 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/$defs/ModelDownloadEvent/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err21];
                            } else {
                              vErrors.push(err21);
                            }
                            errors++;
                          }
                        }
                        var _valid0 = _errs26 === errors;
                        if (_valid0 && valid2) {
                          valid2 = false;
                          passing0 = [passing0, 4];
                        } else {
                          if (_valid0) {
                            valid2 = true;
                            passing0 = 4;
                            if (props0 !== true) {
                              props0 = props0 || {};
                              props0.finished = true;
                              props0.kind = true;
                              props0.received_bytes = true;
                            }
                          }
                        }
                      }
                    }
                  }
                  if (!valid2) {
                    const err22 = { instancePath: instancePath + "/events/" + i0, schemaPath: "#/properties/events/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                    validate189.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs5;
                    if (vErrors !== null) {
                      if (_errs5) {
                        vErrors.length = _errs5;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate189.errors = [{ instancePath: instancePath + "/events", schemaPath: "#/properties/events/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.progress_sequence !== void 0) {
              let data11 = data.progress_sequence;
              const _errs35 = errors;
              if (!(typeof data11 == "number" && (!(data11 % 1) && !isNaN(data11)))) {
                validate189.errors = [{ instancePath: instancePath + "/progress_sequence", schemaPath: "#/properties/progress_sequence/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              var valid0 = _errs35 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.thread_id !== void 0) {
                const _errs37 = errors;
                if (typeof data.thread_id !== "string") {
                  validate189.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs37 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.turn_id !== void 0) {
                  const _errs39 = errors;
                  if (typeof data.turn_id !== "string") {
                    validate189.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs39 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.type !== void 0) {
                    let data14 = data.type;
                    const _errs41 = errors;
                    if (typeof data14 !== "string") {
                      validate189.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    if ("turn_progress" !== data14) {
                      validate189.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "turn_progress" }, message: "must be equal to constant" }];
                      return false;
                    }
                    var valid0 = _errs41 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate189.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate189.errors = vErrors;
  return errors === 0;
}
validate189.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate198(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate198.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.tool_call_id === void 0 && (missing0 = "tool_call_id") || data.title === void 0 && (missing0 = "title") || data.tool_kind === void 0 && (missing0 = "tool_kind") || data.status === void 0 && (missing0 = "status")) {
        validate198.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "status" || key0 === "title" || key0 === "tool_call_id" || key0 === "tool_kind")) {
            validate198.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.status !== void 0) {
            let data0 = data.status;
            const _errs2 = errors;
            if (typeof data0 !== "string") {
              validate198.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/ToolCallStatus/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "pending" || data0 === "in_progress" || data0 === "completed" || data0 === "failed")) {
              validate198.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/$defs/ToolCallStatus/enum", keyword: "enum", params: { allowedValues: schema121.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.title !== void 0) {
              const _errs5 = errors;
              if (typeof data.title !== "string") {
                validate198.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.tool_call_id !== void 0) {
                const _errs7 = errors;
                if (typeof data.tool_call_id !== "string") {
                  validate198.errors = [{ instancePath: instancePath + "/tool_call_id", schemaPath: "#/properties/tool_call_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.tool_kind !== void 0) {
                  let data3 = data.tool_kind;
                  const _errs9 = errors;
                  if (typeof data3 !== "string") {
                    validate198.errors = [{ instancePath: instancePath + "/tool_kind", schemaPath: "#/$defs/ToolKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data3 === "read" || data3 === "edit" || data3 === "delete" || data3 === "move" || data3 === "search" || data3 === "execute" || data3 === "think" || data3 === "fetch" || data3 === "switch_mode" || data3 === "other")) {
                    validate198.errors = [{ instancePath: instancePath + "/tool_kind", schemaPath: "#/$defs/ToolKind/enum", keyword: "enum", params: { allowedValues: schema122.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate198.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate198.errors = vErrors;
  return errors === 0;
}
validate198.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate197(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate197.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.thread_id === void 0 && (missing0 = "thread_id") || data.turn_id === void 0 && (missing0 = "turn_id") || data.progress_sequence === void 0 && (missing0 = "progress_sequence") || data.messages === void 0 && (missing0 = "messages") || data.tool_calls === void 0 && (missing0 = "tool_calls")) {
        validate197.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "messages" || key0 === "model_download" || key0 === "progress_sequence" || key0 === "thread_id" || key0 === "tool_calls" || key0 === "turn_id" || key0 === "type" || key0 === "work")) {
            validate197.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.messages !== void 0) {
            let data0 = data.messages;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs4 = errors;
                  if (typeof data0[i0] !== "string") {
                    validate197.errors = [{ instancePath: instancePath + "/messages/" + i0, schemaPath: "#/properties/messages/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate197.errors = [{ instancePath: instancePath + "/messages", schemaPath: "#/properties/messages/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.model_download !== void 0) {
              let data2 = data.model_download;
              const _errs6 = errors;
              const _errs7 = errors;
              let valid2 = false;
              const _errs8 = errors;
              const _errs9 = errors;
              if (errors === _errs9) {
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                  let missing1;
                  if (data2.kind === void 0 && (missing1 = "kind") || data2.received_bytes === void 0 && (missing1 = "received_bytes") || data2.finished === void 0 && (missing1 = "finished")) {
                    const err0 = { instancePath: instancePath + "/model_download", schemaPath: "#/$defs/ModelDownloadEvent/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  } else {
                    if (data2.finished !== void 0) {
                      const _errs11 = errors;
                      if (typeof data2.finished !== "boolean") {
                        const err1 = { instancePath: instancePath + "/model_download/finished", schemaPath: "#/$defs/ModelDownloadEvent/properties/finished/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                      }
                      var valid4 = _errs11 === errors;
                    } else {
                      var valid4 = true;
                    }
                    if (valid4) {
                      if (data2.kind !== void 0) {
                        let data4 = data2.kind;
                        const _errs13 = errors;
                        if (typeof data4 !== "string") {
                          const err2 = { instancePath: instancePath + "/model_download/kind", schemaPath: "#/$defs/ModelDownloadEvent/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err2];
                          } else {
                            vErrors.push(err2);
                          }
                          errors++;
                        }
                        if ("model_download" !== data4) {
                          const err3 = { instancePath: instancePath + "/model_download/kind", schemaPath: "#/$defs/ModelDownloadEvent/properties/kind/const", keyword: "const", params: { allowedValue: "model_download" }, message: "must be equal to constant" };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                        var valid4 = _errs13 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data2.received_bytes !== void 0) {
                          let data5 = data2.received_bytes;
                          const _errs15 = errors;
                          if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)))) {
                            const err4 = { instancePath: instancePath + "/model_download/received_bytes", schemaPath: "#/$defs/ModelDownloadEvent/properties/received_bytes/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err4];
                            } else {
                              vErrors.push(err4);
                            }
                            errors++;
                          }
                          if (errors === _errs15) {
                            if (typeof data5 == "number") {
                              if (data5 < 0 || isNaN(data5)) {
                                const err5 = { instancePath: instancePath + "/model_download/received_bytes", schemaPath: "#/$defs/ModelDownloadEvent/properties/received_bytes/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                  vErrors = [err5];
                                } else {
                                  vErrors.push(err5);
                                }
                                errors++;
                              }
                            }
                          }
                          var valid4 = _errs15 === errors;
                        } else {
                          var valid4 = true;
                        }
                      }
                    }
                  }
                } else {
                  const err6 = { instancePath: instancePath + "/model_download", schemaPath: "#/$defs/ModelDownloadEvent/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs8 === errors;
              valid2 = valid2 || _valid0;
              if (_valid0) {
                var props0 = {};
                props0.finished = true;
                props0.kind = true;
                props0.received_bytes = true;
              }
              const _errs17 = errors;
              if (data2 !== null) {
                const err7 = { instancePath: instancePath + "/model_download", schemaPath: "#/properties/model_download/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              var _valid0 = _errs17 === errors;
              valid2 = valid2 || _valid0;
              if (!valid2) {
                const err8 = { instancePath: instancePath + "/model_download", schemaPath: "#/properties/model_download/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
                validate197.errors = vErrors;
                return false;
              } else {
                errors = _errs7;
                if (vErrors !== null) {
                  if (_errs7) {
                    vErrors.length = _errs7;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.progress_sequence !== void 0) {
                let data6 = data.progress_sequence;
                const _errs19 = errors;
                if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                  validate197.errors = [{ instancePath: instancePath + "/progress_sequence", schemaPath: "#/properties/progress_sequence/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                var valid0 = _errs19 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.thread_id !== void 0) {
                  const _errs21 = errors;
                  if (typeof data.thread_id !== "string") {
                    validate197.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs21 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.tool_calls !== void 0) {
                    let data8 = data.tool_calls;
                    const _errs23 = errors;
                    if (errors === _errs23) {
                      if (Array.isArray(data8)) {
                        var valid5 = true;
                        const len1 = data8.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          const _errs25 = errors;
                          if (!validate198(data8[i1], { instancePath: instancePath + "/tool_calls/" + i1, parentData: data8, parentDataProperty: i1, rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate198.errors : vErrors.concat(validate198.errors);
                            errors = vErrors.length;
                          }
                          var valid5 = _errs25 === errors;
                          if (!valid5) {
                            break;
                          }
                        }
                      } else {
                        validate197.errors = [{ instancePath: instancePath + "/tool_calls", schemaPath: "#/properties/tool_calls/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs23 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.turn_id !== void 0) {
                      const _errs26 = errors;
                      if (typeof data.turn_id !== "string") {
                        validate197.errors = [{ instancePath: instancePath + "/turn_id", schemaPath: "#/properties/turn_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs26 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.type !== void 0) {
                        let data11 = data.type;
                        const _errs28 = errors;
                        if (typeof data11 !== "string") {
                          validate197.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        if ("turn_snapshot" !== data11) {
                          validate197.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "turn_snapshot" }, message: "must be equal to constant" }];
                          return false;
                        }
                        var valid0 = _errs28 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.work !== void 0) {
                          let data12 = data.work;
                          const _errs30 = errors;
                          const _errs31 = errors;
                          let valid6 = false;
                          const _errs32 = errors;
                          const _errs33 = errors;
                          if (errors === _errs33) {
                            if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                              let missing2;
                              if (data12.kind === void 0 && (missing2 = "kind") || data12.done === void 0 && (missing2 = "done") || data12.total === void 0 && (missing2 = "total")) {
                                const err9 = { instancePath: instancePath + "/work", schemaPath: "#/$defs/WorkProgressEvent/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err9];
                                } else {
                                  vErrors.push(err9);
                                }
                                errors++;
                              } else {
                                if (data12.done !== void 0) {
                                  let data13 = data12.done;
                                  const _errs35 = errors;
                                  if (!(typeof data13 == "number" && (!(data13 % 1) && !isNaN(data13)))) {
                                    const err10 = { instancePath: instancePath + "/work/done", schemaPath: "#/$defs/WorkProgressEvent/properties/done/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                  if (errors === _errs35) {
                                    if (typeof data13 == "number") {
                                      if (data13 < 0 || isNaN(data13)) {
                                        const err11 = { instancePath: instancePath + "/work/done", schemaPath: "#/$defs/WorkProgressEvent/properties/done/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                        if (vErrors === null) {
                                          vErrors = [err11];
                                        } else {
                                          vErrors.push(err11);
                                        }
                                        errors++;
                                      }
                                    }
                                  }
                                  var valid8 = _errs35 === errors;
                                } else {
                                  var valid8 = true;
                                }
                                if (valid8) {
                                  if (data12.kind !== void 0) {
                                    let data14 = data12.kind;
                                    const _errs37 = errors;
                                    if (typeof data14 !== "string") {
                                      const err12 = { instancePath: instancePath + "/work/kind", schemaPath: "#/$defs/WorkProgressEvent/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err12];
                                      } else {
                                        vErrors.push(err12);
                                      }
                                      errors++;
                                    }
                                    if ("work_progress" !== data14) {
                                      const err13 = { instancePath: instancePath + "/work/kind", schemaPath: "#/$defs/WorkProgressEvent/properties/kind/const", keyword: "const", params: { allowedValue: "work_progress" }, message: "must be equal to constant" };
                                      if (vErrors === null) {
                                        vErrors = [err13];
                                      } else {
                                        vErrors.push(err13);
                                      }
                                      errors++;
                                    }
                                    var valid8 = _errs37 === errors;
                                  } else {
                                    var valid8 = true;
                                  }
                                  if (valid8) {
                                    if (data12.total !== void 0) {
                                      let data15 = data12.total;
                                      const _errs39 = errors;
                                      if (!(typeof data15 == "number" && (!(data15 % 1) && !isNaN(data15)))) {
                                        const err14 = { instancePath: instancePath + "/work/total", schemaPath: "#/$defs/WorkProgressEvent/properties/total/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                        if (vErrors === null) {
                                          vErrors = [err14];
                                        } else {
                                          vErrors.push(err14);
                                        }
                                        errors++;
                                      }
                                      if (errors === _errs39) {
                                        if (typeof data15 == "number") {
                                          if (data15 < 1 || isNaN(data15)) {
                                            const err15 = { instancePath: instancePath + "/work/total", schemaPath: "#/$defs/WorkProgressEvent/properties/total/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                            if (vErrors === null) {
                                              vErrors = [err15];
                                            } else {
                                              vErrors.push(err15);
                                            }
                                            errors++;
                                          }
                                        }
                                      }
                                      var valid8 = _errs39 === errors;
                                    } else {
                                      var valid8 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              const err16 = { instancePath: instancePath + "/work", schemaPath: "#/$defs/WorkProgressEvent/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                            }
                          }
                          var _valid1 = _errs32 === errors;
                          valid6 = valid6 || _valid1;
                          if (_valid1) {
                            var props1 = {};
                            props1.done = true;
                            props1.kind = true;
                            props1.total = true;
                          }
                          const _errs41 = errors;
                          if (data12 !== null) {
                            const err17 = { instancePath: instancePath + "/work", schemaPath: "#/properties/work/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err17];
                            } else {
                              vErrors.push(err17);
                            }
                            errors++;
                          }
                          var _valid1 = _errs41 === errors;
                          valid6 = valid6 || _valid1;
                          if (!valid6) {
                            const err18 = { instancePath: instancePath + "/work", schemaPath: "#/properties/work/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err18];
                            } else {
                              vErrors.push(err18);
                            }
                            errors++;
                            validate197.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs31;
                            if (vErrors !== null) {
                              if (_errs31) {
                                vErrors.length = _errs31;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs30 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate197.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate197.errors = vErrors;
  return errors === 0;
}
validate197.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var schema267 = { "additionalProperties": false, "description": "One Thread's line in its project's list: enough for its status and unread marker\nwithout reading the Thread (Q-61).", "properties": { "attached_connector": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "title": "Attached Connector" }, "can_settle_or_snooze": { "description": "Neither working nor waiting for a person's input (F44): a person may settle or snooze it.\nModule C's own rule, so the web app offers what the server accepts.", "title": "Can Settle Or Snooze", "type": "boolean" }, "created_at": { "description": "When the Thread was started or forked; the Thread list's order counts it (F44).", "format": "date-time", "title": "Created At", "type": "string" }, "edited_item": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "description": 'What an "Edit an item" Thread edits, as its edit step\'s `item` input names it\n(`<item id>@<version>`, or `<module id>@<version>#<term IRI>` for a term): the list files\nit under that item (ADR-0031 D2); `None` for any other Thread.', "title": "Edited Item" }, "host": { "title": "Host", "type": "string" }, "last_entry_at": { "format": "date-time", "title": "Last Entry At", "type": "string" }, "last_entry_number": { "title": "Last Entry Number", "type": "integer" }, "latest_person_written_at": { "anyOf": [{ "format": "date-time", "type": "string" }, { "type": "null" }], "description": "A person's message or answer; with the turn times, the list's order (F44, T3 Code).", "title": "Latest Person Written At" }, "latest_turn_finished_at": { "anyOf": [{ "format": "date-time", "type": "string" }, { "type": "null" }], "title": "Latest Turn Finished At" }, "latest_turn_requested_at": { "anyOf": [{ "format": "date-time", "type": "string" }, { "type": "null" }], "title": "Latest Turn Requested At" }, "parent": { "anyOf": [{ "type": "string" }, { "type": "null" }], "description": "The fork point `<thread id>#<number>`, or `None` for a started Thread.", "title": "Parent" }, "project_id": { "title": "Project Id", "type": "string" }, "projection": { "$ref": "#/$defs/ThreadProjection", "description": "Its status, as its overview and live state say it (W-22)." }, "state": { "$ref": "#/$defs/ThreadState" }, "subject": { "anyOf": [{ "type": "string" }, { "type": "null" }], "default": null, "title": "Subject" }, "thread_id": { "title": "Thread Id", "type": "string" }, "title": { "title": "Title", "type": "string" } }, "required": ["thread_id", "project_id", "title", "parent", "state", "host", "created_at", "last_entry_number", "last_entry_at", "latest_turn_requested_at", "latest_turn_finished_at", "latest_person_written_at", "projection", "can_settle_or_snooze"], "title": "ThreadListing", "type": "object" };
function validate202(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate202.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.thread_id === void 0 && (missing0 = "thread_id") || data.project_id === void 0 && (missing0 = "project_id") || data.title === void 0 && (missing0 = "title") || data.parent === void 0 && (missing0 = "parent") || data.state === void 0 && (missing0 = "state") || data.host === void 0 && (missing0 = "host") || data.created_at === void 0 && (missing0 = "created_at") || data.last_entry_number === void 0 && (missing0 = "last_entry_number") || data.last_entry_at === void 0 && (missing0 = "last_entry_at") || data.latest_turn_requested_at === void 0 && (missing0 = "latest_turn_requested_at") || data.latest_turn_finished_at === void 0 && (missing0 = "latest_turn_finished_at") || data.latest_person_written_at === void 0 && (missing0 = "latest_person_written_at") || data.projection === void 0 && (missing0 = "projection") || data.can_settle_or_snooze === void 0 && (missing0 = "can_settle_or_snooze")) {
        validate202.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema267.properties, key0)) {
            validate202.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.attached_connector !== void 0) {
            let data0 = data.attached_connector;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate202.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.can_settle_or_snooze !== void 0) {
              const _errs8 = errors;
              if (typeof data.can_settle_or_snooze !== "boolean") {
                validate202.errors = [{ instancePath: instancePath + "/can_settle_or_snooze", schemaPath: "#/properties/can_settle_or_snooze/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.created_at !== void 0) {
                let data2 = data.created_at;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (errors === _errs10) {
                    if (typeof data2 === "string") {
                      if (!formats0.validate(data2)) {
                        validate202.errors = [{ instancePath: instancePath + "/created_at", schemaPath: "#/properties/created_at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                        return false;
                      }
                    } else {
                      validate202.errors = [{ instancePath: instancePath + "/created_at", schemaPath: "#/properties/created_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.edited_item !== void 0) {
                  let data3 = data.edited_item;
                  const _errs12 = errors;
                  const _errs13 = errors;
                  let valid2 = false;
                  const _errs14 = errors;
                  if (typeof data3 !== "string") {
                    const err3 = { instancePath: instancePath + "/edited_item", schemaPath: "#/properties/edited_item/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var _valid1 = _errs14 === errors;
                  valid2 = valid2 || _valid1;
                  const _errs16 = errors;
                  if (data3 !== null) {
                    const err4 = { instancePath: instancePath + "/edited_item", schemaPath: "#/properties/edited_item/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var _valid1 = _errs16 === errors;
                  valid2 = valid2 || _valid1;
                  if (!valid2) {
                    const err5 = { instancePath: instancePath + "/edited_item", schemaPath: "#/properties/edited_item/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                    validate202.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs13;
                    if (vErrors !== null) {
                      if (_errs13) {
                        vErrors.length = _errs13;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.host !== void 0) {
                    const _errs18 = errors;
                    if (typeof data.host !== "string") {
                      validate202.errors = [{ instancePath: instancePath + "/host", schemaPath: "#/properties/host/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.last_entry_at !== void 0) {
                      let data5 = data.last_entry_at;
                      const _errs20 = errors;
                      if (errors === _errs20) {
                        if (errors === _errs20) {
                          if (typeof data5 === "string") {
                            if (!formats0.validate(data5)) {
                              validate202.errors = [{ instancePath: instancePath + "/last_entry_at", schemaPath: "#/properties/last_entry_at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                              return false;
                            }
                          } else {
                            validate202.errors = [{ instancePath: instancePath + "/last_entry_at", schemaPath: "#/properties/last_entry_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                        }
                      }
                      var valid0 = _errs20 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.last_entry_number !== void 0) {
                        let data6 = data.last_entry_number;
                        const _errs22 = errors;
                        if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                          validate202.errors = [{ instancePath: instancePath + "/last_entry_number", schemaPath: "#/properties/last_entry_number/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                          return false;
                        }
                        var valid0 = _errs22 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.latest_person_written_at !== void 0) {
                          let data7 = data.latest_person_written_at;
                          const _errs24 = errors;
                          const _errs25 = errors;
                          let valid3 = false;
                          const _errs26 = errors;
                          if (errors === _errs26) {
                            if (errors === _errs26) {
                              if (typeof data7 === "string") {
                                if (!formats0.validate(data7)) {
                                  const err6 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                              } else {
                                const err7 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err7];
                                } else {
                                  vErrors.push(err7);
                                }
                                errors++;
                              }
                            }
                          }
                          var _valid2 = _errs26 === errors;
                          valid3 = valid3 || _valid2;
                          const _errs28 = errors;
                          if (data7 !== null) {
                            const err8 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err8];
                            } else {
                              vErrors.push(err8);
                            }
                            errors++;
                          }
                          var _valid2 = _errs28 === errors;
                          valid3 = valid3 || _valid2;
                          if (!valid3) {
                            const err9 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                            validate202.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs25;
                            if (vErrors !== null) {
                              if (_errs25) {
                                vErrors.length = _errs25;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs24 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.latest_turn_finished_at !== void 0) {
                            let data8 = data.latest_turn_finished_at;
                            const _errs30 = errors;
                            const _errs31 = errors;
                            let valid4 = false;
                            const _errs32 = errors;
                            if (errors === _errs32) {
                              if (errors === _errs32) {
                                if (typeof data8 === "string") {
                                  if (!formats0.validate(data8)) {
                                    const err10 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                } else {
                                  const err11 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                }
                              }
                            }
                            var _valid3 = _errs32 === errors;
                            valid4 = valid4 || _valid3;
                            const _errs34 = errors;
                            if (data8 !== null) {
                              const err12 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err12];
                              } else {
                                vErrors.push(err12);
                              }
                              errors++;
                            }
                            var _valid3 = _errs34 === errors;
                            valid4 = valid4 || _valid3;
                            if (!valid4) {
                              const err13 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err13];
                              } else {
                                vErrors.push(err13);
                              }
                              errors++;
                              validate202.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs31;
                              if (vErrors !== null) {
                                if (_errs31) {
                                  vErrors.length = _errs31;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs30 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.latest_turn_requested_at !== void 0) {
                              let data9 = data.latest_turn_requested_at;
                              const _errs36 = errors;
                              const _errs37 = errors;
                              let valid5 = false;
                              const _errs38 = errors;
                              if (errors === _errs38) {
                                if (errors === _errs38) {
                                  if (typeof data9 === "string") {
                                    if (!formats0.validate(data9)) {
                                      const err14 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                      if (vErrors === null) {
                                        vErrors = [err14];
                                      } else {
                                        vErrors.push(err14);
                                      }
                                      errors++;
                                    }
                                  } else {
                                    const err15 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err15];
                                    } else {
                                      vErrors.push(err15);
                                    }
                                    errors++;
                                  }
                                }
                              }
                              var _valid4 = _errs38 === errors;
                              valid5 = valid5 || _valid4;
                              const _errs40 = errors;
                              if (data9 !== null) {
                                const err16 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err16];
                                } else {
                                  vErrors.push(err16);
                                }
                                errors++;
                              }
                              var _valid4 = _errs40 === errors;
                              valid5 = valid5 || _valid4;
                              if (!valid5) {
                                const err17 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err17];
                                } else {
                                  vErrors.push(err17);
                                }
                                errors++;
                                validate202.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs37;
                                if (vErrors !== null) {
                                  if (_errs37) {
                                    vErrors.length = _errs37;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs36 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.parent !== void 0) {
                                let data10 = data.parent;
                                const _errs42 = errors;
                                const _errs43 = errors;
                                let valid6 = false;
                                const _errs44 = errors;
                                if (typeof data10 !== "string") {
                                  const err18 = { instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err18];
                                  } else {
                                    vErrors.push(err18);
                                  }
                                  errors++;
                                }
                                var _valid5 = _errs44 === errors;
                                valid6 = valid6 || _valid5;
                                const _errs46 = errors;
                                if (data10 !== null) {
                                  const err19 = { instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err19];
                                  } else {
                                    vErrors.push(err19);
                                  }
                                  errors++;
                                }
                                var _valid5 = _errs46 === errors;
                                valid6 = valid6 || _valid5;
                                if (!valid6) {
                                  const err20 = { instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err20];
                                  } else {
                                    vErrors.push(err20);
                                  }
                                  errors++;
                                  validate202.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs43;
                                  if (vErrors !== null) {
                                    if (_errs43) {
                                      vErrors.length = _errs43;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs42 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.project_id !== void 0) {
                                  const _errs48 = errors;
                                  if (typeof data.project_id !== "string") {
                                    validate202.errors = [{ instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid0 = _errs48 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.projection !== void 0) {
                                    const _errs50 = errors;
                                    if (!validate162(data.projection, { instancePath: instancePath + "/projection", parentData: data, parentDataProperty: "projection", rootData, dynamicAnchors })) {
                                      vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid0 = _errs50 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.state !== void 0) {
                                      let data13 = data.state;
                                      const _errs51 = errors;
                                      if (typeof data13 !== "string") {
                                        validate202.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      if (!(data13 === "saved" || data13 === "live" || data13 === "closed")) {
                                        validate202.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/enum", keyword: "enum", params: { allowedValues: schema241.enum }, message: "must be equal to one of the allowed values" }];
                                        return false;
                                      }
                                      var valid0 = _errs51 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.subject !== void 0) {
                                        let data14 = data.subject;
                                        const _errs54 = errors;
                                        const _errs55 = errors;
                                        let valid8 = false;
                                        const _errs56 = errors;
                                        if (typeof data14 !== "string") {
                                          const err21 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err21];
                                          } else {
                                            vErrors.push(err21);
                                          }
                                          errors++;
                                        }
                                        var _valid6 = _errs56 === errors;
                                        valid8 = valid8 || _valid6;
                                        const _errs58 = errors;
                                        if (data14 !== null) {
                                          const err22 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err22];
                                          } else {
                                            vErrors.push(err22);
                                          }
                                          errors++;
                                        }
                                        var _valid6 = _errs58 === errors;
                                        valid8 = valid8 || _valid6;
                                        if (!valid8) {
                                          const err23 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err23];
                                          } else {
                                            vErrors.push(err23);
                                          }
                                          errors++;
                                          validate202.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs55;
                                          if (vErrors !== null) {
                                            if (_errs55) {
                                              vErrors.length = _errs55;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid0 = _errs54 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.thread_id !== void 0) {
                                          const _errs60 = errors;
                                          if (typeof data.thread_id !== "string") {
                                            validate202.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                          var valid0 = _errs60 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.title !== void 0) {
                                            const _errs62 = errors;
                                            if (typeof data.title !== "string") {
                                              validate202.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid0 = _errs62 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate202.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate202.errors = vErrors;
  return errors === 0;
}
validate202.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate201(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate201.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.project_id === void 0 && (missing0 = "project_id") || data.threads === void 0 && (missing0 = "threads")) {
        validate201.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "project_id" || key0 === "threads" || key0 === "type")) {
            validate201.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.project_id !== void 0) {
            const _errs2 = errors;
            if (typeof data.project_id !== "string") {
              validate201.errors = [{ instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.threads !== void 0) {
              let data1 = data.threads;
              const _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  const len0 = data1.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs6 = errors;
                    if (!validate202(data1[i0], { instancePath: instancePath + "/threads/" + i0, parentData: data1, parentDataProperty: i0, rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
                      errors = vErrors.length;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate201.errors = [{ instancePath: instancePath + "/threads", schemaPath: "#/properties/threads/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.type !== void 0) {
                let data3 = data.type;
                const _errs7 = errors;
                if (typeof data3 !== "string") {
                  validate201.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("thread_list" !== data3) {
                  validate201.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "thread_list" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate201.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate201.errors = vErrors;
  return errors === 0;
}
validate201.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate206(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate206.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.project_id === void 0 && (missing0 = "project_id") || data.thread === void 0 && (missing0 = "thread")) {
        validate206.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "project_id" || key0 === "thread" || key0 === "type")) {
            validate206.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.project_id !== void 0) {
            const _errs2 = errors;
            if (typeof data.project_id !== "string") {
              validate206.errors = [{ instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.thread !== void 0) {
              const _errs4 = errors;
              if (!validate202(data.thread, { instancePath: instancePath + "/thread", parentData: data, parentDataProperty: "thread", rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.type !== void 0) {
                let data2 = data.type;
                const _errs5 = errors;
                if (typeof data2 !== "string") {
                  validate206.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if ("thread_listed" !== data2) {
                  validate206.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "thread_listed" }, message: "must be equal to constant" }];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate206.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate206.errors = vErrors;
  return errors === 0;
}
validate206.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate210(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate210.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.title === void 0 && (missing0 = "title") || data.status === void 0 && (missing0 = "status") || data.detail === void 0 && (missing0 = "detail") || data.instance === void 0 && (missing0 = "instance") || data.code === void 0 && (missing0 = "code") || data.request_id === void 0 && (missing0 = "request_id") || data.details === void 0 && (missing0 = "details")) {
        validate210.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "code" || key0 === "detail" || key0 === "details" || key0 === "instance" || key0 === "request_id" || key0 === "status" || key0 === "title" || key0 === "type")) {
            validate210.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.code !== void 0) {
            const _errs2 = errors;
            if (typeof data.code !== "string") {
              validate210.errors = [{ instancePath: instancePath + "/code", schemaPath: "#/properties/code/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.detail !== void 0) {
              const _errs4 = errors;
              if (typeof data.detail !== "string") {
                validate210.errors = [{ instancePath: instancePath + "/detail", schemaPath: "#/properties/detail/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.details !== void 0) {
                let data2 = data.details;
                const _errs6 = errors;
                if (errors === _errs6) {
                  if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                    for (const key1 in data2) {
                      const _errs9 = errors;
                      var valid1 = _errs9 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate210.errors = [{ instancePath: instancePath + "/details", schemaPath: "#/properties/details/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                    return false;
                  }
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.instance !== void 0) {
                  const _errs10 = errors;
                  if (typeof data.instance !== "string") {
                    validate210.errors = [{ instancePath: instancePath + "/instance", schemaPath: "#/properties/instance/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.request_id !== void 0) {
                    const _errs12 = errors;
                    if (typeof data.request_id !== "string") {
                      validate210.errors = [{ instancePath: instancePath + "/request_id", schemaPath: "#/properties/request_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.status !== void 0) {
                      let data6 = data.status;
                      const _errs14 = errors;
                      if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                        validate210.errors = [{ instancePath: instancePath + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.title !== void 0) {
                        const _errs16 = errors;
                        if (typeof data.title !== "string") {
                          validate210.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.type !== void 0) {
                          const _errs18 = errors;
                          if (typeof data.type !== "string") {
                            validate210.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate210.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate210.errors = vErrors;
  return errors === 0;
}
validate210.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate209(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate209.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.thread_id === void 0 && (missing0 = "thread_id") || data.problem === void 0 && (missing0 = "problem")) {
        validate209.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "problem" || key0 === "project_id" || key0 === "thread_id" || key0 === "type")) {
            validate209.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.problem !== void 0) {
            const _errs2 = errors;
            if (!validate210(data.problem, { instancePath: instancePath + "/problem", parentData: data, parentDataProperty: "problem", rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate210.errors : vErrors.concat(validate210.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.project_id !== void 0) {
              let data1 = data.project_id;
              const _errs3 = errors;
              const _errs4 = errors;
              let valid1 = false;
              const _errs5 = errors;
              if (typeof data1 !== "string") {
                const err0 = { instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs5 === errors;
              valid1 = valid1 || _valid0;
              const _errs7 = errors;
              if (data1 !== null) {
                const err1 = { instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs7 === errors;
              valid1 = valid1 || _valid0;
              if (!valid1) {
                const err2 = { instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
                validate209.errors = vErrors;
                return false;
              } else {
                errors = _errs4;
                if (vErrors !== null) {
                  if (_errs4) {
                    vErrors.length = _errs4;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.thread_id !== void 0) {
                let data2 = data.thread_id;
                const _errs9 = errors;
                const _errs10 = errors;
                let valid2 = false;
                const _errs11 = errors;
                if (typeof data2 !== "string") {
                  const err3 = { instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var _valid1 = _errs11 === errors;
                valid2 = valid2 || _valid1;
                const _errs13 = errors;
                if (data2 !== null) {
                  const err4 = { instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var _valid1 = _errs13 === errors;
                valid2 = valid2 || _valid1;
                if (!valid2) {
                  const err5 = { instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                  validate209.errors = vErrors;
                  return false;
                } else {
                  errors = _errs10;
                  if (vErrors !== null) {
                    if (_errs10) {
                      vErrors.length = _errs10;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.type !== void 0) {
                  let data3 = data.type;
                  const _errs15 = errors;
                  if (typeof data3 !== "string") {
                    validate209.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if ("error" !== data3) {
                    validate209.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "error" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate209.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate209.errors = vErrors;
  return errors === 0;
}
validate209.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  ;
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate20.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  if (!validate21(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
    vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
    var props0 = true;
  }
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.type === void 0 && (missing0 = "type") || data.thread_id === void 0 && (missing0 = "thread_id") || data.last_entry_number === void 0 && (missing0 = "last_entry_number")) {
        const err0 = { instancePath, schemaPath: "#/$defs/ResyncRequired/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs5 = errors;
        for (const key0 in data) {
          if (!(key0 === "last_entry_number" || key0 === "thread_id" || key0 === "type")) {
            const err1 = { instancePath, schemaPath: "#/$defs/ResyncRequired/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs5 === errors) {
          if (data.last_entry_number !== void 0) {
            let data0 = data.last_entry_number;
            const _errs6 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              const err2 = { instancePath: instancePath + "/last_entry_number", schemaPath: "#/$defs/ResyncRequired/properties/last_entry_number/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.thread_id !== void 0) {
              const _errs8 = errors;
              if (typeof data.thread_id !== "string") {
                const err3 = { instancePath: instancePath + "/thread_id", schemaPath: "#/$defs/ResyncRequired/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs8 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.type !== void 0) {
                let data2 = data.type;
                const _errs10 = errors;
                if (typeof data2 !== "string") {
                  const err4 = { instancePath: instancePath + "/type", schemaPath: "#/$defs/ResyncRequired/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                if ("resync_required" !== data2) {
                  const err5 = { instancePath: instancePath + "/type", schemaPath: "#/$defs/ResyncRequired/properties/type/const", keyword: "const", params: { allowedValue: "resync_required" }, message: "must be equal to constant" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                var valid2 = _errs10 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      }
    } else {
      const err6 = { instancePath, schemaPath: "#/$defs/ResyncRequired/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
      if (props0 !== true) {
        props0 = true;
      }
    }
    const _errs12 = errors;
    if (!validate143(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
      vErrors = vErrors === null ? validate143.errors : vErrors.concat(validate143.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs12 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
        if (props0 !== true) {
          props0 = true;
        }
      }
      const _errs13 = errors;
      if (!validate189(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
        vErrors = vErrors === null ? validate189.errors : vErrors.concat(validate189.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs13 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
          if (props0 !== true) {
            props0 = true;
          }
        }
        const _errs14 = errors;
        if (!validate197(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
          vErrors = vErrors === null ? validate197.errors : vErrors.concat(validate197.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs14 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
            if (props0 !== true) {
              props0 = true;
            }
          }
          const _errs15 = errors;
          if (!validate201(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
            vErrors = vErrors === null ? validate201.errors : vErrors.concat(validate201.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs15 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
              if (props0 !== true) {
                props0 = true;
              }
            }
            const _errs16 = errors;
            if (!validate206(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
              vErrors = vErrors === null ? validate206.errors : vErrors.concat(validate206.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs16 === errors;
            if (_valid0 && valid0) {
              valid0 = false;
              passing0 = [passing0, 6];
            } else {
              if (_valid0) {
                valid0 = true;
                passing0 = 6;
                if (props0 !== true) {
                  props0 = true;
                }
              }
              const _errs17 = errors;
              const _errs18 = errors;
              if (errors === _errs18) {
                if (data && typeof data == "object" && !Array.isArray(data)) {
                  let missing1;
                  if (data.type === void 0 && (missing1 = "type") || data.project_id === void 0 && (missing1 = "project_id") || data.thread_id === void 0 && (missing1 = "thread_id")) {
                    const err7 = { instancePath, schemaPath: "#/$defs/ThreadUnlistedMessage/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                  } else {
                    const _errs20 = errors;
                    for (const key1 in data) {
                      if (!(key1 === "project_id" || key1 === "thread_id" || key1 === "type")) {
                        const err8 = { instancePath, schemaPath: "#/$defs/ThreadUnlistedMessage/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                        break;
                      }
                    }
                    if (_errs20 === errors) {
                      if (data.project_id !== void 0) {
                        const _errs21 = errors;
                        if (typeof data.project_id !== "string") {
                          const err9 = { instancePath: instancePath + "/project_id", schemaPath: "#/$defs/ThreadUnlistedMessage/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err9];
                          } else {
                            vErrors.push(err9);
                          }
                          errors++;
                        }
                        var valid4 = _errs21 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data.thread_id !== void 0) {
                          const _errs23 = errors;
                          if (typeof data.thread_id !== "string") {
                            const err10 = { instancePath: instancePath + "/thread_id", schemaPath: "#/$defs/ThreadUnlistedMessage/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err10];
                            } else {
                              vErrors.push(err10);
                            }
                            errors++;
                          }
                          var valid4 = _errs23 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data.type !== void 0) {
                            let data5 = data.type;
                            const _errs25 = errors;
                            if (typeof data5 !== "string") {
                              const err11 = { instancePath: instancePath + "/type", schemaPath: "#/$defs/ThreadUnlistedMessage/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err11];
                              } else {
                                vErrors.push(err11);
                              }
                              errors++;
                            }
                            if ("thread_unlisted" !== data5) {
                              const err12 = { instancePath: instancePath + "/type", schemaPath: "#/$defs/ThreadUnlistedMessage/properties/type/const", keyword: "const", params: { allowedValue: "thread_unlisted" }, message: "must be equal to constant" };
                              if (vErrors === null) {
                                vErrors = [err12];
                              } else {
                                vErrors.push(err12);
                              }
                              errors++;
                            }
                            var valid4 = _errs25 === errors;
                          } else {
                            var valid4 = true;
                          }
                        }
                      }
                    }
                  }
                } else {
                  const err13 = { instancePath, schemaPath: "#/$defs/ThreadUnlistedMessage/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
              }
              var _valid0 = _errs17 === errors;
              if (_valid0 && valid0) {
                valid0 = false;
                passing0 = [passing0, 7];
              } else {
                if (_valid0) {
                  valid0 = true;
                  passing0 = 7;
                  if (props0 !== true) {
                    props0 = true;
                  }
                }
                const _errs27 = errors;
                const _errs28 = errors;
                if (errors === _errs28) {
                  if (data && typeof data == "object" && !Array.isArray(data)) {
                    let missing2;
                    if (data.type === void 0 && (missing2 = "type") || data.project_id === void 0 && (missing2 = "project_id")) {
                      const err14 = { instancePath, schemaPath: "#/$defs/ThreadPlacementsChangedMessage/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                      if (vErrors === null) {
                        vErrors = [err14];
                      } else {
                        vErrors.push(err14);
                      }
                      errors++;
                    } else {
                      const _errs30 = errors;
                      for (const key2 in data) {
                        if (!(key2 === "project_id" || key2 === "type")) {
                          const err15 = { instancePath, schemaPath: "#/$defs/ThreadPlacementsChangedMessage/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                          if (vErrors === null) {
                            vErrors = [err15];
                          } else {
                            vErrors.push(err15);
                          }
                          errors++;
                          break;
                        }
                      }
                      if (_errs30 === errors) {
                        if (data.project_id !== void 0) {
                          const _errs31 = errors;
                          if (typeof data.project_id !== "string") {
                            const err16 = { instancePath: instancePath + "/project_id", schemaPath: "#/$defs/ThreadPlacementsChangedMessage/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err16];
                            } else {
                              vErrors.push(err16);
                            }
                            errors++;
                          }
                          var valid6 = _errs31 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data.type !== void 0) {
                            let data7 = data.type;
                            const _errs33 = errors;
                            if (typeof data7 !== "string") {
                              const err17 = { instancePath: instancePath + "/type", schemaPath: "#/$defs/ThreadPlacementsChangedMessage/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err17];
                              } else {
                                vErrors.push(err17);
                              }
                              errors++;
                            }
                            if ("thread_placements_changed" !== data7) {
                              const err18 = { instancePath: instancePath + "/type", schemaPath: "#/$defs/ThreadPlacementsChangedMessage/properties/type/const", keyword: "const", params: { allowedValue: "thread_placements_changed" }, message: "must be equal to constant" };
                              if (vErrors === null) {
                                vErrors = [err18];
                              } else {
                                vErrors.push(err18);
                              }
                              errors++;
                            }
                            var valid6 = _errs33 === errors;
                          } else {
                            var valid6 = true;
                          }
                        }
                      }
                    }
                  } else {
                    const err19 = { instancePath, schemaPath: "#/$defs/ThreadPlacementsChangedMessage/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err19];
                    } else {
                      vErrors.push(err19);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs27 === errors;
                if (_valid0 && valid0) {
                  valid0 = false;
                  passing0 = [passing0, 8];
                } else {
                  if (_valid0) {
                    valid0 = true;
                    passing0 = 8;
                    if (props0 !== true) {
                      props0 = true;
                    }
                  }
                  const _errs35 = errors;
                  if (!validate209(data, { instancePath, parentData, parentDataProperty, rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate209.errors : vErrors.concat(validate209.errors);
                    errors = vErrors.length;
                  }
                  var _valid0 = _errs35 === errors;
                  if (_valid0 && valid0) {
                    valid0 = false;
                    passing0 = [passing0, 9];
                  } else {
                    if (_valid0) {
                      valid0 = true;
                      passing0 = 9;
                      if (props0 !== true) {
                        props0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err20 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err20];
    } else {
      vErrors.push(err20);
    }
    errors++;
    validate20.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate20.errors = vErrors;
  evaluated0.props = props0;
  return errors === 0;
}
validate20.evaluated = { "dynamicProps": true, "dynamicItems": false };
var validateEntry = validate213;
function validate213(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate213.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.thread_id === void 0 && (missing0 = "thread_id") || data.number === void 0 && (missing0 = "number") || data.at === void 0 && (missing0 = "at") || data.author === void 0 && (missing0 = "author") || data.payload === void 0 && (missing0 = "payload")) {
        validate213.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "at" || key0 === "author" || key0 === "number" || key0 === "payload" || key0 === "thread_id")) {
            validate213.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.at !== void 0) {
            let data0 = data.at;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (errors === _errs2) {
                if (typeof data0 === "string") {
                  if (!formats0.validate(data0)) {
                    validate213.errors = [{ instancePath: instancePath + "/at", schemaPath: "#/properties/at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                    return false;
                  }
                } else {
                  validate213.errors = [{ instancePath: instancePath + "/at", schemaPath: "#/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.author !== void 0) {
              const _errs4 = errors;
              if (!validate23(data.author, { instancePath: instancePath + "/author", parentData: data, parentDataProperty: "author", rootData, dynamicAnchors })) {
                vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.number !== void 0) {
                let data2 = data.number;
                const _errs5 = errors;
                if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)))) {
                  validate213.errors = [{ instancePath: instancePath + "/number", schemaPath: "#/properties/number/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                  return false;
                }
                if (errors === _errs5) {
                  if (typeof data2 == "number") {
                    if (data2 < 1 || isNaN(data2)) {
                      validate213.errors = [{ instancePath: instancePath + "/number", schemaPath: "#/properties/number/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" }];
                      return false;
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.payload !== void 0) {
                  const _errs7 = errors;
                  if (!validate25(data.payload, { instancePath: instancePath + "/payload", parentData: data, parentDataProperty: "payload", rootData, dynamicAnchors })) {
                    vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.thread_id !== void 0) {
                    const _errs8 = errors;
                    if (typeof data.thread_id !== "string") {
                      validate213.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs8 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate213.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate213.errors = vErrors;
  return errors === 0;
}
validate213.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var validateSettings = validate216;
function validate216(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate216.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.route === void 0 && (missing0 = "route") || data.step_routes === void 0 && (missing0 = "step_routes") || data.permission_profile === void 0 && (missing0 = "permission_profile") || data.reply_tools === void 0 && (missing0 = "reply_tools") || data.reply_item_kinds === void 0 && (missing0 = "reply_item_kinds") || data.agent_instructions === void 0 && (missing0 = "agent_instructions") || data.history_preamble === void 0 && (missing0 = "history_preamble")) {
        validate216.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema42.properties, key0)) {
            validate216.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.agent_instructions !== void 0) {
            let data0 = data.agent_instructions;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/agent_instructions", schemaPath: "#/properties/agent_instructions/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate216.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.agent_setup !== void 0) {
              let data1 = data.agent_setup;
              const _errs8 = errors;
              if (typeof data1 !== "string") {
                validate216.errors = [{ instancePath: instancePath + "/agent_setup", schemaPath: "#/$defs/AgentSetupKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "extend" || data1 === "dmw_only")) {
                validate216.errors = [{ instancePath: instancePath + "/agent_setup", schemaPath: "#/$defs/AgentSetupKind/enum", keyword: "enum", params: { allowedValues: schema43.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.fallback_routes !== void 0) {
                let data2 = data.fallback_routes;
                const _errs11 = errors;
                if (errors === _errs11) {
                  if (Array.isArray(data2)) {
                    if (data2.length > 8) {
                      validate216.errors = [{ instancePath: instancePath + "/fallback_routes", schemaPath: "#/properties/fallback_routes/maxItems", keyword: "maxItems", params: { limit: 8 }, message: "must NOT have more than 8 items" }];
                      return false;
                    } else {
                      var valid3 = true;
                      const len0 = data2.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data3 = data2[i0];
                        const _errs13 = errors;
                        const _errs14 = errors;
                        let valid4 = false;
                        let passing0 = null;
                        const _errs15 = errors;
                        const _errs16 = errors;
                        if (errors === _errs16) {
                          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                            let missing1;
                            if (data3.kind === void 0 && (missing1 = "kind") || data3.agent_id === void 0 && (missing1 = "agent_id") || data3.model_id === void 0 && (missing1 = "model_id")) {
                              const err3 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
                              if (vErrors === null) {
                                vErrors = [err3];
                              } else {
                                vErrors.push(err3);
                              }
                              errors++;
                            } else {
                              if (data3.agent_id !== void 0) {
                                let data4 = data3.agent_id;
                                const _errs18 = errors;
                                if (errors === _errs18) {
                                  if (typeof data4 === "string") {
                                    if (!pattern4.test(data4)) {
                                      const err4 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    }
                                  } else {
                                    const err5 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err5];
                                    } else {
                                      vErrors.push(err5);
                                    }
                                    errors++;
                                  }
                                }
                                var valid6 = _errs18 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data3.kind !== void 0) {
                                  let data5 = data3.kind;
                                  const _errs20 = errors;
                                  if (typeof data5 !== "string") {
                                    const err6 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err6];
                                    } else {
                                      vErrors.push(err6);
                                    }
                                    errors++;
                                  }
                                  if ("agent" !== data5) {
                                    const err7 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                    if (vErrors === null) {
                                      vErrors = [err7];
                                    } else {
                                      vErrors.push(err7);
                                    }
                                    errors++;
                                  }
                                  var valid6 = _errs20 === errors;
                                } else {
                                  var valid6 = true;
                                }
                                if (valid6) {
                                  if (data3.model_id !== void 0) {
                                    let data6 = data3.model_id;
                                    const _errs22 = errors;
                                    const _errs23 = errors;
                                    let valid7 = false;
                                    const _errs24 = errors;
                                    if (errors === _errs24) {
                                      if (typeof data6 === "string") {
                                        if (func2(data6) > 200) {
                                          const err8 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err8];
                                          } else {
                                            vErrors.push(err8);
                                          }
                                          errors++;
                                        } else {
                                          if (func2(data6) < 1) {
                                            const err9 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err9];
                                            } else {
                                              vErrors.push(err9);
                                            }
                                            errors++;
                                          }
                                        }
                                      } else {
                                        const err10 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err10];
                                        } else {
                                          vErrors.push(err10);
                                        }
                                        errors++;
                                      }
                                    }
                                    var _valid2 = _errs24 === errors;
                                    valid7 = valid7 || _valid2;
                                    const _errs26 = errors;
                                    if (data6 !== null) {
                                      const err11 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                      if (vErrors === null) {
                                        vErrors = [err11];
                                      } else {
                                        vErrors.push(err11);
                                      }
                                      errors++;
                                    }
                                    var _valid2 = _errs26 === errors;
                                    valid7 = valid7 || _valid2;
                                    if (!valid7) {
                                      const err12 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err12];
                                      } else {
                                        vErrors.push(err12);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs23;
                                      if (vErrors !== null) {
                                        if (_errs23) {
                                          vErrors.length = _errs23;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs22 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                  if (valid6) {
                                    if (data3.reasoning_effort !== void 0) {
                                      let data7 = data3.reasoning_effort;
                                      const _errs28 = errors;
                                      const _errs29 = errors;
                                      let valid8 = false;
                                      const _errs30 = errors;
                                      if (errors === _errs30) {
                                        if (typeof data7 === "string") {
                                          if (func2(data7) > 200) {
                                            const err13 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data7) < 1) {
                                              const err14 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err14];
                                              } else {
                                                vErrors.push(err14);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err15 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err15];
                                          } else {
                                            vErrors.push(err15);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid3 = _errs30 === errors;
                                      valid8 = valid8 || _valid3;
                                      const _errs32 = errors;
                                      if (data7 !== null) {
                                        const err16 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err16];
                                        } else {
                                          vErrors.push(err16);
                                        }
                                        errors++;
                                      }
                                      var _valid3 = _errs32 === errors;
                                      valid8 = valid8 || _valid3;
                                      if (!valid8) {
                                        const err17 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err17];
                                        } else {
                                          vErrors.push(err17);
                                        }
                                        errors++;
                                      } else {
                                        errors = _errs29;
                                        if (vErrors !== null) {
                                          if (_errs29) {
                                            vErrors.length = _errs29;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid6 = _errs28 === errors;
                                    } else {
                                      var valid6 = true;
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            const err18 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err18];
                            } else {
                              vErrors.push(err18);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1) {
                          valid4 = true;
                          passing0 = 0;
                          var props0 = {};
                          props0.agent_id = true;
                          props0.kind = true;
                          props0.model_id = true;
                          props0.reasoning_effort = true;
                        }
                        const _errs34 = errors;
                        const _errs35 = errors;
                        if (errors === _errs35) {
                          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                            let missing2;
                            if (data3.kind === void 0 && (missing2 = "kind") || data3.route_id === void 0 && (missing2 = "route_id") || data3.model_id === void 0 && (missing2 = "model_id")) {
                              const err19 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" };
                              if (vErrors === null) {
                                vErrors = [err19];
                              } else {
                                vErrors.push(err19);
                              }
                              errors++;
                            } else {
                              if (data3.kind !== void 0) {
                                let data8 = data3.kind;
                                const _errs37 = errors;
                                if (typeof data8 !== "string") {
                                  const err20 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err20];
                                  } else {
                                    vErrors.push(err20);
                                  }
                                  errors++;
                                }
                                if ("api_key" !== data8) {
                                  const err21 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                  if (vErrors === null) {
                                    vErrors = [err21];
                                  } else {
                                    vErrors.push(err21);
                                  }
                                  errors++;
                                }
                                var valid10 = _errs37 === errors;
                              } else {
                                var valid10 = true;
                              }
                              if (valid10) {
                                if (data3.model_id !== void 0) {
                                  let data9 = data3.model_id;
                                  const _errs39 = errors;
                                  if (errors === _errs39) {
                                    if (typeof data9 === "string") {
                                      if (func2(data9) > 200) {
                                        const err22 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                        if (vErrors === null) {
                                          vErrors = [err22];
                                        } else {
                                          vErrors.push(err22);
                                        }
                                        errors++;
                                      } else {
                                        if (func2(data9) < 1) {
                                          const err23 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err23];
                                          } else {
                                            vErrors.push(err23);
                                          }
                                          errors++;
                                        }
                                      }
                                    } else {
                                      const err24 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err24];
                                      } else {
                                        vErrors.push(err24);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid10 = _errs39 === errors;
                                } else {
                                  var valid10 = true;
                                }
                                if (valid10) {
                                  if (data3.route_id !== void 0) {
                                    let data10 = data3.route_id;
                                    const _errs41 = errors;
                                    if (errors === _errs41) {
                                      if (typeof data10 === "string") {
                                        if (!pattern4.test(data10)) {
                                          const err25 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                        }
                                      } else {
                                        const err26 = { instancePath: instancePath + "/fallback_routes/" + i0 + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err26];
                                        } else {
                                          vErrors.push(err26);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid10 = _errs41 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            const err27 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err27];
                            } else {
                              vErrors.push(err27);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs34 === errors;
                        if (_valid1 && valid4) {
                          valid4 = false;
                          passing0 = [passing0, 1];
                        } else {
                          if (_valid1) {
                            valid4 = true;
                            passing0 = 1;
                            if (props0 !== true) {
                              props0 = props0 || {};
                              props0.kind = true;
                              props0.model_id = true;
                              props0.route_id = true;
                            }
                          }
                        }
                        if (!valid4) {
                          const err28 = { instancePath: instancePath + "/fallback_routes/" + i0, schemaPath: "#/properties/fallback_routes/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                          if (vErrors === null) {
                            vErrors = [err28];
                          } else {
                            vErrors.push(err28);
                          }
                          errors++;
                          validate216.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs14;
                          if (vErrors !== null) {
                            if (_errs14) {
                              vErrors.length = _errs14;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid3 = _errs13 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate216.errors = [{ instancePath: instancePath + "/fallback_routes", schemaPath: "#/properties/fallback_routes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs11 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.history_preamble !== void 0) {
                  let data11 = data.history_preamble;
                  const _errs43 = errors;
                  if (errors === _errs43) {
                    if (typeof data11 === "string") {
                      if (!pattern6.test(data11)) {
                        validate216.errors = [{ instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}@[1-9][0-9]{0,3}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}@[1-9][0-9]{0,3}$"' }];
                        return false;
                      }
                    } else {
                      validate216.errors = [{ instancePath: instancePath + "/history_preamble", schemaPath: "#/properties/history_preamble/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                  var valid0 = _errs43 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.permission_profile !== void 0) {
                    let data12 = data.permission_profile;
                    const _errs45 = errors;
                    if (errors === _errs45) {
                      if (typeof data12 === "string") {
                        if (!pattern4.test(data12)) {
                          validate216.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                          return false;
                        }
                      } else {
                        validate216.errors = [{ instancePath: instancePath + "/permission_profile", schemaPath: "#/properties/permission_profile/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                    }
                    var valid0 = _errs45 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.reply_item_kinds !== void 0) {
                      let data13 = data.reply_item_kinds;
                      const _errs47 = errors;
                      if (errors === _errs47) {
                        if (Array.isArray(data13)) {
                          var valid11 = true;
                          const len1 = data13.length;
                          for (let i1 = 0; i1 < len1; i1++) {
                            let data14 = data13[i1];
                            const _errs49 = errors;
                            if (errors === _errs49) {
                              if (typeof data14 === "string") {
                                if (!pattern8.test(data14)) {
                                  validate216.errors = [{ instancePath: instancePath + "/reply_item_kinds/" + i1, schemaPath: "#/properties/reply_item_kinds/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                  return false;
                                }
                              } else {
                                validate216.errors = [{ instancePath: instancePath + "/reply_item_kinds/" + i1, schemaPath: "#/properties/reply_item_kinds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                            }
                            var valid11 = _errs49 === errors;
                            if (!valid11) {
                              break;
                            }
                          }
                        } else {
                          validate216.errors = [{ instancePath: instancePath + "/reply_item_kinds", schemaPath: "#/properties/reply_item_kinds/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs47 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.reply_tools !== void 0) {
                        let data15 = data.reply_tools;
                        const _errs51 = errors;
                        const _errs52 = errors;
                        if (errors === _errs52) {
                          if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                            let missing3;
                            if (data15.dmw === void 0 && (missing3 = "dmw") || data15.skill_servers === void 0 && (missing3 = "skill_servers") || data15.agent_skills === void 0 && (missing3 = "agent_skills")) {
                              validate216.errors = [{ instancePath: instancePath + "/reply_tools", schemaPath: "#/$defs/TurnTools/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" }];
                              return false;
                            } else {
                              if (data15.agent_skills !== void 0) {
                                let data16 = data15.agent_skills;
                                const _errs54 = errors;
                                if (errors === _errs54) {
                                  if (Array.isArray(data16)) {
                                    var valid14 = true;
                                    const len2 = data16.length;
                                    for (let i2 = 0; i2 < len2; i2++) {
                                      let data17 = data16[i2];
                                      const _errs56 = errors;
                                      if (errors === _errs56) {
                                        if (typeof data17 === "string") {
                                          if (!pattern4.test(data17)) {
                                            validate216.errors = [{ instancePath: instancePath + "/reply_tools/agent_skills/" + i2, schemaPath: "#/$defs/TurnTools/properties/agent_skills/items/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                            return false;
                                          }
                                        } else {
                                          validate216.errors = [{ instancePath: instancePath + "/reply_tools/agent_skills/" + i2, schemaPath: "#/$defs/TurnTools/properties/agent_skills/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                          return false;
                                        }
                                      }
                                      var valid14 = _errs56 === errors;
                                      if (!valid14) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate216.errors = [{ instancePath: instancePath + "/reply_tools/agent_skills", schemaPath: "#/$defs/TurnTools/properties/agent_skills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                    return false;
                                  }
                                }
                                var valid13 = _errs54 === errors;
                              } else {
                                var valid13 = true;
                              }
                              if (valid13) {
                                if (data15.dmw !== void 0) {
                                  let data18 = data15.dmw;
                                  const _errs58 = errors;
                                  if (errors === _errs58) {
                                    if (Array.isArray(data18)) {
                                      var valid15 = true;
                                      const len3 = data18.length;
                                      for (let i3 = 0; i3 < len3; i3++) {
                                        let data19 = data18[i3];
                                        const _errs60 = errors;
                                        if (errors === _errs60) {
                                          if (typeof data19 === "string") {
                                            if (!pattern8.test(data19)) {
                                              validate216.errors = [{ instancePath: instancePath + "/reply_tools/dmw/" + i3, schemaPath: "#/$defs/TurnTools/properties/dmw/items/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                              return false;
                                            }
                                          } else {
                                            validate216.errors = [{ instancePath: instancePath + "/reply_tools/dmw/" + i3, schemaPath: "#/$defs/TurnTools/properties/dmw/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                        }
                                        var valid15 = _errs60 === errors;
                                        if (!valid15) {
                                          break;
                                        }
                                      }
                                    } else {
                                      validate216.errors = [{ instancePath: instancePath + "/reply_tools/dmw", schemaPath: "#/$defs/TurnTools/properties/dmw/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                      return false;
                                    }
                                  }
                                  var valid13 = _errs58 === errors;
                                } else {
                                  var valid13 = true;
                                }
                                if (valid13) {
                                  if (data15.skill_servers !== void 0) {
                                    let data20 = data15.skill_servers;
                                    const _errs62 = errors;
                                    if (errors === _errs62) {
                                      if (Array.isArray(data20)) {
                                        var valid16 = true;
                                        const len4 = data20.length;
                                        for (let i4 = 0; i4 < len4; i4++) {
                                          let data21 = data20[i4];
                                          const _errs64 = errors;
                                          if (errors === _errs64) {
                                            if (typeof data21 === "string") {
                                              if (!pattern4.test(data21)) {
                                                validate216.errors = [{ instancePath: instancePath + "/reply_tools/skill_servers/" + i4, schemaPath: "#/$defs/TurnTools/properties/skill_servers/items/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' }];
                                                return false;
                                              }
                                            } else {
                                              validate216.errors = [{ instancePath: instancePath + "/reply_tools/skill_servers/" + i4, schemaPath: "#/$defs/TurnTools/properties/skill_servers/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                          }
                                          var valid16 = _errs64 === errors;
                                          if (!valid16) {
                                            break;
                                          }
                                        }
                                      } else {
                                        validate216.errors = [{ instancePath: instancePath + "/reply_tools/skill_servers", schemaPath: "#/$defs/TurnTools/properties/skill_servers/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                        return false;
                                      }
                                    }
                                    var valid13 = _errs62 === errors;
                                  } else {
                                    var valid13 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate216.errors = [{ instancePath: instancePath + "/reply_tools", schemaPath: "#/$defs/TurnTools/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                            return false;
                          }
                        }
                        var valid0 = _errs51 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.route !== void 0) {
                          let data22 = data.route;
                          const _errs66 = errors;
                          const _errs67 = errors;
                          let valid17 = false;
                          const _errs68 = errors;
                          const _errs69 = errors;
                          let valid18 = false;
                          let passing1 = null;
                          const _errs70 = errors;
                          const _errs71 = errors;
                          if (errors === _errs71) {
                            if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
                              let missing4;
                              if (data22.kind === void 0 && (missing4 = "kind") || data22.agent_id === void 0 && (missing4 = "agent_id") || data22.model_id === void 0 && (missing4 = "model_id")) {
                                const err29 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing4 }, message: "must have required property '" + missing4 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err29];
                                } else {
                                  vErrors.push(err29);
                                }
                                errors++;
                              } else {
                                if (data22.agent_id !== void 0) {
                                  let data23 = data22.agent_id;
                                  const _errs73 = errors;
                                  if (errors === _errs73) {
                                    if (typeof data23 === "string") {
                                      if (!pattern4.test(data23)) {
                                        const err30 = { instancePath: instancePath + "/route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                        if (vErrors === null) {
                                          vErrors = [err30];
                                        } else {
                                          vErrors.push(err30);
                                        }
                                        errors++;
                                      }
                                    } else {
                                      const err31 = { instancePath: instancePath + "/route/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err31];
                                      } else {
                                        vErrors.push(err31);
                                      }
                                      errors++;
                                    }
                                  }
                                  var valid20 = _errs73 === errors;
                                } else {
                                  var valid20 = true;
                                }
                                if (valid20) {
                                  if (data22.kind !== void 0) {
                                    let data24 = data22.kind;
                                    const _errs75 = errors;
                                    if (typeof data24 !== "string") {
                                      const err32 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err32];
                                      } else {
                                        vErrors.push(err32);
                                      }
                                      errors++;
                                    }
                                    if ("agent" !== data24) {
                                      const err33 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                      if (vErrors === null) {
                                        vErrors = [err33];
                                      } else {
                                        vErrors.push(err33);
                                      }
                                      errors++;
                                    }
                                    var valid20 = _errs75 === errors;
                                  } else {
                                    var valid20 = true;
                                  }
                                  if (valid20) {
                                    if (data22.model_id !== void 0) {
                                      let data25 = data22.model_id;
                                      const _errs77 = errors;
                                      const _errs78 = errors;
                                      let valid21 = false;
                                      const _errs79 = errors;
                                      if (errors === _errs79) {
                                        if (typeof data25 === "string") {
                                          if (func2(data25) > 200) {
                                            const err34 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err34];
                                            } else {
                                              vErrors.push(err34);
                                            }
                                            errors++;
                                          } else {
                                            if (func2(data25) < 1) {
                                              const err35 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err35];
                                              } else {
                                                vErrors.push(err35);
                                              }
                                              errors++;
                                            }
                                          }
                                        } else {
                                          const err36 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err36];
                                          } else {
                                            vErrors.push(err36);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid6 = _errs79 === errors;
                                      valid21 = valid21 || _valid6;
                                      const _errs81 = errors;
                                      if (data25 !== null) {
                                        const err37 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err37];
                                        } else {
                                          vErrors.push(err37);
                                        }
                                        errors++;
                                      }
                                      var _valid6 = _errs81 === errors;
                                      valid21 = valid21 || _valid6;
                                      if (!valid21) {
                                        const err38 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err38];
                                        } else {
                                          vErrors.push(err38);
                                        }
                                        errors++;
                                      } else {
                                        errors = _errs78;
                                        if (vErrors !== null) {
                                          if (_errs78) {
                                            vErrors.length = _errs78;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid20 = _errs77 === errors;
                                    } else {
                                      var valid20 = true;
                                    }
                                    if (valid20) {
                                      if (data22.reasoning_effort !== void 0) {
                                        let data26 = data22.reasoning_effort;
                                        const _errs83 = errors;
                                        const _errs84 = errors;
                                        let valid22 = false;
                                        const _errs85 = errors;
                                        if (errors === _errs85) {
                                          if (typeof data26 === "string") {
                                            if (func2(data26) > 200) {
                                              const err39 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                              if (vErrors === null) {
                                                vErrors = [err39];
                                              } else {
                                                vErrors.push(err39);
                                              }
                                              errors++;
                                            } else {
                                              if (func2(data26) < 1) {
                                                const err40 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                if (vErrors === null) {
                                                  vErrors = [err40];
                                                } else {
                                                  vErrors.push(err40);
                                                }
                                                errors++;
                                              }
                                            }
                                          } else {
                                            const err41 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                              vErrors = [err41];
                                            } else {
                                              vErrors.push(err41);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid7 = _errs85 === errors;
                                        valid22 = valid22 || _valid7;
                                        const _errs87 = errors;
                                        if (data26 !== null) {
                                          const err42 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err42];
                                          } else {
                                            vErrors.push(err42);
                                          }
                                          errors++;
                                        }
                                        var _valid7 = _errs87 === errors;
                                        valid22 = valid22 || _valid7;
                                        if (!valid22) {
                                          const err43 = { instancePath: instancePath + "/route/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err43];
                                          } else {
                                            vErrors.push(err43);
                                          }
                                          errors++;
                                        } else {
                                          errors = _errs84;
                                          if (vErrors !== null) {
                                            if (_errs84) {
                                              vErrors.length = _errs84;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid20 = _errs83 === errors;
                                      } else {
                                        var valid20 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              const err44 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err44];
                              } else {
                                vErrors.push(err44);
                              }
                              errors++;
                            }
                          }
                          var _valid5 = _errs70 === errors;
                          if (_valid5) {
                            valid18 = true;
                            passing1 = 0;
                            var props1 = {};
                            props1.agent_id = true;
                            props1.kind = true;
                            props1.model_id = true;
                            props1.reasoning_effort = true;
                          }
                          const _errs89 = errors;
                          const _errs90 = errors;
                          if (errors === _errs90) {
                            if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
                              let missing5;
                              if (data22.kind === void 0 && (missing5 = "kind") || data22.route_id === void 0 && (missing5 = "route_id") || data22.model_id === void 0 && (missing5 = "model_id")) {
                                const err45 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing5 }, message: "must have required property '" + missing5 + "'" };
                                if (vErrors === null) {
                                  vErrors = [err45];
                                } else {
                                  vErrors.push(err45);
                                }
                                errors++;
                              } else {
                                if (data22.kind !== void 0) {
                                  let data27 = data22.kind;
                                  const _errs92 = errors;
                                  if (typeof data27 !== "string") {
                                    const err46 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err46];
                                    } else {
                                      vErrors.push(err46);
                                    }
                                    errors++;
                                  }
                                  if ("api_key" !== data27) {
                                    const err47 = { instancePath: instancePath + "/route/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                    if (vErrors === null) {
                                      vErrors = [err47];
                                    } else {
                                      vErrors.push(err47);
                                    }
                                    errors++;
                                  }
                                  var valid24 = _errs92 === errors;
                                } else {
                                  var valid24 = true;
                                }
                                if (valid24) {
                                  if (data22.model_id !== void 0) {
                                    let data28 = data22.model_id;
                                    const _errs94 = errors;
                                    if (errors === _errs94) {
                                      if (typeof data28 === "string") {
                                        if (func2(data28) > 200) {
                                          const err48 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                          if (vErrors === null) {
                                            vErrors = [err48];
                                          } else {
                                            vErrors.push(err48);
                                          }
                                          errors++;
                                        } else {
                                          if (func2(data28) < 1) {
                                            const err49 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                            if (vErrors === null) {
                                              vErrors = [err49];
                                            } else {
                                              vErrors.push(err49);
                                            }
                                            errors++;
                                          }
                                        }
                                      } else {
                                        const err50 = { instancePath: instancePath + "/route/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                        if (vErrors === null) {
                                          vErrors = [err50];
                                        } else {
                                          vErrors.push(err50);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid24 = _errs94 === errors;
                                  } else {
                                    var valid24 = true;
                                  }
                                  if (valid24) {
                                    if (data22.route_id !== void 0) {
                                      let data29 = data22.route_id;
                                      const _errs96 = errors;
                                      if (errors === _errs96) {
                                        if (typeof data29 === "string") {
                                          if (!pattern4.test(data29)) {
                                            const err51 = { instancePath: instancePath + "/route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                            if (vErrors === null) {
                                              vErrors = [err51];
                                            } else {
                                              vErrors.push(err51);
                                            }
                                            errors++;
                                          }
                                        } else {
                                          const err52 = { instancePath: instancePath + "/route/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err52];
                                          } else {
                                            vErrors.push(err52);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid24 = _errs96 === errors;
                                    } else {
                                      var valid24 = true;
                                    }
                                  }
                                }
                              }
                            } else {
                              const err53 = { instancePath: instancePath + "/route", schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                              if (vErrors === null) {
                                vErrors = [err53];
                              } else {
                                vErrors.push(err53);
                              }
                              errors++;
                            }
                          }
                          var _valid5 = _errs89 === errors;
                          if (_valid5 && valid18) {
                            valid18 = false;
                            passing1 = [passing1, 1];
                          } else {
                            if (_valid5) {
                              valid18 = true;
                              passing1 = 1;
                              if (props1 !== true) {
                                props1 = props1 || {};
                                props1.kind = true;
                                props1.model_id = true;
                                props1.route_id = true;
                              }
                            }
                          }
                          if (!valid18) {
                            const err54 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/anyOf/0/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf" };
                            if (vErrors === null) {
                              vErrors = [err54];
                            } else {
                              vErrors.push(err54);
                            }
                            errors++;
                          } else {
                            errors = _errs69;
                            if (vErrors !== null) {
                              if (_errs69) {
                                vErrors.length = _errs69;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var _valid4 = _errs68 === errors;
                          valid17 = valid17 || _valid4;
                          const _errs98 = errors;
                          if (data22 !== null) {
                            const err55 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err55];
                            } else {
                              vErrors.push(err55);
                            }
                            errors++;
                          }
                          var _valid4 = _errs98 === errors;
                          valid17 = valid17 || _valid4;
                          if (!valid17) {
                            const err56 = { instancePath: instancePath + "/route", schemaPath: "#/properties/route/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err56];
                            } else {
                              vErrors.push(err56);
                            }
                            errors++;
                            validate216.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs67;
                            if (vErrors !== null) {
                              if (_errs67) {
                                vErrors.length = _errs67;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs66 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.step_routes !== void 0) {
                            let data30 = data.step_routes;
                            const _errs100 = errors;
                            if (errors === _errs100) {
                              if (data30 && typeof data30 == "object" && !Array.isArray(data30)) {
                                if (Object.keys(data30).length > 100) {
                                  validate216.errors = [{ instancePath: instancePath + "/step_routes", schemaPath: "#/properties/step_routes/maxProperties", keyword: "maxProperties", params: { limit: 100 }, message: "must NOT have more than 100 properties" }];
                                  return false;
                                } else {
                                  var props2 = {};
                                  for (const key1 in data30) {
                                    if (pattern14.test(key1)) {
                                      let data31 = data30[key1];
                                      const _errs103 = errors;
                                      let valid26 = false;
                                      let passing2 = null;
                                      const _errs104 = errors;
                                      const _errs105 = errors;
                                      if (errors === _errs105) {
                                        if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                          let missing6;
                                          if (data31.kind === void 0 && (missing6 = "kind") || data31.agent_id === void 0 && (missing6 = "agent_id") || data31.model_id === void 0 && (missing6 = "model_id")) {
                                            const err57 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/AgentRoute/required", keyword: "required", params: { missingProperty: missing6 }, message: "must have required property '" + missing6 + "'" };
                                            if (vErrors === null) {
                                              vErrors = [err57];
                                            } else {
                                              vErrors.push(err57);
                                            }
                                            errors++;
                                          } else {
                                            if (data31.agent_id !== void 0) {
                                              let data32 = data31.agent_id;
                                              const _errs107 = errors;
                                              if (errors === _errs107) {
                                                if (typeof data32 === "string") {
                                                  if (!pattern4.test(data32)) {
                                                    const err58 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                    if (vErrors === null) {
                                                      vErrors = [err58];
                                                    } else {
                                                      vErrors.push(err58);
                                                    }
                                                    errors++;
                                                  }
                                                } else {
                                                  const err59 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/agent_id", schemaPath: "#/$defs/AgentRoute/properties/agent_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err59];
                                                  } else {
                                                    vErrors.push(err59);
                                                  }
                                                  errors++;
                                                }
                                              }
                                              var valid28 = _errs107 === errors;
                                            } else {
                                              var valid28 = true;
                                            }
                                            if (valid28) {
                                              if (data31.kind !== void 0) {
                                                let data33 = data31.kind;
                                                const _errs109 = errors;
                                                if (typeof data33 !== "string") {
                                                  const err60 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                  if (vErrors === null) {
                                                    vErrors = [err60];
                                                  } else {
                                                    vErrors.push(err60);
                                                  }
                                                  errors++;
                                                }
                                                if ("agent" !== data33) {
                                                  const err61 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/AgentRoute/properties/kind/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant" };
                                                  if (vErrors === null) {
                                                    vErrors = [err61];
                                                  } else {
                                                    vErrors.push(err61);
                                                  }
                                                  errors++;
                                                }
                                                var valid28 = _errs109 === errors;
                                              } else {
                                                var valid28 = true;
                                              }
                                              if (valid28) {
                                                if (data31.model_id !== void 0) {
                                                  let data34 = data31.model_id;
                                                  const _errs111 = errors;
                                                  const _errs112 = errors;
                                                  let valid29 = false;
                                                  const _errs113 = errors;
                                                  if (errors === _errs113) {
                                                    if (typeof data34 === "string") {
                                                      if (func2(data34) > 200) {
                                                        const err62 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err62];
                                                        } else {
                                                          vErrors.push(err62);
                                                        }
                                                        errors++;
                                                      } else {
                                                        if (func2(data34) < 1) {
                                                          const err63 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err63];
                                                          } else {
                                                            vErrors.push(err63);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                    } else {
                                                      const err64 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                      if (vErrors === null) {
                                                        vErrors = [err64];
                                                      } else {
                                                        vErrors.push(err64);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var _valid9 = _errs113 === errors;
                                                  valid29 = valid29 || _valid9;
                                                  const _errs115 = errors;
                                                  if (data34 !== null) {
                                                    const err65 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                    if (vErrors === null) {
                                                      vErrors = [err65];
                                                    } else {
                                                      vErrors.push(err65);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid9 = _errs115 === errors;
                                                  valid29 = valid29 || _valid9;
                                                  if (!valid29) {
                                                    const err66 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/AgentRoute/properties/model_id/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                    if (vErrors === null) {
                                                      vErrors = [err66];
                                                    } else {
                                                      vErrors.push(err66);
                                                    }
                                                    errors++;
                                                  } else {
                                                    errors = _errs112;
                                                    if (vErrors !== null) {
                                                      if (_errs112) {
                                                        vErrors.length = _errs112;
                                                      } else {
                                                        vErrors = null;
                                                      }
                                                    }
                                                  }
                                                  var valid28 = _errs111 === errors;
                                                } else {
                                                  var valid28 = true;
                                                }
                                                if (valid28) {
                                                  if (data31.reasoning_effort !== void 0) {
                                                    let data35 = data31.reasoning_effort;
                                                    const _errs117 = errors;
                                                    const _errs118 = errors;
                                                    let valid30 = false;
                                                    const _errs119 = errors;
                                                    if (errors === _errs119) {
                                                      if (typeof data35 === "string") {
                                                        if (func2(data35) > 200) {
                                                          const err67 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                          if (vErrors === null) {
                                                            vErrors = [err67];
                                                          } else {
                                                            vErrors.push(err67);
                                                          }
                                                          errors++;
                                                        } else {
                                                          if (func2(data35) < 1) {
                                                            const err68 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                            if (vErrors === null) {
                                                              vErrors = [err68];
                                                            } else {
                                                              vErrors.push(err68);
                                                            }
                                                            errors++;
                                                          }
                                                        }
                                                      } else {
                                                        const err69 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                        if (vErrors === null) {
                                                          vErrors = [err69];
                                                        } else {
                                                          vErrors.push(err69);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                    var _valid10 = _errs119 === errors;
                                                    valid30 = valid30 || _valid10;
                                                    const _errs121 = errors;
                                                    if (data35 !== null) {
                                                      const err70 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                      if (vErrors === null) {
                                                        vErrors = [err70];
                                                      } else {
                                                        vErrors.push(err70);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid10 = _errs121 === errors;
                                                    valid30 = valid30 || _valid10;
                                                    if (!valid30) {
                                                      const err71 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/reasoning_effort", schemaPath: "#/$defs/AgentRoute/properties/reasoning_effort/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                      if (vErrors === null) {
                                                        vErrors = [err71];
                                                      } else {
                                                        vErrors.push(err71);
                                                      }
                                                      errors++;
                                                    } else {
                                                      errors = _errs118;
                                                      if (vErrors !== null) {
                                                        if (_errs118) {
                                                          vErrors.length = _errs118;
                                                        } else {
                                                          vErrors = null;
                                                        }
                                                      }
                                                    }
                                                    var valid28 = _errs117 === errors;
                                                  } else {
                                                    var valid28 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        } else {
                                          const err72 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/AgentRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                          if (vErrors === null) {
                                            vErrors = [err72];
                                          } else {
                                            vErrors.push(err72);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid8 = _errs104 === errors;
                                      if (_valid8) {
                                        valid26 = true;
                                        passing2 = 0;
                                        var props3 = {};
                                        props3.agent_id = true;
                                        props3.kind = true;
                                        props3.model_id = true;
                                        props3.reasoning_effort = true;
                                      }
                                      const _errs123 = errors;
                                      const _errs124 = errors;
                                      if (errors === _errs124) {
                                        if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                          let missing7;
                                          if (data31.kind === void 0 && (missing7 = "kind") || data31.route_id === void 0 && (missing7 = "route_id") || data31.model_id === void 0 && (missing7 = "model_id")) {
                                            const err73 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ApiKeyRoute/required", keyword: "required", params: { missingProperty: missing7 }, message: "must have required property '" + missing7 + "'" };
                                            if (vErrors === null) {
                                              vErrors = [err73];
                                            } else {
                                              vErrors.push(err73);
                                            }
                                            errors++;
                                          } else {
                                            if (data31.kind !== void 0) {
                                              let data36 = data31.kind;
                                              const _errs126 = errors;
                                              if (typeof data36 !== "string") {
                                                const err74 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                if (vErrors === null) {
                                                  vErrors = [err74];
                                                } else {
                                                  vErrors.push(err74);
                                                }
                                                errors++;
                                              }
                                              if ("api_key" !== data36) {
                                                const err75 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/kind", schemaPath: "#/$defs/ApiKeyRoute/properties/kind/const", keyword: "const", params: { allowedValue: "api_key" }, message: "must be equal to constant" };
                                                if (vErrors === null) {
                                                  vErrors = [err75];
                                                } else {
                                                  vErrors.push(err75);
                                                }
                                                errors++;
                                              }
                                              var valid32 = _errs126 === errors;
                                            } else {
                                              var valid32 = true;
                                            }
                                            if (valid32) {
                                              if (data31.model_id !== void 0) {
                                                let data37 = data31.model_id;
                                                const _errs128 = errors;
                                                if (errors === _errs128) {
                                                  if (typeof data37 === "string") {
                                                    if (func2(data37) > 200) {
                                                      const err76 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                                      if (vErrors === null) {
                                                        vErrors = [err76];
                                                      } else {
                                                        vErrors.push(err76);
                                                      }
                                                      errors++;
                                                    } else {
                                                      if (func2(data37) < 1) {
                                                        const err77 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                        if (vErrors === null) {
                                                          vErrors = [err77];
                                                        } else {
                                                          vErrors.push(err77);
                                                        }
                                                        errors++;
                                                      }
                                                    }
                                                  } else {
                                                    const err78 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/model_id", schemaPath: "#/$defs/ApiKeyRoute/properties/model_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                      vErrors = [err78];
                                                    } else {
                                                      vErrors.push(err78);
                                                    }
                                                    errors++;
                                                  }
                                                }
                                                var valid32 = _errs128 === errors;
                                              } else {
                                                var valid32 = true;
                                              }
                                              if (valid32) {
                                                if (data31.route_id !== void 0) {
                                                  let data38 = data31.route_id;
                                                  const _errs130 = errors;
                                                  if (errors === _errs130) {
                                                    if (typeof data38 === "string") {
                                                      if (!pattern4.test(data38)) {
                                                        const err79 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/pattern", keyword: "pattern", params: { pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$" }, message: 'must match pattern "^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$"' };
                                                        if (vErrors === null) {
                                                          vErrors = [err79];
                                                        } else {
                                                          vErrors.push(err79);
                                                        }
                                                        errors++;
                                                      }
                                                    } else {
                                                      const err80 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/route_id", schemaPath: "#/$defs/ApiKeyRoute/properties/route_id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                      if (vErrors === null) {
                                                        vErrors = [err80];
                                                      } else {
                                                        vErrors.push(err80);
                                                      }
                                                      errors++;
                                                    }
                                                  }
                                                  var valid32 = _errs130 === errors;
                                                } else {
                                                  var valid32 = true;
                                                }
                                              }
                                            }
                                          }
                                        } else {
                                          const err81 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/$defs/ApiKeyRoute/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                          if (vErrors === null) {
                                            vErrors = [err81];
                                          } else {
                                            vErrors.push(err81);
                                          }
                                          errors++;
                                        }
                                      }
                                      var _valid8 = _errs123 === errors;
                                      if (_valid8 && valid26) {
                                        valid26 = false;
                                        passing2 = [passing2, 1];
                                      } else {
                                        if (_valid8) {
                                          valid26 = true;
                                          passing2 = 1;
                                          if (props3 !== true) {
                                            props3 = props3 || {};
                                            props3.kind = true;
                                            props3.model_id = true;
                                            props3.route_id = true;
                                          }
                                        }
                                      }
                                      if (!valid26) {
                                        const err82 = { instancePath: instancePath + "/step_routes/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/step_routes/patternProperties/%5E%5Ba-z%5D%5Ba-z0-9_%5D%7B0%2C62%7D(%5C.%5Ba-z%5D%5Ba-z0-9_%5D%7B0%2C62%7D)%7B0%2C7%7D%24/oneOf", keyword: "oneOf", params: { passingSchemas: passing2 }, message: "must match exactly one schema in oneOf" };
                                        if (vErrors === null) {
                                          vErrors = [err82];
                                        } else {
                                          vErrors.push(err82);
                                        }
                                        errors++;
                                        validate216.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs103;
                                        if (vErrors !== null) {
                                          if (_errs103) {
                                            vErrors.length = _errs103;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      props2[key1] = true;
                                    }
                                  }
                                }
                              } else {
                                validate216.errors = [{ instancePath: instancePath + "/step_routes", schemaPath: "#/properties/step_routes/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                            var valid0 = _errs100 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.stop_before_agent_steps !== void 0) {
                              const _errs132 = errors;
                              if (typeof data.stop_before_agent_steps !== "boolean") {
                                validate216.errors = [{ instancePath: instancePath + "/stop_before_agent_steps", schemaPath: "#/properties/stop_before_agent_steps/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                return false;
                              }
                              var valid0 = _errs132 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate216.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate216.errors = vErrors;
  return errors === 0;
}
validate216.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var validateBindings = validate217;
function validate217(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate217.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.content_version === void 0 && (missing0 = "content_version") || data.corpus_version === void 0 && (missing0 = "corpus_version") || data.subject === void 0 && (missing0 = "subject")) {
        validate217.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "content_version" || key0 === "context_outputs" || key0 === "corpus_version" || key0 === "selection" || key0 === "source_version" || key0 === "subject")) {
            validate217.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.content_version !== void 0) {
            const _errs2 = errors;
            if (typeof data.content_version !== "string") {
              validate217.errors = [{ instancePath: instancePath + "/content_version", schemaPath: "#/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.context_outputs !== void 0) {
              let data1 = data.context_outputs;
              const _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  const len0 = data1.length;
                  for (let i0 = 0; i0 < len0; i0++) {
                    const _errs6 = errors;
                    if (typeof data1[i0] !== "string") {
                      validate217.errors = [{ instancePath: instancePath + "/context_outputs/" + i0, schemaPath: "#/properties/context_outputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate217.errors = [{ instancePath: instancePath + "/context_outputs", schemaPath: "#/properties/context_outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.corpus_version !== void 0) {
                let data3 = data.corpus_version;
                const _errs8 = errors;
                const _errs9 = errors;
                let valid2 = false;
                const _errs10 = errors;
                if (typeof data3 !== "string") {
                  const err0 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                var _valid0 = _errs10 === errors;
                valid2 = valid2 || _valid0;
                const _errs12 = errors;
                if (data3 !== null) {
                  const err1 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var _valid0 = _errs12 === errors;
                valid2 = valid2 || _valid0;
                if (!valid2) {
                  const err2 = { instancePath: instancePath + "/corpus_version", schemaPath: "#/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                  validate217.errors = vErrors;
                  return false;
                } else {
                  errors = _errs9;
                  if (vErrors !== null) {
                    if (_errs9) {
                      vErrors.length = _errs9;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.selection !== void 0) {
                  let data4 = data.selection;
                  const _errs14 = errors;
                  if (errors === _errs14) {
                    if (Array.isArray(data4)) {
                      if (data4.length > 200) {
                        validate217.errors = [{ instancePath: instancePath + "/selection", schemaPath: "#/properties/selection/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" }];
                        return false;
                      } else {
                        var valid3 = true;
                        const len1 = data4.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                          const _errs16 = errors;
                          if (typeof data4[i1] !== "string") {
                            validate217.errors = [{ instancePath: instancePath + "/selection/" + i1, schemaPath: "#/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          var valid3 = _errs16 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate217.errors = [{ instancePath: instancePath + "/selection", schemaPath: "#/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.source_version !== void 0) {
                    let data6 = data.source_version;
                    const _errs18 = errors;
                    const _errs19 = errors;
                    let valid4 = false;
                    const _errs20 = errors;
                    if (typeof data6 !== "string") {
                      const err3 = { instancePath: instancePath + "/source_version", schemaPath: "#/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err3];
                      } else {
                        vErrors.push(err3);
                      }
                      errors++;
                    }
                    var _valid1 = _errs20 === errors;
                    valid4 = valid4 || _valid1;
                    const _errs22 = errors;
                    if (data6 !== null) {
                      const err4 = { instancePath: instancePath + "/source_version", schemaPath: "#/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid1 = _errs22 === errors;
                    valid4 = valid4 || _valid1;
                    if (!valid4) {
                      const err5 = { instancePath: instancePath + "/source_version", schemaPath: "#/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                      validate217.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs19;
                      if (vErrors !== null) {
                        if (_errs19) {
                          vErrors.length = _errs19;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.subject !== void 0) {
                      let data7 = data.subject;
                      const _errs24 = errors;
                      const _errs25 = errors;
                      let valid5 = false;
                      const _errs26 = errors;
                      if (typeof data7 !== "string") {
                        const err6 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                      var _valid2 = _errs26 === errors;
                      valid5 = valid5 || _valid2;
                      const _errs28 = errors;
                      if (data7 !== null) {
                        const err7 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err7];
                        } else {
                          vErrors.push(err7);
                        }
                        errors++;
                      }
                      var _valid2 = _errs28 === errors;
                      valid5 = valid5 || _valid2;
                      if (!valid5) {
                        const err8 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                        validate217.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs25;
                        if (vErrors !== null) {
                          if (_errs25) {
                            vErrors.length = _errs25;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid0 = _errs24 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate217.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate217.errors = vErrors;
  return errors === 0;
}
validate217.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var validateListing = validate218;
function validate218(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate218.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.thread_id === void 0 && (missing0 = "thread_id") || data.project_id === void 0 && (missing0 = "project_id") || data.title === void 0 && (missing0 = "title") || data.parent === void 0 && (missing0 = "parent") || data.state === void 0 && (missing0 = "state") || data.host === void 0 && (missing0 = "host") || data.created_at === void 0 && (missing0 = "created_at") || data.last_entry_number === void 0 && (missing0 = "last_entry_number") || data.last_entry_at === void 0 && (missing0 = "last_entry_at") || data.latest_turn_requested_at === void 0 && (missing0 = "latest_turn_requested_at") || data.latest_turn_finished_at === void 0 && (missing0 = "latest_turn_finished_at") || data.latest_person_written_at === void 0 && (missing0 = "latest_person_written_at") || data.projection === void 0 && (missing0 = "projection") || data.can_settle_or_snooze === void 0 && (missing0 = "can_settle_or_snooze")) {
        validate218.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema267.properties, key0)) {
            validate218.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.attached_connector !== void 0) {
            let data0 = data.attached_connector;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate218.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.can_settle_or_snooze !== void 0) {
              const _errs8 = errors;
              if (typeof data.can_settle_or_snooze !== "boolean") {
                validate218.errors = [{ instancePath: instancePath + "/can_settle_or_snooze", schemaPath: "#/properties/can_settle_or_snooze/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.created_at !== void 0) {
                let data2 = data.created_at;
                const _errs10 = errors;
                if (errors === _errs10) {
                  if (errors === _errs10) {
                    if (typeof data2 === "string") {
                      if (!formats0.validate(data2)) {
                        validate218.errors = [{ instancePath: instancePath + "/created_at", schemaPath: "#/properties/created_at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                        return false;
                      }
                    } else {
                      validate218.errors = [{ instancePath: instancePath + "/created_at", schemaPath: "#/properties/created_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.edited_item !== void 0) {
                  let data3 = data.edited_item;
                  const _errs12 = errors;
                  const _errs13 = errors;
                  let valid2 = false;
                  const _errs14 = errors;
                  if (typeof data3 !== "string") {
                    const err3 = { instancePath: instancePath + "/edited_item", schemaPath: "#/properties/edited_item/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var _valid1 = _errs14 === errors;
                  valid2 = valid2 || _valid1;
                  const _errs16 = errors;
                  if (data3 !== null) {
                    const err4 = { instancePath: instancePath + "/edited_item", schemaPath: "#/properties/edited_item/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var _valid1 = _errs16 === errors;
                  valid2 = valid2 || _valid1;
                  if (!valid2) {
                    const err5 = { instancePath: instancePath + "/edited_item", schemaPath: "#/properties/edited_item/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                    validate218.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs13;
                    if (vErrors !== null) {
                      if (_errs13) {
                        vErrors.length = _errs13;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.host !== void 0) {
                    const _errs18 = errors;
                    if (typeof data.host !== "string") {
                      validate218.errors = [{ instancePath: instancePath + "/host", schemaPath: "#/properties/host/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.last_entry_at !== void 0) {
                      let data5 = data.last_entry_at;
                      const _errs20 = errors;
                      if (errors === _errs20) {
                        if (errors === _errs20) {
                          if (typeof data5 === "string") {
                            if (!formats0.validate(data5)) {
                              validate218.errors = [{ instancePath: instancePath + "/last_entry_at", schemaPath: "#/properties/last_entry_at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' }];
                              return false;
                            }
                          } else {
                            validate218.errors = [{ instancePath: instancePath + "/last_entry_at", schemaPath: "#/properties/last_entry_at/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                        }
                      }
                      var valid0 = _errs20 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.last_entry_number !== void 0) {
                        let data6 = data.last_entry_number;
                        const _errs22 = errors;
                        if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)))) {
                          validate218.errors = [{ instancePath: instancePath + "/last_entry_number", schemaPath: "#/properties/last_entry_number/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                          return false;
                        }
                        var valid0 = _errs22 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.latest_person_written_at !== void 0) {
                          let data7 = data.latest_person_written_at;
                          const _errs24 = errors;
                          const _errs25 = errors;
                          let valid3 = false;
                          const _errs26 = errors;
                          if (errors === _errs26) {
                            if (errors === _errs26) {
                              if (typeof data7 === "string") {
                                if (!formats0.validate(data7)) {
                                  const err6 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                              } else {
                                const err7 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err7];
                                } else {
                                  vErrors.push(err7);
                                }
                                errors++;
                              }
                            }
                          }
                          var _valid2 = _errs26 === errors;
                          valid3 = valid3 || _valid2;
                          const _errs28 = errors;
                          if (data7 !== null) {
                            const err8 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err8];
                            } else {
                              vErrors.push(err8);
                            }
                            errors++;
                          }
                          var _valid2 = _errs28 === errors;
                          valid3 = valid3 || _valid2;
                          if (!valid3) {
                            const err9 = { instancePath: instancePath + "/latest_person_written_at", schemaPath: "#/properties/latest_person_written_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                            validate218.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs25;
                            if (vErrors !== null) {
                              if (_errs25) {
                                vErrors.length = _errs25;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs24 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.latest_turn_finished_at !== void 0) {
                            let data8 = data.latest_turn_finished_at;
                            const _errs30 = errors;
                            const _errs31 = errors;
                            let valid4 = false;
                            const _errs32 = errors;
                            if (errors === _errs32) {
                              if (errors === _errs32) {
                                if (typeof data8 === "string") {
                                  if (!formats0.validate(data8)) {
                                    const err10 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                } else {
                                  const err11 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err11];
                                  } else {
                                    vErrors.push(err11);
                                  }
                                  errors++;
                                }
                              }
                            }
                            var _valid3 = _errs32 === errors;
                            valid4 = valid4 || _valid3;
                            const _errs34 = errors;
                            if (data8 !== null) {
                              const err12 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err12];
                              } else {
                                vErrors.push(err12);
                              }
                              errors++;
                            }
                            var _valid3 = _errs34 === errors;
                            valid4 = valid4 || _valid3;
                            if (!valid4) {
                              const err13 = { instancePath: instancePath + "/latest_turn_finished_at", schemaPath: "#/properties/latest_turn_finished_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err13];
                              } else {
                                vErrors.push(err13);
                              }
                              errors++;
                              validate218.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs31;
                              if (vErrors !== null) {
                                if (_errs31) {
                                  vErrors.length = _errs31;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid0 = _errs30 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.latest_turn_requested_at !== void 0) {
                              let data9 = data.latest_turn_requested_at;
                              const _errs36 = errors;
                              const _errs37 = errors;
                              let valid5 = false;
                              const _errs38 = errors;
                              if (errors === _errs38) {
                                if (errors === _errs38) {
                                  if (typeof data9 === "string") {
                                    if (!formats0.validate(data9)) {
                                      const err14 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                                      if (vErrors === null) {
                                        vErrors = [err14];
                                      } else {
                                        vErrors.push(err14);
                                      }
                                      errors++;
                                    }
                                  } else {
                                    const err15 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err15];
                                    } else {
                                      vErrors.push(err15);
                                    }
                                    errors++;
                                  }
                                }
                              }
                              var _valid4 = _errs38 === errors;
                              valid5 = valid5 || _valid4;
                              const _errs40 = errors;
                              if (data9 !== null) {
                                const err16 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err16];
                                } else {
                                  vErrors.push(err16);
                                }
                                errors++;
                              }
                              var _valid4 = _errs40 === errors;
                              valid5 = valid5 || _valid4;
                              if (!valid5) {
                                const err17 = { instancePath: instancePath + "/latest_turn_requested_at", schemaPath: "#/properties/latest_turn_requested_at/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err17];
                                } else {
                                  vErrors.push(err17);
                                }
                                errors++;
                                validate218.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs37;
                                if (vErrors !== null) {
                                  if (_errs37) {
                                    vErrors.length = _errs37;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs36 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.parent !== void 0) {
                                let data10 = data.parent;
                                const _errs42 = errors;
                                const _errs43 = errors;
                                let valid6 = false;
                                const _errs44 = errors;
                                if (typeof data10 !== "string") {
                                  const err18 = { instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err18];
                                  } else {
                                    vErrors.push(err18);
                                  }
                                  errors++;
                                }
                                var _valid5 = _errs44 === errors;
                                valid6 = valid6 || _valid5;
                                const _errs46 = errors;
                                if (data10 !== null) {
                                  const err19 = { instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err19];
                                  } else {
                                    vErrors.push(err19);
                                  }
                                  errors++;
                                }
                                var _valid5 = _errs46 === errors;
                                valid6 = valid6 || _valid5;
                                if (!valid6) {
                                  const err20 = { instancePath: instancePath + "/parent", schemaPath: "#/properties/parent/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err20];
                                  } else {
                                    vErrors.push(err20);
                                  }
                                  errors++;
                                  validate218.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs43;
                                  if (vErrors !== null) {
                                    if (_errs43) {
                                      vErrors.length = _errs43;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs42 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.project_id !== void 0) {
                                  const _errs48 = errors;
                                  if (typeof data.project_id !== "string") {
                                    validate218.errors = [{ instancePath: instancePath + "/project_id", schemaPath: "#/properties/project_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid0 = _errs48 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.projection !== void 0) {
                                    const _errs50 = errors;
                                    if (!validate162(data.projection, { instancePath: instancePath + "/projection", parentData: data, parentDataProperty: "projection", rootData, dynamicAnchors })) {
                                      vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid0 = _errs50 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.state !== void 0) {
                                      let data13 = data.state;
                                      const _errs51 = errors;
                                      if (typeof data13 !== "string") {
                                        validate218.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      if (!(data13 === "saved" || data13 === "live" || data13 === "closed")) {
                                        validate218.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/enum", keyword: "enum", params: { allowedValues: schema241.enum }, message: "must be equal to one of the allowed values" }];
                                        return false;
                                      }
                                      var valid0 = _errs51 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.subject !== void 0) {
                                        let data14 = data.subject;
                                        const _errs54 = errors;
                                        const _errs55 = errors;
                                        let valid8 = false;
                                        const _errs56 = errors;
                                        if (typeof data14 !== "string") {
                                          const err21 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                          if (vErrors === null) {
                                            vErrors = [err21];
                                          } else {
                                            vErrors.push(err21);
                                          }
                                          errors++;
                                        }
                                        var _valid6 = _errs56 === errors;
                                        valid8 = valid8 || _valid6;
                                        const _errs58 = errors;
                                        if (data14 !== null) {
                                          const err22 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err22];
                                          } else {
                                            vErrors.push(err22);
                                          }
                                          errors++;
                                        }
                                        var _valid6 = _errs58 === errors;
                                        valid8 = valid8 || _valid6;
                                        if (!valid8) {
                                          const err23 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                          if (vErrors === null) {
                                            vErrors = [err23];
                                          } else {
                                            vErrors.push(err23);
                                          }
                                          errors++;
                                          validate218.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs55;
                                          if (vErrors !== null) {
                                            if (_errs55) {
                                              vErrors.length = _errs55;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid0 = _errs54 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.thread_id !== void 0) {
                                          const _errs60 = errors;
                                          if (typeof data.thread_id !== "string") {
                                            validate218.errors = [{ instancePath: instancePath + "/thread_id", schemaPath: "#/properties/thread_id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                          var valid0 = _errs60 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.title !== void 0) {
                                            const _errs62 = errors;
                                            if (typeof data.title !== "string") {
                                              validate218.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid0 = _errs62 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate218.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate218.errors = vErrors;
  return errors === 0;
}
validate218.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var validateFacts = validate220;
function validate220(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate220.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.state === void 0 && (missing0 = "state") || data.host === void 0 && (missing0 = "host") || data.attached_connector === void 0 && (missing0 = "attached_connector") || data.connector_online === void 0 && (missing0 = "connector_online") || data.route_unavailable_because === void 0 && (missing0 = "route_unavailable_because") || data.title === void 0 && (missing0 = "title") || data.settings === void 0 && (missing0 = "settings") || data.bindings === void 0 && (missing0 = "bindings") || data.serves_participants === void 0 && (missing0 = "serves_participants") || data.projection === void 0 && (missing0 = "projection") || data.detail === void 0 && (missing0 = "detail")) {
        validate220.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func1.call(schema193.properties, key0)) {
            validate220.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.attached_connector !== void 0) {
            let data0 = data.attached_connector;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (typeof data0 !== "string") {
              const err0 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/attached_connector", schemaPath: "#/properties/attached_connector/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate220.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.bindings !== void 0) {
              let data1 = data.bindings;
              const _errs8 = errors;
              const _errs9 = errors;
              if (errors === _errs9) {
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                  let missing1;
                  if (data1.content_version === void 0 && (missing1 = "content_version") || data1.corpus_version === void 0 && (missing1 = "corpus_version") || data1.subject === void 0 && (missing1 = "subject")) {
                    validate220.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                    return false;
                  } else {
                    const _errs11 = errors;
                    for (const key1 in data1) {
                      if (!(key1 === "content_version" || key1 === "context_outputs" || key1 === "corpus_version" || key1 === "selection" || key1 === "source_version" || key1 === "subject")) {
                        validate220.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                        return false;
                        break;
                      }
                    }
                    if (_errs11 === errors) {
                      if (data1.content_version !== void 0) {
                        const _errs12 = errors;
                        if (typeof data1.content_version !== "string") {
                          validate220.errors = [{ instancePath: instancePath + "/bindings/content_version", schemaPath: "#/$defs/ThreadBindings/properties/content_version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        var valid3 = _errs12 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data1.context_outputs !== void 0) {
                          let data3 = data1.context_outputs;
                          const _errs14 = errors;
                          if (errors === _errs14) {
                            if (Array.isArray(data3)) {
                              var valid4 = true;
                              const len0 = data3.length;
                              for (let i0 = 0; i0 < len0; i0++) {
                                const _errs16 = errors;
                                if (typeof data3[i0] !== "string") {
                                  validate220.errors = [{ instancePath: instancePath + "/bindings/context_outputs/" + i0, schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid4 = _errs16 === errors;
                                if (!valid4) {
                                  break;
                                }
                              }
                            } else {
                              validate220.errors = [{ instancePath: instancePath + "/bindings/context_outputs", schemaPath: "#/$defs/ThreadBindings/properties/context_outputs/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid3 = _errs14 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data1.corpus_version !== void 0) {
                            let data5 = data1.corpus_version;
                            const _errs18 = errors;
                            const _errs19 = errors;
                            let valid5 = false;
                            const _errs20 = errors;
                            if (typeof data5 !== "string") {
                              const err3 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err3];
                              } else {
                                vErrors.push(err3);
                              }
                              errors++;
                            }
                            var _valid1 = _errs20 === errors;
                            valid5 = valid5 || _valid1;
                            const _errs22 = errors;
                            if (data5 !== null) {
                              const err4 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err4];
                              } else {
                                vErrors.push(err4);
                              }
                              errors++;
                            }
                            var _valid1 = _errs22 === errors;
                            valid5 = valid5 || _valid1;
                            if (!valid5) {
                              const err5 = { instancePath: instancePath + "/bindings/corpus_version", schemaPath: "#/$defs/ThreadBindings/properties/corpus_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                              if (vErrors === null) {
                                vErrors = [err5];
                              } else {
                                vErrors.push(err5);
                              }
                              errors++;
                              validate220.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs19;
                              if (vErrors !== null) {
                                if (_errs19) {
                                  vErrors.length = _errs19;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid3 = _errs18 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.selection !== void 0) {
                              let data6 = data1.selection;
                              const _errs24 = errors;
                              if (errors === _errs24) {
                                if (Array.isArray(data6)) {
                                  if (data6.length > 200) {
                                    validate220.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" }];
                                    return false;
                                  } else {
                                    var valid6 = true;
                                    const len1 = data6.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                      const _errs26 = errors;
                                      if (typeof data6[i1] !== "string") {
                                        validate220.errors = [{ instancePath: instancePath + "/bindings/selection/" + i1, schemaPath: "#/$defs/ThreadBindings/properties/selection/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      var valid6 = _errs26 === errors;
                                      if (!valid6) {
                                        break;
                                      }
                                    }
                                  }
                                } else {
                                  validate220.errors = [{ instancePath: instancePath + "/bindings/selection", schemaPath: "#/$defs/ThreadBindings/properties/selection/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid3 = _errs24 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.source_version !== void 0) {
                                let data8 = data1.source_version;
                                const _errs28 = errors;
                                const _errs29 = errors;
                                let valid7 = false;
                                const _errs30 = errors;
                                if (typeof data8 !== "string") {
                                  const err6 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                  if (vErrors === null) {
                                    vErrors = [err6];
                                  } else {
                                    vErrors.push(err6);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs30 === errors;
                                valid7 = valid7 || _valid2;
                                const _errs32 = errors;
                                if (data8 !== null) {
                                  const err7 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                  if (vErrors === null) {
                                    vErrors = [err7];
                                  } else {
                                    vErrors.push(err7);
                                  }
                                  errors++;
                                }
                                var _valid2 = _errs32 === errors;
                                valid7 = valid7 || _valid2;
                                if (!valid7) {
                                  const err8 = { instancePath: instancePath + "/bindings/source_version", schemaPath: "#/$defs/ThreadBindings/properties/source_version/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                  validate220.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs29;
                                  if (vErrors !== null) {
                                    if (_errs29) {
                                      vErrors.length = _errs29;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid3 = _errs28 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.subject !== void 0) {
                                  let data9 = data1.subject;
                                  const _errs34 = errors;
                                  const _errs35 = errors;
                                  let valid8 = false;
                                  const _errs36 = errors;
                                  if (typeof data9 !== "string") {
                                    const err9 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err9];
                                    } else {
                                      vErrors.push(err9);
                                    }
                                    errors++;
                                  }
                                  var _valid3 = _errs36 === errors;
                                  valid8 = valid8 || _valid3;
                                  const _errs38 = errors;
                                  if (data9 !== null) {
                                    const err10 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                  var _valid3 = _errs38 === errors;
                                  valid8 = valid8 || _valid3;
                                  if (!valid8) {
                                    const err11 = { instancePath: instancePath + "/bindings/subject", schemaPath: "#/$defs/ThreadBindings/properties/subject/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err11];
                                    } else {
                                      vErrors.push(err11);
                                    }
                                    errors++;
                                    validate220.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs35;
                                    if (vErrors !== null) {
                                      if (_errs35) {
                                        vErrors.length = _errs35;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid3 = _errs34 === errors;
                                } else {
                                  var valid3 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate220.errors = [{ instancePath: instancePath + "/bindings", schemaPath: "#/$defs/ThreadBindings/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                  return false;
                }
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.connector_online !== void 0) {
                const _errs40 = errors;
                if (typeof data.connector_online !== "boolean") {
                  validate220.errors = [{ instancePath: instancePath + "/connector_online", schemaPath: "#/properties/connector_online/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs40 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.departures !== void 0) {
                  let data11 = data.departures;
                  const _errs42 = errors;
                  if (errors === _errs42) {
                    if (Array.isArray(data11)) {
                      var valid9 = true;
                      const len2 = data11.length;
                      for (let i2 = 0; i2 < len2; i2++) {
                        let data12 = data11[i2];
                        const _errs44 = errors;
                        const _errs45 = errors;
                        if (errors === _errs45) {
                          if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                            let missing2;
                            if (data12.workflow === void 0 && (missing2 = "workflow") || data12.after_step === void 0 && (missing2 = "after_step")) {
                              validate220.errors = [{ instancePath: instancePath + "/departures/" + i2, schemaPath: "#/$defs/Departure/required", keyword: "required", params: { missingProperty: missing2 }, message: "must have required property '" + missing2 + "'" }];
                              return false;
                            } else {
                              const _errs47 = errors;
                              for (const key2 in data12) {
                                if (!(key2 === "after_step" || key2 === "workflow")) {
                                  validate220.errors = [{ instancePath: instancePath + "/departures/" + i2, schemaPath: "#/$defs/Departure/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" }];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs47 === errors) {
                                if (data12.after_step !== void 0) {
                                  let data13 = data12.after_step;
                                  const _errs48 = errors;
                                  const _errs49 = errors;
                                  let valid12 = false;
                                  const _errs50 = errors;
                                  if (typeof data13 !== "string") {
                                    const err12 = { instancePath: instancePath + "/departures/" + i2 + "/after_step", schemaPath: "#/$defs/Departure/properties/after_step/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                      vErrors = [err12];
                                    } else {
                                      vErrors.push(err12);
                                    }
                                    errors++;
                                  }
                                  var _valid4 = _errs50 === errors;
                                  valid12 = valid12 || _valid4;
                                  const _errs52 = errors;
                                  if (data13 !== null) {
                                    const err13 = { instancePath: instancePath + "/departures/" + i2 + "/after_step", schemaPath: "#/$defs/Departure/properties/after_step/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                    if (vErrors === null) {
                                      vErrors = [err13];
                                    } else {
                                      vErrors.push(err13);
                                    }
                                    errors++;
                                  }
                                  var _valid4 = _errs52 === errors;
                                  valid12 = valid12 || _valid4;
                                  if (!valid12) {
                                    const err14 = { instancePath: instancePath + "/departures/" + i2 + "/after_step", schemaPath: "#/$defs/Departure/properties/after_step/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                    if (vErrors === null) {
                                      vErrors = [err14];
                                    } else {
                                      vErrors.push(err14);
                                    }
                                    errors++;
                                    validate220.errors = vErrors;
                                    return false;
                                  } else {
                                    errors = _errs49;
                                    if (vErrors !== null) {
                                      if (_errs49) {
                                        vErrors.length = _errs49;
                                      } else {
                                        vErrors = null;
                                      }
                                    }
                                  }
                                  var valid11 = _errs48 === errors;
                                } else {
                                  var valid11 = true;
                                }
                                if (valid11) {
                                  if (data12.workflow !== void 0) {
                                    const _errs54 = errors;
                                    if (typeof data12.workflow !== "string") {
                                      validate220.errors = [{ instancePath: instancePath + "/departures/" + i2 + "/workflow", schemaPath: "#/$defs/Departure/properties/workflow/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid11 = _errs54 === errors;
                                  } else {
                                    var valid11 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate220.errors = [{ instancePath: instancePath + "/departures/" + i2, schemaPath: "#/$defs/Departure/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                            return false;
                          }
                        }
                        var valid9 = _errs44 === errors;
                        if (!valid9) {
                          break;
                        }
                      }
                    } else {
                      validate220.errors = [{ instancePath: instancePath + "/departures", schemaPath: "#/properties/departures/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs42 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.detail !== void 0) {
                    const _errs56 = errors;
                    if (!validate145(data.detail, { instancePath: instancePath + "/detail", parentData: data, parentDataProperty: "detail", rootData, dynamicAnchors })) {
                      vErrors = vErrors === null ? validate145.errors : vErrors.concat(validate145.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs56 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.host !== void 0) {
                      const _errs57 = errors;
                      if (typeof data.host !== "string") {
                        validate220.errors = [{ instancePath: instancePath + "/host", schemaPath: "#/properties/host/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs57 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.kept_input_changes !== void 0) {
                        let data17 = data.kept_input_changes;
                        const _errs59 = errors;
                        if (errors === _errs59) {
                          if (Array.isArray(data17)) {
                            var valid13 = true;
                            const len3 = data17.length;
                            for (let i3 = 0; i3 < len3; i3++) {
                              let data18 = data17[i3];
                              const _errs61 = errors;
                              const _errs62 = errors;
                              if (errors === _errs62) {
                                if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                                  let missing3;
                                  if (data18.step_key === void 0 && (missing3 = "step_key") || data18.input === void 0 && (missing3 = "input") || data18.read === void 0 && (missing3 = "read") || data18.now === void 0 && (missing3 = "now")) {
                                    validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3, schemaPath: "#/$defs/KeptInputChange/required", keyword: "required", params: { missingProperty: missing3 }, message: "must have required property '" + missing3 + "'" }];
                                    return false;
                                  } else {
                                    const _errs64 = errors;
                                    for (const key3 in data18) {
                                      if (!(key3 === "input" || key3 === "now" || key3 === "read" || key3 === "step_key")) {
                                        validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3, schemaPath: "#/$defs/KeptInputChange/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" }];
                                        return false;
                                        break;
                                      }
                                    }
                                    if (_errs64 === errors) {
                                      if (data18.input !== void 0) {
                                        let data19 = data18.input;
                                        const _errs65 = errors;
                                        if (errors === _errs65) {
                                          if (typeof data19 === "string") {
                                            if (!pattern8.test(data19)) {
                                              validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/input", schemaPath: "#/$defs/KeptInputChange/properties/input/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}$"' }];
                                              return false;
                                            }
                                          } else {
                                            validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/input", schemaPath: "#/$defs/KeptInputChange/properties/input/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                        }
                                        var valid15 = _errs65 === errors;
                                      } else {
                                        var valid15 = true;
                                      }
                                      if (valid15) {
                                        if (data18.now !== void 0) {
                                          const _errs67 = errors;
                                          if (typeof data18.now !== "string") {
                                            validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/now", schemaPath: "#/$defs/KeptInputChange/properties/now/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                          }
                                          var valid15 = _errs67 === errors;
                                        } else {
                                          var valid15 = true;
                                        }
                                        if (valid15) {
                                          if (data18.read !== void 0) {
                                            const _errs69 = errors;
                                            if (typeof data18.read !== "string") {
                                              validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/read", schemaPath: "#/$defs/KeptInputChange/properties/read/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid15 = _errs69 === errors;
                                          } else {
                                            var valid15 = true;
                                          }
                                          if (valid15) {
                                            if (data18.step_key !== void 0) {
                                              let data22 = data18.step_key;
                                              const _errs71 = errors;
                                              if (errors === _errs71) {
                                                if (typeof data22 === "string") {
                                                  if (!pattern14.test(data22)) {
                                                    validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/step_key", schemaPath: "#/$defs/KeptInputChange/properties/step_key/pattern", keyword: "pattern", params: { pattern: "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$" }, message: 'must match pattern "^[a-z][a-z0-9_]{0,62}(\\.[a-z][a-z0-9_]{0,62}){0,7}$"' }];
                                                    return false;
                                                  }
                                                } else {
                                                  validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3 + "/step_key", schemaPath: "#/$defs/KeptInputChange/properties/step_key/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                              }
                                              var valid15 = _errs71 === errors;
                                            } else {
                                              var valid15 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate220.errors = [{ instancePath: instancePath + "/kept_input_changes/" + i3, schemaPath: "#/$defs/KeptInputChange/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                  return false;
                                }
                              }
                              var valid13 = _errs61 === errors;
                              if (!valid13) {
                                break;
                              }
                            }
                          } else {
                            validate220.errors = [{ instancePath: instancePath + "/kept_input_changes", schemaPath: "#/properties/kept_input_changes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs59 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.latest_outcome !== void 0) {
                          let data23 = data.latest_outcome;
                          const _errs73 = errors;
                          const _errs74 = errors;
                          let valid16 = false;
                          const _errs75 = errors;
                          if (!validate138(data23, { instancePath: instancePath + "/latest_outcome", parentData: data, parentDataProperty: "latest_outcome", rootData, dynamicAnchors })) {
                            vErrors = vErrors === null ? validate138.errors : vErrors.concat(validate138.errors);
                            errors = vErrors.length;
                          }
                          var _valid5 = _errs75 === errors;
                          valid16 = valid16 || _valid5;
                          const _errs76 = errors;
                          if (data23 !== null) {
                            const err15 = { instancePath: instancePath + "/latest_outcome", schemaPath: "#/properties/latest_outcome/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                            if (vErrors === null) {
                              vErrors = [err15];
                            } else {
                              vErrors.push(err15);
                            }
                            errors++;
                          }
                          var _valid5 = _errs76 === errors;
                          valid16 = valid16 || _valid5;
                          if (!valid16) {
                            const err16 = { instancePath: instancePath + "/latest_outcome", schemaPath: "#/properties/latest_outcome/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err16];
                            } else {
                              vErrors.push(err16);
                            }
                            errors++;
                            validate220.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs74;
                            if (vErrors !== null) {
                              if (_errs74) {
                                vErrors.length = _errs74;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid0 = _errs73 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.projection !== void 0) {
                            const _errs78 = errors;
                            if (!validate162(data.projection, { instancePath: instancePath + "/projection", parentData: data, parentDataProperty: "projection", rootData, dynamicAnchors })) {
                              vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs78 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.route_unavailable_because !== void 0) {
                              let data25 = data.route_unavailable_because;
                              const _errs79 = errors;
                              const _errs80 = errors;
                              let valid17 = false;
                              const _errs81 = errors;
                              if (typeof data25 !== "string") {
                                const err17 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/$defs/RouteUnavailability/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err17];
                                } else {
                                  vErrors.push(err17);
                                }
                                errors++;
                              }
                              if (!(data25 === "not_installed" || data25 === "not_logged_in" || data25 === "failed" || data25 === "no_key" || data25 === "blocked" || data25 === "model_unavailable")) {
                                const err18 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/$defs/RouteUnavailability/enum", keyword: "enum", params: { allowedValues: schema240.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                              var _valid6 = _errs81 === errors;
                              valid17 = valid17 || _valid6;
                              const _errs84 = errors;
                              if (data25 !== null) {
                                const err19 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/properties/route_unavailable_because/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                  vErrors = [err19];
                                } else {
                                  vErrors.push(err19);
                                }
                                errors++;
                              }
                              var _valid6 = _errs84 === errors;
                              valid17 = valid17 || _valid6;
                              if (!valid17) {
                                const err20 = { instancePath: instancePath + "/route_unavailable_because", schemaPath: "#/properties/route_unavailable_because/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                                validate220.errors = vErrors;
                                return false;
                              } else {
                                errors = _errs80;
                                if (vErrors !== null) {
                                  if (_errs80) {
                                    vErrors.length = _errs80;
                                  } else {
                                    vErrors = null;
                                  }
                                }
                              }
                              var valid0 = _errs79 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.serves_participants !== void 0) {
                                const _errs86 = errors;
                                if (typeof data.serves_participants !== "boolean") {
                                  validate220.errors = [{ instancePath: instancePath + "/serves_participants", schemaPath: "#/properties/serves_participants/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                  return false;
                                }
                                var valid0 = _errs86 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.settings !== void 0) {
                                  const _errs88 = errors;
                                  if (!validate27(data.settings, { instancePath: instancePath + "/settings", parentData: data, parentDataProperty: "settings", rootData, dynamicAnchors })) {
                                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid0 = _errs88 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.state !== void 0) {
                                    let data28 = data.state;
                                    const _errs89 = errors;
                                    if (typeof data28 !== "string") {
                                      validate220.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    if (!(data28 === "saved" || data28 === "live" || data28 === "closed")) {
                                      validate220.errors = [{ instancePath: instancePath + "/state", schemaPath: "#/$defs/ThreadState/enum", keyword: "enum", params: { allowedValues: schema241.enum }, message: "must be equal to one of the allowed values" }];
                                      return false;
                                    }
                                    var valid0 = _errs89 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.title !== void 0) {
                                      const _errs92 = errors;
                                      if (typeof data.title !== "string") {
                                        validate220.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      var valid0 = _errs92 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.waiting_for_sender !== void 0) {
                                        let data30 = data.waiting_for_sender;
                                        const _errs94 = errors;
                                        if (errors === _errs94) {
                                          if (Array.isArray(data30)) {
                                            var valid20 = true;
                                            const len4 = data30.length;
                                            for (let i4 = 0; i4 < len4; i4++) {
                                              let data31 = data30[i4];
                                              const _errs96 = errors;
                                              if (!(typeof data31 == "number" && (!(data31 % 1) && !isNaN(data31)))) {
                                                validate220.errors = [{ instancePath: instancePath + "/waiting_for_sender/" + i4, schemaPath: "#/properties/waiting_for_sender/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                                return false;
                                              }
                                              var valid20 = _errs96 === errors;
                                              if (!valid20) {
                                                break;
                                              }
                                            }
                                          } else {
                                            validate220.errors = [{ instancePath: instancePath + "/waiting_for_sender", schemaPath: "#/properties/waiting_for_sender/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                            return false;
                                          }
                                        }
                                        var valid0 = _errs94 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate220.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate220.errors = vErrors;
  return errors === 0;
}
validate220.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
var validateProjectedValue = validate225;
function validate225(data, { instancePath = "", parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {}) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate225.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = void 0;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = void 0;
  }
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      let missing0;
      if (data.name === void 0 && (missing0 = "name") || data.kind === void 0 && (missing0 = "kind") || data.entry === void 0 && (missing0 = "entry")) {
        validate225.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === "count" || key0 === "entry" || key0 === "kind" || key0 === "name" || key0 === "text")) {
            validate225.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.count !== void 0) {
            let data0 = data.count;
            const _errs2 = errors;
            const _errs3 = errors;
            let valid1 = false;
            const _errs4 = errors;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)))) {
              const err0 = { instancePath: instancePath + "/count", schemaPath: "#/properties/count/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs4 === errors;
            valid1 = valid1 || _valid0;
            const _errs6 = errors;
            if (data0 !== null) {
              const err1 = { instancePath: instancePath + "/count", schemaPath: "#/properties/count/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var _valid0 = _errs6 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const err2 = { instancePath: instancePath + "/count", schemaPath: "#/properties/count/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate225.errors = vErrors;
              return false;
            } else {
              errors = _errs3;
              if (vErrors !== null) {
                if (_errs3) {
                  vErrors.length = _errs3;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.entry !== void 0) {
              let data1 = data.entry;
              const _errs8 = errors;
              if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)))) {
                validate225.errors = [{ instancePath: instancePath + "/entry", schemaPath: "#/properties/entry/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.kind !== void 0) {
                let data2 = data.kind;
                const _errs10 = errors;
                if (typeof data2 !== "string") {
                  validate225.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/ValueKind/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data2 === "text" || data2 === "choice" || data2 === "annotations" || data2 === "instance_data" || data2 === "change_set" || data2 === "text_units" || data2 === "item" || data2 === "item_refs" || data2 === "term_cards" || data2 === "check_report" || data2 === "derived" || data2 === "workspace_file" || data2 === "corpus_import" || data2 === "source_version" || data2 === "release_request" || data2 === "release" || data2 === "html_page" || data2 === "derived_records" || data2 === "memory" || data2 === "result")) {
                  validate225.errors = [{ instancePath: instancePath + "/kind", schemaPath: "#/$defs/ValueKind/enum", keyword: "enum", params: { allowedValues: schema94.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== void 0) {
                  const _errs13 = errors;
                  if (typeof data.name !== "string") {
                    validate225.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.text !== void 0) {
                    let data4 = data.text;
                    const _errs15 = errors;
                    const _errs16 = errors;
                    let valid3 = false;
                    const _errs17 = errors;
                    if (typeof data4 !== "string") {
                      const err3 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err3];
                      } else {
                        vErrors.push(err3);
                      }
                      errors++;
                    }
                    var _valid1 = _errs17 === errors;
                    valid3 = valid3 || _valid1;
                    const _errs19 = errors;
                    if (data4 !== null) {
                      const err4 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid1 = _errs19 === errors;
                    valid3 = valid3 || _valid1;
                    if (!valid3) {
                      const err5 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                      validate225.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs16;
                      if (vErrors !== null) {
                        if (_errs16) {
                          vErrors.length = _errs16;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs15 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate225.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate225.errors = vErrors;
  return errors === 0;
}
validate225.evaluated = { "props": true, "dynamicProps": false, "dynamicItems": false };
export {
  validateBindings,
  validateEntry,
  validateFacts,
  validateListing,
  validateProjectedValue,
  validateServerMessage,
  validateSettings
};
